// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: 'https://des-evo-v5-816-0.evo.dev-jtides.com' | (string & {});
};

export type CreatePlatformConfiguration = {
    change_reason?: string | null;
    type?: string | null;
    code: string;
    name: string;
    public: boolean;
    data: Array<{
        [key: string]: unknown;
    }>;
};

export type UpdatePlatformConfiguration = {
    change_reason?: string | null;
    code: string;
    name: string;
    public: boolean;
    data: Array<{
        [key: string]: unknown;
    }>;
};

export type DisconnectAdapterRequestBody = {
    /**
     * Adapter unique code
     */
    adapter_code: string;
    /**
     * Tenant unique code
     */
    tenant_code: string;
};

export type ConnectAdapterRequestBody = AdapterConnectionFields;

export type AdapterRequestBody = AdapterFields;

export type UnregisterInventoryItemByGuestRequestBody = {
    /**
     * External Id is a unique identifier of an external user. An example is a lead uuid.
     */
    externalId: string;
};

export type ConsumerCanceledWebhook = ConsumerCanceled;

export type RegisterDeviceRequest = {
    /**
     * Device Identifier. Either LeafletId (RC) which is 16 character long string or Device Serial Number (TC) which is at least 12 characters long. For TC, only first 12 characters will be used
     */
    deviceId: string;
    /**
     * Consumer Id is a unique identifier of a user. An example is a consumer uuid.
     */
    consumerId: string;
};

export type GuestRegisterDeviceRequest = {
    /**
     * Device Identifier. Either LeafletId (RC) which is 16 character long string or Device Serial Number (TC) which is at least 12 characters long. For TC, only first 12 characters will be used
     */
    deviceId: string;
    /**
     * External Id is a unique identifier of an external user. An example is a lead uuid.
     */
    externalId: string;
};

export type UnregisterInventoryItemByConsumerRequestBody = {
    /**
     * Consumer Id is a unique identifier of a user. An example is a consumer uuid.
     */
    consumerId: string;
};

export type AssignCustomerToInventoryItem = {
    /**
     * Consumer Id is a unique identifier of a user. An example is a consumer uuid.
     */
    consumerId: string;
};

export type MeRegisterProduct = {
    code?: string;
    purchase_date?: string | null;
};

export type RegisterProductRequestBody = {
    code?: string;
    purchase_date?: string | null;
    user?: {
        /**
         * One of object property must be provided!
         */
        identity?: {
            /**
             * Registered CAS customer UUID
             */
            des_user_id?: string | null;
            /**
             * Registered external customer ID/UUID (Ambassador)
             */
            external_user_id?: string | null;
            /**
             * Alternative to provide email for registered users
             */
            personal_identifier?: string | null;
        };
        is_virtual?: boolean | null;
    };
};

export type ProductPrefixRequest = ProductPrefixRequestFields;

export type UpdateSpexClusterRequestBody = {
    /**
     * The country codes of the Spex Cluster
     */
    country_codes: Array<string>;
};

export type CreateSpexClusterRequestBody = {
    /**
     * The name of the Spex Cluster
     */
    name: string;
    /**
     * The country codes of the Spex Cluster
     */
    country_codes: Array<string>;
};

export type UpdateShippingRequestBody = {
    carrier?: string;
    title?: string;
    trackNumber?: string;
    trackUrl?: string | null;
};

export type CancelOrderRequestBody = {
    items?: Array<{
        sku?: string;
        qty?: number;
    }>;
};

export type UpdateStatusRequestBody = {
    status_code?: 'confirmed' | 'processing' | 'shipped' | 'shipped_to_warehouse' | 'delivered' | 'delivered_to_pick_up_point';
};

export type CancellationRequestBody = {
    order_id: string;
    reason: string;
};

export type WithdrawRequestBody = {
    /**
     * Magento order increment id
     */
    order_id: string;
    reason?: string | null;
    /**
     * Customer first name
     */
    first_name?: string;
    /**
     * Customer last name
     */
    last_name?: string;
    /**
     * Customer email
     */
    email?: string;
    /**
     * Customer phone number
     */
    phone?: string;
};

export type CreateOrderInMagentoRequestBody = {
    external_id?: string | null;
    currency: string;
    status: string;
    state: string;
    payment: {
        method: string;
        title: string;
    };
    items: Array<{
        sku: string;
        qty: number;
        price: number;
        tax: number;
        discount: number;
    }>;
    shipping: {
        amount: number;
        title: string;
        method: string;
    };
    customer: {
        uuid: string;
        email: string;
        firstname: string;
        lastname: string;
        dob: string;
        is_age_verified: boolean;
    };
    address?: {
        street: string;
        city: string;
        postcode: string;
        country: string;
        phone: string;
    };
};

export type ReasonRequestBody = {
    reason_code?: string;
    reason_message?: string | null;
};

export type CreateOrderRequestBody = {
    entity_type: string;
    event_code: string;
    hash: string;
    payload: {
        increment_id: string;
        entity_id: number;
        status: 'new' | 'confirmed' | 'processing' | 'pending_payment' | 'payment_failed' | 'payment_completed' | 'holded' | 'shipped' | 'shipped_to_warehouse' | 'delivered' | 'delivered_to_pick_up_point' | 'pending_cancellation' | 'canceled' | 'returned';
        state: string;
        order_currency_code: string;
        total_due: number;
        total_item_count: number;
        subtotal: number;
        shipping_amount: number;
        shipping_description?: string;
        grand_total: number;
        total_paid?: number;
        discount_amount: number;
        tax_amount: number;
        base_tax_amount: number;
        shipping_tax_amount: number;
        customer_email: string;
        customer_firstname?: string;
        customer_lastname: string;
        store_id: number;
        store_name: string;
        attributes?: {
            [key: string]: unknown;
        };
        parent_id?: string | null;
        reason_code?: string | null;
        reason_message?: string | null;
        coupon_code?: string | null;
        created_at?: string | null;
        customer: {
            dob: string;
            uuid: string;
            age_verified: number;
        };
        payment: {
            title?: string;
            method: string;
            amount_ordered: number;
        };
        billing_address: {
            address_type: string;
            entity_id: number;
            city: string;
            country_id: string;
            email: string;
            firstname?: string;
            lastname: string;
            street: Array<string>;
            postcode?: string | null;
            telephone?: string | null;
            company?: string | null;
            sublocality_level_2?: string | null;
            administrative_area_level_2?: string | null;
            neighborhood?: string | null;
            premise?: string | null;
            landmark?: string | null;
            district?: string | null;
            building_number?: string | null;
            short_address?: string | null;
        };
        shipping_address?: {
            sublocality_level_2?: string | null;
            administrative_area_level_2?: string | null;
            neighborhood?: string | null;
            premise?: string | null;
            landmark?: string | null;
            district?: string | null;
            building_number?: string | null;
            short_address?: string | null;
        };
        items: Array<{
            item_id: number;
            parent_item_id?: number;
            product_type: string;
            product_id: number;
            name: string;
            qty_ordered: number;
            sku: string;
            sap_sku?: string | null;
            price: number;
            price_incl_tax?: number;
            original_price: number;
            original_price_incl_tax: number;
            tax_amount: number;
            discount_percent: number;
            discount_amount: number;
            promotional_offers?: Array<string>;
            extension_attributes?: {
                presentation_info?: {
                    presentation_price?: number | null;
                };
            };
        }>;
        adjustments?: Array<{
            type: string;
            open_date: string;
            status: string;
            jti_inform_warehouse: boolean;
            data: {
                order_adjustment: {
                    order_adjustment: string | null;
                    amount: number;
                    currency: string;
                };
                items: Array<{
                    sku: string;
                    qty: number;
                    requires_return: boolean;
                    amount: number;
                    currency: string;
                    parent_sku: string | null;
                }>;
            };
        }>;
        extension_attributes: {
            order_type: string;
            fms_number?: string | null;
            base_gift_cards_amount?: number;
            gift_cards_amount?: number;
            gift_cards?: Array<{
                code: string;
                amount: number;
            }>;
            loyalty_discount?: {
                loyalty_discount_uuid?: string;
                loyalty_discount_name?: string;
                loyalty_discount_sku?: string;
                loyalty_discount_points?: number;
                loyalty_discount_amount?: number;
            };
            payment_additional_info?: Array<{
                key: string;
                value: string;
            }>;
            applied_taxes?: Array<{
                code?: string;
                title?: string;
                percent: number;
                amount: number;
                base_amount: number;
                extension_attributes?: {
                    identifier?: string | null;
                };
            }>;
            item_applied_taxes?: Array<{
                type: string;
                item_id?: number;
                associated_item_id?: number;
                applied_taxes?: Array<{
                    code?: string;
                    title?: string;
                    percent: number;
                    amount: number;
                    base_amount: number;
                    extension_attributes?: {
                        identifier?: string | null;
                    };
                }>;
            }>;
            shipping_assignments: Array<{
                shipping: {
                    method?: string | null;
                    address?: {
                        address_type: string;
                        entity_id: number;
                        city: string;
                        country_id: string;
                        email: string;
                        firstname?: string;
                        lastname: string;
                        street: Array<string>;
                        postcode?: string | null;
                        telephone?: string | null;
                        company?: string | null;
                        sublocality_level_2?: string | null;
                        administrative_area_level_2?: string | null;
                        neighborhood?: string | null;
                        premise?: string | null;
                        landmark?: string | null;
                        district?: string | null;
                        building_number?: string | null;
                        short_address?: string | null;
                    } & {
                        extension_attributes?: {
                            pickup_information?: string;
                        };
                    };
                };
            }>;
        };
    };
};

export type CreateInvoiceRequestBody = {
    /**
     * Encoded Base64 binary code of the file
     */
    file?: string;
};

export type CreatePaymentRequestBody = {
    /**
     * ID of the order
     */
    order_id: number;
    /**
     * Uuid of the customer
     */
    customer_uuid: string;
    /**
     * Whether payment needs to be tokenized
     */
    tokenize: boolean;
};

export type InitializeSessionRequestBody = {
    /**
     * Unique UUID of order payment transaction
     */
    payment_token: string;
    /**
     * Payment Method associated to order that will be paid
     */
    payment_method: string;
    /**
     * Addition session options
     */
    options?: {
        [key: string]: unknown;
    };
};

export type UpdatePaymentExternalDataRequestBody = {
    data: {
        [key: string]: unknown;
    };
};

export type PaymentMethodRequestBody = PaymentMethod;

export type PaySessionRequestBody = {
    /**
     * Identifier of the payment session created for secured fields flow
     */
    session_id: string;
    /**
     * Identifier of the order that will be paid
     */
    order_id: number;
    /**
     * UUID of the consumer paying for the order
     */
    consumer_id: string;
    /**
     * Payment method code associated to the order that will be paid
     */
    payment_method: string;
    /**
     * Addition session options
     */
    options?: {
        [key: string]: unknown;
    } | null;
    /**
     * Indicates if the payment method should be tokenized for future payments
     */
    tokenize: boolean;
};

export type CreateAuthorisationRequestBody = {
    uuid: string;
    /**
     * Tokenized payment session
     */
    token: string;
    number: string;
    expiration_date: string;
    /**
     * Authorisation metadata
     */
    metadata: {
        [key: string]: unknown;
    };
};

export type UpdateRefundRequestBody = {
    status: 'new' | 'processing' | 'done' | 'failed';
};

export type InitializeAuthorisationRequestBody = {
    /**
     * Addition session options
     */
    options?: {
        subscription_uuid?: string;
        [key: string]: string | undefined;
    };
};

export type CreateRefundRequestBody = {
    /**
     * ID of the order
     */
    order_id: number;
    /**
     * Payment amount that was paid
     */
    amount: number;
    /**
     * Payment currency
     */
    currency: string;
    /**
     * Refund reason code
     */
    reason_code: string;
    /**
     * Unique credit memo identifier
     */
    credit_memo_id: number;
};

export type UpdatePaymentRequestBody = {
    /**
     * Payment Method associated to order that will be paid
     */
    payment_method: string;
    status: 'pending' | 'paid' | 'authorised' | 'refund' | 'chargeback' | 'failed';
    /**
     * Payment amount that was paid
     */
    amount: number;
    /**
     * Payment currency
     */
    currency: string;
    /**
     * Tokenized payment session
     */
    token?: string | null;
    /**
     * Payment metadata
     */
    metadata?: {
        [key: string]: unknown;
    } | null;
    /**
     * Indicating whether soft or hard decline has occurred
     */
    gateway_status?: 'soft_decline' | 'hard_decline' | null;
    /**
     * Providing the details about the reason for the error
     */
    gateway_details?: string | null;
};

export type SendPaymentLinkRequestBody = {
    /**
     * ID of the order
     */
    order_id: string;
    /**
     * Uuid of the customer that owns the order
     */
    customer_uuid: string;
    /**
     * Channel used to send the payment link
     */
    channel: 'EMAIL' | 'SMS' | 'NONE';
    /**
     * Payment method used to generate the payment link
     */
    method: 'cc';
};

export type CreateSessionRequestBody = {
    /**
     * Payment method code
     */
    payment_method: string;
};

export type CreateUserSubmissionRequestBody = {
    /**
     * Array with unspecified unvalidated payload.
     */
    questions?: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Array with unspecified unvalidated payload.
     */
    answers?: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Array with unspecified unvalidated payload.
     */
    results?: {
        [key: string]: unknown;
    };
};

export type SearchableData = Searchable;

export type UpdateChargeRequestBody = {
    consumer_id: string;
    order_id: string;
    entity_id: number;
    amount: number;
    currency: string;
    status: 'pending' | 'success' | 'failed';
};

export type UpdateSubscriptionStatusRequestBody = {
    status: 'active' | 'paused' | 'canceled';
};

export type CreateSubscriptionRequestBody = {
    consumer_id: string;
    shipping_address_id: number;
    billing_address_id: number;
    amount: number;
    currency: string;
    products: Array<{
        sku: string;
        qty: number;
        options?: Array<{
            sku: string;
            qty: number;
        }>;
    }>;
};

export type CancelSubscriptionRequestBody = {
    /**
     * Optional reason for cancellation
     */
    reason_description?: string | null;
};

export type UpdateSubscriptionRequestBody = {
    billed_at?: string;
    products?: Array<{
        sku: string;
        qty: number;
        options?: Array<{
            sku: string;
            qty: number;
        }>;
    }>;
};

export type UpdateTrialRequestBody = {
    status: 'pending' | 'ongoing' | 'charging' | 'failed' | 'fully_charged' | 'canceled' | 'blocked';
};

export type CreateTradeInRequestBody = {
    consumer_id: string;
    order_id: string;
    model: string;
    serial_number?: string | null;
    new_sku: string;
    new_model?: string | null;
    purchase_date: string;
};

export type RegisterOfflineActionRequestBody = {
    customer_uuid: string;
    /**
     * Order UUID
     */
    action_uuid: string;
    type: string;
};

export type WebhookData = WebhookFields;

export type VerifyEmailRequestBody = {
    /**
     * Email address
     */
    email: string;
    /**
     * Email validation type
     */
    type?: 'format' | 'domain' | 'strict' | null;
};

export type VerifyPhoneRequestBody = {
    /**
     * Phone number
     */
    phone: string;
    /**
     * Phone validation type. `format` - checks if the phone number format is valid, `strict` - checks phone number via third-party service
     */
    type?: 'format' | 'strict' | null;
};

export type CancelBusBatchRequestBody = {
    /**
     * Identifier of the bus batch to cancel
     */
    batch_id: string;
    /**
     * Reason for cancelling the batch (minimum 10 characters)
     */
    reason: string;
};

export type AnonymizeProfileRequestBody = {
    reason_for_anonymization: 'profile_cleansing_test_profile' | 'profile_cleansing_orphan_profile' | 'profile_cleansing_potential_fraud' | 'profile_cleansing_duplicated' | 'profile_cleansing_non_contactable_inactive' | 'consumer_request' | 'retention_rule_exceeded' | 'local_process_double_opt_in_not_done' | 'profile_cleansing_cdp_evo_align' | 'profile_cleansing_snp_invalid_inactive' | 'profile_cleansing_direct_ingestion' | 'profile_cleansing_invalid_age' | 'other';
    trigger_source: 'cdp' | 'gcc_agent' | 'account_dashboard' | 'fms' | 'sales_and_operations' | 'other';
    /**
     * External ticket, job, or request identifier.
     */
    external_id?: string | null;
};

export type UpdateRoleRequest = {
    /**
     * The display name of the role
     */
    name: string;
    /**
     * The external identifier for the role
     */
    external_id?: string | null;
    /**
     * A description of the role
     */
    description: string;
    /**
     * Whether the role is enabled
     */
    is_enabled: boolean;
    /**
     * List of permission keys to assign to the role
     */
    permissions?: Array<string>;
};

export type GenerateS2sTokenRequestBody = {
    scopes: Array<string>;
    /**
     * JWT token for the client assertion
     */
    assertion: string;
};

export type CreateRoleRequest = {
    /**
     * The unique key identifier for the role
     */
    key: string;
    /**
     * The display name of the role
     */
    name: string;
    /**
     * The external identifier for the role
     */
    external_id?: string | null;
    /**
     * A description of the role
     */
    description: string;
    /**
     * Whether the role is enabled
     */
    is_enabled: boolean;
    /**
     * List of permission keys to assign to the role
     */
    permissions?: Array<string>;
};

export type CreateEntraApplicationRequest = {
    /**
     * The display name for the new Entra application (also used as the EVO role name)
     */
    name: string;
    /**
     * The permissions granted to the EVO role created for the application. When omitted, no dedicated role is created
     */
    new_role_permissions?: Array<string>;
    /**
     * Existing Entra app role values to grant to the new application
     */
    assign_existing_roles?: Array<string>;
    /**
     * The delay in seconds before the subsequent Entra requests are processed
     */
    entra_delay_seconds?: number;
};

/**
 * Feature content as a text
 */
export type ScenarioValidationRequestBody = string;

export type CreateAgeVerificationItemRequestBody = {
    /**
     * Email address
     */
    email: string;
    /**
     * Is age verified
     */
    is_verified: boolean;
    /**
     * Verification status
     */
    verification_status: 'pending' | 'failed' | 'success' | 'abandoned';
    extra_data?: {
        [key: string]: unknown;
    } | null;
    /**
     * Token source field
     */
    token_source?: 'email' | 'uuid' | null;
};

export type UpdateIntegrationTestResultRequestBody = {
    items: Array<{
        /**
         * Status
         */
        status: 'to_run' | 'passed' | 'failed' | 'fail_reported' | 'in_progress';
        /**
         * Tenant code identifier
         */
        tenant_code: string;
        /**
         * Feature code identifier
         */
        feature_code: string;
        /**
         * Feature title
         */
        feature_title: string;
        /**
         * Scenario code identifier
         */
        scenario_code: string;
        /**
         * Scenario title
         */
        scenario_title: string;
        /**
         * Example line reference
         */
        example_line: string;
        /**
         * CI pipeline URL
         */
        pipeline_url: string;
        tags: Array<string>;
        /**
         * Details of the failed step
         */
        failed_step?: {
            /**
             * Step text
             */
            text: string;
            /**
             * Step keyword
             */
            keyword: string;
            /**
             * Step line number
             */
            line: number;
            /**
             * Error message if the step failed
             */
            error_message?: string | null;
        } | null;
    }>;
};

export type GetActionVerificationCodeRequestBody = {
    /**
     * Uuid of item to get
     */
    uuid: string;
};

export type MigrateOktaApplicationToEntraRequest = {
    /**
     * The id of the source Okta application (for OIDC apps this equals the client id)
     */
    okta_app_id: string;
    /**
     * The display name for the new Entra application (also used as the EVO role name)
     */
    entra_app_name: string;
    /**
     * The delay in seconds before the subsequent Entra requests are processed
     */
    entra_delay_seconds?: number;
    /**
     * If true, the migration will skip any Okta scopes that are not used by the application (not granted through access policies)
     */
    skip_unused_scopes?: boolean;
};

export type UpdateTenantMappingRequestBody = {
    tenant_token: string;
    mapped_to?: string | null;
    /**
     * The list of mapped tenant code overrides per-service. The keys are service names, either in abbreviated form (e.g. avp) or in the full form (e.g. des-services/avp/v1)
     */
    overrides?: {
        [key: string]: string | null;
    };
};

export type UpdateSingleTenantMappingRequestBody = {
    tenant_token: string;
    /**
     * If set to null, the mapping will be removed
     */
    tenant_code: string | null;
    options?: {
        /**
         * The purpose_id that, when specified, should be rewritten to the legitimate interest marketing communication category. Note that this can also be achieved by using the purpose_to_category_mapping option.
         */
        legitimate_interest_consent_id?: string;
        /**
         * A map of purpose_ids from OT to the marketing communication category in EVO
         */
        purpose_to_category_mapping?: {
            [key: string]: string;
        };
        /**
         * Whether to convert the lead
         */
        convert_lead?: boolean;
        /**
         * The opt-in strategy to use for the tenant
         */
        opt_in_strategy?: string;
        /**
         * The phone country code to use for the tenant
         */
        phone_country_code?: string;
    };
};

export type UpdateShortUrlRequest = {
    /**
     * The original destination long URL
     */
    url: string;
};

export type CreateShortUrlRequest = {
    /**
     * The original destination long URL
     */
    url: string;
    /**
     * The unique code for the short URL, put only if you want to customize it instead generated one
     */
    code?: string | null;
    /**
     * External identifier used for grouping or filtering
     */
    external_id?: string | null;
    /**
     * Campaign identifier used for grouping or filtering
     */
    campaign_id?: string | null;
};

export type IngestClicksRequest = {
    /**
     * List of click events
     */
    clicks: Array<{
        /**
         * Short URL code
         */
        code: string;
        /**
         * Date and time of the click
         */
        clicked_at: string;
        /**
         * Country code
         */
        country?: string | null;
        /**
         * City name
         */
        city?: string | null;
        /**
         * Region code
         */
        region?: string | null;
        /**
         * Autonomous system number
         */
        asn?: number | null;
        /**
         * Client user agent string
         */
        user_agent?: string | null;
    }>;
};

export type CreateBulkShortUrlRequest = {
    /**
     * Optional campaign identifier applied to all items. When present, it overrides any item-level campaign_id values.
     */
    campaign_id?: string | null;
    /**
     * List of short URLs to create
     */
    items: Array<{
        /**
         * The original destination long URL
         */
        url: string;
        /**
         * External identifier used for grouping or filtering
         */
        external_id?: string | null;
        /**
         * Campaign identifier used for grouping or filtering when no top-level campaign_id override is provided
         */
        campaign_id?: string | null;
    }>;
};

export type CreateActionVerificationItemRequestBody = {
    /**
     * Channel of action verification
     */
    channel: 'email' | 'sms' | 'whatsapp' | 'viber';
    /**
     * Identifier of action verification (phone number or email address)
     */
    identifier: string;
    /**
     * Template to use for the action verification message
     */
    template?: string | null;
    /**
     * Identifier of the action verification message type. Use template instead.
     *
     * @deprecated
     */
    message_type?: 'EMAIL_CONFIRMATION_CODE' | 'SMS_CONFIRMATION_CODE' | 'WHATSAPP_CONFIRMATION_CODE' | 'LOGIN_OTP' | null;
    /**
     * Name of subject of action verification
     */
    name?: string | null;
    /**
     * Determines if a message should be sent to the user
     */
    send_message?: boolean | null;
};

export type VerifyActionVerificationItemRequestBody = {
    /**
     * Code for verification
     */
    code: string;
};

export type UpdateConsumerUuidRequest = {
    meta?: {
        /**
         * Webhook event type
         */
        event_type?: string;
        /**
         * Tenant code
         */
        tenant_code?: string;
    };
    data?: {
        /**
         * Age verification item uuid
         */
        age_verification_item_uuid?: string;
        /**
         * Consumer uuid
         */
        consumer_uuid?: string;
    };
};

export type PerformAgeVerificationRequest = {
    /**
     * Uuid of AgeVerificationItem
     */
    request_uuid?: string | null;
    /**
     * Email of consumer performing age verification
     */
    email?: string | null;
    /**
     * Method code from adapter
     */
    method_code: string;
    /**
     * Country code
     */
    country_code?: string;
    /**
     * Fields with additional payload for adapter
     */
    fields?: {
        [key: string]: unknown;
    } | null;
};

export type InitializeAsynchronousAgeVerificationRequest = {
    /**
     * Email of consumer performing age verification
     */
    email?: string | null;
    /**
     * Method code from adapter
     */
    method_code: string;
    /**
     * Country code
     */
    country_code?: string;
    /**
     * Fields with additional payload for adapter
     */
    fields?: {
        [key: string]: unknown;
    } | null;
};

export type CodeRouteRequest = CodeRouteFields;

export type UpdateOneTrustPreferenceWebhookRequestBody = {
    payload: Array<{
        email: string;
        'Data Source'?: string | null;
        profiles: Array<{
            purposeId: string;
            profilefields: {
                transactionStatus: string;
                consentDate: string | null;
                oneOff?: boolean | null;
            };
        }>;
    }>;
};

export type PerformOneTrustPurposesSyncRequest = {
    meta: {
        /**
         * Webhook event type
         */
        event_type: string;
        /**
         * Tenant code
         */
        tenant_code: string;
    };
    timestamp?: string | number;
    data?: {
        /**
         * Flag indicating whether force synchronization or normal one
         */
        force?: boolean | null;
    };
};

export type UpdateConsents = {
    /**
     * The collection of all consents
     */
    consents?: Array<{
        /**
         * The consent's purpose UUID (as in OneTrust)
         */
        id: string;
        /**
         * Whether the consent was accepted.
         */
        accepted: boolean;
        /**
         * Whether the consent marked as one time consent to receive marketing communications.
         */
        one_off?: boolean;
    }>;
};

export type CreateFeedbackVoteRequestBody = {
    vote_type: boolean;
    content: {
        url: string;
        reference_type: 'faq_page' | 'video';
        reference_name: string;
    };
    content_type: 'website' | 'product';
};

export type CouponGenerationWebhookRequest = {
    meta: {
        /**
         * Event type
         */
        event_type: string;
        /**
         * Tenant code
         */
        tenant_code: string;
    };
    data: {
        /**
         * CAS UUID or external user identifier (uuid or other format)
         */
        UserId: string;
        /**
         * OpenLoyalty event code
         */
        event_code: string;
    };
};

export type BulkGenerateCouponRequestBody = {
    /**
     * OpenLoyalty event name
     */
    event_code: string;
    /**
     * Quantity of coupons to generate
     */
    quantity: number;
};

export type GenerateSingleCouponRequestBody = {
    /**
     * OpenLoyalty event code
     */
    event_code: string;
    /**
     * CAS UUID or external user identifier (uuid or other format)
     */
    user_id: string;
    /**
     * if FALSE, messaging will be skipped
     */
    suppress_notification?: boolean;
};

export type ServiceRequestExternalCouponRequestBody = {
    fields?: {
        external_order_id?: string;
        order_rows?: Array<{
            product_id?: string;
            quantity?: number;
        }>;
    };
};

export type ExternalProviderRewardUpdatedRequestBody = {
    /**
     * External provider brand code
     */
    brand_code: string;
    /**
     * List of reward fields that changed
     */
    changed_fields: Array<string>;
};

export type EncryptRequestBody = {
    reason?: string;
    data?: Array<string>;
};

export type DecryptRequestBody = {
    data?: Array<string>;
};

export type StartInventoryExportRequestBody = {
    filter: InventoryExportFilterSchema;
};

export type InventoryItemImportRequestBody = {
    /**
     * The name of the file to be imported
     */
    filename?: string | null;
    /**
     * If the file is already being processed, the import will be performed anyway
     */
    force?: boolean | null;
};

export type DeviceInventoryPayloadImportRequestBody = {
    /**
     * The devices to be imported
     */
    devices: Array<{
        /**
         * The TC of the device
         */
        tc: string;
        /**
         * The RC of the device
         */
        rc: string;
        /**
         * The country code of the device
         */
        device_country: string;
        /**
         * The tenant code of the device
         */
        tenant_code: string;
        /**
         * Uuid of the consumer
         */
        user_id?: string | null;
        /**
         * User assigment date
         */
        user_assignment_date?: string | null;
        /**
         * Warranty expiration date
         */
        warranty_expiry_date?: string | null;
        /**
         * Registration date
         */
        registration_date?: string | null;
        /**
         * Uuid of the external user
         */
        external_id?: string | null;
    }>;
};

export type PackCodesImportRequestBody = {
    /**
     * The names of the files to be imported
     */
    filenames: Array<string>;
};

export type DeviceInventoryImportRequestBody = {
    filename: string;
    trigger_consumers_import?: boolean;
};

export type UserRegisterInventoryItemRequestBody = {
    product_inventory_type?: 'device' | 'sticks' | 'onetime_leaflet' | 'default' | null;
};

export type RegisterInventoryItemRequestBody = {
    purchase_date?: string | null;
    product_inventory_type?: 'device' | 'sticks' | 'onetime_leaflet' | 'default' | null;
    /**
     * Registered CAS customer UUID - required without external_user_id and personal_identifier
     */
    des_user_id?: string;
    /**
     * Registered external customer ID/UUID (Ambassador / Lead) - required without des_user_id and personal_identifier
     */
    external_user_id?: string;
    /**
     * Alternative to provide email for registered users - required without des_user_id and external_user_id
     */
    personal_identifier?: string;
};

export type SetInventoryItemRegistrabilityRequestBody = {
    is_registrable: boolean;
};

export type UnregisterInventoryItemRequestBody = {
    /**
     * Registered CAS customer UUID - required without external_user_id and personal_identifier
     */
    des_user_id?: string;
    /**
     * Registered external customer ID/UUID (Ambassador / Lead) - required without des_user_id and personal_identifier
     */
    external_user_id?: string;
    /**
     * Alternative to provide email for registered users - required without des_user_id and external_user_id
     */
    personal_identifier?: string;
};

export type AttachInventoryItemRequestBody = {
    /**
     * Registered CAS customer UUID
     */
    des_user_id?: string;
};

export type CancelWarrantyRequestBody = {
    reason?: string;
};

export type UpdateWarrantyRequestBody = {
    start_date?: string;
    expiration_date?: string;
    reason?: string;
};

export type CreateOrderActionRequestBody = {
    /**
     * Lead uuid
     */
    uuid?: string | null;
    /**
     * Lead email address
     */
    email?: string | null;
    /**
     * Lead phone number
     */
    phone?: string | null;
    /**
     * Datetime of creation in the external provider
     */
    external_created_at: string;
    /**
     * Whether loyalty points were redeemed for the order
     */
    has_loyalty_points_applied?: boolean;
    source: ActionSourceSchema;
    /**
     * Order action data details
     */
    data: {
        products?: Array<{
            /**
             * Identifier of the product. SKU is looked up using an internal reference table in the Leads domain configuration
             */
            identifier: string;
            /**
             * Optional SAP SKU passed through without transformation
             */
            sap_sku?: string | null;
            /**
             * Serial number of the device
             */
            serial_number?: string;
            /**
             * Quantity used to calculate purchase item quantities. For a quantity of N, pass quantity: N or pass the product N times
             */
            quantity?: number;
            /**
             * Price as a floating point
             */
            price?: number;
            /**
             * Device description
             */
            device_description?: string;
            /**
             * Sale ID
             */
            sale_id?: number;
            /**
             * Trade-in data
             */
            trade_in?: {
                traded_in_model: string;
                traded_in_serial_number?: string;
            };
        }> | null;
        /**
         * Reason for the purchase
         */
        purchase_reason?: string | null;
    };
    tracking?: TrackingSchema;
};

export type UpdateActionRequestBody = {
    /**
     * Action status
     */
    status: 'new' | 'processing' | 'processed' | 'failed';
};

export type CreateDeviceRegistrationActionRequestBody = {
    /**
     * Lead uuid
     */
    uuid?: string | null;
    /**
     * Lead email address
     */
    email?: string | null;
    /**
     * Lead phone number
     */
    phone?: string | null;
    /**
     * External created at
     */
    external_created_at: string;
    source: ActionSourceSchema;
    /**
     * Device registration action data details
     */
    data: {
        /**
         * Serial number of the device, required if device_serial_code is absent.
         */
        serial_number?: string;
        /**
         * Leaflet code of the device, required if serial_number is absent
         */
        device_serial_code?: string;
    };
    tracking?: TrackingSchema;
};

export type CreateActionRequestBody = {
    /**
     * Lead uuid
     */
    uuid?: string | null;
    /**
     * Lead email address
     */
    email?: string | null;
    /**
     * Lead phone number
     */
    phone?: string | null;
    /**
     * Datetime of creation in the external provider
     */
    external_created_at: string;
    source: ActionSourceSchema;
    /**
     * Action type
     */
    type: string;
    /**
     * Whether loyalty points were redeemed for the order
     */
    has_loyalty_points_applied?: boolean;
    /**
     * Action data details
     */
    data: {
        /**
         * Amount as a floating point
         */
        amount?: number | null;
        /**
         * Quantity. This is ignored when the products field is passed
         */
        quantity?: number | null;
        skus?: Array<string> | null;
        /**
         * Serial number
         */
        serial_number?: string | null;
        /**
         * Serial number
         */
        device_serial_code?: string | null;
        /**
         * Magento SKU
         */
        sku?: string | null;
        products?: Array<{
            /**
             * Product identifier
             */
            identifier: string;
            /**
             * Optional SAP SKU passed through without transformation
             */
            sap_sku?: string | null;
            /**
             * Product serial number
             */
            serial_number?: string | null;
            /**
             * Quantity used to calculate purchase item quantities. For a quantity of N, pass quantity: N or pass the product N times
             */
            quantity?: number | null;
            /**
             * Product price as floating point
             */
            price?: number | null;
            /**
             * Trade-in data
             */
            trade_in?: {
                traded_in_model: string;
                traded_in_serial_number?: string;
            };
        }> | null;
        flavors?: Array<{
            /**
             * Product name
             */
            product?: string;
            /**
             * Product identifier, local SKU Code
             */
            identifier?: string;
            /**
             * Order adopted in the tasting activity
             */
            order?: number;
        }> | null;
        /**
         * Reason for the purchase
         */
        purchase_reason?: string | null;
        [key: string]: string | number | null | number | null | Array<string> | null | string | null | string | null | string | null | Array<{
            /**
             * Product identifier
             */
            identifier: string;
            /**
             * Optional SAP SKU passed through without transformation
             */
            sap_sku?: string | null;
            /**
             * Product serial number
             */
            serial_number?: string | null;
            /**
             * Quantity used to calculate purchase item quantities. For a quantity of N, pass quantity: N or pass the product N times
             */
            quantity?: number | null;
            /**
             * Product price as floating point
             */
            price?: number | null;
            /**
             * Trade-in data
             */
            trade_in?: {
                traded_in_model: string;
                traded_in_serial_number?: string;
            };
        }> | null | Array<{
            /**
             * Product name
             */
            product?: string;
            /**
             * Product identifier, local SKU Code
             */
            identifier?: string;
            /**
             * Order adopted in the tasting activity
             */
            order?: number;
        }> | null | string | null | undefined;
    };
    tracking?: TrackingSchema;
};

export type CreateLeadRequestBody = {
    address?: LeadAddressSchema;
    /**
     * Brand
     */
    brand?: string | null;
    /**
     * Consents status
     */
    consents?: Array<{
        /**
         * Consent group type
         */
        type: string;
        /**
         * Consent group is accepted or not
         */
        accepted: boolean;
    }> | null;
    /**
     * Whether to convert the lead. If this is omitted, the tenant's configured value will be used.
     */
    convert_lead?: boolean | null;
    /**
     * Date of birth
     */
    date_of_birth?: string | null;
    /**
     * Email address
     */
    email: string;
    /**
     * The limit is maximum 50 items/properties inside this object
     */
    extra_profile_information?: {
        /**
         * Language
         */
        language?: string;
        [key: string]: string | undefined;
    } | null;
    /**
     * First name
     */
    first_name?: string | null;
    /**
     * Gender
     */
    gender?: 'male' | 'female' | 'prefer_not_to_say' | null;
    /**
     * Is age verified
     */
    is_age_verified: boolean;
    /**
     * Last name
     */
    last_name: string;
    /**
     * Notification channel
     */
    notification_channel?: 'email' | 'sms' | null;
    /**
     * The opt-in strategy. If this is omitted, the tenant's configured value will be used.
     */
    opt_in_strategy?: 'single-opt-in' | 'double-opt-in-email' | 'double-opt-in-webhook' | 'from-consumer' | null;
    /**
     * Phone number
     */
    phone?: string | null;
    /**
     * Referral code
     */
    referral_code?: string | null;
    source: LeadSourceSchema;
    tracking?: TrackingSchema;
};

export type UpdateLeadRequestBody = {
    address?: LeadAddressSchema;
    /**
     * Brand
     */
    brand?: string | null;
    /**
     * Consents status
     */
    consents?: Array<{
        /**
         * Consent group type
         */
        type: string;
        /**
         * Consent group is accepted or not
         */
        accepted: boolean;
    }> | null;
    /**
     * Whether to convert the lead. If this is omitted, the tenant's configured value will be used.
     */
    convert_lead?: boolean | null;
    /**
     * Date of birth
     */
    date_of_birth?: string | null;
    /**
     * Email address
     */
    email?: string;
    /**
     * The limit is maximum 50 items/properties inside this object
     */
    extra_profile_information?: {
        /**
         * Language
         */
        language?: string;
        [key: string]: string | undefined;
    } | null;
    /**
     * First name
     */
    first_name?: string | null;
    /**
     * Gender
     */
    gender?: 'male' | 'female' | 'prefer_not_to_say' | null;
    /**
     * Is age verified
     */
    is_age_verified?: boolean;
    /**
     * Last name
     */
    last_name?: string;
    /**
     * Notification channel
     */
    notification_channel?: 'email' | 'sms' | null;
    /**
     * Phone number
     */
    phone?: string | null;
    /**
     * Referral code
     */
    referral_code?: string | null;
    tracking?: TrackingSchema;
};

export type InvalidateTranslationCacheRequestBody = {
    tenant_code: string;
    iso_code: string;
};

export type UpdateReadRequestBody = {
    /**
     * Article ID
     */
    article_id: string;
};

export type VideoWatchedRequestBody = {
    /**
     * Internal video ID used in configuration
     */
    video_id: string;
};

export type GetQrCodeReadRequestBody = {
    /**
     * Article ID
     */
    qr_code_id: string;
};

export type QuizCompletedRequestBody = {
    /**
     * Internal quiz ID used in configuration
     */
    quiz_id: string;
};

export type CreateContestRequestBody = {
    contest_id: string;
    contest: Array<{
        question?: string;
        answers?: Array<string>;
    }>;
    /**
     * An array of files related to the contest submission. If using x-www-form-urlencoded, these might be expected as base64 encoded strings.
     */
    files?: Array<Blob | File> | null;
};

export type TransferCreatedWebhookRequestBody = {
    /**
     * Unique identifier for each webhook
     */
    messageId: string;
    /**
     * OL store code
     */
    storeCode: string;
    /**
     * Date of event creation
     */
    createdAt: string;
    data: {
        actionCause?: {
            /**
             * Transaction id
             */
            transactionId?: string | null;
        } | null;
        member: {
            /**
             * Customer OL uuid
             */
            customerId: string;
            /**
             * Customer OL email
             */
            email: string;
        };
        /**
         * Is transfer pending
         */
        pending: boolean;
        /**
         * Transfer id
         */
        transferId: string;
        /**
         * Units
         */
        units: number;
    };
};

export type TriggerAddingConsumerPointsRequestBody = {
    /**
     * Type of triggering method
     */
    type: 'survey' | 'event';
    data: SurveyRequestBodySchema | EventRequestBodySchema;
};

export type TransferConsumerPointsRequestBody = TransferRequestBodySchema;

export type PointsChangedWebhookRequestBody = {
    /**
     * Unique identifier for each webhook
     */
    messageId: string;
    /**
     * Webhook event name
     */
    eventName: string;
    /**
     * Open Loyalty Store Code
     */
    storeCode: string;
    /**
     * Date of event creation
     */
    createdAt?: string;
    data: {
        /**
         * Points amount
         */
        amount: number;
        customer: {
            /**
             * Customer OL uuid
             */
            customerId: string;
        };
        /**
         * Transfer id
         */
        transferId: string;
    };
};

export type InitializeBulkEventsRequestBody = {
    /**
     * Consumer UUIDs
     */
    uuids: Array<string>;
    /**
     * Event type
     */
    event_type: string;
    multiplier?: number;
};

export type UpdateRewardRedemptionStatusChangedWebhookRequestBody = {
    /**
     * Unique identifier for each webhook
     */
    messageId: string;
    /**
     * Open Loyalty Store Code
     */
    storeCode: string;
    /**
     * Date of event creation
     */
    createdAt: string;
    data: {
        issuedReward: {
            /**
             * Code
             */
            issuedRewardId: string;
            /**
             * Coupon status
             */
            rewardId: string;
            /**
             * Reward name
             */
            name: string;
            /**
             * OL member id
             */
            customerId: string;
            /**
             * Price of the reward
             */
            price?: number | null;
            /**
             * Redemption date
             */
            redemptionDate?: string | null;
            /**
             * Cost in points
             */
            costInPoints?: number | null;
            issuedCoupon: {
                /**
                 * Coupon code
                 */
                code: string;
                /**
                 * Coupon value
                 */
                value?: number | null;
                /**
                 * Active from
                 */
                activeFrom?: string | null;
                /**
                 * Active to
                 */
                activeTo?: string | null;
            };
        };
        /**
         * Old status of the reward redemption
         */
        oldStatus: string;
        /**
         * New status of the reward redemption
         */
        newStatus: string;
        /**
         * Old comment for the reward redemption
         */
        oldComment?: string | null;
        /**
         * New comment for the reward redemption
         */
        newComment?: string | null;
    };
};

export type CreateRewardRedeemedWebhookRequestBody = {
    /**
     * Unique identifier for each webhook
     */
    messageId: string;
    /**
     * OL store code
     */
    storeCode: string;
    /**
     * Date of event creation
     */
    createdAt: string;
    data: {
        coupon: {
            /**
             * Code
             */
            code: string;
            /**
             * Coupon status
             */
            status: string;
            /**
             * Active from
             */
            activeFrom?: string | null;
            /**
             * Active to
             */
            activeTo?: string | null;
            /**
             * Used at
             */
            usedAt?: string | null;
            /**
             * Coupon value
             */
            value?: number | null;
        };
        customer: {
            /**
             * OL member id
             */
            customerId: string;
        };
        reward: {
            /**
             * OL reward id
             */
            rewardId: string;
            /**
             * Reward name
             */
            rewardName: string;
        };
        rewardRedemption: {
            /**
             * Redeemed reward id
             */
            redeemedRewardId: string;
        };
    };
};

export type DeleteRewardWebhookRequestBody = {
    /**
     * Unique identifier for each webhook
     */
    messageId: string;
    /**
     * Open Loyalty Store Code
     */
    storeCode: string;
    /**
     * Date of event creation
     */
    createdAt: string;
    data: {
        reward: {
            /**
             * OL reward id
             */
            rewardId: string;
        };
    };
};

export type UpdateRewardRedemptionsStatusRequestBody = {
    /**
     * Redemption UUIDs
     */
    redemptionUuids: Array<string>;
    /**
     * New status
     */
    status: string;
};

export type GetBuyPrizeRequestBody = {
    reward_uuid: string;
    /**
     * Quantity
     */
    qty?: number;
    address?: DeliveryAddress;
};

export type GetRedeemRewardRequestBody = {
    reward_uuid: string;
};

export type EligibleRewardRequestBody = EligibleRewardRequestBodySchema;

export type CreateUpdateRewardWebhookRequestBody = {
    /**
     * Unique identifier for each webhook
     */
    messageId: string;
    /**
     * Open Loyalty Store Code
     */
    storeCode: string;
    /**
     * Date of event creation
     */
    createdAt: string;
    data: {
        reward: {
            /**
             * OL reward id
             */
            rewardId: string;
            /**
             * Reward name
             */
            name: string;
            /**
             * Cost in points
             */
            costInPoints?: number;
            /**
             * Price value
             */
            price?: number | null;
            /**
             * Coupon value
             */
            couponValue?: number | null;
            /**
             * Whether reward is active
             */
            active?: boolean;
            activity?: {
                /**
                 * Always active
                 */
                allTime?: boolean;
                /**
                 * Active from date
                 */
                from?: string | null;
                /**
                 * Active to date
                 */
                to?: string | null;
            };
            visibility?: {
                /**
                 * Always visible
                 */
                allTime?: boolean;
                /**
                 * Visible from date
                 */
                from?: string | null;
                /**
                 * Visible to date
                 */
                to?: string | null;
            };
            /**
             * Category names
             */
            categoryNames?: Array<string>;
            /**
             * Level/tier names
             */
            levelNames?: Array<string> | null;
            /**
             * Reward labels
             */
            labels?: Array<{
                key?: string;
                value?: string;
            }> | null;
            /**
             * Photo URLs
             */
            photos?: Array<string> | null;
            /**
             * Short description
             */
            shortDescription?: string | null;
            /**
             * Brand name
             */
            brandName?: string | null;
            /**
             * Usage instruction
             */
            usageInstruction?: string | null;
            /**
             * Usage limit configuration
             */
            usageLimit?: {
                [key: string]: unknown;
            } | null;
            /**
             * Days valid after redemption
             */
            daysValid?: number | null;
            /**
             * Fixed validity date
             */
            dateValid?: string | null;
            /**
             * Coupon generator configuration
             */
            couponGenerator?: {
                [key: string]: unknown;
            } | null;
            /**
             * Custom fields keyed by custom field group and field key
             */
            customFields?: {
                [key: string]: {
                    [key: string]: Array<string>;
                };
            } | null;
            /**
             * Reward creation date in OL
             */
            createdAt?: string;
        };
    };
};

export type IncreaseRewardCouponsRequestBody = {
    coupons: Array<string>;
};

export type ConsumerSurveyStartedRequestBody = {
    /**
     * Serial number of device or pack to register
     */
    serial_code: string;
    /**
     * External identifier of real survey, eg. SurveyMonkey ID or URL
     */
    external_survey_id?: string;
};

export type UpdateLevelChangedWebhookRequestBody = {
    /**
     * Unique identifier for each webhook
     */
    messageId: string;
    /**
     * Webhook event name
     */
    eventName?: string;
    /**
     * Open Loyalty Store Code
     */
    storeCode: string;
    /**
     * Date of event creation
     */
    createdAt: string;
    data: {
        customer: {
            /**
             * Customer Open Loyalty uuid
             */
            customerId: string;
        };
        level: {
            /**
             * Customer new level id
             */
            levelId: string;
            /**
             * Customer level name
             */
            name: string;
        };
    };
};

export type FormMessageRequestBody = {
    /**
     * Channel code
     */
    channel?: string | null;
    /**
     * Template type
     */
    type: string;
    user?: {
        /**
         * User full name
         */
        name?: string;
        /**
         * Recipient email or phone or any channel related to final messaging provider
         */
        channel?: string;
    } | null;
    /**
     * Message payload to use in final messaging provider
     */
    payload: {
        [key: string]: unknown;
    };
    /**
     * Provider code
     */
    provider?: 'PIPEDREAM' | 'HTTP_SENDER' | 'CM' | 'SENDGRID' | 'ADOBE_CAMPAIGN' | 'ADOBE_CAMPAIGN_SMS' | 'ADOBE_CAMPAIGN_CLASSIC_SMS' | 'KAKAO_TALK' | 'TWILIO' | 'WHATSAPP' | 'CM_VIBER' | 'FIREBASE';
    /**
     * Specific data subject for consent provider
     */
    data_subject?: string;
    /**
     * Collection point token to process consent
     */
    collection_point_token?: string;
    /**
     * One or more consent purposes delimited by comma
     */
    consent_purposes?: string;
};

export type EventMessageRequestBody = {
    /**
     * Channel code
     */
    channel: string;
    /**
     * Template type
     */
    type: string;
    /**
     * Campaign ID to use for this message
     */
    campaign_id?: string;
    user: {
        /**
         * User full name
         */
        name?: string;
        /**
         * Recipient email or phone or any channel related to final messaging provider
         */
        channel?: string;
    };
    /**
     * Message payload to use in final messaging provider
     */
    payload: {
        [key: string]: unknown;
    };
    /**
     * Provider code
     */
    provider?: 'PIPEDREAM' | 'HTTP_SENDER' | 'CM' | 'SENDGRID' | 'ADOBE_CAMPAIGN' | 'ADOBE_CAMPAIGN_SMS' | 'ADOBE_CAMPAIGN_CLASSIC_SMS' | 'KAKAO_TALK' | 'TWILIO' | 'WHATSAPP' | 'CM_VIBER' | 'FIREBASE';
};

export type UpdateCmStatusWebhookRequestBody = {
    messages?: {
        msg?: {
            status: {
                code: string;
            };
            reference: string;
        };
    };
};

export type MarketingCommunicationRequest = MarketingCommunicationInputFields;

export type UpdatePreferredLanguageOfMarketingCommunicationRequestBody = PreferredLanguageFields;

export type UpdateEmailOfMarketingCommunicationRequest = EmailFields;

export type SendPushNotificationRequestBody = {
    payload: SendPushNotificationFields;
    /**
     * Time to live in seconds. After this time, the notification will not be delivered if the device is offline.
     */
    ttl?: number | null;
};

export type SubscribeRequest = SubscribePushNotificationFields;

export type UnsubscribeRequestBody = {
    /**
     * System identifier
     */
    system: string;
    /**
     * System user identifier
     */
    system_user: string;
    /**
     * Reason for unsubscribing
     */
    reason?: string | null;
};

export type CreateDeliveryEventRequestBody = {
    /**
     * Unique reference of the sent push notification, embedded in the notification payload
     */
    reference: string;
    /**
     * Type of the delivery event (e.g. received, opened, clicked)
     */
    event_type: string;
    /**
     * Optional raw provider response payload
     */
    raw_payload?: {
        [key: string]: unknown;
    } | null;
};

export type LocalTemplateRequest = {
    /**
     * Template contents
     */
    body?: string;
};

export type OfflineCampaignRequestBody = OfflineCampaign;

export type OfflineCampaignCouponRequestBody = OfflineCampaignCouponRequest;

export type ImportOfflineCampaignCouponsRequestBody = {
    /**
     * The coupons' codes' format.
     */
    format?: 'EAN8' | 'EAN13' | 'Code128';
    codes?: Array<string>;
};

export type UpdateBurnOfflineCampaignCouponWebhookRequestBody = {
    meta?: {
        /**
         * Must be "burnOfflineCampaignCoupon".
         */
        event_type: string;
        /**
         * Tenant which to address with this webhook
         */
        tenant_code: string;
    };
    data?: {
        /**
         * The type of event triggering the burning
         */
        event: string;
        /**
         * The webhook origin's source identifier
         */
        source_id: string;
        /**
         * The user's UUID for whom this coupon was burned
         */
        user_uuid: string;
    };
};

export type RegisterCasConsumerWebhookRequestBody = {
    meta?: {
        /**
         * Must be "burnOfflineCampaignCoupon".
         */
        event_type: string;
        /**
         * Tenant which to address with this webhook
         */
        tenant_code: string;
    };
    data?: {
        /**
         * The consumer's UUID for whom this coupon was burned
         */
        uuid: string;
        /**
         * The consumer's email address
         */
        email: string;
        /**
         * The consumer's first name
         */
        first_name: string;
        custom_attributes?: {
            preferredLanguage?: string;
            language?: string;
        } | null;
        source?: {
            source_id?: string;
        } | null;
    };
};

export type ImportProductRequestBody = ImportProductSchema;

/**
 * Collection of events from Trustpilot
 */
export type EventRequestBody = {
    events?: Array<{
        eventName?: string;
        eventData?: {
            id?: string;
            /**
             * Required unless eventName is service-review-deleted or product-review-deleted
             */
            consumer?: {
                name?: string;
            };
        };
    }>;
};

export type AssignWorkgroupRequestBody = {
    /**
     * SurveyMonkey external workgroup identifier to assign to the current tenant
     */
    external_workgroup_id: string;
};

export type SurveyMonkeyWebhookRequestBody = {
    /**
     * Webhook name
     */
    name: string;
    /**
     * Filter type for the webhook
     */
    filter_type: string;
    /**
     * Type of event that triggered the webhook
     */
    event_type: string;
    /**
     * Unique event identifier
     */
    event_id: string;
    /**
     * Type of the object
     */
    object_type: string;
    /**
     * Identifier of the object (response ID, collector ID, etc.)
     */
    object_id: string;
    resources?: {
        /**
         * Associated survey identifier
         */
        survey_id?: string;
    };
};

export type BackfillSurveyResponsesRequestBody = {
    /**
     * External SurveyMonkey survey identifier
     */
    survey_id: string;
    /**
     * Optional: filter responses modified after this timestamp (ISO 8601 UTC, e.g., 2024-01-01T00:00:00Z)
     */
    started_at?: string | null;
    /**
     * Optional: filter responses modified before this timestamp (ISO 8601 UTC). Must be used with started_at and >= started_at.
     */
    ended_at?: string | null;
    /**
     * Optional: array of specific response IDs to backfill. If not provided, all responses matching date range will be fetched.
     */
    response_ids?: Array<string> | null;
};

export type FetchSurveyResponsesRequestBody = {
    /**
     * External SurveyMonkey survey identifier
     */
    survey_id: string;
    /**
     * Fetch responses created at or after this timestamp (ISO 8601 UTC, e.g., 2024-01-01T00:00:00Z)
     */
    created_from: string;
    /**
     * Fetch responses created at or before this timestamp (ISO 8601 UTC). Must be >= created_from.
     */
    created_until: string;
};

export type TenantUpdateContactPersonRequestBody = {
    /**
     * Name or email of the person responsible for this tenant. Automatically filled if not specified.
     */
    contact_person?: string;
};

export type TenantUpdateRequestBody = TenantUpdateFields;

export type TenantUpdateSemVersionRequestBody = {
    /**
     * Tenant sem_version to update
     */
    sem_version: string;
    /**
     * Flag to determine if tenant should be migrated and des version updated
     */
    update_tenant_version: boolean;
};

export type CreateTenantRequestBody = TenantCreateFields;

export type ImportTenantRequestBody = ImportTenantFields;

export type CreateConfigurationItem = {
    type?: string;
    options?: {
        [key: string]: unknown;
    };
};

export type UpdateConfigurationItem = {
    options?: {
        [key: string]: unknown;
    };
    change_reason?: string | null;
};

export type BulkUpsertConfigurationItems = {
    items: Array<ConfigurationItem>;
};

export type ConfigurationBody = {
    name?: string;
};

export type DeactivateConsumerRequestBody = {
    /**
     * Consumer deactivation reason
     */
    reason?: string | null;
    /**
     * Consumer deactivation duration in seconds
     */
    duration?: number | null;
};

export type AnonymizeConsumersRequest = {
    /**
     * Array of consumer UUIDs to anonymize
     */
    data: Array<string>;
};

export type MarkConsumersAsExternalAgeVerifiedRequest = {
    /**
     * Array of consumer emails to mark as external age-verified
     */
    emails: Array<string>;
};

export type ProcessAnonymizedCdpProfilesRequestBody = {
    data?: Array<{
        id?: string;
        cas_uuid?: string | null;
        email?: string | null;
        id_profile_legacy?: string | null;
        legacy_system?: string | null;
        anonymization_date?: string;
        keep_anonymizing_until?: string | null;
        status_code?: string;
        status_message?: string | null;
    }>;
    dataVersion?: number;
    eventTime?: string;
    eventType?: string;
    id?: string;
    metadataVersion?: number;
    subject?: string;
    topic?: string;
};

export type ProcessDataSubjectAccessRequestRequestBody = {
    first_name: string;
    last_name: string;
    email: string;
    language: string;
    market?: string | null;
    country?: string | null;
    request_types: Array<string>;
    additional_data?: {
        requestDetails?: string;
        [key: string]: string | string | undefined;
    };
};

export type ActivateConsumerRequestBody = {
    /**
     * Consumer activation reason
     */
    reason?: string | null;
};

export type ChangePassword = {
    /**
     * User current password
     */
    current_password: string;
    /**
     * User new password
     */
    new_password: string;
    /**
     * User new password
     */
    new_password_confirmation: string;
};

export type CreateBulkOneTimeLimitedToken = {
    /**
     * List of consumer UUIDs to create tokens for. Invalid UUIDs are silently ignored. Maximum 10000 entries (configurable).
     */
    uuids: Array<string>;
    /**
     * List of scopes to be issued for each token
     */
    scopes?: Array<string> | null;
    /**
     * When set to true, only one authentication session can be created per token
     */
    single_use?: boolean;
    /**
     * Token expiration time in minutes. When expired, won't be possible to create another authentication session
     */
    expires_in?: number;
};

export type ValidateSession = {
    /**
     * Personal access token
     */
    token?: string;
};

export type CreateOneTimeLimitedToken = {
    /**
     * List of scopes the token will work for
     */
    scopes?: Array<string> | null;
    /**
     * When set to true, only one authentication session can be created for the token
     */
    single_use?: boolean;
    /**
     * One time limited token expiration time in minutes. When expired, won't be possible to create another authentication session
     */
    expires_in?: number;
};

export type SetPassword = {
    /**
     * User new password
     */
    password: string;
    /**
     * User new password
     */
    password_confirmation: string;
    consents?: Array<{
        /**
         * Consent uuid
         */
        id?: string;
        /**
         * Consent accepted or not
         */
        accepted?: boolean;
        /**
         * Whether marked as one time consent to receive marketing communications
         */
        one_off?: boolean;
    }>;
};

export type Authentication = {
    strategy?: 'email-credential' | 'kakao-credential' | 'facebook-credential' | 'google-credential' | 'phone-number-credential' | 'magento-credential' | 'magento-to-email-credential' | 'one-time-limited-token';
    strategy_data?: EmailCredentialStrategySchema | FacebookCredentialStrategySchema | GoogleCredentialStrategySchema | KakaoCredentialStrategySchema;
    /**
     * The desired session TTL (time to live) in seconds. Optional, defaults to 2592000 (30 days) if omitted.
     */
    session_ttl?: number;
};

export type KakaoUnlinkCallback = {
    app_id: number;
    user_id: number;
    referrer_type: 'ACCOUNT_DELETE' | 'FORCED_ACCOUNT_DELETE' | 'UNLINK_FROM_APPS' | 'UNLINK_FROM_ADMIN' | 'INCOMPLETE_SIGN_UP';
};

export type ForgotPassword = {
    /**
     * User email address
     */
    email: string;
};

export type InitializeAuthentication = {
    strategy?: 'email-credential' | 'kakao-credential' | 'facebook-credential' | 'google-credential' | 'phone-number-credential' | 'magento-credential' | 'magento-to-email-credential' | 'one-time-limited-token';
    strategy_data?: {
        /**
         * Channel of action verification
         */
        channel: 'email' | 'sms' | 'whatsapp' | 'viber';
        /**
         * Identifier of action verification (phone number or email address)
         */
        identifier: string;
        /**
         * Template to use for the action verification message
         */
        template?: string | null;
    };
};

export type UpdateCustomAttribute = {
    /**
     * Custom attribute value
     */
    value?: string;
};

export type UpdateCustomAttributes = {
    /**
     * Consumer language
     */
    language?: string;
    /**
     * Consumer language
     */
    preferredLanguage?: string;
    consents?: Array<{
        /**
         * Consent uuid
         */
        id?: string;
        /**
         * Consent accepted or not
         */
        accepted?: boolean;
        /**
         * Whether marked as one time consent to receive marketing communications
         */
        one_off?: boolean;
    }>;
    [key: string]: string | null | string | Array<{
        /**
         * Consent uuid
         */
        id?: string;
        /**
         * Consent accepted or not
         */
        accepted?: boolean;
        /**
         * Whether marked as one time consent to receive marketing communications
         */
        one_off?: boolean;
    }> | undefined;
};

export type UpdateFullProfileRequestBody = {
    first_name?: string | null;
    last_name?: string;
    phone?: string | null;
    email?: string;
    /**
     * Consumer birthday
     */
    date_of_birth?: string;
    gender?: 'male' | 'female' | 'prefer_not_to_say' | null;
    /**
     * Datetime of creation of the consumer. Format: Y-m-d H:i:s.
     */
    created_at?: string;
};

export type AddressBody = {
    /**
     * First name
     */
    first_name?: string | null;
    /**
     * Last name
     */
    last_name: string;
    /**
     * Street and numbers
     */
    street: Array<string>;
    /**
     * City
     */
    city: string;
    region?: RegionSchema;
    /**
     * Postal code
     */
    post_code?: string | null;
    /**
     * Country code
     */
    country_code: string;
    /**
     * Phone number
     */
    phone?: string | null;
    /**
     * Address is default for shipping
     */
    default_shipping?: boolean;
    /**
     * Address is default for billing
     */
    default_billing?: boolean;
    /**
     * Second-order civil entity below the country level
     */
    administrative_area_level_2?: string | null;
    /**
     * Second-order civil entity below a locality
     */
    sublocality_level_2?: string | null;
    /**
     * Neighborhood/Area
     */
    neighborhood?: string | null;
    /**
     * Building name
     */
    premise?: string | null;
    /**
     * Landmark & special instructions
     */
    landmark?: string | null;
    /**
     * District
     */
    district?: string | null;
    /**
     * Building number
     */
    building_number?: string | null;
    /**
     * Short address
     */
    short_address?: string | null;
};

export type UpdateProfileRequestBody = {
    /**
     * Consumer birthday
     */
    date_of_birth: string;
    /**
     * Required without last_name. Nullable or optional when configured.
     */
    first_name?: string | null;
    gender?: 'male' | 'female' | 'prefer_not_to_say' | null;
    /**
     * Required without first_name.
     */
    last_name: string;
};

export type Address = Array<{
    /**
     * Address id
     */
    id: number;
    /**
     * First name
     */
    firstname: string | null;
    /**
     * Last name
     */
    lastname: string;
    /**
     * Street and numbers
     */
    street: Array<string>;
    /**
     * City
     */
    city: string;
    region?: RegionSchema;
    /**
     * Postal code
     */
    postcode: string | null;
    /**
     * Country code
     */
    country_id: string;
    /**
     * Phone number
     */
    telephone: string;
    /**
     * Address is default for shipping
     */
    default_shipping?: boolean;
    /**
     * Address is default for billing
     */
    default_billing?: boolean;
    /**
     * Address custom attributes
     */
    custom_attributes?: Array<{
        /**
         * Attribute code
         */
        attribute_code?: string;
        /**
         * Attribute value
         */
        value?: string;
    }>;
    /**
     * Extension attributes from Magento
     */
    extension_attributes: {
        /**
         * Indicates whether address is subscription address
         */
        subscription: boolean;
    };
}>;

export type VerifyAgeBody = {
    /**
     * Age verification UUID
     */
    age_verification_uuid: string;
};

export type ChangeEmailRequestBody = {
    /**
     * Update email request UUID
     */
    uuid?: string;
};

export type DeprecatedUpdateConsents = {
    /**
     * The collection of all consents
     */
    consents?: Array<{
        /**
         * The consent's purpose UUID (as in OneTrust)
         */
        id: string;
        /**
         * Whether the consent was accepted.
         */
        accepted: boolean;
        /**
         * Whether the consent marked as one time consent to receive marketing communications.
         */
        one_off?: boolean;
    }>;
};

export type UpdateEmailRequestBody = {
    email?: string;
};

export type ChangePhoneRequestBody = {
    phone: string;
    /**
     * Action verification item UUID
     */
    action_verification_uuid?: string | null;
    /**
     * Age verification UUID
     */
    age_verification_uuid?: string | null;
};

export type AssignReferrerRequestBody = {
    /**
     * Parent referrer code to assign. When the tenant has the phone-alias feature enabled, the referrer's phone number (E.164 or local format) is also accepted in this same field and resolved to their referral code.
     */
    referrer_code: string;
    /**
     * Referral code source
     */
    source?: 'registration' | 'cart' | 'checkout' | 'account_dashboard' | null;
};

export type Registration = {
    email?: string;
    phone?: string;
    first_name?: string;
    last_name?: string;
    date_of_birth?: string;
    gender?: 'male' | 'female' | 'prefer_not_to_say' | null;
    custom_attributes?: {
        [key: string]: unknown;
    };
    /**
     * Referrer's referral code. When the tenant has the phone-alias feature enabled, the referrer's phone number (E.164 or local format) is also accepted in this same field and resolved to their referral code.
     */
    referral_code?: string;
    strategy?: 'email-credential' | 'kakao-credential' | 'facebook-credential' | 'google-credential';
    strategy_data?: RegistrationEmailCredentialStrategySchema | RegistrationKakaoCredentialStrategySchema | FacebookCredentialStrategySchema | GoogleCredentialStrategySchema;
    /**
     * The UUID obtained from the age verification process. The email addresses of the AV item and consumer data must match.
     */
    age_verification_uuid?: string;
    source?: {
        channel?: string;
        source_type: string;
        source_id: string;
        representative_id: string;
        timestamp?: string;
        /**
         * The calculated sha256 hmac hash of the lexically key-sorted fields of the object in JSON format. Note that the secret needs to be configured in the tenant configuration.
         */
        hash?: string;
    };
    /**
     * The keys for this object must refer to the action verification channel (e.g. "email" or "sms").
     */
    verified_action_uuids?: {
        [key: string]: string;
    };
    consents?: Array<{
        id?: string;
        accepted?: boolean;
        one_off?: boolean;
    }>;
    tracking?: TrackingSchema;
    /**
     * Unique inventory item identifier
     */
    device_code?: string | null;
};

export type InitializeRegistration = {
    /**
     * Channel of action verification
     */
    channel: 'email' | 'sms' | 'whatsapp' | 'viber';
    /**
     * Identifier of action verification (phone number or email address)
     */
    identifier: string;
    /**
     * Template to use for the action verification message
     */
    template?: string | null;
};

export type GenerateWalletPass = {
    type: 'apple' | 'google';
};

export type VerifyEmailResponse = {
    data: EmailValidation;
};

export type ValidationError = {
    error_code: string;
    attributes?: {
        [key: string]: unknown;
    };
    message?: string;
    errors?: {
        [key: string]: unknown;
    };
};

export type ErrorCodesList = {
    data: Array<{
        /**
         * Error Code
         */
        code?: string;
        /**
         * Optional message that is associated with the error code.
         */
        message?: string | null;
    }>;
};

export type NotFoundError = {
    errors?: {
        [key: string]: unknown;
    };
    error_code: string;
};

export type TooManyAttemptsError = {
    errors?: {
        [key: string]: unknown;
    };
};

export type ErrorForbidden = {
    message?: string;
    error_code?: string;
};

export type VerifyPhoneResponse = {
    data: PhoneValidation;
};

export type SuccessMessage = {
    message: string;
};

export type ErrorBadRequest = {
    message?: string;
    error_code: string;
};

export type CommonError = {
    message?: string;
    error_code: string;
    errors?: {
        [key: string]: unknown;
    };
};

export type PermissionError = {
    message?: string;
    error_code?: string;
};

export type AnonymizedProfileResponse = AnonymizedProfileSchema;

export type ListAnonymizationsResponse = {
    data?: Array<AnonymizationSchema>;
    meta?: PaginationMetaFields;
};

export type ListRolesResponse = {
    data?: Array<Role>;
    meta?: PaginationMetaFields;
};

export type RoleResponse = Role;

export type ListPermissionsResponse = {
    data?: Array<PermissionFields>;
};

export type EntraCallbackResponse = {
    token_type: string;
    expires_in: number;
    ext_expires_in: number;
    access_token: string;
    scope: string;
    token_header: {
        [key: string]: unknown;
    };
    token_payload: {
        [key: string]: unknown;
    };
};

export type GenerateS2sTokenResponse = {
    token_type?: string;
    expires_in?: number;
    access_token?: string;
    scope?: string;
};

export type PublicPlatformConfigurationListResponse = Array<PublicPlatformConfiguration>;

export type ListPlatformConfigurationResponse = {
    data?: Array<PlatformConfigurationExtended>;
    meta?: PaginationMetaFields;
};

export type PlatformConfigurationResponse = {
    /**
     * Message
     */
    message?: string;
    data?: PlatformConfigurationExtended;
};

export type SyncConsumerToCdpResponse = {
    data: {
        consumer_synced: boolean;
        lead_synced: boolean;
        actions_synced: number;
        quizzes_synced: number;
        marketing_communication_synced: boolean;
    };
};

export type CreateEntraApplicationResponse = CreateEntraApplication;

export type ActionVerificationCodeResponse = {
    code: string;
};

export type ScenarioValidationResponse = {
    data: {
        success: boolean;
        errors: Array<{
            scenario?: string | null;
            step: string;
            message: string;
            line: number;
        } | null>;
    };
};

export type ListIntegrationTestResultResponse = {
    data: Array<IntegrationTestResultsFields>;
    meta: PaginationMetaFields;
};

export type GetIntegrationTestResultSummaryResponse = {
    /**
     * Summary results keyed by tenant code
     */
    data: {
        [key: string]: {
            /**
             * Aggregated tenant status
             */
            status: 'to_run' | 'passed' | 'failed' | 'fail_reported' | 'in_progress';
            /**
             * Number of passed tests for the tenant
             */
            passed: number;
            /**
             * Total number of tests for the tenant
             */
            total: number;
            /**
             * Feature results keyed by feature code (e.g. F.01, F.02)
             */
            features: {
                [key: string]: {
                    /**
                     * Aggregated feature status
                     */
                    status: 'to_run' | 'passed' | 'failed' | 'fail_reported' | 'in_progress';
                    /**
                     * Number of passed tests in the feature
                     */
                    passed: number;
                    /**
                     * Total number of tests in the feature
                     */
                    total: number;
                };
            };
        };
    };
};

export type UpdateIntegrationTestResultResponse = {
    data: Array<IntegrationTestResultsFields>;
};

export type GetScenarioCodesResponse = {
    /**
     * Scenario codes grouped by feature code
     */
    data: {
        [key: string]: Array<string>;
    };
};

export type AgeVerificationUuidResponse = {
    data: {
        uuid: string;
    };
};

export type ScenarioValidationBadRequestResponse = {
    message?: string;
};

export type OktaCallbackResponse = {
    token_type?: string;
    expires_in?: number;
    access_token?: string;
    scope?: string;
};

export type MigrateOktaApplicationToEntraResponse = MigrateOktaApplicationToEntra;

export type GetTenantMappingsByServiceResponse = Array<TenantMappingSchema>;

export type UpdateSingleTenantMappingResponse = {
    tenant_token: string;
    tenant_code: string | null;
    options?: {
        /**
         * The purpose_id that, when specified, should be rewritten to the legitimate interest marketing communication category. Note that this can also be achieved by using the purpose_to_category_mapping option.
         */
        legitimate_interest_consent_id?: string;
        /**
         * A map of purpose_ids from OT to the marketing communication category in EVO
         */
        purpose_to_category_mapping?: {
            [key: string]: string;
        };
        /**
         * Whether to convert the lead
         */
        convert_lead?: boolean;
        /**
         * The opt-in strategy to use for the tenant
         */
        opt_in_strategy?: string;
        /**
         * The phone country code to use for the tenant
         */
        phone_country_code?: string;
    };
};

export type ListTenantMappingsResponse = {
    [key: string]: Array<TenantMappingSchema>;
};

export type GetTenantMappingByAccessTokenResponse = AccessTokenBasedTenantMappingSchema;

export type GetTenantMappingByTenantCodeResponse = TenantCodeBasedTenantMappingSchema;

export type GetTenantMappingsByServiceForAccessTokenResponse = TenantMappingSchema;

export type ListShortUrlResponse = {
    data?: Array<ShortUrl>;
    meta?: PaginationMetaFields;
};

export type CreateBulkShortUrlFailedResponse = {
    /**
     * Message
     */
    message: string;
    /**
     * Created short URLs
     */
    data: Array<ShortUrl>;
    /**
     * Per-item creation failures
     */
    errors: Array<{
        /**
         * Zero-based index of the failed input item
         */
        index: number;
        /**
         * Failure code
         */
        error_code: string;
        /**
         * Failure message
         */
        message: string;
    }>;
};

export type CreateBulkShortUrlPartialResponse = {
    /**
     * Message
     */
    message: string;
    /**
     * Created short URLs
     */
    data: Array<ShortUrl>;
    /**
     * Per-item creation failures
     */
    errors: Array<{
        /**
         * Zero-based index of the failed input item
         */
        index: number;
        /**
         * Failure code
         */
        error_code: string;
        /**
         * Failure message
         */
        message: string;
    }>;
};

export type ShortUrlResponse = ShortUrl;

export type CreateBulkShortUrlResponse = {
    /**
     * Message
     */
    message: string;
    /**
     * Created short URLs
     */
    data: Array<ShortUrl>;
};

export type IngestClicksResponse = {
    /**
     * Message
     */
    message: string;
    data: {
        /**
         * Number of stored click events
         */
        stored: number;
    };
};

export type ListClicksResponse = {
    data?: Array<ShortUrlClick>;
    meta?: PaginationMetaFields;
};

export type PlatformVersionResponse = {
    /**
     * Message
     */
    message?: string;
    data?: PlatformVersion;
};

export type ListPlatformVersionsResponse = {
    data?: Array<PlatformVersionsList>;
};

export type ActionVerificationResponse = {
    data: ActionVerificationItem;
};

export type ListAdapterResponse = {
    data?: Array<Adapter>;
    meta?: PaginationMetaFields;
};

export type ConnectionResponse = AdapterConnectionFields;

export type AdapterResponse = Adapter;

export type HasHiddenVerificationResponse = {
    has_hidden_verification?: boolean;
};

export type AvailableMethodsResponse = {
    data?: Array<AgeVerificationMethodFields>;
    meta?: PaginationMetaFields;
    links?: Array<PaginationLinksFields>;
};

export type AgeVerificationItemHashResponse = AgeVerificationItemHashSchema;

export type AgeVerificationDateResponse = {
    data?: {
        /**
         * Date of performing age verification
         */
        verification_date?: string;
    };
};

export type AgeVerificationResponse = AgeVerificationItemSchema;

export type InitializeAsynchronousAgeVerificationResponse = {
    data?: {
        /**
         * Age verification item uuid
         */
        uuid: string;
        /**
         * If age verification finished and successful
         */
        is_verified: boolean;
        /**
         * Age verification status
         */
        verification_status: 'pending' | 'failed' | 'success' | 'abandoned';
        /**
         * Whether provider finished verification flow
         */
        verification_performed: boolean;
        /**
         * Optional object with data returned by adapter
         */
        data: {
            [key: string]: unknown;
        };
    };
};

export type CodeRouteListResponse = {
    data?: Array<CodeRoute>;
    meta?: PaginationMetaFields;
};

export type CodeRouteResponse = CodeRoute;

export type UpdateOneTrustPreferenceWebhookErrorResponse = {
    /**
     * Error message
     */
    message: string;
    /**
     * List of errors
     */
    errors: Array<string>;
};

export type GetFeedbackVoteSummaryResponse = {
    message: string;
    data: FeedbackVoteSummaryBody;
    meta: FeedbackVoteMeta;
};

export type CreateFeedbackVoteResponse = {
    message: string;
    data: FeedbackVoteBody;
    meta: FeedbackVoteMeta;
};

export type GetFeedbackVoteResponse = {
    message: string;
    data: FeedbackVoteBody;
    meta: FeedbackVoteMeta;
};

export type CouponUsersResponse = Array<string>;

export type CouponBatchStatusResponse = {
    /**
     * Batch status
     */
    status?: string;
};

export type CouponsResponse = Array<string>;

export type CouponBatchResponse = {
    /**
     * Batch UUID
     */
    batch_id?: string;
};

export type ServiceExternalProvidersResponse = {
    message: string;
    data: {
        /**
         * Response data from coupon provider
         */
        external_provider_data?: {
            [key: string]: unknown;
        };
    };
};

export type ExternalProvidersResponse = {
    data?: Array<ExternalProvider>;
};

export type CreateYggWebhookResponse = {
    data: {
        /**
         * YGG webhook ID.
         */
        id: number;
        /**
         * Callback URL registered with YGG.
         */
        url: string;
        /**
         * Whether YGG considers the webhook active.
         */
        is_active: boolean;
    };
};

export type DecryptResponse = {
    data?: Array<string>;
};

export type EncryptResponse = CryptographySchema;

export type UnregisterInventoryItemForGuestResponse = {
    data?: DeviceId;
    message?: string | null;
    code?: string;
};

export type CannotAttachResponse = ErrorMessageFields;

export type GetInventoryItem = {
    data?: DisInventoryItem;
    message?: string | null;
    code?: string;
};

export type DeviceNotExistResponse = ErrorMessageFields;

export type DiSv1BadRequestResponse = {
    message?: string;
};

export type DeviceRegisteredResponse = {
    data?: DisInventoryItem;
    message?: string | null;
    code?: string;
};

export type GetInventoryItems = {
    data?: Array<DisInventoryItem>;
    message?: string | null;
};

export type InventoryItemCodeValidation = {
    data?: string;
    message?: string;
    code?: string;
};

export type ConsumerAssignedResponse = {
    data?: DisInventoryItem;
    message?: string | null;
    code?: string;
};

export type DeviceAlreadyRegisteredResponse = {
    message?: string;
};

export type InvalidFormatResponse = ErrorMessageFields;

export type GetDeviceRegistrationHistoryResponse = {
    data?: Array<DisRegistrationSchema>;
};

export type ListInventoryExportsResponse = {
    data: Array<InventoryExportSchema>;
    meta: PaginationMetaFields;
};

export type InventoryExportResponse = {
    data: InventoryExportSchema;
};

export type UserDetails = {
    device?: UserDeviceDetails;
    sticks?: UserDeviceDetails;
    onetime_leaflet?: UserDeviceDetails;
    default?: UserDeviceDetails;
};

export type RegisterProduct = {
    executed?: boolean;
    identifier?: Identifier;
    inventory?: UserInventory;
    warranty?: IrSv1WarrantySchema;
    loyalty_rule?: string | null;
    is_genuine?: boolean | null;
    is_registrable?: boolean | null;
};

export type DiSv1ImportValidationErrorResponse = {
    message?: string;
    errors?: Array<{
        message?: string;
        device?: {
            [key: string]: unknown;
        };
    }>;
};

export type InventoryItemValidationResponse = {
    data?: InventoryItemValidationSchema;
};

export type DeviceNotRegistrableResponse = {
    message?: string;
};

export type IsAttachableResponse = {
    /**
     * Whether the inventory item is attachable or not.
     */
    is_attachable?: boolean;
};

export type InventoryItemListResponse = {
    data?: Array<InventoryItemSchema>;
    meta?: PaginationMetaFields;
    links?: Array<PaginationLinksFields>;
};

export type InventoryItemResponse = {
    data?: InventoryItemSchema;
};

export type ProductPrefixResponse = ProductPrefix;

export type ProductPrefixListResponse = {
    data?: Array<ProductPrefix>;
    meta?: PaginationMetaFields;
    links?: Array<PaginationLinksFields>;
};

export type InventoryItemReportResponse = {
    data?: Array<InventoryItemReportSchema>;
    meta?: PaginationMetaFields;
    links?: Array<PaginationLinksFields>;
};

export type InventoryItemReportExportResponse = string;

export type InventoryImportReportResponse = {
    data?: Array<InventoryImportReportSchema>;
    meta?: PaginationMetaFields;
    links?: Array<PaginationLinksFields>;
};

export type InventoryImportErrorReportResponse = {
    data?: Array<InventoryImportErrorReportSchema>;
    meta?: PaginationMetaFields;
    links?: Array<PaginationLinksFields>;
};

export type PrefixesReportResponse = {
    data?: Array<PrefixReportSchema>;
    meta?: PaginationMetaFields;
    links?: Array<PaginationLinksFields>;
};

export type SpexClusterListResponse = {
    data?: Array<SpexCluster>;
    meta?: PaginationMetaFields;
    links?: Array<PaginationLinksFields>;
};

export type SpexClusterResponse = SpexCluster;

export type WarrantyResponse = {
    data?: Warranty;
};

export type ListPurchasesResponse = {
    data: Array<PurchaseSchema>;
    meta: PaginationMetaFields;
};

export type PurchaseResponse = {
    data: PurchaseSchema;
};

export type ListActionsResponse = {
    data: Array<ActionSchema>;
    meta: PaginationMetaFields;
};

export type ActionResponse = {
    data: ActionSchema;
    /**
     * Additional info
     */
    message?: string | null;
};

export type LeadResponse = {
    data: LeadSchema;
    /**
     * Additional info
     */
    message?: string | null;
    /**
     * Error code presented with error responses
     */
    error_code?: string | null;
};

export type VerifyConsentResponse = {
    /**
     * Set password token
     */
    token: string | null;
};

export type ListLeadsResponse = {
    data: Array<LeadSchema>;
    meta: PaginationMetaFields;
};

export type ConsumerActivatedInLoyaltyResponse = {
    /**
     * Consumer open loyalty uuid
     */
    open_loyalty_uuid: string;
};

export type LoyaltyDomainConfigurationResponse = LoyaltyDomainConfiguration;

export type ConsumerAchievementsResponse = {
    data: {
        items?: Array<{
            /**
             * Achievement name
             */
            name: string;
            /**
             * Achievement completed
             */
            completed_count: number;
            /**
             * Is achievement limit reached
             */
            limit_reached: boolean;
            rules?: Array<{
                /**
                 * Number of points for achievement
                 */
                points_value: number;
                /**
                 * Custom event trigger
                 */
                custom_event: string;
                /**
                 * Achievement goal value
                 */
                goal: number;
                /**
                 * Achievement current value
                 */
                value: number;
            }>;
        }>;
    };
};

export type ErrorWithNextAvailableDateResponse = {
    /**
     * Human-readable reason why the QR code read is not available
     */
    message: 'QR code scan is in cooldown period.' | 'QR code scan limit reached for the current period.';
    /**
     * Machine-readable QR code read availability error code
     */
    error_code: 'loyalty.earnings::qr_code_cooldown_active' | 'loyalty.earnings::qr_code_participation_limit_reached';
    /**
     * Date and time when this consumer can read the QR code again
     */
    next_available_at: string;
};

export type QrCodeReadConflictResponse = {
    /**
     * Human-readable reason why the QR code read cannot be completed
     */
    message: 'The QR code has been already read.' | 'QR code scan limit reached for the current period.' | 'QR code read is already in progress.';
    /**
     * Machine-readable QR code read conflict error code
     */
    error_code: 'loyalty.earnings::qr_code_has_been_already_read' | 'loyalty.earnings::qr_code_participation_limit_reached' | 'loyalty.earnings::qr_code_read_in_progress';
    /**
     * Date and time when this consumer can read the QR code again, returned for participation limit conflicts
     */
    next_available_at?: string;
};

export type QrCodeGetResponse = {
    data: {
        /**
         * Is this lottery was triggered for this consumer
         */
        is_lottery_triggered: boolean;
        lottery_outcomes: Array<{
            name: string;
            is_win: boolean;
            points: number;
        }>;
    };
};

export type ListEarningsResponse = {
    data: Array<IndexEarningResponseSchema>;
    meta: PaginationMetaFields;
};

export type EarningRuleResponse = {
    data: {
        /**
         * Name of event
         */
        event_name: string;
        /**
         * Points amount
         */
        points: number;
    };
};

export type QrCodeReadResponse = {
    data: {
        message: string;
        is_rewarded: boolean;
        /**
         * Amount of earned points
         */
        earned_points: number;
        selected_outcome?: {
            name?: string | null;
            is_win?: boolean | null;
        } | null;
    };
};

export type ContestStatusResponse = {
    data: {
        files_limit: number;
        file_size_limit: number;
        file_mime_types: Array<string>;
        month_participation_limit: number;
        month_participation_count: number;
        file_upload_enabled: boolean;
    };
};

export type TransferConsumerPointsResponse = {
    data?: {
        /**
         * Transfer ID
         */
        transfer_id: string;
    };
};

export type ConsumerPointsHistoryResponse = {
    data: Array<{
        /**
         * Earned points
         */
        points: number;
        /**
         * Balance after operation
         */
        balance_after: number;
        /**
         * History event type
         */
        type: 'added' | 'spent' | 'expired' | 'canceled' | 'points_were_refunded' | 'points_transfer_canceled' | 'referrers_affiliate_registered' | 'referrer_network_purchase' | 'referrer_network_first_purchase' | 'ignored';
        /**
         * Is points added event. If it is not, then points were spent
         */
        is_added?: boolean;
        /**
         * History event subtype
         */
        subtype?: 'points_were_added' | 'points_were_spent' | 'points_were_refunded' | 'points_redeemed' | 'prize_bought' | 'online_purchase' | 'offline_purchase' | 'campaign_triggered' | 'points_transfer_canceled' | 'points_transfer_expired' | 'achievement' | 'ignored' | null;
        /**
         * Redemption status of the issued reward
         */
        issued_reward_status?: string | null;
        /**
         * Campaign name
         */
        campaign: string;
        created_at: string;
        /**
         * Coupon code
         */
        coupon?: string | null;
        /**
         * Coupon type
         */
        coupon_type?: string | null;
        /**
         * Coupon pin
         */
        coupon_pin?: string | null;
        /**
         * Order id
         */
        order_id?: string | null;
    }>;
    meta: PaginationMetaFields;
};

export type ConsumerNetworkPointsResponse = {
    data?: {
        /**
         * Amount of points
         */
        points?: number;
    };
};

export type ConsumerLoyaltyProfileResponse = {
    data: {
        /**
         * Points
         */
        points: number;
        /**
         * Points to expire
         */
        points_to_expire: number;
        /**
         * Points will expire at
         */
        expire_at: string;
        /**
         * Pending points
         */
        pending_points: number;
        /**
         * Tier name
         */
        tier_name: string;
        /**
         * Tier image url
         */
        tier_image_url?: string | null;
        /**
         * Next tier name, or null when the consumer is in the top tier
         */
        next_tier_name: string | null;
        /**
         * Points to next tier
         */
        points_to_next_tier: number;
        /**
         * Current tier assignment date
         */
        current_tier_assignment_date: string;
        /**
         * Cumulative points
         */
        cumulative_points: number;
        /**
         * Points to maintain current tier
         */
        points_to_maintain_current_tier: number;
        /**
         * Current tier secured till
         */
        current_tier_secured_till: string;
        /**
         * Has consumer at least one registered inventory of type device?
         */
        has_registered_device: boolean;
    };
};

export type RewardDetailResponse = {
    data: IndexRewardResponseSchema;
};

export type RedeemRewardResponse = {
    data: Array<RedeemRewardResponseSchema>;
};

export type ListRewardFiltersResponse = RewardFiltersResponseSchema;

export type CheckRewardEligibilityResponse = {
    data: EligibleRewardResponseSchema;
};

export type ConsumerRedeemRewardResponse = {
    data: RewardResponseSchema;
};

export type ConsumerRewardsResponse = {
    data: Array<RewardResponseSchema>;
};

export type PrizeBoughtResponse = {
    data?: {
        vouchers?: Array<{
            code?: string;
            type?: 'coupon' | 'url' | 'physical' | 'url_with_pin' | 'coupon_with_pin';
            pin?: string | null;
            redemption_instructions?: string | null;
            expiry_date?: string | null;
            barcode?: string | null;
            voucher_code?: string | null;
            voucher_pin?: string | null;
            voucher_type?: string | null;
        }>;
        /**
         * @deprecated
         */
        reward_code: string;
        /**
         * @deprecated
         */
        codes: Array<string>;
        /**
         * @deprecated
         */
        codes_type: 'coupon' | 'url' | 'physical' | 'url_with_pin' | 'coupon_with_pin';
        /**
         * Instant lottery outcome: true = won, false = lost, null = not a lottery reward.
         */
        won?: boolean | null;
    };
};

export type RewardConsumersListResponse = {
    data?: Array<RewardConsumer>;
    meta?: PaginationMetaFields;
    links?: Array<PaginationLinksFields>;
};

export type ConsumerOrderResponse = {
    data?: {
        transaction_id: string;
        consumer_uuid: string;
        points: number;
        comment?: string | null;
    };
};

export type IndexRewardsResponse = {
    data: Array<IndexRewardResponseSchema>;
    meta: PaginationMetaFields;
};

export type ConsumerEligibleRewardsResponse = {
    data: Array<EligibleRewardResponseSchema>;
};

export type AvailableSurveysResponse = {
    data: {
        surveys?: Array<{
            /**
             * Survey ID
             */
            survey_id: string;
            /**
             * Type of the survey - one_time or recurring
             */
            type: 'one_time' | 'recurring';
            /**
             * Status of the survey for the consumer
             */
            status: 'available' | 'in_progress' | 'completed';
            /**
             * Device serial code, if survey started already
             */
            serial_code?: string | null;
            /**
             * Indicates the survey is valid only for consumers with existing registered device
             */
            is_only_for_device_owners: boolean;
            /**
             * For recurring surveys, this is the day of the week when the recurring survey is available for particular cycle. 1 = Mon, 2 = Tue, etc
             */
            start_day?: number | null;
        }>;
    };
};

export type GetConsumerSurveyStatusResponse = {
    data: {
        /**
         * Status of the survey for the consumer
         */
        status: 'available' | 'in_progress' | 'completed';
    };
};

export type TiersResponse = {
    data: Array<TierResponseSchema>;
};

export type ConsumerTierResponse = {
    data: {
        /**
         * Tier name
         */
        name: string;
        /**
         * Tier image url
         */
        image_url?: string | null;
    };
};

export type EventResponse = {
    /**
     * Requested template type
     */
    event_type?: string;
    /**
     * Channel code
     */
    channel?: 'EMAIL' | 'FORM' | 'SMS' | 'URL' | 'QUIZ' | 'WHATSAPP' | 'VIBER' | 'PUSH';
    /**
     * Event processing status
     */
    status?: string;
};

export type MarketingCommunicationPaginateResponse = {
    data?: Array<MarketingCommunication>;
    meta?: PaginationMetaFields;
    links?: Array<PaginationLinksFields>;
};

export type MarketingCommunicationUnsubscribeResponse = {
    /**
     * Unsubscribe message
     */
    message?: string;
};

export type MarketingCommunicationResponse = MarketingCommunication;

export type MarketingCommunicationCollectionResponse = {
    data?: Array<MarketingCommunication>;
};

export type PushNotificationsStatusResponse = {
    data?: PushSubscriptionStatusSchema;
};

export type PushNotificationSubscribedResponse = {
    data?: PushSubscribedSchema;
};

export type CampaignDeliveryLogsResponse = {
    data?: Array<{
        id?: number;
        type?: string;
        channel?: 'EMAIL' | 'FORM' | 'SMS' | 'URL' | 'QUIZ' | 'WHATSAPP' | 'VIBER' | 'PUSH';
        campaign_id?: string;
        provider_status?: string | null;
        reference?: string | null;
        driver?: string | null;
        provider_response?: {
            [key: string]: unknown;
        } | null;
        created_at?: string;
        updated_at?: string;
    }>;
    meta?: {
        current_page?: number;
        per_page?: number;
        total?: number;
        last_page?: number;
    };
};

export type ListDeliveryLogsResponse = {
    data?: Array<{
        id?: number;
        type?: string;
        channel?: 'EMAIL' | 'FORM' | 'SMS' | 'URL' | 'QUIZ' | 'WHATSAPP' | 'VIBER' | 'PUSH';
        campaign_id?: string;
        provider_status?: string | null;
        reference?: string | null;
        driver?: 'adobe_campaign' | 'adobe_campaign_sms' | 'adobe_campaign_classic_sms' | 'adobe_campaign_workflow' | 'http_sender' | 'vodafone_ua_http_sender' | 'cm' | 'sendgrid' | 'pipedream' | 'kakao_talk' | 'twilio' | 'whatsapp' | 'cm_viber' | 'firebase' | null;
        provider_response?: {
            [key: string]: unknown;
        } | null;
        consumer_uuid?: string | null;
        event_type?: string | null;
        created_at?: string;
        updated_at?: string;
    }>;
    meta?: PaginationMetaFields;
};

export type CampaignEventReportResponse = {
    data?: Array<{
        channel?: 'EMAIL' | 'FORM' | 'SMS' | 'URL' | 'QUIZ' | 'WHATSAPP' | 'VIBER' | 'PUSH';
        statuses?: Array<{
            status?: string;
            count?: number;
        }>;
    }>;
};

export type LocalTemplateCreatedResponse = LocalTemplate;

export type LocalTemplateResponse = LocalTemplate;

export type LocalTemplateInUseResponse = {
    error_code?: string;
    message?: string;
};

export type LocalTemplateListResponse = Array<LocalTemplate>;

export type ListActivityLogResponse = {
    data?: Array<ActivityLog>;
    meta?: PaginationMetaFields;
};

export type HealthCheckResponse = {
    message?: string;
    data?: HealthCheck;
};

export type HealthCheckFailedResponse = {
    error_code?: string;
    message?: string;
    data?: HealthCheck;
};

export type UpdateOfflineCampaignResponse = {
    data?: OfflineCampaign;
};

export type GetOfflineCampaignResponse = {
    data?: OfflineCampaign;
};

export type ListOfflineCampaignsResponse = {
    data?: Array<OfflineCampaign>;
    meta?: PaginationMetaFields;
};

export type CreateOfflineCampaignResponse = {
    data?: OfflineCampaign;
};

export type ImportOfflineCampaignCouponResponse = {
    message: string;
    data: {
        imported: number;
    };
};

export type OfflineCampaignCouponResponse = {
    data?: OfflineCampaignCoupon;
};

export type ListOfflineCampaignCouponsResponse = {
    data?: Array<OfflineCampaignCoupon>;
    meta?: PaginationMetaFields;
};

export type ListOrderResponse = {
    data?: Array<OrderFields>;
    meta?: PaginationMetaFields;
};

export type WithdrawResponse = {
    data: WithdrawFields;
};

export type UpdateStatusResponse = {
    order_id?: string;
    status?: 'new' | 'confirmed' | 'processing' | 'pending_payment' | 'payment_failed' | 'payment_completed' | 'holded' | 'shipped' | 'shipped_to_warehouse' | 'delivered' | 'delivered_to_pick_up_point' | 'pending_cancellation' | 'canceled' | 'returned';
};

export type CancellationRequestResponse = {
    data: {
        order_id: string;
        status: string;
        created_at: string;
    };
};

export type GetWithdrawCandidatesResponse = {
    data: Array<{
        order_id: string;
        items_count: number;
        date: string;
    }>;
};

export type FetchInvoiceResponse = {
    url?: string;
};

export type CreateOrderInMagentoResponse = {
    data?: {
        order_id?: string;
        entity_id?: number;
        amount?: number;
        currency?: string;
    };
};

export type OrderSuccessResponse = {
    order_id?: string;
};

export type IsWithdrawEligibleResponse = {
    data: {
        is_eligible: boolean;
    };
};

export type ListWithdrawsResponse = {
    data: Array<WithdrawFields>;
    meta: PaginationMetaFields;
    links: Array<PaginationLinksFields>;
};

export type OrderResponse = OrderFields;

export type GetTokenResponse = {
    data?: {
        /**
         * Unique payment token identifier
         */
        token?: string;
        /**
         * Magento order ID
         */
        order_id?: number;
        /**
         * User ID
         */
        customer_uuid?: string;
        /**
         * Unique UUID of order payment transaction
         */
        payment_token?: string;
        metadata?: {
            /**
             * Payment method provider brand
             */
            brand?: string;
            expiry?: {
                /**
                 * Card's expiration month
                 */
                month?: string;
                /**
                 * Card's expiration year
                 */
                year?: string;
            };
        };
        method?: {
            /**
             * Payment method title
             */
            code?: string;
            icon?: string | null;
            type?: 'online' | 'offline';
            tokenizable?: boolean;
        };
    };
};

export type PaymentExternalDataResponse = {
    data: {
        payment_token: string;
        external_id: string | null;
        amount: number;
        currency: string;
        status: 'pending' | 'paid' | 'authorised' | 'refund' | 'chargeback' | 'failed';
        external_data: {
            [key: string]: unknown;
        } | null;
        created_at: string;
        updated_at: string;
    };
};

export type UpdatePaymentResponse = {
    message?: string;
};

export type PaymentTokenResponse = {
    data?: {
        payment_token?: string;
    };
};

export type PaymentMethodResponse = {
    data?: PaymentMethod;
};

export type ListPaymentMethodsResponse = {
    data?: Array<PaymentMethod>;
};

export type SessionResponse = {
    data?: {
        [key: string]: unknown;
    };
};

export type CreditCardResponse = {
    data?: CreditCard;
};

export type ListCreditCardsResponse = {
    data?: Array<CreditCard>;
};

export type PaymentResponse = {
    data?: {
        payment_token?: string;
        method?: {
            /**
             * Payment method title
             */
            title?: string;
            /**
             * Payment method icon URL
             */
            icon?: string | null;
        };
        /**
         * UUID of the affected order
         */
        order_id?: number;
        /**
         * Amount
         */
        amount?: number;
        /**
         * Currency code
         */
        currency?: string;
        status?: 'pending' | 'paid' | 'authorised' | 'refund' | 'chargeback' | 'failed';
        gateway_status?: 'soft_decline' | 'hard_decline' | null;
        gateway_details?: string | null;
        tokenize?: boolean;
    };
};

export type PaymentMethodClientResponse = {
    data?: {
        client?: string;
    };
};

export type RefundResponse = {
    data?: Refund;
};

export type ListProductResponse = {
    data?: Array<Product>;
    meta?: PaginationMetaFields;
};

export type ProductResponse = {
    data?: Product;
};

export type ValidationErrorResponse = {
    message?: string;
    errors?: {
        [key: string]: unknown;
    };
};

export type ListReviewsResponse = {
    data?: Array<Review>;
    meta?: PaginationMetaFields;
    links?: Array<PaginationLinksFields>;
};

export type ForbiddenErrorResponse = {
    message?: string;
};

export type CommonErrorResponse = {
    message?: string;
};

export type TenantWorkgroupCreatedResponse = {
    /**
     * Response message
     */
    message?: string;
    data?: {
        ''?: TenantWorkgroup;
    };
};

export type BackfillSurveyResponsesAcceptedResponse = {
    /**
     * Response message
     */
    message?: string;
    /**
     * External SurveyMonkey survey ID
     */
    survey_id?: string;
};

export type SurveyMonkeyWebhookResponse = {
    /**
     * Response message
     */
    message?: string;
    /**
     * Response data
     */
    data?: {
        [key: string]: unknown;
    };
};

export type FetchSurveyResponsesResponse = {
    /**
     * Response message
     */
    message?: string;
    /**
     * External SurveyMonkey survey ID
     */
    survey_id?: string;
    /**
     * Start of the fetched created-at period (ISO 8601 UTC)
     */
    created_from?: string;
    /**
     * End of the fetched created-at period (ISO 8601 UTC)
     */
    created_until?: string;
};

export type TenantWorkgroupsResponse = {
    /**
     * Response message
     */
    message?: string;
    data?: Array<TenantWorkgroup>;
};

export type CreateUserSubmissionResponse = {
    message?: string;
    data?: {
        [key: string]: unknown;
    };
};

export type UserSubmissionsResponse = {
    data?: Array<QuizSubmission>;
};

export type ListSearchablesResponse = {
    data?: Array<Searchable>;
    meta?: PaginationMetaFields;
};

export type SearchableResponse = Searchable;

export type SearchItemsResponse = {
    data?: Array<SearchItemResponse>;
    meta?: {
        /**
         * Current page
         */
        current_page?: number;
        /**
         * First page url
         */
        first_page_url?: string;
        /**
         * From
         */
        from?: number | null;
        /**
         * Last page
         */
        last_page?: number;
        /**
         * Last page url
         */
        last_page_url?: string;
        /**
         * Next page url
         */
        next_page_url?: string | null;
        /**
         * Path
         */
        path?: string;
        /**
         * Per page
         */
        per_page?: number;
        /**
         * Prev page url
         */
        prev_page_url?: string | null;
        /**
         * To
         */
        to?: number | null;
        /**
         * Total
         */
        total?: number;
    };
};

export type SubscriptionEligibilityResponse = {
    is_eligible?: boolean;
};

export type UserSubscriptionResponse = {
    uuid: string;
    consumer_id: string;
    billed_at: string;
    next_charge_at: string | null;
    amount: number;
    currency: string;
    shipping_cost?: number | null;
    shipping_method?: string | null;
    payment_token: string | null;
    shipping_address_id: number;
    billing_address_id: number;
    status: 'pending' | 'active' | 'canceled' | 'suspended' | 'paused';
    reason: string | null;
    products: Array<SubscriptionProductFields>;
    events: Array<SubscriptionEventFields>;
    payment_details?: PaymentDetailsFields;
};

export type SubscriptionConfigurationResponse = {
    period: {
        value: number;
        unit: 'month';
    };
    next_charge_at: string;
};

export type SubscriptionResponse = SubscriptionFields;

export type SubscriptionEventsResponse = {
    data?: Array<SubscriptionHistoryEventFields>;
    meta?: PaginationMetaFields;
    links?: Array<PaginationLinksFields>;
};

export type IsShippingAddressEligibleForRemovalResponse = {
    is_eligible_for_removal?: boolean;
};

export type ConsumerSubscriptionsResponse = {
    data?: Array<SubscriptionFields>;
    meta?: PaginationMetaFields;
    links?: Array<PaginationLinksFields>;
};

export type TrialResponse = TrialFields;

export type ListTrialResponse = {
    data: Array<TrialFields>;
    meta: PaginationMetaFields;
    links: Array<PaginationLinksFields>;
};

export type IsEligibleResponse = {
    is_eligible: boolean;
    trial: string | null;
};

export type TenantListResponse = {
    data?: Array<TenantList>;
    meta?: PaginationMetaFields;
};

export type TenantVersionHistoryResponse = {
    data?: Array<{
        version?: string;
        created_at?: string;
    }>;
    links?: Array<PaginationLinksFields>;
    meta?: PaginationMetaFields;
};

export type ImportTenantResponse = {
    /**
     * Message
     */
    message?: string;
    data?: {
        /**
         * Tenant code
         */
        code?: string;
    };
};

export type ExportTenantResponse = {
    /**
     * Message
     */
    message?: string;
    /**
     * Encrypted tenant data
     */
    data?: string;
};

export type TenantResponse = {
    /**
     * Message
     */
    message?: string;
    data?: Tenant;
};

export type TenantsVersionsResponse = {
    data: {
        [key: string]: TenantVersion;
    };
};

export type ListConfigurationResponse = {
    data?: Array<ConfigurationSchema>;
    meta?: PaginationMetaFields;
};

export type PublicConfigurationResponse = {
    message: string;
    data: {
        [key: string]: unknown;
    };
};

export type ConfigurationResponse = {
    data?: ConfigurationSchema;
};

export type ConfigurationItemResponse = {
    data?: {
        items?: Array<ConfigurationItem>;
    };
};

export type ConfigurationSchemasResponse = {
    data?: {
        [key: string]: unknown;
    };
};

export type ListBusinessMetricsResponse = {
    data?: Array<BusinessMetric>;
};

export type GetEligibleDevicesResponse = {
    data: Array<{
        device_id: string;
        device_name: string | null;
    }>;
};

export type IsConsumerEligibleResponse = {
    is_eligible: boolean;
    error_code?: string | null;
    message?: string | null;
};

export type CreateTradeInResponse = {
    data?: {
        uuid: string;
        serial_number: string | null;
        tracking_code: string | null;
    };
};

export type TradeInPublicConfigurationResponse = {
    data: {
        online: {
            registered_devices_only: boolean;
            /**
             * @deprecated
             */
            supported_models: {
                internal: Array<string>;
                competitor: Array<string>;
            };
        };
        offline: {
            registered_devices_only: boolean;
            /**
             * @deprecated
             */
            supported_models: {
                internal: Array<string>;
                competitor: Array<string>;
            };
        };
    };
};

export type ListAllTradeInsResponse = {
    data: Array<{
        uuid: string;
        consumer_id?: string;
        order_id?: string | null;
        model: string;
        model_type: 'internal' | 'competitor';
        serial_number?: string | null;
        new_sku: string;
        new_model?: string | null;
        purchase_date: string;
        channel: string;
        channel_type: 'online' | 'offline' | 'both';
        status: 'active' | 'canceled' | 'completed';
        created_at: string;
        updated_at: string;
    }>;
    meta: PaginationMetaFields;
    links: Array<PaginationLinksFields>;
};

export type GetAvailableConsentsResponse = Array<{
    id: string;
    name: string;
    description: string;
    language: string;
    mandatory: boolean;
    default?: boolean | null;
    context: string;
    section: {
        /**
         * Section UUID we get from OT
         */
        id: string;
        /**
         * Localized section name from OT
         */
        name: string;
        /**
         * Localized section description from OT
         */
        description: string;
    };
}>;

export type ProcessAnonymizedCdpProfilesResponse = {
    success: boolean;
    errors?: {
        failed_cas_uuids?: Array<string>;
        failed_emails?: Array<string>;
    };
};

export type ConsumerProfileResponse = ConsumerProfileSchema;

export type ProcessDataSubjectAccessRequestResponse = {
    /**
     * The request queue id as returned from OneTrust
     */
    request_id: string;
};

export type MarkConsumersAsExternalAgeVerifiedResponse = {
    /**
     * Number of consumers successfully marked as external age-verified
     */
    fixed?: number;
    /**
     * Number of consumers already age-verified
     */
    already_verified?: number;
    /**
     * Number of emails not found
     */
    not_found?: number;
    /**
     * Number of consumers that failed to process
     */
    failed?: number;
    /**
     * Details of failed consumers
     */
    errors?: Array<{
        email?: string;
        error?: string;
    }>;
};

export type AnonymizeConsumersResponse = {
    /**
     * Success message
     */
    message?: string;
    /**
     * Number of consumers anonymized
     */
    count?: number;
};

export type GetUsersConsentsResponse = Array<{
    id: string;
    name: string;
    description: string;
    language: string;
    mandatory: boolean;
    context: string;
    /**
     * If the user confirmed the consent
     */
    accepted: boolean;
    /**
     * If the user marked consent as one_off
     */
    one_off: boolean;
    created_at?: string | null;
    /**
     * Date when accepted consent will be revoked
     */
    revokes_at: string | null;
}>;

export type UsersDomainConfigurationResponse = UsersDomainConfiguration;

export type ConsumerResponse = Consumer;

export type ConsumerOneTimeLimitedTokenResponse = {
    data?: {
        /**
         * Short-lived, single-use, unscoped token valid for 30 seconds
         */
        token?: string;
    };
};

export type BulkOneTimeLimitedTokenResponse = {
    data?: Array<{
        /**
         * Consumer UUID
         */
        uuid?: string;
        /**
         * Generated one time limited token
         */
        token?: string;
    }>;
};

export type InitializeAuthenticationResponse = {
    /**
     * The type of authentication strategy being initialized
     */
    strategy?: 'email-credential' | 'kakao-credential' | 'facebook-credential' | 'google-credential' | 'phone-number-credential' | 'magento-credential' | 'magento-to-email-credential' | 'one-time-limited-token';
    data?: {
        /**
         * Action verification UUID
         */
        uuid?: string;
    };
};

export type AuthenticationResponse = {
    data?: PersonalAccessTokenSchema;
};

export type OneTimeLimitedTokenResponse = {
    data?: {
        /**
         * User uuid
         */
        user_uuid?: string;
        /**
         * List of scopes the token will work for
         */
        scopes?: Array<string> | null;
        /**
         * When set to true, only one authentication session can be created for the token
         */
        single_use?: boolean;
        /**
         * One time limited token expiration datetime. When expired, won't be possible to create another authentication session
         */
        expires_at?: string;
    };
};

export type ListConsumerDeactivationsResponse = {
    data?: Array<ConsumerDeactivation>;
    meta?: PaginationMetaFields;
};

export type ValidateAddressResponse = {
    is_verified: boolean;
    status: 'valid' | 'invalid';
    reason?: string | null;
};

export type VerifyAgeResponse = {
    is_age_verified?: boolean;
};

export type GetComplaints = {
    has_complaints?: boolean;
};

export type UserSessionsResponse = {
    data?: Array<{
        user_uuid?: string;
        created_at?: string;
        expires_at?: string;
        last_access_at?: string | null;
        last_access_ip?: string | null;
        last_access_user_agent?: string | null;
    }>;
};

export type RegistrationResponse = RegistrationSchema;

export type InitializeRegistrationResponse = {
    data?: {
        /**
         * Action verification UUID
         */
        uuid?: string;
        /**
         * Action verification channel
         */
        channel?: string;
        /**
         * Action verification identifier (phone number or email address)
         */
        identifier?: string;
        /**
         * Action verification status
         */
        status?: 'validated' | 'sent' | 'used';
    };
};

export type ConsumersReportResponse = {
    data?: Array<ConsumerReportSchema>;
    meta?: PaginationMetaFields;
};

/**
 * HTML fallback message
 */
export type WalletProviderIsNotStreamable = string;

/**
 * HTML error text
 */
export type FailedToGeneratePass = string;

/**
 * Binary pkpass file
 */
export type StreamedWalletPass = Blob | File;

export type GeneratedWalletPass = {
    data?: {
        wallet_type?: string;
        wallet_object_id?: string;
        pass_url?: string;
    };
};

export type WebhookEventValueList = {
    data: Array<string>;
};

export type ListWebhookResponse = {
    data?: Array<Webhook>;
    meta?: PaginationMetaFields;
};

export type WebhookTransformersResponse = {
    /**
     * Available webhook transformers with their possible arguments
     */
    transformers?: {
        [key: string]: Array<string>;
    };
};

export type WebhookResponse = Webhook;

export type PhoneValidation = {
    /**
     * The phone number that has been verified. Formatted in international format if valid.
     */
    phone: string;
    /**
     * Indicates whether the phone number is valid or not
     */
    is_valid: boolean;
    /**
     * A message providing additional information about the validation result
     */
    message?: string | null;
};

export type EmailValidation = {
    /**
     * The email address to validate
     */
    email: string;
    /**
     * Whether the email address is valid
     */
    is_valid: boolean;
    /**
     * The validation message
     */
    message?: string | null;
};

export type PaginationMetaFields = {
    /**
     * Current page
     */
    current_page?: number;
    /**
     * First page url
     */
    first_page_url?: string;
    /**
     * From
     */
    from?: number | null;
    /**
     * Last page
     */
    last_page?: number;
    /**
     * Last page url
     */
    last_page_url?: string;
    /**
     * Next page url
     */
    next_page_url?: string | null;
    /**
     * Path
     */
    path?: string;
    /**
     * Per page
     */
    per_page?: number;
    /**
     * Prev page url
     */
    prev_page_url?: string | null;
    /**
     * To
     */
    to?: number | null;
    /**
     * Total
     */
    total?: number;
};

export type CommonFields = {
    /**
     * Record identifier
     */
    id?: number;
    /**
     * Record creation time
     */
    created_at?: string;
    /**
     * Record update time
     */
    updated_at?: string;
};

export type PaginationLinksFields = {
    /**
     * Link url
     */
    url?: string | null;
    /**
     * Link label
     */
    label?: string;
    /**
     * Link is active or not
     */
    active?: boolean;
};

export type ErrorMessageFields = {
    message?: string;
    error_code: string;
};

export type TrackingSchema = {
    /**
     * Channel ID
     */
    channel_id?: string | null;
    /**
     * Channel type
     */
    channel_type?: string | null;
    /**
     * Country
     */
    country?: string | null;
    /**
     * Campaign ID
     */
    campaign_id?: string | null;
    /**
     * Content ID
     */
    content_id?: string | null;
    /**
     * Guided trial
     */
    guided_trial?: boolean | null;
    /**
     * Program ID
     */
    program_id?: string | null;
} | null;

export type AnonymizationSchema = {
    profile_uuid?: string;
    status?: 'in_progress' | 'done' | 'error';
    reason_for_anonymization?: 'profile_cleansing_test_profile' | 'profile_cleansing_orphan_profile' | 'profile_cleansing_potential_fraud' | 'profile_cleansing_duplicated' | 'profile_cleansing_non_contactable_inactive' | 'consumer_request' | 'retention_rule_exceeded' | 'local_process_double_opt_in_not_done' | 'profile_cleansing_cdp_evo_align' | 'profile_cleansing_snp_invalid_inactive' | 'profile_cleansing_direct_ingestion' | 'profile_cleansing_invalid_age' | 'other';
    trigger_source?: 'cdp' | 'gcc_agent' | 'account_dashboard' | 'fms' | 'sales_and_operations' | 'other';
    external_id?: string | null;
    created_at?: string;
    updated_at?: string;
    finished_at?: string | null;
    steps?: Array<AnonymizationStepSchema>;
};

export type AnonymizedProfileSchema = {
    /**
     * Profile uuid
     */
    uuid?: string | null;
    /**
     * Profile email
     */
    email?: string;
    /**
     * Profile phone
     */
    phone?: string | null;
    /**
     * Profile first name
     */
    first_name?: string;
    /**
     * Profile last name
     */
    last_name?: string;
    /**
     * Created date
     */
    created_at?: string | null;
    /**
     * Updated date
     */
    updated_at?: string | null;
    /**
     * Anonymized date
     */
    anonymized_at?: string | null;
};

export type AnonymizationStepSchema = {
    system?: 'evo' | 'one_trust' | 'cdp' | 'gcc' | 'loyalty' | 'magento' | 'event_grid' | 'webhook';
    status?: 'pending' | 'success' | 'failed' | 'callback_not_available';
    details?: {
        [key: string]: unknown;
    } | null;
    error_message?: string | null;
    created_at?: string;
};

export type PermissionFields = {
    /**
     * The unique key identifier for the permission
     */
    key?: string;
};

export type RoleFields = {
    /**
     * The unique key identifier for the role
     */
    key?: string;
    /**
     * The display name of the role
     */
    name?: string;
    /**
     * The external identifier for the role
     */
    external_id?: string | null;
    /**
     * A description of the role
     */
    description?: string;
    /**
     * Whether the role is enabled
     */
    is_enabled?: boolean;
    /**
     * List of permission keys assigned to the role
     */
    permissions?: Array<string>;
    /**
     * The date and time when the role was created
     */
    created_at?: string;
    /**
     * The date and time when the role was last updated
     */
    updated_at?: string;
};

export type Role = RoleFields;

export type PlatformConfigurationExtended = PlatformConfiguration & {
    type?: string | null;
    id?: number;
};

export type PublicPlatformConfiguration = {
    code?: string;
    name?: string;
    data?: Array<{
        [key: string]: unknown;
    }>;
};

export type PlatformConfiguration = {
    code?: string;
    name?: string;
    public?: boolean;
    data?: Array<{
        [key: string]: unknown;
    }>;
};

export type CreateEntraApplication = {
    /**
     * The EVO role created for the application
     */
    role?: {
        key: string;
        name: string;
        permissions: Array<string>;
    };
    /**
     * The newly created Entra application registration
     */
    entra_application?: {
        /**
         * The Entra application object id
         */
        id: string;
        /**
         * The Entra application (client) id
         */
        app_id: string;
        /**
         * The display name of the Entra application
         */
        name: string;
        /**
         * The client secrets provisioned for the application (shown only once)
         */
        credentials: Array<{
            key_id: string;
            display_name: string;
            /**
             * The generated secret value
             */
            secret_text: string;
            end_date_time: string;
        }>;
        /**
         * The EVO Entra app roles granted to the application
         */
        roles: Array<{
            /**
             * The Entra app role id
             */
            id: string;
            /**
             * The Entra app role value (scope identifier)
             */
            value: string;
            /**
             * The Entra app role display name
             */
            name: string;
        }>;
    };
};

export type IntegrationTestResultsFields = {
    /**
     * Status
     */
    status: 'to_run' | 'passed' | 'failed' | 'fail_reported' | 'in_progress';
    /**
     * Tenant code identifier
     */
    tenant_code: string;
    /**
     * Feature code identifier
     */
    feature_code: string;
    /**
     * Feature title
     */
    feature_title: string;
    /**
     * Scenario code identifier
     */
    scenario_code: string;
    /**
     * Scenario title
     */
    scenario_title: string;
    /**
     * Example line reference
     */
    example_line: string;
    /**
     * Application version
     */
    version: string;
    /**
     * CI pipeline URL
     */
    pipeline_url: string;
    tags: Array<string>;
    ticket_tags: Array<string>;
    /**
     * Details of the failed step
     */
    failed_step: {
        /**
         * Step text
         */
        text: string;
        /**
         * Step keyword
         */
        keyword: string;
        /**
         * Step line number
         */
        line: number;
        /**
         * Error message if the step failed
         */
        error_message?: string | null;
    } | null;
    /**
     * Test execution timestamp
     */
    created_at?: string;
};

export type MigrateOktaApplicationToEntra = {
    /**
     * A snapshot of the source Okta application
     */
    okta_application?: {
        app_id: string;
        name: string;
        label: string;
        status: string;
        groups: Array<string>;
        scopes: Array<string>;
    };
    /**
     * The EVO role created for the migrated application
     */
    role?: {
        key: string;
        name: string;
        permissions: Array<string>;
    };
    /**
     * The newly created Entra application registration
     */
    entra_application?: {
        /**
         * The Entra application object id
         */
        id: string;
        /**
         * The Entra application (client) id
         */
        app_id: string;
        /**
         * The display name of the Entra application
         */
        name: string;
        /**
         * The client secrets provisioned for the application (shown only once)
         */
        credentials: Array<{
            key_id: string;
            display_name: string;
            /**
             * The generated secret value
             */
            secret_text: string;
            end_date_time: string;
        }>;
        /**
         * The EVO Entra app roles (scope:<group>) granted to the application
         */
        roles: Array<{
            /**
             * The Entra app role id
             */
            id: string;
            /**
             * The Entra app role value (scope identifier)
             */
            value: string;
            /**
             * The Entra app role display name
             */
            name: string;
        }>;
    };
};

export type AccessTokenBasedTenantMappingSchema = {
    /**
     * Tenant token from the services
     */
    tenant_token: string;
    /**
     * The value that this tenant token maps to for most/all services
     */
    mapped_to: string | null;
    /**
     * The list of mapped tenant code overrides per-service
     */
    overrides: {
        [key: string]: string | null;
    };
};

export type TenantCodeBasedTenantMappingSchema = {
    /**
     * Tenant code from the EVO
     */
    tenant_code: string;
    /**
     * The list of lists of mapped tenant tokens that map to this tenant code. Services without any mapping will not be included in the response.
     */
    mappings: {
        [key: string]: Array<string | null>;
    };
};

export type TenantMappingSchema = {
    /**
     * Tenant code in EVO
     */
    tenant_code: string;
    /**
     * Tenant token from the services
     */
    tenant_token: string;
    options?: {
        /**
         * The purpose_id that, when specified, should be rewritten to the legitimate interest marketing communication category. Note that this can also be achieved by using the purpose_to_category_mapping option.
         */
        legitimate_interest_consent_id?: string;
        /**
         * A map of purpose_ids from OT to the marketing communication category in EVO
         */
        purpose_to_category_mapping?: {
            [key: string]: string;
        };
        /**
         * Whether to convert the lead
         */
        convert_lead?: boolean;
        /**
         * The opt-in strategy to use for the tenant
         */
        opt_in_strategy?: string;
        /**
         * The phone country code to use for the tenant
         */
        phone_country_code?: string;
    };
};

export type ShortUrlFields = {
    /**
     * The unique code for the short URL
     */
    code?: string;
    /**
     * The original long URL
     */
    url?: string;
    /**
     * External identifier used for grouping or filtering
     */
    external_id?: string | null;
    /**
     * Campaign identifier used for grouping or filtering
     */
    campaign_id?: string | null;
    /**
     * The date and time when the short URL was created
     */
    created_at?: string;
    /**
     * The date and time when the short URL was last updated
     */
    updated_at?: string;
};

export type ShortUrlClickFields = {
    /**
     * Short URL code
     */
    code?: string;
    /**
     * Date and time when the click was registered
     */
    clicked_at?: string;
    /**
     * Country code associated with the click
     */
    country?: string | null;
    /**
     * City associated with the click
     */
    city?: string | null;
    /**
     * Region associated with the click
     */
    region?: string | null;
    /**
     * Autonomous system number associated with the click
     */
    asn?: number | null;
    /**
     * User agent associated with the click
     */
    user_agent?: string | null;
};

export type ShortUrlClick = ShortUrlClickFields;

export type ShortUrl = ShortUrlFields;

export type PlatformVersion = {
    version?: string;
};

export type PlatformVersionsList = {
    version?: string;
    description?: string;
    stability?: string;
    labels?: Array<string>;
    registered_at?: string;
    unregistered_at?: string | null;
    first_used_at?: string | null;
    stability_updated_at?: string;
    created_at?: string;
    updated_at?: string;
    configuration_schema?: {
        [key: string]: unknown;
    } | null;
};

export type ActionVerificationItem = {
    uuid: string;
    channel: string;
    identifier: string;
    name?: string | null;
    status: string;
};

export type AdapterConnectionFields = {
    /**
     * Adapter access token
     */
    token: string;
    /**
     * Adapter unique code
     */
    adapter_code: string;
    /**
     * Tenant unique code
     */
    tenant_code: string;
};

export type AdapterFields = {
    /**
     * Adapter type
     */
    type?: 'age_verification' | 'payments' | 'orders';
    /**
     * Adapter name
     */
    name: string;
    /**
     * Adapter description
     */
    description: string | null;
    /**
     * Adapter unique code
     */
    code: string;
    /**
     * Adapter base URL
     */
    url: string;
    /**
     * Adapter additional options
     */
    options: {
        [key: string]: unknown;
    } | null;
};

export type AdapterResponseFields = {
    /**
     * Id of adapter
     */
    id?: number;
    /**
     * Adapter type
     */
    type?: 'age_verification' | 'payments' | 'orders';
    /**
     * Adapter name
     */
    name: string;
    /**
     * Adapter description
     */
    description: string | null;
    /**
     * Adapter unique code
     */
    code: string;
    /**
     * Adapter base URL
     */
    url: string;
    /**
     * Adapter additional options
     */
    options: {
        [key: string]: unknown;
    } | null;
};

export type Adapter = AdapterResponseFields & {
    connections: Array<AdapterConnectionFields>;
};

export type AgeVerificationMethodFields = {
    /**
     * Verification adapter code
     */
    adapter_code?: string;
    /**
     * Verification method code
     */
    code?: string;
    /**
     * Verification method type
     */
    type?: 'sync' | 'async';
    /**
     * Verification method name
     */
    name?: string;
    /**
     * Verification method description
     */
    description?: string | null;
    /**
     * Verification method fields content
     */
    fields?: Array<{
        /**
         * Verification method field code
         */
        code?: string;
        /**
         * Verification method field label
         */
        label?: string;
        /**
         * Hint for verification method field
         */
        hint?: string | null;
        /**
         * Validation rules used for verification method field
         */
        validation?: string | null;
        /**
         * Verification type
         */
        type?: 'number' | 'string' | 'date' | 'bool' | 'array';
        /**
         * Flag indicates whether this field is mandatory
         */
        is_required?: boolean;
    }>;
};

export type AgeVerificationItemSchema = {
    data?: AgeVerificationItemFields;
};

export type AgeVerificationItemFields = {
    /**
     * Age verification item uuid
     */
    uuid?: string;
    /**
     * If age verification finished and successful
     */
    is_verified?: boolean;
    /**
     * Age verification status
     */
    verification_status?: 'pending' | 'failed' | 'success' | 'abandoned';
    /**
     * Whether provider finished verification flow
     */
    verification_performed?: boolean;
    /**
     * Optional object with consumer data
     */
    consumer_data?: {
        /**
         * Name
         */
        name?: string | null;
        /**
         * Phone number
         */
        phone?: string | null;
        /**
         * Date of birth
         */
        date_of_birth?: string | null;
        [key: string]: string | string | null | string | null | string | null | undefined;
    };
    error?: AgeVerificationErrorSchema | null;
};

export type AgeVerificationItemHashFields = {
    /**
     * AgeVerificationItemHash uuid
     */
    age_verification_item_uuid?: string;
    /**
     * Consumer uuid
     */
    consumer_uuid?: string;
};

export type AgeVerificationErrorSchema = {
    /**
     * Unique adapter error code
     */
    error_code: string;
    /**
     * Adapter error message
     */
    message: string;
    /**
     * Optional object with additional data
     */
    attributes?: {
        [key: string]: string;
    } | null;
};

export type AgeVerificationItemHashSchema = {
    data?: AgeVerificationItemHashFields;
};

export type CodeRouteFields = {
    /**
     * Unique string identifier
     */
    code?: string;
    /**
     * Internal name
     */
    name?: string;
    /**
     * URL associated with QR code
     */
    url?: string;
};

export type CodeRoute = CodeRouteFields;

export type FeedbackVoteSummaryBody = {
    url: string;
    likes: number;
    dislikes: number;
    total: number;
};

export type FeedbackVoteBody = {
    vote_type: boolean;
    content_type: 'website' | 'product';
    content: {
        url: string;
        reference_type: 'faq_page' | 'video';
        reference_name: string;
    };
    /**
     * Datetime of creation of the feedback. Format: Y-m-d H:i:s.
     */
    created_at: string;
};

export type FeedbackVoteMeta = {
    can_vote: boolean;
    votes_left_today: number;
};

export type ExternalProvider = {
    code: string;
    name: string;
    description: string;
    fields?: Array<ExternalProviderField> | null;
};

export type ExternalProviderField = {
    code: string;
    label: string;
    hint?: string | null;
    validation?: string | null;
    type: 'number' | 'string' | 'date' | 'bool' | 'array';
    is_required: boolean;
};

export type CryptographySchema = Array<string>;

export type WarrantySchemaBase = {
    status?: string;
    start_date?: string;
    expiration_date?: string;
    history_items?: Array<{
        action?: string;
        reason?: string;
        data?: {
            before?: {
                status?: string;
                start_date?: string;
                expiration_date?: string;
            };
            after?: {
                status?: string;
                start_date?: string;
                expiration_date?: string;
            };
        };
    }>;
} | null;

export type DisInventoryItem = {
    deviceId?: string | null;
    deviceName?: string | null;
    productId?: string | null;
    registrationDate?: string | null;
    warrantyExpiryDate?: string | null;
    iotTenantCode?: string | null;
    productType?: string | null;
    productColor?: string | null;
    productVersion?: string | null;
    isVirtual?: boolean;
    isBluetooth?: boolean;
    userId?: string | null;
    userAssignmentDate?: string | null;
    tenantCode?: string | null;
    countryCode?: string | null;
    trackingCode?: string | null;
    randomCode?: string | null;
    tenantCodeString?: string | null;
    externalId?: string | null;
    consumerId?: string | null;
};

export type DeviceId = {
    deviceIdentifier?: string;
};

export type DisRegistrationSchema = {
    /**
     * Available statuses: paired, registered, unregistered, consumer_attached
     */
    status: string;
    createdAt: string;
    externalId?: string | null;
    consumerId?: string | null;
};

export type ConsumerCanceled = {
    meta?: {
        /**
         * Webhook event type
         */
        event_type?: string;
        /**
         * Tenant code
         */
        tenant_code?: string;
    };
    data?: {
        /**
         * Consumer uuid
         */
        uuid?: string;
        /**
         * Consumer email
         */
        email?: string;
    };
};

export type InventoryExportSchema = {
    /**
     * The unique identifier of the export
     */
    export_id?: string;
    /**
     * The batch identifier for related export
     */
    batch_id?: string | null;
    /**
     * The name of the exported file
     */
    file_name?: string;
    /**
     * The current status of the export
     */
    status?: 'pending' | 'chunking' | 'merging' | 'completed' | 'failed';
    filters?: InventoryExportFilterSchema;
    /**
     * The date and time when the export will expire
     */
    expires_at?: string | null;
    /**
     * The date and time when the export was created
     */
    created_at?: string;
    /**
     * The date and time when the export was last updated
     */
    updated_at?: string;
    /**
     * The completion percentage of the export process
     */
    completion_percentage?: number | null;
    /**
     * The URL to download the exported file
     */
    url?: string | null;
    /**
     * The reason for export failure, if applicable
     */
    failure_reason?: string | null;
};

/**
 * At least one of the following filters must be provided to limit the export size: tenant_code, spex_cluster_name, or country_code.
 */
export type InventoryExportFilterSchema = {
    /**
     * Filter by tenant code
     */
    tenant_code?: string;
    /**
     * Filter by spex cluster name
     */
    spex_cluster_name?: string;
    /**
     * Filter by prefix code for the device
     */
    prefix?: string;
    /**
     * Filter by country code
     */
    country_code?: string;
    created_at?: {
        /**
         * Greater than or equal filter. Returns items created after the specified date/time.
         */
        gte?: string;
        /**
         * Less than or equal filter. Returns items created before the specified date/time.
         */
        lte?: string;
    };
    updated_at?: {
        /**
         * Greater than or equal filter. Returns items updated after the specified date/time.
         */
        gte?: string;
        /**
         * Less than or equal filter. Returns items updated before the specified date/time.
         */
        lte?: string;
    };
    /**
     * Filter the list by any type of code. Use % as a wildcard character.
     */
    codes?: Array<string>;
    /**
     * Filter by registration status. If true, only registered items will be returned. If false, only unregistered items will be returned. If not provided, all items will be returned.
     */
    is_registered?: boolean;
    /**
     * Filter by registrable status. If true, only registrable items will be returned. If false, only unregistrable items will be returned. If not provided, all items will be returned.
     */
    is_registrable?: boolean;
    /**
     * Filter by is_virtual flag. If true, only virtual items will be returned. If false, only real items will be returned. If not provided, all items will be returned.
     */
    is_virtual?: boolean;
};

export type UserDeviceDetails = {
    is_allowed_to_register?: boolean;
    /**
     * device|sticks|accessory
     */
    product_type?: string;
    registered_this_month?: number;
    registered_this_week?: number;
    remaining_weekly_limit?: number;
    remaining_monthly_limit?: number;
};

export type UserInventory = {
    id?: number;
    user_id?: number;
    identifier_id?: number;
    type?: string;
    product?: string;
    created_at?: string;
    updated_at?: string;
};

export type Identifier = {
    id?: number | null;
    country_code?: string | null;
    tenant_code?: string | null;
    product_sku?: string | null;
    serial_code?: string | null;
    leaflet_code?: string | null;
    type?: string;
    is_used?: boolean;
    is_virtual?: boolean;
    created_at?: string;
    updated_at?: string;
};

export type IrSv1WarrantySchema = {
    id?: number;
    tenant_code?: string;
    user_inventory_id?: string;
    start_date?: string;
    expiration_date?: string;
};

export type BasicProductSchema = {
    sku?: string;
    type?: string;
    name?: string;
    loyalty_rule?: string | null;
};

export type InventoryItemSchema = {
    tenant_code?: string | null;
    country_code?: string | null;
    spex_cluster_name?: string | null;
    product_sku?: string | null;
    serial_code?: string | null;
    leaflet_code?: string | null;
    user_code?: string | null;
    type?: string | null;
    is_used?: boolean | null;
    is_virtual?: boolean | null;
    is_registrable?: boolean | null;
    warranty?: ItemsWarranty | null;
    current_registration?: ItemRegistrationSchema | null;
    current_owner?: OwnerSchema | null;
    product?: BasicProductSchema | null;
    product_prefix?: ProductPrefixSchema | null;
    registration_history?: Array<RegistrationHistorySchema> | null;
};

export type ProductPrefixSchema = {
    /**
     * Product Prefix
     */
    prefix?: string | null;
    /**
     * Product Color
     */
    product_color?: string | null;
    /**
     * Product Type
     */
    product_type?: string | null;
};

export type OwnerSchema = {
    /**
     * Registered customer UUID
     */
    des_user_id?: string | null;
    /**
     * Registered external user ID/UUID (Ambassador / Lead)
     */
    external_user_id?: string | null;
    /**
     * Alternative to provide email for registered users
     */
    personal_identifier?: string | null;
} | null;

export type ItemRegistrationSchema = {
    status?: string;
    /**
     * @deprecated
     */
    registration_date?: string;
    created_at?: string;
};

export type InventoryItemValidationSchema = {
    serial_code?: string | null;
    leaflet_code?: string | null;
    user_code?: string | null;
    has_previous_registrations?: boolean;
};

export type ItemsWarranty = {
    status?: string;
    start_date?: string;
    expiration_date?: string;
    history_items?: Array<{
        action?: string;
        reason?: string;
        data?: {
            before?: {
                status?: string;
                start_date?: string;
                expiration_date?: string;
            };
            after?: {
                status?: string;
                start_date?: string;
                expiration_date?: string;
            };
        };
    }>;
} | null;

export type RegistrationHistorySchema = {
    status?: string;
    created_at?: string;
    owner?: OwnerSchema | null;
};

export type ProductPrefixRequestFields = {
    /**
     * Product Color
     */
    product_color?: string | null;
    /**
     * Product Type
     */
    product_type?: string | null;
    /**
     * Product Prefix
     */
    prefix: string;
    /**
     * Product Prefix SKU
     */
    sku: string;
    /**
     * Product Prefix Tenant Code
     */
    tenant_code: string;
};

export type ProductPrefixFields = {
    /**
     * Product Color
     */
    product_color?: string | null;
    /**
     * Product Type
     */
    product_type?: string | null;
    /**
     * Product Notes
     */
    notes?: string | null;
    /**
     * Product Prefix
     */
    prefix?: string | null;
    /**
     * Product Prefix SKU
     */
    sku?: string | null;
    /**
     * Product Prefix Tenant Code
     */
    tenant_code?: string;
};

export type ProductPrefix = ProductPrefixFields & CommonFields;

export type ProductReportSchema = {
    external_id?: number | null;
    brand?: string | null;
    sku?: string;
    type?: string | null;
    name?: string | null;
    loyalty_rule?: string | null;
} | null;

export type InventoryImportReportSchema = {
    original_path?: string | null;
    archived_path?: string | null;
    errors_number?: number | null;
    successes_number?: number | null;
    total_number?: number | null;
    started_at?: string | null;
    finished_at?: string | null;
};

export type InventoryImportErrorReportSchema = {
    id?: number;
    report_id?: number;
    message?: string;
    /**
     * JSON data of the error
     */
    data?: {
        sku?: string;
        serial?: string;
    };
    type?: string;
    created_at?: string;
};

export type OwnerReportSchema = {
    /**
     * Registered CAS customer UUID
     */
    des_user_id?: string | null;
    /**
     * Registered external customer ID/UUID (Ambassador)
     */
    external_user_id?: string | null;
    /**
     * Alternative to provide email for registered users
     */
    personal_identifier?: string | null;
} | null;

export type RegistrationReportSchema = {
    status?: string | null;
    registration_date?: string | null;
} | null;

export type InventoryItemReportSchema = {
    tenant_code?: string | null;
    country_code?: string | null;
    spex_cluster_name?: string | null;
    product_sku?: string | null;
    serial_code?: string | null;
    leaflet_code?: string | null;
    created_at?: string | null;
    updated_at?: string | null;
    is_used?: boolean | null;
    is_virtual?: boolean | null;
    warranty?: ReportingWarranty | null;
    product?: ProductReportSchema | null;
    current_registration?: RegistrationReportSchema | null;
    current_owner?: OwnerReportSchema | null;
    registration_history?: Array<RegistrationReportSchema> | null;
};

export type PrefixReportSchema = {
    prefix?: string | null;
    tenant_code?: string | null;
    country_code?: string | null;
    spex_cluster?: string | null;
    product_color?: string | null;
    product_type?: string | null;
    product?: ProductReportSchema | null;
};

export type ReportingWarranty = {
    status?: string;
    start_date?: string;
    expiration_date?: string;
    history_items?: Array<{
        action?: string;
        reason?: string;
        data?: {
            before?: {
                status?: string;
                start_date?: string;
                expiration_date?: string;
            };
            after?: {
                status?: string;
                start_date?: string;
                expiration_date?: string;
            };
        };
    }>;
} | null;

export type SpexClusterFields = {
    /**
     * The name of the Spex Cluster
     */
    name: string;
    /**
     * The country codes of the Spex Cluster
     */
    country_codes: Array<string>;
    created_at?: string | null;
    updated_at?: string | null;
};

export type SpexCluster = SpexClusterFields;

export type Warranty = {
    status?: string;
    start_date?: string;
    expiration_date?: string;
    history_items?: Array<{
        action?: string;
        reason?: string;
        data?: {
            before?: {
                status?: string;
                start_date?: string;
                expiration_date?: string;
            };
            after?: {
                status?: string;
                start_date?: string;
                expiration_date?: string;
            };
        };
    }>;
} | null;

export type PurchaseSchema = {
    /**
     * Action uuid
     */
    uuid: string;
    /**
     * External created at
     */
    external_created_at: string;
    /**
     * Type
     */
    type: string;
    /**
     * Purchase items
     */
    items: Array<{
        /**
         * SKU of purchase item
         */
        sku: string;
        /**
         * SAP SKU of purchase item
         */
        sap_sku: string | null;
        /**
         * Quantity of purchase items
         */
        quantity: number;
    }>;
};

export type ActionSchema = {
    /**
     * Action uuid
     */
    uuid: string;
    /**
     * External created at
     */
    external_created_at: string;
    /**
     * Status
     */
    status: 'new' | 'waiting-reward-rules' | 'processing' | 'processed' | 'failed';
    /**
     * Lead email address
     */
    email: string;
    /**
     * B2C rule code
     */
    b2c_rule_code?: string | null;
    /**
     * Type
     */
    type: string;
    /**
     * Data details
     */
    data?: {
        [key: string]: unknown;
    };
    tracking?: TrackingSchema | null;
    created_at: string | null;
    updated_at: string | null;
};

export type ActionSourceSchema = {
    /**
     * Representative id
     */
    representative_id: string;
    /**
     * Source id
     */
    source_id: string;
    /**
     * Source type
     */
    source_type: string;
};

export type LeadSchema = {
    address?: LeadAddressSchema | null;
    /**
     * Brand
     */
    brand?: string | null;
    /**
     * Date of birth
     */
    date_of_birth?: string | null;
    /**
     * Email address
     */
    email: string;
    extra_profile_information?: {
        /**
         * Language
         */
        language?: string;
    } | null;
    /**
     * First name
     */
    first_name?: string | null;
    /**
     * Gender
     */
    gender?: 'male' | 'female' | 'prefer_not_to_say' | null;
    /**
     * Is age verified
     */
    is_age_verified: boolean;
    /**
     * Is converted
     */
    is_converted: boolean;
    /**
     * Last name
     */
    last_name: string;
    /**
     * Notification channel
     */
    notification_channel?: 'email' | 'sms' | null;
    /**
     * Phone number
     */
    phone?: string | null;
    source?: LeadSourceSchema | null;
    tracking?: TrackingSchema | null;
    /**
     * Lead uuid
     */
    uuid: string;
    /**
     * Referral code
     */
    referral_code?: string | null;
    created_at?: string;
    updated_at?: string;
    /**
     * Date and time when the lead was anonymized
     */
    anonymized_at?: string | null;
};

export type LeadSourceSchema = {
    /**
     * Channel
     */
    channel?: string | null;
    /**
     * Representative id
     */
    representative_id: string;
    /**
     * Source id
     */
    source_id: string;
    /**
     * Source type
     */
    source_type: string;
};

export type LeadAddressSchema = {
    /**
     * Second-order civil entity below the country level
     */
    administrative_area_level_2?: string | null;
    /**
     * City
     */
    city?: string | null;
    /**
     * Postal code
     */
    postcode?: string | null;
    /**
     * Region
     */
    region?: string | null;
    /**
     * Street and numbers
     */
    street?: Array<string | null> | null;
    /**
     * Second-order civil entity below a locality
     */
    sublocality_level_2?: string | null;
    /**
     * Neighborhood/Area
     */
    neighborhood?: string | null;
    /**
     * Building name
     */
    premise?: string | null;
    /**
     * Landmark & special instructions
     */
    landmark?: string | null;
    /**
     * District
     */
    district?: string | null;
    /**
     * Building number
     */
    building_number?: string | null;
};

export type LoyaltyDomainConfiguration = {
    /**
     * Is Loyalty active
     */
    is_active: boolean;
};

export type ValidityRules = {
    time: {
        /**
         * Is limited
         */
        limited: boolean | null;
        /**
         * From
         */
        from: string | null;
        /**
         * To
         */
        to: string | null;
    };
} | null;

export type IndexEarningResponseSchema = {
    /**
     * Reward identifier
     */
    identifier: string;
    /**
     * Earning type
     */
    type: 'article' | 'product' | 'video' | 'quiz';
    /**
     * Tier levels
     */
    levels: Array<string>;
    /**
     * Amount of points with multiply
     */
    points_with_multiply: number;
    /**
     * Amount of points without multiply
     */
    points_without_multiply: number;
    /**
     * Is available
     */
    is_available: boolean;
    /**
     * Is read
     */
    is_read?: boolean | null;
    /**
     * Is video watched
     */
    is_watched?: boolean | null;
    /**
     * Is quiz completed
     */
    is_completed?: boolean | null;
    validity_rules: ValidityRules;
};

export type SurveyRequestBodySchema = {
    /**
     * Survey ID, eg. SurveyMonkey ID
     */
    survey_id: string;
} & {
    /**
     * Unique code for the survey, internal ID of survey on Evo side
     */
    unique_code?: string;
};

export type TransferRequestBodySchema = {
    points: number;
    comment?: string | null;
    wallet_code?: string | null;
};

export type EventRequestBodySchema = {
    /**
     * Event type
     */
    event_type: string;
    /**
     * Number of times event has to be triggered
     */
    multiplier?: number | null;
};

export type DeliveryAddress = {
    /**
     * First name
     */
    first_name?: string | null;
    /**
     * Last name
     */
    last_name: string;
    /**
     * Street and numbers
     */
    street: Array<string>;
    /**
     * City
     */
    city: string;
    region?: DeliveryAddressRegionSchema;
    /**
     * Postal code
     */
    post_code?: string | null;
    /**
     * Country code
     */
    country_code: string;
    /**
     * Phone number
     */
    phone?: string | null;
    /**
     * Second-order civil entity below the country level
     */
    administrative_area_level_2?: string | null;
    /**
     * Second-order civil entity below a locality
     */
    sublocality_level_2?: string | null;
    /**
     * Neighborhood/Area
     */
    neighborhood?: string | null;
    /**
     * Building name
     */
    premise?: string | null;
    /**
     * Landmark & special instructions
     */
    landmark?: string | null;
    /**
     * District
     */
    district?: string | null;
    /**
     * Building number
     */
    building_number?: string | null;
};

export type EligibleRewardRequestBodySchema = {
    order: {
        /**
         * Total price
         */
        order_total: number;
        /**
         * Minimum amount that a customer has to pay
         */
        minimum_payable_amount?: number;
        items: {
            'sku-1'?: {
                price: number;
                /**
                 * Quantity
                 */
                qty: number;
                /**
                 * List of categories which this product belongs to
                 */
                categories?: Array<number>;
            };
            'sku-2'?: {
                price: number;
                /**
                 * Quantity
                 */
                qty: number;
                /**
                 * List of categories which this product belongs to
                 */
                categories?: Array<number>;
            };
        };
    };
};

export type EligibleRewardResponseSchema = {
    reward_uuid: string;
    points: number;
    price: number;
    is_eligible: boolean;
    skus: Array<string>;
};

export type IndexRewardResponseSchema = {
    /**
     * Reward identifier
     */
    identifier: string;
    /**
     * Reward type
     */
    type: 'campaign' | 'prize' | 'external';
    /**
     * Type of prize
     */
    prize_type?: 'physical' | 'simplified' | 'delayed_lottery_physical' | 'instant_lottery_physical' | 'ygg';
    /**
     * Brand name
     */
    brand_name: string;
    presentation: {
        /**
         * Name
         */
        name: string;
        /**
         * Description
         */
        description?: string | null;
        /**
         * Images
         */
        images: Array<string>;
    };
    /**
     * Points amount
     */
    points: number;
    /**
     * Price
     */
    price: number;
    /**
     * Has coupons
     */
    has_coupons: boolean;
    /**
     * Is the reward currently active
     */
    is_active?: boolean;
    /**
     * Is the reward redeemable for logged in consumer, available only in consumer endpoints
     */
    is_redeemable?: boolean | null;
    /**
     * Tier levels
     */
    levels: Array<string>;
    /**
     * Created at
     */
    created_at: string;
    custom_attributes: {
        /**
         * Color name
         */
        color: string | null;
        /**
         * If delivery address is required
         */
        is_address_required: boolean;
        /**
         * Slug / link
         */
        slug: string | null;
        /**
         * Locations
         */
        locations: Array<string>;
    };
    usage_limit: {
        /**
         * General usage limit, -1 means unlimited
         */
        general?: number | null;
        /**
         * Per user usage limit
         */
        per_user?: number | null;
    };
    visibility: {
        /**
         * If the reward is visible all the time
         */
        all_time?: boolean | null;
        /**
         * Visibility from date
         */
        from?: string | null;
        /**
         * Visibility to date
         */
        to?: string | null;
    };
    /**
     * Number of times the reward has been redeemed by logged consumer
     */
    redeemed_times?: number | null;
    validity_rules: ValidityRules;
};

export type RewardFiltersResponseSchema = {
    data: {
        /**
         * Category buckets. Every reward belongs to exactly one bucket.
         */
        categories: {
            /**
             * Rewards returned by GET /rewards?is_virtual=1&prize_type=simplified
             */
            virtual: {
                /**
                 * Unique, alphabetically sorted subcategory names within this bucket
                 */
                subcategories: Array<string>;
                /**
                 * Number of visible rewards in this bucket
                 */
                total: number;
            };
            /**
             * Rewards returned by GET /rewards?is_virtual=0&prize_type=simplified
             */
            sensory_experience: {
                /**
                 * Unique, alphabetically sorted subcategory names within this bucket
                 */
                subcategories: Array<string>;
                /**
                 * Number of visible rewards in this bucket
                 */
                total: number;
            };
            /**
             * Rewards returned by GET /rewards?prize_type=physical
             */
            physical: {
                /**
                 * Unique, alphabetically sorted subcategory names within this bucket
                 */
                subcategories: Array<string>;
                /**
                 * Number of visible rewards in this bucket
                 */
                total: number;
            };
            /**
             * Rewards returned by GET /rewards?is_lottery=1
             */
            lottery: {
                /**
                 * Unique, alphabetically sorted subcategory names within this bucket
                 */
                subcategories: Array<string>;
                /**
                 * Number of visible rewards in this bucket
                 */
                total: number;
            };
        };
        /**
         * Points range across all visible rewards. Null when no rewards are visible.
         */
        points: {
            min: number | null;
            max: number | null;
        };
        /**
         * Active tier names in Open Loyalty order
         */
        tiers: Array<string>;
    };
};

export type RewardResponseSchema = {
    name: string;
    reward_uuid: string;
    points: number;
    price: number;
};

export type RedeemRewardResponseSchema = {
    /**
     * Issued reward UUID
     */
    uuid: string;
    /**
     * Issued coupon code
     */
    code?: string | null;
};

/**
 * Region
 */
export type DeliveryAddressRegionSchema = {
    /**
     * Code of region
     */
    region_code?: string | null;
    /**
     * Region name
     */
    region?: string | null;
    /**
     * Region ID
     */
    region_id?: number;
};

export type RewardConsumer = {
    consumer_uuid?: string;
    redemption_uuid?: string;
    redemption_status?: string;
    address?: {
        [key: string]: unknown;
    } | null;
};

export type TierResponseSchema = {
    name: string;
    /**
     * Points amount to achieve this tier
     */
    condition_value: number;
};

export type MarketingCommunication = MarketingCommunicationBaseFields;

export type MarketingCommunicationBaseFields = {
    /**
     * Marketing communication uuid
     */
    uuid: string;
    /**
     * Marketing communication uuid
     */
    subscriber_uuid: string;
    /**
     * Marketing communication email
     */
    email: string;
    /**
     * Marketing communication category
     */
    category: string;
};

export type PreferredLanguageFields = {
    /**
     * Preferred language code
     */
    preferredLanguage: string;
};

export type EmailFields = {
    /**
     * Email
     */
    email: string;
};

export type MarketingCommunicationInputFields = {
    /**
     * Marketing communication email
     */
    email: string;
    /**
     * Marketing communication category
     */
    category: string;
    consents?: Array<ConsentFields>;
    /**
     * Marketing communication preferred language
     */
    preferredLanguage?: string;
};

export type ConsentFields = {
    /**
     * Consent uuid
     */
    id: string;
    /**
     * Consent accepted or not
     */
    accepted: boolean;
};

export type PushSubscriptionSchema = {
    /**
     * Push notification subscription uuid
     */
    uuid: string;
    /**
     * Push notification subscription creation date and time
     */
    created_at: string;
    /**
     * Firebase token
     */
    firebase_token: string;
    /**
     * Platform of the device. If not provided, it will be determined from the user agent header.
     */
    platform?: 'androidos' | 'blackberryos' | 'palmos' | 'symbianos' | 'windowsmobileos' | 'windowsphoneos' | 'ios' | 'ipados' | 'sailfishos' | 'meegoos' | 'maemoos' | 'javaos' | 'webos' | 'badaos' | 'brewos' | 'harmonyos' | 'windows' | 'windows nt' | 'os x' | 'debian' | 'ubuntu' | 'macintosh' | 'openbsd' | 'linux' | 'chromeos' | null;
    /**
     * Type of the device. If not provided, it will be determined from the user agent header.
     */
    device_type?: 'desktop' | 'phone' | 'tablet' | 'robot' | 'other' | null;
};

export type SendPushNotificationFields = {
    /**
     * Title of the push notification
     */
    title: string;
    /**
     * Body of the push notification
     */
    body: string;
    /**
     * URL of the icon to display with the notification. This should be a small image, typically 48x48 pixels. Publicly accessible URL is required.
     */
    icon?: string | null;
    /**
     * URL of an image to display with the notification. Publicly accessible URL is required.
     */
    image?: string | null;
    /**
     * Additional data to send with the notification. This can include any key-value pairs that you want to include in the notification payload.
     */
    data?: {
        [key: string]: string;
    } | null;
};

export type SubscribePushNotificationFields = {
    /**
     * Firebase token
     */
    firebase_token: string;
    /**
     * Platform of the device. If not provided, it will be determined from the user agent header.
     */
    platform?: 'androidos' | 'blackberryos' | 'palmos' | 'symbianos' | 'windowsmobileos' | 'windowsphoneos' | 'ios' | 'ipados' | 'sailfishos' | 'meegoos' | 'maemoos' | 'javaos' | 'webos' | 'badaos' | 'brewos' | 'harmonyos' | 'windows' | 'windows nt' | 'os x' | 'debian' | 'ubuntu' | 'macintosh' | 'openbsd' | 'linux' | 'chromeos' | null;
    /**
     * Type of the device. If not provided, it will be determined from the user agent header.
     */
    device_type?: 'desktop' | 'phone' | 'tablet' | 'robot' | 'other' | null;
};

export type PushSubscribedSchema = {
    /**
     * Consumer uuid
     */
    consumer_uuid: string;
    /**
     * Push notification subscription uuid
     */
    uuid: string;
    /**
     * Push notification subscription creation date and time
     */
    created_at: string;
    /**
     * Firebase token
     */
    firebase_token: string;
    /**
     * Platform of the device. If not provided, it will be determined from the user agent header.
     */
    platform?: 'androidos' | 'blackberryos' | 'palmos' | 'symbianos' | 'windowsmobileos' | 'windowsphoneos' | 'ios' | 'ipados' | 'sailfishos' | 'meegoos' | 'maemoos' | 'javaos' | 'webos' | 'badaos' | 'brewos' | 'harmonyos' | 'windows' | 'windows nt' | 'os x' | 'debian' | 'ubuntu' | 'macintosh' | 'openbsd' | 'linux' | 'chromeos' | null;
    /**
     * Type of the device. If not provided, it will be determined from the user agent header.
     */
    device_type?: 'desktop' | 'phone' | 'tablet' | 'robot' | 'other' | null;
};

export type PushSubscriptionStatusSchema = {
    /**
     * Consumer UUID
     */
    consumer_uuid: string;
    /**
     * Indicates whether the consumer is subscribed to push notifications
     */
    is_subscribed: boolean;
    /**
     * List of push notification subscriptions for the consumer
     */
    subscriptions: Array<PushSubscriptionSchema>;
};

export type LocalTemplateFields = {
    /**
     * Template UUID
     */
    uuid?: string;
    /**
     * Template body supporting [Mustache](https://mustache.github.io/) placeholders. Placeholders must be wrapped in double curly braces
     */
    body?: string;
    /**
     * Record creation time
     */
    created_at?: string;
    /**
     * Record update time
     */
    updated_at?: string;
};

export type LocalTemplate = LocalTemplateFields;

export type ActivityLogFields = {
    /**
     * Log name
     */
    log_name?: string;
    /**
     * Event description
     */
    description?: string;
    /**
     * Class of related model
     */
    subject_type?: string | null;
    /**
     * Id of related model
     */
    subject_id?: number | null;
    event?: string | null;
    /**
     * Changes causer name
     */
    causer_name?: string | null;
    /**
     * Changes causer email
     */
    causer_email?: string | null;
    /**
     * Related tenant code
     */
    tenant_code?: string | null;
    /**
     * Properties of activity
     */
    properties?: {
        [key: string]: unknown;
    };
    batch_uuid?: string | null;
    /**
     * Record identifier
     */
    id?: number;
    /**
     * Record creation time
     */
    created_at?: string;
    /**
     * Record update time
     */
    updated_at?: string;
};

export type ActivityLog = ActivityLogFields;

export type HealthCheck = {
    status: 'failed' | 'ok';
    level?: 'warning' | 'fatal';
    checks: {
        [key: string]: {
            /**
             * Whether the check is ok, or why it failed.
             */
            status?: 'crashed' | 'failed' | 'ok' | 'skipped' | 'warning';
            message?: string | null | {
                [key: string]: unknown;
            };
        };
    };
};

export type OfflineCampaign = {
    /**
     * Name of the event
     */
    name: string;
    /**
     * Slug for the event (must be: lowercase latin letters, digits, dash
     */
    slug?: string | null;
    /**
     * Start time of the event
     */
    starts_at: string;
    /**
     * End time of the event (must be after starts_at)
     */
    ends_at: string;
    /**
     * Event type
     */
    event: string;
    /**
     * Source ID for the event
     */
    source_id: string;
};

export type OfflineCampaignCoupon = {
    /**
     * UUID of the associated offline campaign.
     */
    offline_campaign_uuid: string;
    /**
     * The coupon's code format.
     */
    format: 'EAN8' | 'EAN13' | 'Code128';
    /**
     * The coupon's code in the specified format.
     */
    code: string;
    /**
     * The user who used the coupon (if any).
     */
    user_uuid?: string | null;
};

export type OfflineCampaignCouponRequest = {
    /**
     * UUID of the associated offline campaign.
     */
    offline_campaign_uuid: string;
    /**
     * The coupon's code format.
     */
    format: 'EAN8' | 'EAN13' | 'Code128';
    /**
     * The coupon's code in the specified format.
     */
    code: string;
};

export type WithdrawFields = {
    uuid: string;
    order_id: string;
    reason: string | null;
    status: 'open' | 'closed';
    created_at: string;
    closed_at: string | null;
};

export type OrderFields = {
    info?: {
        oid?: number;
        order_id?: string;
        order_status?: 'new' | 'confirmed' | 'processing' | 'pending_payment' | 'payment_failed' | 'payment_completed' | 'holded' | 'shipped' | 'shipped_to_warehouse' | 'delivered' | 'delivered_to_pick_up_point' | 'pending_cancellation' | 'canceled' | 'returned';
        order_date?: string;
        total_due?: number;
        total_item_count?: number;
        subtotal?: number;
        tax_total?: number;
        shipping_amount?: number;
        update_date?: string;
        total?: number;
        discount?: number;
        shipping_amount_tax?: number;
        order_type?: string;
        fms_number?: string | null;
        coupons?: Array<{
            coupon?: string;
            category?: string;
        }>;
        loyalty_campaign_id?: string | null;
        cancel_reason_code?: string | null;
        cancel_reason_message?: string | null;
        parent_id?: string | null;
        attributes?: {
            traded_in_new_sku?: string | null;
            traded_in_model?: string | null;
            traded_in_serial_number?: string | null;
        } | null;
        store_id?: number;
        store_name?: string;
        total_discount?: number;
        order_origin?: string | null;
        expert_name?: string | null;
        loyalty_campaign?: {
            discounted_skus?: Array<string>;
            spent_points?: number;
            discount_amount?: number;
            name?: string | null;
        } | null;
    };
    customer?: {
        uuid?: string;
        email?: string;
        first_name?: string | null;
        last_name?: string;
        phone?: string;
        dob?: string;
        age_verified?: number;
    };
    billing_address?: {
        entity_id?: number;
        address_type?: string;
        city?: string;
        region?: string | null;
        region_code?: string | null;
        country_id?: string;
        email?: string;
        firstname?: string | null;
        lastname?: string;
        postcode?: string | null;
        street?: Array<string>;
        telephone?: string | null;
        company?: string | null;
    };
    payment?: {
        amount?: number;
        currency?: string;
        payment_method?: string;
        method_title?: string | null;
        method_code?: string | null;
        method_icon?: string | null;
    };
    shipping?: {
        amount?: number;
        method?: string | null;
        address?: {
            entity_id?: number;
            address_type?: string;
            city?: string;
            region?: string | null;
            region_code?: string | null;
            country_id?: string;
            email?: string;
            firstname?: string | null;
            lastname?: string;
            postcode?: string | null;
            street?: Array<string>;
            telephone?: string | null;
            company?: string | null;
        } & ({
            store_id?: string | null;
            store_name?: string | null;
        } | null);
    };
    gift_card?: {
        base_gift_cards_amount?: number;
        gift_cards_amount?: number;
        gift_cards?: Array<{
            code?: string;
            amount?: number;
        }>;
    };
    taxes?: {
        base_tax_amount?: number;
        tax_amount?: number;
        applied_taxes?: Array<{
            code?: string | null;
            title?: string | null;
            base_amount?: number;
            amount?: number;
        }>;
        item_applied_taxes?: Array<{
            type?: string;
            item_id?: number | null;
            associated_item_id?: number | null;
            applied_taxes?: Array<{
                code?: string | null;
                title?: string | null;
                base_amount?: number;
                amount?: number;
            }>;
        }>;
    };
    products?: Array<{
        product_type?: string;
        product_id?: number;
        name?: string;
        qty_ordered?: number;
        sku?: string;
        price?: number;
        price_incl_tax?: number;
        original_price?: number;
        original_price_incl_tax?: number;
        tax_amount?: number;
        discount_percent?: number;
        discount_amount?: number;
        sap_sku?: string | null;
        register_device_on_behalf_of_consumer?: boolean | null;
        items?: Array<{
            sku?: string;
            name?: string;
            qty?: number;
            original_price?: number;
            original_price_incl_tax?: number;
            presentation_price?: number | null;
            sap_sku?: string | null;
        }>;
        promotional_offers?: Array<string>;
    }>;
    adjustments?: Array<{
        type?: string;
        status?: string;
        open_date?: string;
        inform_warehouse?: boolean;
        data?: {
            order_adjustment?: {
                refund_request_id?: string | null;
                amount?: number;
                currency?: string;
            };
            items?: Array<{
                sku?: string;
                qty?: number;
                requires_return?: boolean;
                amount?: number;
                currency?: string;
                parent_sku?: string | null;
            }>;
        };
    }>;
};

export type PaymentMethod = {
    code?: string;
    title?: string;
    description?: string;
    icon?: string | null;
    type?: 'online' | 'offline';
    tokenizable?: boolean;
    visible?: boolean;
    adapter_code?: string;
    enabled?: boolean;
};

export type Refund = {
    uuid?: string;
    order_id?: number;
    customer_uuid?: string;
    payment_token?: string;
    amount?: number;
    currency?: string;
    reason_code?: string;
    status?: 'new' | 'processing' | 'done' | 'failed';
};

export type CreditCard = {
    uuid?: string;
    token_uuid?: string;
    number?: string;
    expiration_date?: string;
    /**
     * Raw data received from the adapter
     */
    metadata?: {
        [key: string]: unknown;
    };
};

export type Product = {
    id?: number;
    sku?: string;
    sap_sku?: string | null;
    type?: string | null;
    name?: string;
    structure_type?: string;
    price?: number;
    currency?: string;
    loyalty_rule?: string | null;
};

export type ImportProductSchema = {
    [key: string]: unknown;
};

export type Review = {
    review_id?: string;
    type?: 'product' | 'business-unit';
    profile_uuid?: string | null;
    sku?: string | null;
    /**
     * Review data
     */
    data?: {
        [key: string]: unknown;
    };
};

export type TenantWorkgroup = {
    /**
     * Tenant-workgroup mapping ID
     */
    id: number;
    /**
     * Workgroup ID in the shared database
     */
    workgroup_id: number;
    /**
     * SurveyMonkey external workgroup identifier
     */
    external_workgroup_id: string;
    /**
     * Name of the workgroup
     */
    workgroup_name: string;
};

export type QuizSubmission = {
    /**
     * Array with unspecified unvalidated payload.
     */
    questions?: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Array with unspecified unvalidated payload.
     */
    answers?: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Array with unspecified unvalidated payload.
     */
    results?: {
        [key: string]: unknown;
    };
};

export type Searchable = {
    /**
     * Original object identifier
     */
    item_id?: string;
    /**
     * Searchable item type
     */
    type?: 'product' | 'page' | 'faq';
    /**
     * Searchable item title
     */
    title?: string;
    /**
     * Original content URL
     */
    url?: string;
    /**
     * Language two symbol code
     */
    language?: string;
    /**
     * Searchable item thumbnail image
     */
    thumbnail?: string | null;
    /**
     * Content as JSON object
     */
    content?: {
        [key: string]: unknown;
    };
};

export type SearchItemResponse = {
    /**
     * Original object identifier
     */
    item_id?: string;
    /**
     * Searchable item type
     */
    type?: 'product' | 'page' | 'faq';
    /**
     * Searchable item title
     */
    title?: string;
    /**
     * Original content URL
     */
    url?: string;
    /**
     * Language two symbol code
     */
    language?: string;
    /**
     * Searchable item thumbnail image
     */
    thumbnail?: string | null;
    /**
     * Content as JSON object
     */
    content?: {
        [key: string]: unknown;
    };
} & {
    /**
     * Ranking score
     */
    ranking_score?: number | null;
    /**
     * Highlighted content
     */
    formatted?: {
        [key: string]: string;
    } | null;
};

export type SubscriptionFields = {
    uuid?: string;
    billed_at?: string;
    payment_token?: string | null;
    next_charge_at?: string | null;
    amount?: number;
    currency?: string;
    status?: 'pending' | 'active' | 'canceled' | 'suspended' | 'paused';
};

export type SubscriptionHistoryEventFields = {
    event: string;
    metadata: {
        [key: string]: unknown;
    } | null;
    date: string | null;
    type: 'internal' | 'external';
};

export type SubscriptionEventFields = {
    event: string;
    metadata: {
        [key: string]: unknown;
    } | null;
    date: string | null;
};

export type PaymentDetailsFields = {
    title: string;
    name: string;
    icon: string | null;
    card_number?: string;
    expiry?: {
        month?: string;
        year?: string;
    };
    brand: string;
    funding_method: string;
};

export type SubscriptionProductFields = {
    sku: string;
    qty: number;
    options: Array<{
        sku: string;
        qty: number;
    }> | null;
};

export type TrialFields = {
    uuid: string;
    consumer_id: string;
    order_id: number | null;
    final_order_id: number | null;
    sku: string;
    final_sku: string | null;
    manufacturer: string | null;
    program_id: number | null;
    status: 'pending' | 'ongoing' | 'charging' | 'failed' | 'fully_charged' | 'canceled' | 'blocked';
    channel: string;
    channel_type: 'online' | 'offline';
    start_date: string | null;
    end_date: string | null;
    billing_date: string | null;
    created_at: string;
    updated_at: string;
};

export type TenantVersion = TenantVersionFields;

export type Tenant = TenantFields;

export type TenantListingFields = {
    /**
     * Tenant ID
     */
    id?: number;
    /**
     * Tenant code
     */
    code: string;
    /**
     * Tenant name
     */
    name?: string;
    /**
     * Tenant country relation
     */
    country_code?: string;
    /**
     * Tenant configuration Id
     */
    configuration_id?: number | null;
    /**
     * Version
     */
    des_version?: string;
    /**
     * Previous Version
     */
    des_previous_version?: string;
    /**
     * Tenant database cluster
     */
    database_cluster?: string;
    /**
     * Is production
     */
    is_production?: boolean;
    /**
     * Has disaster recovery enabled
     */
    has_disaster_recovery_enabled?: boolean;
    /**
     * Auto update strategy. 'disabled' - tenant will not be auto updated on a new release. 'nightly' - tenant will be automatically updated on each new release. 'stable' - not working yet
     */
    auto_update?: 'disabled' | 'stable' | 'nightly';
    /**
     * Name or email of the person responsible for this tenant
     */
    contact_person?: string;
    /**
     * Record creation time
     */
    created_at?: string | null;
    /**
     * Record update time
     */
    updated_at?: string | null;
    /**
     * Cached aggregate tenant health-check status; null when no cached result is available
     */
    health_status?: string | null;
};

export type TenantVersionFields = {
    /**
     * Tenant code
     */
    code?: string;
    /**
     * Tenant name
     */
    name?: string;
    /**
     * Current version
     */
    version: string;
    /**
     * Has disaster recovery enabled
     */
    has_disaster_recovery_enabled: boolean;
    /**
     * Timestamp when the tenant was upgraded to the current version. Null if the upgrade was not tracked
     */
    version_upgraded_at: string | null;
};

export type TenantCreateFields = {
    /**
     * Tenant code
     */
    code: string;
    /**
     * Tenant name
     */
    name?: string;
    /**
     * Tenant country relation
     */
    country_code?: string;
    /**
     * Tenant configuration Id
     */
    configuration_id?: number | null;
    /**
     * Tenant database cluster
     */
    database_cluster?: string;
    /**
     * Is production
     */
    is_production?: boolean;
    /**
     * Auto update strategy. 'disabled' - tenant will not be auto updated on a new release. 'nightly' - tenant will be automatically updated on each new release. 'stable' - not working yet
     */
    auto_update?: 'disabled' | 'stable' | 'nightly';
    /**
     * Name or email of the person responsible for this tenant. Automatically filled if not specified.
     */
    contact_person?: string;
};

export type TenantFields = {
    /**
     * Tenant ID
     */
    id?: number;
    /**
     * Tenant code
     */
    code: string;
    /**
     * Tenant name
     */
    name?: string;
    /**
     * Tenant country relation
     */
    country_code?: string;
    /**
     * Tenant configuration Id
     */
    configuration_id?: number | null;
    /**
     * Version
     */
    des_version?: string;
    /**
     * Previous Version
     */
    des_previous_version?: string;
    /**
     * Tenant database cluster
     */
    database_cluster?: string;
    /**
     * Is production
     */
    is_production?: boolean;
    /**
     * Has disaster recovery enabled
     */
    has_disaster_recovery_enabled?: boolean;
    /**
     * Auto update strategy. 'disabled' - tenant will not be auto updated on a new release. 'nightly' - tenant will be automatically updated on each new release. 'stable' - not working yet
     */
    auto_update?: 'disabled' | 'stable' | 'nightly';
    /**
     * Name or email of the person responsible for this tenant
     */
    contact_person?: string;
    /**
     * Record creation time
     */
    created_at?: string | null;
    /**
     * Record update time
     */
    updated_at?: string | null;
};

export type ImportTenantFields = {
    /**
     * Encrypted data of the tenant with configuration and items
     */
    data: string;
    /**
     * Tenant code - use it if want to overwrite the code in encrypted data
     */
    tenant_code?: string;
    /**
     * Configuration name - use it if want to overwrite the code in encrypted data
     */
    configuration_name?: string;
};

export type TenantUpdateFields = {
    /**
     * Tenant name
     */
    name?: string;
    /**
     * Tenant country relation
     */
    country_code?: string;
    /**
     * Tenant configuration Id
     */
    configuration_id?: number;
    /**
     * Version
     */
    des_version?: string;
    /**
     * Previous Version
     */
    des_previous_version?: string;
    /**
     * Is production
     */
    is_production?: boolean;
    /**
     * Has disaster recovery
     */
    has_disaster_recovery_enabled?: boolean;
    /**
     * Auto update strategy. 'disabled' - tenant will not be auto updated on a new release. 'nightly' - tenant will be automatically updated on each new release. 'stable' - not working yet
     */
    auto_update?: 'disabled' | 'stable' | 'nightly';
};

export type ConfigurationSchema = {
    id?: number;
    name: string;
    items: Array<ConfigurationItem>;
};

export type TenantList = TenantListingFields & {
    configuration?: ConfigurationSchema;
};

export type ConfigurationItem = {
    id?: number;
    configuration_id?: number;
    type: string;
    options: {
        [key: string]: unknown;
    };
    updated_at?: string;
};

export type BusinessMetric = {
    id?: number;
    date?: string;
    name?: string;
    value?: string;
    created_at?: string;
    updated_at?: string;
};

export type UsersDomainConfiguration = {
    password_requirements: PasswordRequirementsFields;
    custom_attributes: {
        [key: string]: CustomAttributeFields;
    };
    /**
     * Keyed by the strategy, this contains information about the available authentication methods.
     */
    available_authentication_strategies: {
        [key: string]: AuthenticationMethodFields;
    };
    referrals: {
        /**
         * Status of the referrals subdomain
         */
        enabled?: boolean;
    };
    /**
     * Date of birth change policy
     */
    date_of_birth_change_policy: 'allow' | 'allow_if_not_av' | 'deny';
    /**
     * Minimum age in years
     */
    minimum_age_in_years: number;
    two_factor_authentication?: {
        /**
         * TwoFactorAuthentication method
         */
        method?: 'age_verification';
    };
    registration?: {
        /**
         * Whether age verification is required during registration
         */
        requires_age_verification?: boolean;
        /**
         * Whether device registration is required during registration
         */
        requires_device_registration?: boolean;
    };
};

export type Consumer = ConsumerFields;

export type CustomAttributeFields = {
    /**
     * Hint for attribute
     */
    hint?: string;
    /**
     * Type of attribute
     */
    type?: string;
    /**
     * Label for attribute
     */
    label?: string;
    /**
     * Behaviour of attribute
     */
    behaviour?: Array<string> | null;
    /**
     * Regex for string field validation
     */
    validation?: string | null;
    /**
     * Display after specific attribute
     */
    display_after?: string | null;
    /**
     * Indicates if attribute is required
     */
    is_required?: boolean;
    /**
     * Indicates if attribute is address field
     */
    is_address_field?: boolean;
    /**
     * Indicates whether attribute value can be cleared (this applies to an attribute that already has some value - when false it is forbidden to update to null/empty value after setting some not empty value)
     */
    clearable?: boolean;
};

export type PasswordRequirementsFields = {
    /**
     * Minimum length of password
     */
    min_length?: number;
    /**
     * Minimum count of lower case characters in password
     */
    min_lower_case?: number;
    /**
     * Minimum count of upper case characters in password
     */
    min_upper_case?: number;
    /**
     * Minimum count of digits in password
     */
    min_number?: number;
    /**
     * Minimum count of symbols (special characters) in password
     */
    min_symbol?: number;
    /**
     * Indicates if username should be excluded from password; this also means that if your email is j.doe@a.com then you can't use letter "j" in password
     */
    exclude_username?: boolean;
};

export type PersonalAccessTokenFields = {
    /**
     * User uuid
     */
    user_uuid: string;
    /**
     * Personal access token
     */
    token: string;
    /**
     * Magento personal access token
     */
    magento_token?: string | null;
    /**
     * Date time when access token expires
     */
    expires_at: number;
    profile?: ConsumerProfileSchema;
};

export type ConsumerMetaFields = {
    /**
     * Indicates if consumer is age verified
     */
    is_age_verified: boolean;
    /**
     * Indicates if consumer date of birth can be changed
     */
    allow_date_of_birth_update: boolean;
    /**
     * Indicates if consumer name can be changed
     */
    allow_name_update: boolean;
    /**
     * Two factor authentication status
     */
    two_factor_authentication_status?: AuthenticationStatusData | null;
};

export type ConsumerFields = {
    /**
     * Consumer uuid
     */
    uuid?: string;
    /**
     * Consumer email
     */
    email?: string;
    /**
     * Consumer phone
     */
    phone?: string | null;
    /**
     * Consumer first name
     */
    first_name?: string;
    /**
     * Consumer last name
     */
    last_name?: string;
    /**
     * Created date
     */
    created_at?: string | null;
    /**
     * Consumer birthday
     */
    date_of_birth?: string | null;
    /**
     * The age verification UUID if the user is age verified.
     */
    age_verification_uuid?: string | null;
    /**
     * Consumer custom attributes
     */
    custom_attributes?: {
        [key: string]: string | null;
    };
    /**
     * Consumer gender
     */
    gender?: 'male' | 'female' | 'prefer_not_to_say' | null;
    /**
     * Consumer referral code
     */
    referral_code?: string | null;
    /**
     * Consumer addresses
     */
    addresses?: Array<ConsumerAddressFields>;
    /**
     * Consumer source
     */
    source?: {
        [key: string]: string;
    };
    tracking?: TrackingSchema | null;
    /**
     * Consumer referred by
     */
    referred_by?: string | null;
    /**
     * Consumer referred at
     */
    referred_at?: string | null;
    /**
     * Consumer referral source
     */
    referral_source?: string | null;
    /**
     * How the referrer was resolved
     */
    referral_identifier_type?: 'phone_number' | 'referral_code';
    /**
     * Consumer parent code
     */
    parent_code?: string | null;
    /**
     * Consumer open loyalty uuid
     */
    open_loyalty_uuid?: string | null;
    /**
     * Consumer has first referrer purchase
     */
    has_first_referrer_purchase?: boolean;
    /**
     * Consumer has first loyalty purchase
     */
    has_first_loyalty_purchase?: boolean;
    /**
     * Consumer first purchase date
     */
    first_purchase_date?: string | null;
    /**
     * Consumer anonymized at
     */
    anonymized_at?: string | null;
    /**
     * Consumer deactivated at
     */
    deactivated_at?: string | null;
};

export type AuthenticationMethodFields = {
    /**
     * The strategy slug that controls which strategy is being used for authenticating and registering users
     */
    strategy: string;
    /**
     * Whether a password needs to be provided in the authentication payload
     */
    requires_password: boolean;
    /**
     * Whether this strategy can be used to register users or only authenticate them
     */
    registers_consumers: boolean;
    /**
     * Whether the strategy logs the user in after registration (i.e. provides an authentication token)
     */
    logs_user_in_after_registration: boolean;
    /**
     * Additional options that will give extra information to the client that requires the authentication methods.
     */
    options: {
        [key: string]: unknown;
    };
};

export type ConsumerAddressFields = {
    /**
     * Address ID
     */
    id?: number;
    /**
     * First name
     */
    firstname?: string | null;
    /**
     * Last name
     */
    lastname?: string;
    /**
     * Street and numbers
     */
    street?: Array<string>;
    /**
     * City
     */
    city?: string;
    /**
     * Postal code
     */
    postcode?: string | null;
    /**
     * Country code
     */
    country_id?: string;
    /**
     * Phone number
     */
    telephone?: string | null;
    /**
     * Address is default for shipping
     */
    default_shipping?: boolean;
    /**
     * Address is default for billing
     */
    default_billing?: boolean;
    region?: RegionSchema;
    /**
     * Extension attributes from Magento
     */
    extension_attributes?: {
        /**
         * Indicates whether address is subscription address
         */
        subscription?: boolean;
    };
    /**
     * Second-order civil entity below the country level
     */
    administrative_area_level_2?: string | null;
    /**
     * Second-order civil entity below a locality
     */
    sublocality_level_2?: string | null;
    /**
     * Neighborhood/Area
     */
    neighborhood?: string | null;
    /**
     * Building name
     */
    premise?: string | null;
    /**
     * Landmark & special instructions
     */
    landmark?: string | null;
    /**
     * District
     */
    district?: string | null;
    /**
     * Building number
     */
    building_number?: string | null;
    /**
     * Short address
     */
    short_address?: string | null;
};

export type ConsumerWithAuthenticationFields = ConsumerFields & {
    authentication: PersonalAccessTokenFields;
};

export type FacebookCredentialStrategySchema = {
    /**
     * Code fetched via Facebook OAuth redirection process
     */
    code: string;
};

export type ConsumerProfileSchema = {
    data?: {
        consumer?: Consumer;
        is_pending_email_verification?: boolean;
        referrer_statistics?: {
            /**
             * Total points earned from referrals
             */
            earned_points?: number;
            /**
             * Total number of referrals made
             */
            referrals_count?: number;
            /**
             * Number of referrals that completed their first order
             */
            completed_first_order_count?: number;
        } | null;
        purposes?: Array<string>;
        /**
         * Indicates if the consumer has registered a device, if null then evaluation has not been performed
         */
        has_registered_device?: boolean | null;
        referrals?: {
            /**
             * Indicates if user is eligible to enter a referral code
             */
            can_enter_a_code?: boolean;
            /**
             * Indicates if user is eligible for referral discount
             */
            can_receive_discount?: boolean;
        } | null;
    };
    meta?: ConsumerMetaFields;
};

/**
 * Region
 */
export type RegionSchema = {
    /**
     * Code of region
     */
    region_code?: string | null;
    /**
     * Region name
     */
    region?: string | null;
    /**
     * Region ID
     */
    region_id?: number;
};

export type GoogleCredentialStrategySchema = {
    /**
     * Code fetched via Google OAuth redirection process or an ID token (JWT) when client is different than "web"
     */
    code: string;
    /**
     * Type of the client application
     */
    client?: 'web' | 'android' | 'ios' | null;
};

export type EmailCredentialStrategySchema = {
    /**
     * Identifier supported by email-credential strategy
     */
    identifier?: string;
    password?: string;
};

export type PersonalAccessTokenSchema = PersonalAccessTokenFields;

export type KakaoCredentialStrategySchema = {
    /**
     * Code fetched via Kakao OAuth redirection process
     */
    code?: string;
    /**
     * Custom redirect URI
     */
    redirect_uri?: string | null;
};

export type ConsumerDeactivation = {
    id?: number;
    consumer_uuid?: string;
    /**
     * Null for permanent deactivation; future date for active temporary; past date for expired temporary.
     */
    deactivated_until?: string | null;
    reason?: string | null;
    type?: 'permanent' | 'temporary';
    status?: 'active' | 'expired';
    created_at?: string;
    updated_at?: string;
};

export type RegistrationEmailCredentialStrategySchema = {
    /**
     * Identifier supported by email-credential strategy
     */
    identifier?: string;
    password?: string;
};

export type RegistrationSchema = ConsumerFields | ConsumerWithAuthenticationFields;

export type RegistrationKakaoCredentialStrategySchema = {
    /**
     * Code fetched via Kakao OAuth redirection process
     */
    code?: string;
    /**
     * Custom redirect URI
     */
    redirect_uri?: string | null;
};

export type ConsumerReportSchema = ConsumerReportFields;

export type ConsumerReportFields = {
    /**
     * Consumer uuid
     */
    uuid?: string;
    /**
     * Consumer email
     */
    email?: string;
    /**
     * Consumer phone
     */
    phone?: string | null;
    /**
     * Consumer first name
     */
    first_name?: string;
    /**
     * Consumer last name
     */
    last_name?: string;
    /**
     * Consumer birthday
     */
    date_of_birth?: string | null;
    /**
     * Consumer custom attributes
     */
    custom_attributes?: {
        [key: string]: unknown;
    };
    /**
     * Consumer gender
     */
    gender?: 'male' | 'female' | 'prefer_not_to_say' | null;
    /**
     * Consumer addresses
     */
    addresses?: Array<ConsumerAddressFields>;
    /**
     * The age verification UUID if the user is age verified.
     */
    age_verification_uuid?: string | null;
    is_pending_email_verification?: boolean;
    /**
     * Referral Code
     */
    referral_code?: string;
    /**
     * Consumer referred by
     */
    referred_by?: string | null;
    purposes?: Array<string>;
    /**
     * Consumer source
     */
    source?: {
        [key: string]: string;
    };
    /**
     * Consumer authentication strategies
     */
    authentication_strategies?: Array<'email-credential' | 'kakao-credential' | 'facebook-credential' | 'google-credential' | 'phone-number-credential' | 'magento-credential' | 'magento-to-email-credential' | 'one-time-limited-token'>;
    /**
     * Consumer created at
     */
    created_at?: string;
    /**
     * Consumer deactivated at
     */
    deactivated_at?: string | null;
    /**
     * Consumer anonymized at
     */
    anonymized_at?: string | null;
    /**
     * Consumer updated at
     */
    updated_at?: string;
};

/**
 * 2FA status
 */
export type AuthenticationStatusData = {
    /**
     * 2FA method
     */
    method: 'age_verification';
    /**
     * 2FA creation date
     */
    expires_at: string;
};

export type WebhookFields = {
    /**
     * Webhook identifier
     */
    id?: number;
    /**
     * Webhook event
     */
    event?: string;
    /**
     * Webhook name
     */
    name?: string;
    /**
     * Webhook description
     */
    description?: string | null;
    /**
     * Webhook URL
     */
    url?: string;
    /**
     * Webhook secret key
     */
    secret?: string;
    /**
     * Webhook transformer: the name(s) of the transformer(s) to use for the webhook payload
     */
    transformers?: Array<'none' | 'non-standard-date-of-birth'> | null;
};

export type Webhook = WebhookFields;

export type DisInventoryItemCodeValidationData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Device Identifier. Either LeafletId (RC) which is 16 character long string or Device Serial Number (TC) which is at least 12 characters long. For TC, only first 12 characters will be used
         */
        code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/devices/validation/{code}';
};

export type DisInventoryItemCodeValidationErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * The requested Device Id doesn't exist as a valid Leaflet Id or Serial Number.
     */
    406: ErrorMessageFields;
    /**
     * The requested Device Id is already registered to some user.
     */
    409: DeviceAlreadyRegisteredResponse;
    /**
     * Failed due to an error throughout the processing.
     */
    500: unknown;
};

export type DisInventoryItemCodeValidationError = DisInventoryItemCodeValidationErrors[keyof DisInventoryItemCodeValidationErrors];

export type DisInventoryItemCodeValidationResponses = {
    /**
     * Device id is valid for registration.
     */
    200: InventoryItemCodeValidation;
};

export type DisInventoryItemCodeValidationResponse = DisInventoryItemCodeValidationResponses[keyof DisInventoryItemCodeValidationResponses];

export type ConsumerCanceledData = {
    /**
     * Consumer canceled webhook data
     */
    body?: ConsumerCanceled;
    headers?: {
        /**
         * Security scheme: WebhookSecurityScheme
         */
        'X-DES-SIGNATURE'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/webhooks/consumer_canceled';
};

export type ConsumerCanceledErrors = {
    /**
     * The request parameters are invalid, either missing or not correctly formatted.
     */
    400: ErrorMessageFields;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to an error throughout the processing.
     */
    500: unknown;
};

export type ConsumerCanceledError = ConsumerCanceledErrors[keyof ConsumerCanceledErrors];

export type ConsumerCanceledResponses = {
    /**
     * Empty response
     */
    200: unknown;
};

export type GetDisInventoryItemData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * The microservice way of authenticating users is now deprecated and will be removed in the future. Use the 'UserSecurityScheme' instead.
         */
        'X-DES-CONSUMER-IAM-TOKEN'?: string | null;
    };
    path: {
        /**
         * Device Identifier. Either LeafletId (RC) which is 16 character long string or Device Serial Number (TC) which is at least 12 characters long. For TC, only first 12 characters will be used
         */
        code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/devices/{code}';
};

export type GetDisInventoryItemErrors = {
    /**
     * The provided Device Id is invalid or no such Device is registered with the provided Device Id.
     */
    400: DiSv1BadRequestResponse;
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Failed due to an error throughout the processing.
     */
    500: unknown;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type GetDisInventoryItemError = GetDisInventoryItemErrors[keyof GetDisInventoryItemErrors];

export type GetDisInventoryItemResponses = {
    /**
     * Device information successfully retrieved.
     */
    200: GetInventoryItem;
    /**
     * The Device with the specified Device Id was not found.
     */
    204: void;
};

export type GetDisInventoryItemResponse = GetDisInventoryItemResponses[keyof GetDisInventoryItemResponses];

export type ListDisInventoryItemForUserData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * The microservice way of authenticating users is now deprecated and will be removed in the future. Use the 'UserSecurityScheme' instead.
         */
        'X-DES-CONSUMER-IAM-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Personal ID of the user or Consumer Uuid
         */
        userId?: string;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/devices';
};

export type ListDisInventoryItemForUserErrors = {
    /**
     * The request parameters are invalid, either missing or not correctly formatted.
     */
    400: ErrorMessageFields;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Failed due to an error throughout the processing.
     */
    500: unknown;
};

export type ListDisInventoryItemForUserError = ListDisInventoryItemForUserErrors[keyof ListDisInventoryItemForUserErrors];

export type ListDisInventoryItemForUserResponses = {
    /**
     * Device list information successfully retrieved.
     */
    200: GetInventoryItems;
};

export type ListDisInventoryItemForUserResponse = ListDisInventoryItemForUserResponses[keyof ListDisInventoryItemForUserResponses];

export type RegisterDiSv1InventoryItemData = {
    /**
     * Register a new Device
     */
    body?: RegisterDeviceRequest;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating users is now deprecated and will be removed in the future. Use the 'UserSecurityScheme' instead.
         */
        'X-DES-CONSUMER-IAM-TOKEN'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/devices';
};

export type RegisterDiSv1InventoryItemErrors = {
    /**
     * The request parameters are invalid, either missing or not correctly formatted.
     */
    400: ErrorMessageFields;
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * The requested Device Id doesn't exist as a valid Leaflet Id or Serial Number.
     */
    406: ErrorMessageFields;
    /**
     * The requested Device Id is already registered to some user.
     */
    409: DeviceAlreadyRegisteredResponse;
    /**
     * Failed due to an error throughout the processing.
     */
    500: unknown;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type RegisterDiSv1InventoryItemError = RegisterDiSv1InventoryItemErrors[keyof RegisterDiSv1InventoryItemErrors];

export type RegisterDiSv1InventoryItemResponses = {
    /**
     * The successful device registration process triggered result with requested device information.
     */
    202: DeviceRegisteredResponse;
};

export type RegisterDiSv1InventoryItemResponse = RegisterDiSv1InventoryItemResponses[keyof RegisterDiSv1InventoryItemResponses];

export type UnregisterInventoryItemForConsumerData = {
    /**
     * Unregister a Inventory Item by Consumer
     */
    body?: UnregisterInventoryItemByConsumerRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * The microservice way of authenticating users is now deprecated and will be removed in the future. Use the 'UserSecurityScheme' instead.
         */
        'X-DES-CONSUMER-IAM-TOKEN'?: string | null;
    };
    path: {
        /**
         * Device Identifier. Either LeafletId (RC) which is 16 character long string or Device Serial Number (TC) which is at least 12 characters long. For TC, only first 12 characters will be used
         */
        code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/devices/{code}/unassign';
};

export type UnregisterInventoryItemForConsumerErrors = {
    /**
     * The request parameters are invalid, either missing or not correctly formatted.
     */
    400: ErrorMessageFields;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Failed due to an error throughout the processing.
     */
    500: unknown;
};

export type UnregisterInventoryItemForConsumerError = UnregisterInventoryItemForConsumerErrors[keyof UnregisterInventoryItemForConsumerErrors];

export type UnregisterInventoryItemForConsumerResponses = {
    /**
     * Device removal request is successfully processed.
     */
    202: UnregisterInventoryItemForGuestResponse;
};

export type UnregisterInventoryItemForConsumerResponse = UnregisterInventoryItemForConsumerResponses[keyof UnregisterInventoryItemForConsumerResponses];

export type RegisterInventoryItemForGuestData = {
    /**
     * Register a new Device
     */
    body?: GuestRegisterDeviceRequest;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/devices/guest';
};

export type RegisterInventoryItemForGuestErrors = {
    /**
     * The request parameters are invalid, either missing or not correctly formatted.
     */
    400: ErrorMessageFields;
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * The requested Device Id doesn't exist as a valid Leaflet Id or Serial Number.
     */
    406: ErrorMessageFields;
    /**
     * The requested Device Id is already registered to some user.
     */
    409: DeviceAlreadyRegisteredResponse;
    /**
     * Failed due to an error throughout the processing.
     */
    500: unknown;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type RegisterInventoryItemForGuestError = RegisterInventoryItemForGuestErrors[keyof RegisterInventoryItemForGuestErrors];

export type RegisterInventoryItemForGuestResponses = {
    /**
     * The successful device registration process triggered result with requested device information.
     */
    202: DeviceRegisteredResponse;
};

export type RegisterInventoryItemForGuestResponse = RegisterInventoryItemForGuestResponses[keyof RegisterInventoryItemForGuestResponses];

export type UnregisterInventoryItemForGuestData = {
    /**
     * Unregister a Inventory Item by Guest
     */
    body?: UnregisterInventoryItemByGuestRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Device Identifier. Either LeafletId (RC) which is 16 character long string or Device Serial Number (TC) which is at least 12 characters long. For TC, only first 12 characters will be used
         */
        code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/devices/guest/{code}/unassign';
};

export type UnregisterInventoryItemForGuestErrors = {
    /**
     * The request parameters are invalid, either missing or not correctly formatted.
     */
    400: ErrorMessageFields;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Failed due to an error throughout the processing.
     */
    500: unknown;
};

export type UnregisterInventoryItemForGuestError = UnregisterInventoryItemForGuestErrors[keyof UnregisterInventoryItemForGuestErrors];

export type UnregisterInventoryItemForGuestResponses = {
    /**
     * Device removal request is successfully processed.
     */
    202: UnregisterInventoryItemForGuestResponse;
};

export type UnregisterInventoryItemForGuestResponse2 = UnregisterInventoryItemForGuestResponses[keyof UnregisterInventoryItemForGuestResponses];

export type AssignCustomerToInventoryItemData = {
    /**
     * Assign Customer to Inventory Item
     */
    body?: AssignCustomerToInventoryItem;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Device Identifier. Either LeafletId (RC) which is 16 character long string or Device Serial Number (TC) which is at least 12 characters long. For TC, only first 12 characters will be used
         */
        code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/devices/{code}/consumer';
};

export type AssignCustomerToInventoryItemErrors = {
    /**
     * The request parameters are invalid, either missing or not correctly formatted.
     */
    400: ErrorMessageFields;
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * The requested Device Id doesn't exist as a valid Leaflet Id or Serial Number.
     */
    406: ErrorMessageFields;
    /**
     * The requested device cannot be attached to the consumer.
     */
    409: ErrorMessageFields;
    /**
     * Failed due to an error throughout the processing.
     */
    500: unknown;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type AssignCustomerToInventoryItemError = AssignCustomerToInventoryItemErrors[keyof AssignCustomerToInventoryItemErrors];

export type AssignCustomerToInventoryItemResponses = {
    /**
     * The successful Consumer assignment process triggered result with requested device information.
     */
    202: ConsumerAssignedResponse;
};

export type AssignCustomerToInventoryItemResponse = AssignCustomerToInventoryItemResponses[keyof AssignCustomerToInventoryItemResponses];

export type ListDeviceRegistrationHistoryData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Device Identifier. Either LeafletId (RC) which is 16 character long string or Device Serial Number (TC) which is at least 12 characters long. For TC, only first 12 characters will be used
         */
        code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/devices/{code}/history';
};

export type ListDeviceRegistrationHistoryErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * The requested Device Id doesn't exist as a valid Leaflet Id or Serial Number.
     */
    404: ErrorMessageFields;
    /**
     * Failed due to an error throughout the processing.
     */
    500: unknown;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type ListDeviceRegistrationHistoryError = ListDeviceRegistrationHistoryErrors[keyof ListDeviceRegistrationHistoryErrors];

export type ListDeviceRegistrationHistoryResponses = {
    /**
     * List of device registration history
     */
    200: GetDeviceRegistrationHistoryResponse;
};

export type ListDeviceRegistrationHistoryResponse = ListDeviceRegistrationHistoryResponses[keyof ListDeviceRegistrationHistoryResponses];

export type ProductRegisterData = {
    /**
     * Information to register a new product
     */
    body?: RegisterProductRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/products/register';
};

export type ProductRegisterErrors = {
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type ProductRegisterError = ProductRegisterErrors[keyof ProductRegisterErrors];

export type ProductRegisterResponses = {
    /**
     * Register a new product to setup customer inventory and warranty.
     */
    200: RegisterProduct;
};

export type ProductRegisterResponse = ProductRegisterResponses[keyof ProductRegisterResponses];

export type UserDetailsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating users is now deprecated and will be removed in the future. Use the 'UserSecurityScheme' instead.
         */
        'X-DES-CONSUMER-IAM-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/me';
};

export type UserDetailsErrors = {
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type UserDetailsError = UserDetailsErrors[keyof UserDetailsErrors];

export type UserDetailsResponses = {
    /**
     * Get information about all kinds of limits per product type for logged user.
     */
    200: UserDetails;
};

export type UserDetailsResponse = UserDetailsResponses[keyof UserDetailsResponses];

export type MeProductRegisterData = {
    /**
     * Information to register a new product for logged customer
     */
    body?: MeRegisterProduct;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating users is now deprecated and will be removed in the future. Use the 'UserSecurityScheme' instead.
         */
        'X-DES-CONSUMER-IAM-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/me/products/register';
};

export type MeProductRegisterErrors = {
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type MeProductRegisterError = MeProductRegisterErrors[keyof MeProductRegisterErrors];

export type MeProductRegisterResponses = {
    /**
     * Register a new product to setup customer inventory and warranty.
     */
    200: RegisterProduct;
};

export type MeProductRegisterResponse = MeProductRegisterResponses[keyof MeProductRegisterResponses];

export type GetProductPrefixesData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * The page number of items
         */
        page?: number | null;
        /**
         * The number of items per page
         */
        per_page?: number | null;
        /**
         * Filter by prefix code for the device. It is embedded in the leaflet number
         */
        'filters[prefix]'?: string | null;
        /**
         * Filter by tenant code
         */
        'filters[tenant_code]'?: string | null;
        /**
         * Filter by SKU
         */
        'filters[sku]'?: string | null;
        /**
         * Filter by product color
         */
        'filters[product_color]'?: string | null;
        /**
         * Filter by product type
         */
        'filters[product_type]'?: string | null;
        /**
         * Sorting by field. Adding '-' before field changes the direction to descending
         */
        sort?: string | null;
    };
    url: '/api/inventory/product-prefixes';
};

export type GetProductPrefixesErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetProductPrefixesError = GetProductPrefixesErrors[keyof GetProductPrefixesErrors];

export type GetProductPrefixesResponses = {
    /**
     * Returns a list of product prefixes
     */
    200: ProductPrefixListResponse;
};

export type GetProductPrefixesResponse = GetProductPrefixesResponses[keyof GetProductPrefixesResponses];

export type ProductPrefixData = {
    /**
     * ProductPrefix data
     */
    body?: ProductPrefixRequestFields;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/inventory/product-prefixes';
};

export type ProductPrefixErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ProductPrefixError = ProductPrefixErrors[keyof ProductPrefixErrors];

export type ProductPrefixResponses = {
    /**
     * Product prefix response
     */
    201: ProductPrefix;
};

export type ProductPrefixResponse2 = ProductPrefixResponses[keyof ProductPrefixResponses];

export type DeleteProductPrefixData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * ID of Product Prefix
         */
        id: number;
    };
    query?: never;
    url: '/api/inventory/product-prefixes/{id}';
};

export type DeleteProductPrefixErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DeleteProductPrefixError = DeleteProductPrefixErrors[keyof DeleteProductPrefixErrors];

export type DeleteProductPrefixResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeleteProductPrefixResponse = DeleteProductPrefixResponses[keyof DeleteProductPrefixResponses];

export type GetProductPrefixData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * ID of Product Prefix
         */
        id: number;
    };
    query?: never;
    url: '/api/inventory/product-prefixes/{id}';
};

export type GetProductPrefixErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetProductPrefixError = GetProductPrefixErrors[keyof GetProductPrefixErrors];

export type GetProductPrefixResponses = {
    /**
     * Product prefix response
     */
    200: ProductPrefix;
};

export type GetProductPrefixResponse = GetProductPrefixResponses[keyof GetProductPrefixResponses];

export type UpdateProductPrefixData = {
    /**
     * ProductPrefix data
     */
    body?: ProductPrefixRequestFields;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * ID of Product Prefix
         */
        id: number;
    };
    query?: never;
    url: '/api/inventory/product-prefixes/{id}';
};

export type UpdateProductPrefixErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateProductPrefixError = UpdateProductPrefixErrors[keyof UpdateProductPrefixErrors];

export type UpdateProductPrefixResponses = {
    /**
     * Product prefix response
     */
    200: ProductPrefix;
};

export type UpdateProductPrefixResponse = UpdateProductPrefixResponses[keyof UpdateProductPrefixResponses];

export type GetConfigurationSchemasData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/tenants/configurations/schemas';
};

export type GetConfigurationSchemasErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetConfigurationSchemasError = GetConfigurationSchemasErrors[keyof GetConfigurationSchemasErrors];

export type GetConfigurationSchemasResponses = {
    /**
     * Configuration schemas response
     */
    200: ConfigurationSchemasResponse;
};

export type GetConfigurationSchemasResponse = GetConfigurationSchemasResponses[keyof GetConfigurationSchemasResponses];

export type UpdateBulkConfigurationItemsData = {
    /**
     * List of Configuration Items
     */
    body?: BulkUpsertConfigurationItems;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Configuration identifier
         */
        id: number;
    };
    query?: {
        /**
         * Dry run
         */
        'dry-run'?: boolean;
    };
    url: '/api/tenants/configurations/{id}/items/bulk';
};

export type UpdateBulkConfigurationItemsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateBulkConfigurationItemsError = UpdateBulkConfigurationItemsErrors[keyof UpdateBulkConfigurationItemsErrors];

export type UpdateBulkConfigurationItemsResponses = {
    /**
     * Configuration item response
     */
    200: ConfigurationItemResponse;
};

export type UpdateBulkConfigurationItemsResponse = UpdateBulkConfigurationItemsResponses[keyof UpdateBulkConfigurationItemsResponses];

export type DeleteConfigurationItemData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Configuration identifier
         */
        id: number;
        /**
         * Type of configuration item
         */
        type: string;
    };
    query?: never;
    url: '/api/tenants/configurations/{id}/items/{type}';
};

export type DeleteConfigurationItemErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DeleteConfigurationItemError = DeleteConfigurationItemErrors[keyof DeleteConfigurationItemErrors];

export type DeleteConfigurationItemResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeleteConfigurationItemResponse = DeleteConfigurationItemResponses[keyof DeleteConfigurationItemResponses];

export type GetConfigurationItemData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Configuration identifier
         */
        id: number;
        /**
         * Type of configuration item
         */
        type: string;
    };
    query?: never;
    url: '/api/tenants/configurations/{id}/items/{type}';
};

export type GetConfigurationItemErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetConfigurationItemError = GetConfigurationItemErrors[keyof GetConfigurationItemErrors];

export type GetConfigurationItemResponses = {
    /**
     * Configuration item response
     */
    200: ConfigurationItemResponse;
};

export type GetConfigurationItemResponse = GetConfigurationItemResponses[keyof GetConfigurationItemResponses];

export type UpdateConfigurationItemData = {
    /**
     * Update Configuration Item
     */
    body?: UpdateConfigurationItem;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Configuration identifier
         */
        id: number;
        /**
         * Type of configuration item
         */
        type: string;
    };
    query?: never;
    url: '/api/tenants/configurations/{id}/items/{type}';
};

export type UpdateConfigurationItemErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateConfigurationItemError = UpdateConfigurationItemErrors[keyof UpdateConfigurationItemErrors];

export type UpdateConfigurationItemResponses = {
    /**
     * Configuration item response
     */
    200: ConfigurationItemResponse;
};

export type UpdateConfigurationItemResponse = UpdateConfigurationItemResponses[keyof UpdateConfigurationItemResponses];

export type CreateConfigurationItemData = {
    /**
     * Create Configuration Item
     */
    body?: CreateConfigurationItem;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Configuration identifier
         */
        id: number;
    };
    query?: {
        /**
         * Dry run
         */
        'dry-run'?: boolean;
    };
    url: '/api/tenants/configurations/{id}/items';
};

export type CreateConfigurationItemErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreateConfigurationItemError = CreateConfigurationItemErrors[keyof CreateConfigurationItemErrors];

export type CreateConfigurationItemResponses = {
    /**
     * Configuration item response
     */
    200: ConfigurationItemResponse;
};

export type CreateConfigurationItemResponse = CreateConfigurationItemResponses[keyof CreateConfigurationItemResponses];

export type ListConfigurationsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/tenants/configurations';
};

export type ListConfigurationsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListConfigurationsError = ListConfigurationsErrors[keyof ListConfigurationsErrors];

export type ListConfigurationsResponses = {
    /**
     * Return a list of all configurations
     */
    200: ListConfigurationResponse;
};

export type ListConfigurationsResponse = ListConfigurationsResponses[keyof ListConfigurationsResponses];

export type CreateConfigurationData = {
    /**
     * Configuration
     */
    body?: ConfigurationBody;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/tenants/configurations';
};

export type CreateConfigurationErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreateConfigurationError = CreateConfigurationErrors[keyof CreateConfigurationErrors];

export type CreateConfigurationResponses = {
    /**
     * Configuration response
     */
    200: ConfigurationResponse;
};

export type CreateConfigurationResponse = CreateConfigurationResponses[keyof CreateConfigurationResponses];

export type DeleteConfigurationData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Configuration identifier
         */
        id: number;
    };
    query?: {
        /**
         * Dry run
         */
        'dry-run'?: boolean;
    };
    url: '/api/tenants/configurations/{id}';
};

export type DeleteConfigurationErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DeleteConfigurationError = DeleteConfigurationErrors[keyof DeleteConfigurationErrors];

export type DeleteConfigurationResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeleteConfigurationResponse = DeleteConfigurationResponses[keyof DeleteConfigurationResponses];

export type GetConfigurationData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Configuration identifier
         */
        id: number;
    };
    query?: {
        /**
         * Dry run
         */
        'dry-run'?: boolean;
    };
    url: '/api/tenants/configurations/{id}';
};

export type GetConfigurationErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetConfigurationError = GetConfigurationErrors[keyof GetConfigurationErrors];

export type GetConfigurationResponses = {
    /**
     * Configuration response
     */
    200: ConfigurationResponse;
};

export type GetConfigurationResponse = GetConfigurationResponses[keyof GetConfigurationResponses];

export type UpdateConfigurationData = {
    /**
     * Configuration
     */
    body?: ConfigurationBody;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Configuration identifier
         */
        id: number;
    };
    query?: {
        /**
         * Dry run
         */
        'dry-run'?: boolean;
    };
    url: '/api/tenants/configurations/{id}';
};

export type UpdateConfigurationErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateConfigurationError = UpdateConfigurationErrors[keyof UpdateConfigurationErrors];

export type UpdateConfigurationResponses = {
    /**
     * Configuration response
     */
    200: ConfigurationResponse;
};

export type UpdateConfigurationResponse = UpdateConfigurationResponses[keyof UpdateConfigurationResponses];

export type ListTenantsVersionsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/tenants-versions';
};

export type ListTenantsVersionsErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
};

export type ListTenantsVersionsError = ListTenantsVersionsErrors[keyof ListTenantsVersionsErrors];

export type ListTenantsVersionsResponses = {
    /**
     * Return a list of tenants with current version
     */
    200: TenantsVersionsResponse;
};

export type ListTenantsVersionsResponse = ListTenantsVersionsResponses[keyof ListTenantsVersionsResponses];

export type ListTenantPublicConfigurationsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/tenants/public-configurations';
};

export type ListTenantPublicConfigurationsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
};

export type ListTenantPublicConfigurationsError = ListTenantPublicConfigurationsErrors[keyof ListTenantPublicConfigurationsErrors];

export type ListTenantPublicConfigurationsResponses = {
    /**
     * Public configuration response
     */
    200: PublicConfigurationResponse;
};

export type ListTenantPublicConfigurationsResponse = ListTenantPublicConfigurationsResponses[keyof ListTenantPublicConfigurationsResponses];

export type ListBusinessMetricsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters using the standardized query processing system
         */
        filter?: {
            date?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            name?: {
                /**
                 * In filter
                 */
                in?: string;
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
        };
        /**
         * Comma-separated list of fields to sort by. Prefix with "-" for descending order (e.g., "code,-created_at"). Multiple fields are supported.
         */
        sort?: string;
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/tenants/business-metrics';
};

export type ListBusinessMetricsErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type ListBusinessMetricsError = ListBusinessMetricsErrors[keyof ListBusinessMetricsErrors];

export type ListBusinessMetricsResponses = {
    /**
     * Tenant's business metrics list.
     */
    200: ListBusinessMetricsResponse;
};

export type ListBusinessMetricsResponse2 = ListBusinessMetricsResponses[keyof ListBusinessMetricsResponses];

export type ListTenantsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            /**
             * Tenants created before date
             */
            created_before?: string;
            /**
             * Tenants created after date
             */
            created_after?: string;
            phrase?: {
                /**
                 * Like filter
                 */
                like?: string;
            };
            name?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            code?: {
                /**
                 * In filter
                 */
                in?: string;
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            contact_person?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            sem_version?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            des_version?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            created_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            is_production?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
        };
        /**
         * Comma-separated list of fields to sort by. Prefix with "-" for descending order (e.g., "code,-created_at"). Multiple fields are supported.
         */
        sort?: string;
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
    };
    url: '/api/tenants';
};

export type ListTenantsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListTenantsError = ListTenantsErrors[keyof ListTenantsErrors];

export type ListTenantsResponses = {
    /**
     * Return a list of available tenants
     */
    200: TenantListResponse;
};

export type ListTenantsResponse = ListTenantsResponses[keyof ListTenantsResponses];

export type CreateTenantData = {
    /**
     * Tenant Create Data
     */
    body?: TenantCreateFields;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/tenants';
};

export type CreateTenantErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreateTenantError = CreateTenantErrors[keyof CreateTenantErrors];

export type CreateTenantResponses = {
    /**
     * Single Tenant response
     */
    201: TenantResponse;
};

export type CreateTenantResponse = CreateTenantResponses[keyof CreateTenantResponses];

export type DeleteTenantData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Tenant Code
         */
        code: string;
    };
    query?: never;
    url: '/api/tenants/{code}';
};

export type DeleteTenantErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DeleteTenantError = DeleteTenantErrors[keyof DeleteTenantErrors];

export type DeleteTenantResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeleteTenantResponse = DeleteTenantResponses[keyof DeleteTenantResponses];

export type GetTenantData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Tenant Code
         */
        code: string;
    };
    query?: never;
    url: '/api/tenants/{code}';
};

export type GetTenantErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetTenantError = GetTenantErrors[keyof GetTenantErrors];

export type GetTenantResponses = {
    /**
     * Single Tenant response
     */
    200: TenantResponse;
};

export type GetTenantResponse = GetTenantResponses[keyof GetTenantResponses];

export type UpdateTenantData = {
    /**
     * Tenant Update Data
     */
    body?: TenantUpdateFields;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Tenant Code
         */
        code: string;
    };
    query?: never;
    url: '/api/tenants/{code}';
};

export type UpdateTenantErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateTenantError = UpdateTenantErrors[keyof UpdateTenantErrors];

export type UpdateTenantResponses = {
    /**
     * Single Tenant response
     */
    200: TenantResponse;
};

export type UpdateTenantResponse = UpdateTenantResponses[keyof UpdateTenantResponses];

export type ListTenantVersionHistoryData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Tenant Code
         */
        code: string;
    };
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            version?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
        };
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
    };
    url: '/api/tenants/{code}/versions';
};

export type ListTenantVersionHistoryErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
};

export type ListTenantVersionHistoryError = ListTenantVersionHistoryErrors[keyof ListTenantVersionHistoryErrors];

export type ListTenantVersionHistoryResponses = {
    /**
     * Return a tenant version history
     */
    200: TenantVersionHistoryResponse;
};

export type ListTenantVersionHistoryResponse = ListTenantVersionHistoryResponses[keyof ListTenantVersionHistoryResponses];

export type UpdateTenantContactPersonData = {
    /**
     * Tenant update contact person data
     */
    body?: TenantUpdateContactPersonRequestBody;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Tenant Code
         */
        code: string;
    };
    query?: never;
    url: '/api/tenants/{code}/contact-person';
};

export type UpdateTenantContactPersonErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateTenantContactPersonError = UpdateTenantContactPersonErrors[keyof UpdateTenantContactPersonErrors];

export type UpdateTenantContactPersonResponses = {
    /**
     * Single Tenant response
     */
    200: TenantResponse;
};

export type UpdateTenantContactPersonResponse = UpdateTenantContactPersonResponses[keyof UpdateTenantContactPersonResponses];

export type ExportTenantData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Tenant Code
         */
        code: string;
    };
    query?: never;
    url: '/api/tenants/{code}/export';
};

export type ExportTenantErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ExportTenantError = ExportTenantErrors[keyof ExportTenantErrors];

export type ExportTenantResponses = {
    /**
     * Export Tenant response
     */
    200: ExportTenantResponse;
};

export type ExportTenantResponse2 = ExportTenantResponses[keyof ExportTenantResponses];

export type ImportTenantData = {
    /**
     * The encrypted data to import the tenant with configuration
     */
    body?: ImportTenantFields;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/tenants/import';
};

export type ImportTenantErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ImportTenantError = ImportTenantErrors[keyof ImportTenantErrors];

export type ImportTenantResponses = {
    /**
     * Import Tenant response
     */
    201: ImportTenantResponse;
};

export type ImportTenantResponse2 = ImportTenantResponses[keyof ImportTenantResponses];

export type UpdateTenantSemVersionData = {
    /**
     * Tenant update sem_version
     */
    body?: TenantUpdateSemVersionRequestBody;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Tenant Code
         */
        code: string;
    };
    query?: never;
    url: '/api/tenants/{code}/sem-version';
};

export type UpdateTenantSemVersionErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
};

export type UpdateTenantSemVersionError = UpdateTenantSemVersionErrors[keyof UpdateTenantSemVersionErrors];

export type UpdateTenantSemVersionResponses = {
    /**
     * Single Tenant response
     */
    200: TenantResponse;
};

export type UpdateTenantSemVersionResponse = UpdateTenantSemVersionResponses[keyof UpdateTenantSemVersionResponses];

export type ListErrorCodesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/platform/error-codes';
};

export type ListErrorCodesResponses = {
    /**
     * List of error codes.
     */
    200: ErrorCodesList;
};

export type ListErrorCodesResponse = ListErrorCodesResponses[keyof ListErrorCodesResponses];

export type GetErrorCodesData = {
    body?: never;
    path: {
        /**
         * Full name of an existing domain. It should be in a snake case format.
         */
        domain: string;
    };
    query?: never;
    url: '/api/platform/error-codes/{domain}';
};

export type GetErrorCodesResponses = {
    /**
     * List of error codes.
     */
    200: ErrorCodesList;
};

export type GetErrorCodesResponse = GetErrorCodesResponses[keyof GetErrorCodesResponses];

export type GetPlatformVersionData = {
    body?: never;
    headers?: {
        /**
         * Tenant code
         */
        'X-DES-TENANT'?: string;
    };
    path?: never;
    query?: {
        /**
         * Tenant code
         */
        tenant_code?: string;
    };
    url: '/api/platform/version';
};

export type GetPlatformVersionErrors = {
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetPlatformVersionError = GetPlatformVersionErrors[keyof GetPlatformVersionErrors];

export type GetPlatformVersionResponses = {
    /**
     * Platform Version Response
     */
    200: PlatformVersionResponse;
};

export type GetPlatformVersionResponse = GetPlatformVersionResponses[keyof GetPlatformVersionResponses];

export type ListPlatformVersionsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Include the version configuration schema
         */
        with_configuration_schema?: string;
        /**
         * Filter the versions by attributes.
         */
        filter?: {
            version?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            stability?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            registered_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            unregistered_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            first_used_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            stability_updated_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            created_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            updated_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
        };
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Comma-separated list of fields to sort by. Prefix with "-" for descending order (e.g., "code,-created_at"). Multiple fields are supported.
         */
        sort?: string;
    };
    url: '/api/platform/versions';
};

export type ListPlatformVersionsErrors = {
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListPlatformVersionsError = ListPlatformVersionsErrors[keyof ListPlatformVersionsErrors];

export type ListPlatformVersionsResponses = {
    /**
     * List all available versions, optionally with configuration schema
     */
    200: ListPlatformVersionsResponse;
};

export type ListPlatformVersionsResponse2 = ListPlatformVersionsResponses[keyof ListPlatformVersionsResponses];

export type ListIntegrationTestResultData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * Security scheme: StaticTokenSecurityScheme
         */
        'X-DES-STATIC-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            tenant_code?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * In filter
                 */
                in?: string;
            };
            version?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            feature_code?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * In filter
                 */
                in?: string;
            };
            scenario_code?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            status?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * In filter
                 */
                in?: string;
            };
        };
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
    };
    url: '/api/platform/integration-tests/results';
};

export type ListIntegrationTestResultErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type ListIntegrationTestResultError = ListIntegrationTestResultErrors[keyof ListIntegrationTestResultErrors];

export type ListIntegrationTestResultResponses = {
    /**
     * IndexIntegrationTestResultResponse
     */
    200: ListIntegrationTestResultResponse;
};

export type ListIntegrationTestResultResponse2 = ListIntegrationTestResultResponses[keyof ListIntegrationTestResultResponses];

export type UpdateIntegrationTestResultData = {
    body?: UpdateIntegrationTestResultRequestBody;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/platform/integration-tests/results';
};

export type UpdateIntegrationTestResultErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type UpdateIntegrationTestResultError = UpdateIntegrationTestResultErrors[keyof UpdateIntegrationTestResultErrors];

export type UpdateIntegrationTestResultResponses = {
    /**
     * UpdateIntegrationTestResultResponse
     */
    200: UpdateIntegrationTestResultResponse;
};

export type UpdateIntegrationTestResultResponse2 = UpdateIntegrationTestResultResponses[keyof UpdateIntegrationTestResultResponses];

export type GetIntegrationTestResultSummaryControllerData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * Security scheme: StaticTokenSecurityScheme
         */
        'X-DES-STATIC-TOKEN'?: string | null;
    };
    path: {
        /**
         * Version identifier
         */
        version: string;
    };
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            tenant_code?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
        };
    };
    url: '/api/platform/integration-tests/results/summary/{version}';
};

export type GetIntegrationTestResultSummaryControllerErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type GetIntegrationTestResultSummaryControllerError = GetIntegrationTestResultSummaryControllerErrors[keyof GetIntegrationTestResultSummaryControllerErrors];

export type GetIntegrationTestResultSummaryControllerResponses = {
    /**
     * GetIntegrationTestResultSummaryResponse
     */
    200: GetIntegrationTestResultSummaryResponse;
};

export type GetIntegrationTestResultSummaryControllerResponse = GetIntegrationTestResultSummaryControllerResponses[keyof GetIntegrationTestResultSummaryControllerResponses];

export type GetScenarioCodesData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * Security scheme: StaticTokenSecurityScheme
         */
        'X-DES-STATIC-TOKEN'?: string | null;
    };
    path: {
        /**
         * Version identifier
         */
        version: string;
    };
    query?: never;
    url: '/api/platform/integration-tests/results/scenarios/{version}';
};

export type GetScenarioCodesErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
};

export type GetScenarioCodesError = GetScenarioCodesErrors[keyof GetScenarioCodesErrors];

export type GetScenarioCodesResponses = {
    /**
     * GetScenarioCodesResponse
     */
    200: GetScenarioCodesResponse;
};

export type GetScenarioCodesResponse2 = GetScenarioCodesResponses[keyof GetScenarioCodesResponses];

export type VerifyTestScenarioData = {
    body?: ScenarioValidationRequestBody;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/platform/integration-tests/validate';
};

export type VerifyTestScenarioErrors = {
    /**
     * Bad Request
     */
    400: ScenarioValidationBadRequestResponse;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type VerifyTestScenarioError = VerifyTestScenarioErrors[keyof VerifyTestScenarioErrors];

export type VerifyTestScenarioResponses = {
    /**
     * ScenarioValidationResponse
     */
    200: ScenarioValidationResponse;
};

export type VerifyTestScenarioResponse = VerifyTestScenarioResponses[keyof VerifyTestScenarioResponses];

export type InternalGetActionVerificationCodeData = {
    body?: GetActionVerificationCodeRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * Security scheme: WhitelistedIpAddressSecurityScheme
         */
        'X-IP-WHITELISTED'?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/platform/integration-tests/__e2e-tests__/get-ac-code';
};

export type InternalGetActionVerificationCodeErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
};

export type InternalGetActionVerificationCodeError = InternalGetActionVerificationCodeErrors[keyof InternalGetActionVerificationCodeErrors];

export type InternalGetActionVerificationCodeResponses = {
    /**
     * ActionVerificationCodeResponse
     */
    200: ActionVerificationCodeResponse;
};

export type InternalGetActionVerificationCodeResponse = InternalGetActionVerificationCodeResponses[keyof InternalGetActionVerificationCodeResponses];

export type InternalStoreAgeVerificationItemData = {
    body?: CreateAgeVerificationItemRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * Security scheme: WhitelistedIpAddressSecurityScheme
         */
        'X-IP-WHITELISTED'?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/platform/integration-tests/__e2e-tests__/store-av-item';
};

export type InternalStoreAgeVerificationItemErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
};

export type InternalStoreAgeVerificationItemError = InternalStoreAgeVerificationItemErrors[keyof InternalStoreAgeVerificationItemErrors];

export type InternalStoreAgeVerificationItemResponses = {
    /**
     * AgeVerificationUuidResponse
     */
    200: AgeVerificationUuidResponse;
};

export type InternalStoreAgeVerificationItemResponse = InternalStoreAgeVerificationItemResponses[keyof InternalStoreAgeVerificationItemResponses];

export type ListPublicPlatformConfigurationData = {
    body?: never;
    path?: never;
    query: {
        /**
         * List of codes, separated with coma
         */
        codes: string;
    };
    url: '/api/platform/configuration/public';
};

export type ListPublicPlatformConfigurationErrors = {
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListPublicPlatformConfigurationError = ListPublicPlatformConfigurationErrors[keyof ListPublicPlatformConfigurationErrors];

export type ListPublicPlatformConfigurationResponses = {
    /**
     * Return a list of all platform configurations
     */
    200: PublicPlatformConfigurationListResponse;
};

export type ListPublicPlatformConfigurationResponse = ListPublicPlatformConfigurationResponses[keyof ListPublicPlatformConfigurationResponses];

export type ListPlatformConfigurationData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            code?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            name?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            public?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
        };
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * DEPRECATED: Filter by configuration code. Use filter[code][eq] instead.
         *
         * @deprecated
         */
        code?: string | null;
        /**
         * DEPRECATED: Filter by configuration name. Use filter[name][eq] instead.
         *
         * @deprecated
         */
        name?: string | null;
        /**
         * DEPRECATED: Filter by public visibility. Use filter[public][eq] instead.
         *
         * @deprecated
         */
        public?: string | null;
    };
    url: '/api/platform/configuration';
};

export type ListPlatformConfigurationErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListPlatformConfigurationError = ListPlatformConfigurationErrors[keyof ListPlatformConfigurationErrors];

export type ListPlatformConfigurationResponses = {
    /**
     * Return a list of all platform configurations
     */
    200: ListPlatformConfigurationResponse;
};

export type ListPlatformConfigurationResponse2 = ListPlatformConfigurationResponses[keyof ListPlatformConfigurationResponses];

export type CreatePlatformConfigurationData = {
    /**
     * Create Platform Configuration
     */
    body?: CreatePlatformConfiguration;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/platform/configuration';
};

export type CreatePlatformConfigurationErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreatePlatformConfigurationError = CreatePlatformConfigurationErrors[keyof CreatePlatformConfigurationErrors];

export type CreatePlatformConfigurationResponses = {
    /**
     * Configuration response
     */
    201: PlatformConfigurationResponse;
};

export type CreatePlatformConfigurationResponse = CreatePlatformConfigurationResponses[keyof CreatePlatformConfigurationResponses];

export type DeletePlatformConfigurationData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Platform Configuration code
         */
        code: string;
    };
    query?: never;
    url: '/api/platform/configuration/{code}';
};

export type DeletePlatformConfigurationErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DeletePlatformConfigurationError = DeletePlatformConfigurationErrors[keyof DeletePlatformConfigurationErrors];

export type DeletePlatformConfigurationResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeletePlatformConfigurationResponse = DeletePlatformConfigurationResponses[keyof DeletePlatformConfigurationResponses];

export type GetPlatformConfigurationData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Platform Configuration code
         */
        code: string;
    };
    query?: never;
    url: '/api/platform/configuration/{code}';
};

export type GetPlatformConfigurationErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetPlatformConfigurationError = GetPlatformConfigurationErrors[keyof GetPlatformConfigurationErrors];

export type GetPlatformConfigurationResponses = {
    /**
     * Configuration response
     */
    200: PlatformConfigurationResponse;
};

export type GetPlatformConfigurationResponse = GetPlatformConfigurationResponses[keyof GetPlatformConfigurationResponses];

export type UpdatePlatformConfigurationData = {
    /**
     * Update Platform Configuration
     */
    body?: UpdatePlatformConfiguration;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Platform Configuration code
         */
        code: string;
    };
    query?: never;
    url: '/api/platform/configuration/{code}';
};

export type UpdatePlatformConfigurationErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdatePlatformConfigurationError = UpdatePlatformConfigurationErrors[keyof UpdatePlatformConfigurationErrors];

export type UpdatePlatformConfigurationResponses = {
    /**
     * Configuration response
     */
    200: PlatformConfigurationResponse;
};

export type UpdatePlatformConfigurationResponse = UpdatePlatformConfigurationResponses[keyof UpdatePlatformConfigurationResponses];

export type ListTenantMappingsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/platform/proxy/tenants';
};

export type ListTenantMappingsErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
};

export type ListTenantMappingsError = ListTenantMappingsErrors[keyof ListTenantMappingsErrors];

export type ListTenantMappingsResponses = {
    /**
     * List of the tenant mappings
     */
    200: ListTenantMappingsResponse;
};

export type ListTenantMappingsResponse2 = ListTenantMappingsResponses[keyof ListTenantMappingsResponses];

export type UpdateTenantMappingData = {
    /**
     * Request payload to update the tenant mapping
     */
    body?: UpdateTenantMappingRequestBody;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/platform/proxy/tenants';
};

export type UpdateTenantMappingErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
};

export type UpdateTenantMappingError = UpdateTenantMappingErrors[keyof UpdateTenantMappingErrors];

export type UpdateTenantMappingResponses = {
    /**
     * List of mapped tenant codes for the given access token
     */
    201: AccessTokenBasedTenantMappingSchema;
};

export type UpdateTenantMappingResponse = UpdateTenantMappingResponses[keyof UpdateTenantMappingResponses];

export type GetTenantMappingByAccessTokenData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Service access token
         */
        accessToken: string;
    };
    query?: {
        /**
         * Whether to list all overrides
         */
        all?: boolean;
    };
    url: '/api/platform/proxy/tenants/by-access-token/{accessToken}';
};

export type GetTenantMappingByAccessTokenErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    404: CommonError;
};

export type GetTenantMappingByAccessTokenError = GetTenantMappingByAccessTokenErrors[keyof GetTenantMappingByAccessTokenErrors];

export type GetTenantMappingByAccessTokenResponses = {
    /**
     * List of mapped tenant codes for the given access token
     */
    200: AccessTokenBasedTenantMappingSchema;
};

export type GetTenantMappingByAccessTokenResponse2 = GetTenantMappingByAccessTokenResponses[keyof GetTenantMappingByAccessTokenResponses];

export type GetTenantMappingByTenantCodeData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * EVO tenant code
         */
        tenantCode: string;
    };
    query?: {
        /**
         * Whether to list all overrides
         */
        all?: boolean;
    };
    url: '/api/platform/proxy/tenants/by-tenant-code/{tenantCode}';
};

export type GetTenantMappingByTenantCodeErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    404: CommonError;
};

export type GetTenantMappingByTenantCodeError = GetTenantMappingByTenantCodeErrors[keyof GetTenantMappingByTenantCodeErrors];

export type GetTenantMappingByTenantCodeResponses = {
    /**
     * The list of tenant codes per-service that the access token maps to
     */
    200: TenantCodeBasedTenantMappingSchema;
};

export type GetTenantMappingByTenantCodeResponse2 = GetTenantMappingByTenantCodeResponses[keyof GetTenantMappingByTenantCodeResponses];

export type GetTenantMappingsByServiceData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Service name, short or long
         */
        service: string;
    };
    query?: never;
    url: '/api/platform/proxy/tenants/by-service/{service}';
};

export type GetTenantMappingsByServiceErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    404: CommonError;
};

export type GetTenantMappingsByServiceError = GetTenantMappingsByServiceErrors[keyof GetTenantMappingsByServiceErrors];

export type GetTenantMappingsByServiceResponses = {
    /**
     * Get list of the tenant mappings for a specific service
     */
    200: GetTenantMappingsByServiceResponse;
};

export type GetTenantMappingsByServiceResponse2 = GetTenantMappingsByServiceResponses[keyof GetTenantMappingsByServiceResponses];

export type UpdateSingleTenantMappingData = {
    /**
     * Request payload to update a single tenant mapping (with options)
     */
    body?: UpdateSingleTenantMappingRequestBody;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Service name, short or long
         */
        service: string;
    };
    query?: never;
    url: '/api/platform/proxy/tenants/by-service/{service}';
};

export type UpdateSingleTenantMappingErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    404: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type UpdateSingleTenantMappingError = UpdateSingleTenantMappingErrors[keyof UpdateSingleTenantMappingErrors];

export type UpdateSingleTenantMappingResponses = {
    /**
     * A single tenant mapping with options (if any)
     */
    201: UpdateSingleTenantMappingResponse;
};

export type UpdateSingleTenantMappingResponse2 = UpdateSingleTenantMappingResponses[keyof UpdateSingleTenantMappingResponses];

export type GetTenantMappingsByServiceForAccessTokenData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Service name, short or long
         */
        service: string;
        /**
         * Service access token
         */
        accessToken: string;
    };
    query?: never;
    url: '/api/platform/proxy/tenants/by-service/{service}/{accessToken}';
};

export type GetTenantMappingsByServiceForAccessTokenErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    404: CommonError;
};

export type GetTenantMappingsByServiceForAccessTokenError = GetTenantMappingsByServiceForAccessTokenErrors[keyof GetTenantMappingsByServiceForAccessTokenErrors];

export type GetTenantMappingsByServiceForAccessTokenResponses = {
    /**
     * The tenant mapping for a specific service for a specific access token
     */
    200: GetTenantMappingsByServiceForAccessTokenResponse;
};

export type GetTenantMappingsByServiceForAccessTokenResponse2 = GetTenantMappingsByServiceForAccessTokenResponses[keyof GetTenantMappingsByServiceForAccessTokenResponses];

export type CancelBusBatchData = {
    body?: CancelBusBatchRequestBody;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/platform/batches/cancel';
};

export type CancelBusBatchErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type CancelBusBatchError = CancelBusBatchErrors[keyof CancelBusBatchErrors];

export type CancelBusBatchResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type CancelBusBatchResponse = CancelBusBatchResponses[keyof CancelBusBatchResponses];

export type ListPermissionsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/platform/permissions';
};

export type ListPermissionsErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
};

export type ListPermissionsError = ListPermissionsErrors[keyof ListPermissionsErrors];

export type ListPermissionsResponses = {
    /**
     * Return a list of available permissions.
     */
    200: ListPermissionsResponse;
};

export type ListPermissionsResponse2 = ListPermissionsResponses[keyof ListPermissionsResponses];

export type ListRolesData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters using the standardized query processing system
         */
        filter?: {
            key?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            name?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            is_enabled?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
        };
        /**
         * Comma-separated list of fields to sort by. Prefix with "-" for descending order (e.g., "code,-created_at"). Multiple fields are supported.
         */
        sort?: string;
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
    };
    url: '/api/platform/roles';
};

export type ListRolesErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type ListRolesError = ListRolesErrors[keyof ListRolesErrors];

export type ListRolesResponses = {
    /**
     * Return a list of roles
     */
    200: ListRolesResponse;
};

export type ListRolesResponse2 = ListRolesResponses[keyof ListRolesResponses];

export type CreateRoleData = {
    /**
     * New role data
     */
    body?: CreateRoleRequest;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/platform/roles';
};

export type CreateRoleErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type CreateRoleError = CreateRoleErrors[keyof CreateRoleErrors];

export type CreateRoleResponses = {
    /**
     * Role response
     */
    201: Role;
};

export type CreateRoleResponse = CreateRoleResponses[keyof CreateRoleResponses];

export type DeleteRoleData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Role key
         */
        key: string;
    };
    query?: never;
    url: '/api/platform/roles/{key}';
};

export type DeleteRoleErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Empty response
     */
    404: unknown;
};

export type DeleteRoleError = DeleteRoleErrors[keyof DeleteRoleErrors];

export type DeleteRoleResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeleteRoleResponse = DeleteRoleResponses[keyof DeleteRoleResponses];

export type UpdateRoleData = {
    /**
     * Updated role data
     */
    body?: UpdateRoleRequest;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Role key
         */
        key: string;
    };
    query?: never;
    url: '/api/platform/roles/{key}';
};

export type UpdateRoleErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Empty response
     */
    404: unknown;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type UpdateRoleError = UpdateRoleErrors[keyof UpdateRoleErrors];

export type UpdateRoleResponses = {
    /**
     * Role response
     */
    200: Role;
};

export type UpdateRoleResponse = UpdateRoleResponses[keyof UpdateRoleResponses];

export type MigrateOktaApplicationToEntraData = {
    /**
     * Okta application migration data
     */
    body?: MigrateOktaApplicationToEntraRequest;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/platform/okta-to-entra-migration';
};

export type MigrateOktaApplicationToEntraErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type MigrateOktaApplicationToEntraError = MigrateOktaApplicationToEntraErrors[keyof MigrateOktaApplicationToEntraErrors];

export type MigrateOktaApplicationToEntraResponses = {
    /**
     * Okta to Entra migration result
     */
    201: MigrateOktaApplicationToEntra;
};

export type MigrateOktaApplicationToEntraResponse2 = MigrateOktaApplicationToEntraResponses[keyof MigrateOktaApplicationToEntraResponses];

export type CreateEntraApplicationData = {
    /**
     * Entra application creation data
     */
    body?: CreateEntraApplicationRequest;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/platform/entra/applications';
};

export type CreateEntraApplicationErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type CreateEntraApplicationError = CreateEntraApplicationErrors[keyof CreateEntraApplicationErrors];

export type CreateEntraApplicationResponses = {
    /**
     * Entra application creation result
     */
    201: CreateEntraApplication;
};

export type CreateEntraApplicationResponse2 = CreateEntraApplicationResponses[keyof CreateEntraApplicationResponses];

export type GenerateS2sTokenData = {
    body?: GenerateS2sTokenRequestBody;
    path?: never;
    query?: never;
    url: '/api/platform/oauth2/authorize';
};

export type GenerateS2sTokenErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type GenerateS2sTokenError = GenerateS2sTokenErrors[keyof GenerateS2sTokenErrors];

export type GenerateS2sTokenResponses = {
    /**
     * The S2S token
     */
    200: GenerateS2sTokenResponse;
};

export type GenerateS2sTokenResponse2 = GenerateS2sTokenResponses[keyof GenerateS2sTokenResponses];

export type VerifyEmailData = {
    body?: VerifyEmailRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/platform/email-validation';
};

export type VerifyEmailErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type VerifyEmailError = VerifyEmailErrors[keyof VerifyEmailErrors];

export type VerifyEmailResponses = {
    /**
     * Email validation response
     */
    200: VerifyEmailResponse;
};

export type VerifyEmailResponse2 = VerifyEmailResponses[keyof VerifyEmailResponses];

export type VerifyPhoneData = {
    body?: VerifyPhoneRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/platform/phone-validation';
};

export type VerifyPhoneErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type VerifyPhoneError = VerifyPhoneErrors[keyof VerifyPhoneErrors];

export type VerifyPhoneResponses = {
    /**
     * Phone validation response
     */
    200: VerifyPhoneResponse;
};

export type VerifyPhoneResponse2 = VerifyPhoneResponses[keyof VerifyPhoneResponses];

export type PlatformProfileAnonymizationData = {
    /**
     * Audit metadata for the anonymization request.
     */
    body?: AnonymizeProfileRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        uuid?: string;
        email?: string;
        phone?: string;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/platform/profile';
};

export type PlatformProfileAnonymizationErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type PlatformProfileAnonymizationError = PlatformProfileAnonymizationErrors[keyof PlatformProfileAnonymizationErrors];

export type PlatformProfileAnonymizationResponses = {
    /**
     * Anonymized profile response
     */
    200: AnonymizedProfileSchema;
};

export type PlatformProfileAnonymizationResponse = PlatformProfileAnonymizationResponses[keyof PlatformProfileAnonymizationResponses];

export type ListAnonymizationsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Anonymization request filters
         */
        filter?: {
            profile_uuid?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            external_id?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            status?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * In filter
                 */
                in?: string;
            };
            reason_for_anonymization?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            trigger_source?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * In filter
                 */
                in?: string;
            };
            system?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            created_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
        };
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/platform/anonymizations/status';
};

export type ListAnonymizationsErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type ListAnonymizationsError = ListAnonymizationsErrors[keyof ListAnonymizationsErrors];

export type ListAnonymizationsResponses = {
    /**
     * Return tenant anonymization request statuses
     */
    200: ListAnonymizationsResponse;
};

export type ListAnonymizationsResponse2 = ListAnonymizationsResponses[keyof ListAnonymizationsResponses];

export type PlatformSyncConsumerToCdpData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer identifier
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/platform/data-sync/consumers/{uuid}';
};

export type PlatformSyncConsumerToCdpErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type PlatformSyncConsumerToCdpError = PlatformSyncConsumerToCdpErrors[keyof PlatformSyncConsumerToCdpErrors];

export type PlatformSyncConsumerToCdpResponses = {
    /**
     * Consumer CDP sync triggered successfully
     */
    202: SyncConsumerToCdpResponse;
};

export type PlatformSyncConsumerToCdpResponse = PlatformSyncConsumerToCdpResponses[keyof PlatformSyncConsumerToCdpResponses];

export type ListShortUrlData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters using the standardized query processing system
         */
        filter?: {
            created_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            updated_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            code?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            url?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            external_id?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            campaign_id?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
        };
        /**
         * Comma-separated list of fields to sort by. Prefix with "-" for descending order (e.g., "code,-created_at"). Multiple fields are supported.
         */
        sort?: string;
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
    };
    url: '/api/platform/url-shortener/codes';
};

export type ListShortUrlErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListShortUrlError = ListShortUrlErrors[keyof ListShortUrlErrors];

export type ListShortUrlResponses = {
    /**
     * Return a list of available short URLs
     */
    200: ListShortUrlResponse;
};

export type ListShortUrlResponse2 = ListShortUrlResponses[keyof ListShortUrlResponses];

export type CreateShortUrlData = {
    /**
     * New short code URL data
     */
    body?: CreateShortUrlRequest;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/platform/url-shortener/codes';
};

export type CreateShortUrlErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreateShortUrlError = CreateShortUrlErrors[keyof CreateShortUrlErrors];

export type CreateShortUrlResponses = {
    /**
     * Short URL code response
     */
    201: ShortUrl;
};

export type CreateShortUrlResponse = CreateShortUrlResponses[keyof CreateShortUrlResponses];

export type CreateBulkShortUrlData = {
    /**
     * Bulk short URLs payload
     */
    body?: CreateBulkShortUrlRequest;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/platform/url-shortener/codes/bulk';
};

export type CreateBulkShortUrlErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Short URLs could not be created
     */
    409: CreateBulkShortUrlFailedResponse;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreateBulkShortUrlError = CreateBulkShortUrlErrors[keyof CreateBulkShortUrlErrors];

export type CreateBulkShortUrlResponses = {
    /**
     * Created short URLs response
     */
    201: CreateBulkShortUrlResponse;
    /**
     * Partially created short URLs response
     */
    207: CreateBulkShortUrlPartialResponse;
};

export type CreateBulkShortUrlResponse2 = CreateBulkShortUrlResponses[keyof CreateBulkShortUrlResponses];

export type DeleteShortUrlData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Short URL code
         */
        code: string;
    };
    query?: never;
    url: '/api/platform/url-shortener/codes/{code}';
};

export type DeleteShortUrlErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DeleteShortUrlError = DeleteShortUrlErrors[keyof DeleteShortUrlErrors];

export type DeleteShortUrlResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeleteShortUrlResponse = DeleteShortUrlResponses[keyof DeleteShortUrlResponses];

export type GetShortUrlData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Short URL code
         */
        code: string;
    };
    query?: never;
    url: '/api/platform/url-shortener/codes/{code}';
};

export type GetShortUrlErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetShortUrlError = GetShortUrlErrors[keyof GetShortUrlErrors];

export type GetShortUrlResponses = {
    /**
     * Short URL code response
     */
    200: ShortUrl;
};

export type GetShortUrlResponse = GetShortUrlResponses[keyof GetShortUrlResponses];

export type UpdateShortUrlData = {
    /**
     * Updated short code URL
     */
    body?: UpdateShortUrlRequest;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Short URL code
         */
        code: string;
    };
    query?: never;
    url: '/api/platform/url-shortener/codes/{code}';
};

export type UpdateShortUrlErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateShortUrlError = UpdateShortUrlErrors[keyof UpdateShortUrlErrors];

export type UpdateShortUrlResponses = {
    /**
     * Short URL code response
     */
    200: ShortUrl;
};

export type UpdateShortUrlResponse = UpdateShortUrlResponses[keyof UpdateShortUrlResponses];

export type ListClicksData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters using the standardized query processing system
         */
        filter?: {
            clicked_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            code?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            external_id?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            campaign_id?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
        };
        /**
         * Comma-separated list of fields to sort by. Prefix with "-" for descending order (e.g., "code,-created_at"). Multiple fields are supported.
         */
        sort?: string;
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
    };
    url: '/api/platform/url-shortener/clicks';
};

export type ListClicksErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListClicksError = ListClicksErrors[keyof ListClicksErrors];

export type ListClicksResponses = {
    /**
     * Return a list of short URL clicks
     */
    200: ListClicksResponse;
};

export type ListClicksResponse2 = ListClicksResponses[keyof ListClicksResponses];

export type IngestClickBatchData = {
    /**
     * Batch of click events to persist
     */
    body?: IngestClicksRequest;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/platform/url-shortener/clicks';
};

export type IngestClickBatchErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type IngestClickBatchError = IngestClickBatchErrors[keyof IngestClickBatchErrors];

export type IngestClickBatchResponses = {
    /**
     * Stored click batch result
     */
    200: IngestClicksResponse;
};

export type IngestClickBatchResponse = IngestClickBatchResponses[keyof IngestClickBatchResponses];

export type ListClicksByCodeData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Short URL code
         */
        code: string;
    };
    query?: {
        /**
         * Filter parameters using the standardized query processing system
         */
        filter?: {
            clicked_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
        };
        /**
         * Comma-separated list of fields to sort by. Prefix with "-" for descending order (e.g., "code,-created_at"). Multiple fields are supported.
         */
        sort?: string;
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
    };
    url: '/api/platform/url-shortener/codes/{code}/clicks';
};

export type ListClicksByCodeErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListClicksByCodeError = ListClicksByCodeErrors[keyof ListClicksByCodeErrors];

export type ListClicksByCodeResponses = {
    /**
     * Return a list of short URL clicks
     */
    200: ListClicksResponse;
};

export type ListClicksByCodeResponse = ListClicksByCodeResponses[keyof ListClicksByCodeResponses];

export type OktaAuthRedirectData = {
    body?: never;
    path?: never;
    query: {
        /**
         * List of scopes, separated with coma
         */
        scopes: string;
    };
    url: '/platform/auth/okta/redirect';
};

export type OktaAuthRedirectErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type OktaAuthRedirectError = OktaAuthRedirectErrors[keyof OktaAuthRedirectErrors];

export type GetOktaAuthCallbackData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Auth code from Okta
         */
        code?: string;
    };
    url: '/platform/auth/okta/callback';
};

export type GetOktaAuthCallbackErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetOktaAuthCallbackError = GetOktaAuthCallbackErrors[keyof GetOktaAuthCallbackErrors];

export type GetOktaAuthCallbackResponses = {
    /**
     * Okta callback response
     */
    200: OktaCallbackResponse;
};

export type GetOktaAuthCallbackResponse = GetOktaAuthCallbackResponses[keyof GetOktaAuthCallbackResponses];

export type EntraAuthRedirectData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/platform/auth/entra/redirect';
};

export type EntraAuthRedirectErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type EntraAuthRedirectError = EntraAuthRedirectErrors[keyof EntraAuthRedirectErrors];

export type EntraAuthCallbackData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Auth code from Identity Access Management service
         */
        code?: string;
    };
    url: '/platform/auth/entra/callback';
};

export type EntraAuthCallbackErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type EntraAuthCallbackError = EntraAuthCallbackErrors[keyof EntraAuthCallbackErrors];

export type EntraAuthCallbackResponses = {
    /**
     * Entra Authorization callback response
     */
    200: EntraCallbackResponse;
};

export type EntraAuthCallbackResponse = EntraAuthCallbackResponses[keyof EntraAuthCallbackResponses];

export type DecryptDataData = {
    /**
     * Data to decrypt
     */
    body?: DecryptRequestBody;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/cryptography/decrypt';
};

export type DecryptDataErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DecryptDataError = DecryptDataErrors[keyof DecryptDataErrors];

export type DecryptDataResponses = {
    /**
     * Decrypted string value
     */
    200: DecryptResponse;
};

export type DecryptDataResponse = DecryptDataResponses[keyof DecryptDataResponses];

export type EncryptDataData = {
    /**
     * Data to encrypt
     */
    body?: EncryptRequestBody;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/cryptography/encrypt';
};

export type EncryptDataErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type EncryptDataError = EncryptDataErrors[keyof EncryptDataErrors];

export type EncryptDataResponses = {
    /**
     * List of encoded data with key reference and encrypted string
     */
    200: CryptographySchema;
};

export type EncryptDataResponse = EncryptDataResponses[keyof EncryptDataResponses];

export type DeprecatedDeleteCodeRouteData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * QR Code value
         */
        code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/code-routes/{code}';
};

export type DeprecatedDeleteCodeRouteErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DeprecatedDeleteCodeRouteError = DeprecatedDeleteCodeRouteErrors[keyof DeprecatedDeleteCodeRouteErrors];

export type DeprecatedDeleteCodeRouteResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeprecatedDeleteCodeRouteResponse = DeprecatedDeleteCodeRouteResponses[keyof DeprecatedDeleteCodeRouteResponses];

export type DeprecatedGetCodeRouteData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path: {
        /**
         * QR Code value
         */
        code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/code-routes/{code}';
};

export type DeprecatedGetCodeRouteErrors = {
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DeprecatedGetCodeRouteError = DeprecatedGetCodeRouteErrors[keyof DeprecatedGetCodeRouteErrors];

export type DeprecatedGetCodeRouteResponses = {
    /**
     * Single code route response
     */
    200: CodeRoute;
};

export type DeprecatedGetCodeRouteResponse = DeprecatedGetCodeRouteResponses[keyof DeprecatedGetCodeRouteResponses];

export type DeprecatedUpdateCodeRouteData = {
    /**
     * Code route data
     */
    body?: CodeRouteFields;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * QR Code value
         */
        code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/code-routes/{code}';
};

export type DeprecatedUpdateCodeRouteErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    410: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DeprecatedUpdateCodeRouteError = DeprecatedUpdateCodeRouteErrors[keyof DeprecatedUpdateCodeRouteErrors];

export type DeprecatedUpdateCodeRouteResponses = {
    /**
     * Single code route response
     */
    200: CodeRoute;
};

export type DeprecatedUpdateCodeRouteResponse = DeprecatedUpdateCodeRouteResponses[keyof DeprecatedUpdateCodeRouteResponses];

export type DeprecatedListCodeRoutesData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/code-routes';
};

export type DeprecatedListCodeRoutesErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DeprecatedListCodeRoutesError = DeprecatedListCodeRoutesErrors[keyof DeprecatedListCodeRoutesErrors];

export type DeprecatedListCodeRoutesResponses = {
    /**
     * Return a list of available codes routes
     */
    200: CodeRouteListResponse;
};

export type DeprecatedListCodeRoutesResponse = DeprecatedListCodeRoutesResponses[keyof DeprecatedListCodeRoutesResponses];

export type DeprecatedCreateCodeRouteData = {
    /**
     * Code route data
     */
    body?: CodeRouteFields;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/code-routes';
};

export type DeprecatedCreateCodeRouteErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    410: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DeprecatedCreateCodeRouteError = DeprecatedCreateCodeRouteErrors[keyof DeprecatedCreateCodeRouteErrors];

export type DeprecatedCreateCodeRouteResponses = {
    /**
     * Single code route response
     */
    201: CodeRoute;
};

export type DeprecatedCreateCodeRouteResponse = DeprecatedCreateCodeRouteResponses[keyof DeprecatedCreateCodeRouteResponses];

export type FindActionVerificationItemData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path: {
        /**
         * Uuid value for Action Verification
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/action-verifications/items/{uuid}';
};

export type FindActionVerificationItemErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type FindActionVerificationItemError = FindActionVerificationItemErrors[keyof FindActionVerificationItemErrors];

export type FindActionVerificationItemResponses = {
    /**
     * Single action verification item response
     */
    200: ActionVerificationResponse;
};

export type FindActionVerificationItemResponse = FindActionVerificationItemResponses[keyof FindActionVerificationItemResponses];

export type CreateActionVerificationData = {
    body?: CreateActionVerificationItemRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: StaticTokenSecurityScheme
         */
        'X-DES-STATIC-TOKEN'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/action-verifications/items';
};

export type CreateActionVerificationErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Too many attempts
     */
    429: TooManyAttemptsError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreateActionVerificationError = CreateActionVerificationErrors[keyof CreateActionVerificationErrors];

export type CreateActionVerificationResponses = {
    /**
     * Single action verification item response
     */
    201: ActionVerificationResponse;
};

export type CreateActionVerificationResponse = CreateActionVerificationResponses[keyof CreateActionVerificationResponses];

export type VerifyActionVerificationData = {
    body?: VerifyActionVerificationItemRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: StaticTokenSecurityScheme
         */
        'X-DES-STATIC-TOKEN'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Uuid value for Action Verification
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/action-verifications/items/{uuid}/verify';
};

export type VerifyActionVerificationErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type VerifyActionVerificationError = VerifyActionVerificationErrors[keyof VerifyActionVerificationErrors];

export type VerifyActionVerificationResponses = {
    /**
     * Single action verification item response
     */
    200: ActionVerificationResponse;
};

export type VerifyActionVerificationResponse = VerifyActionVerificationResponses[keyof VerifyActionVerificationResponses];

export type UnsubscribeMarketingCommunicationData = {
    body?: never;
    path: {
        /**
         * Marketing Communication identifier (UUID, subscriber UUID, or email)
         */
        identifier: string;
    };
    query?: {
        /**
         * Marketing Communication topic
         */
        'categories[]'?: Array<string>;
        /**
         * Tenant code
         */
        tenant_code?: string;
    };
    url: '/api/messaging/marketing-communications/{identifier}/unsubscribe';
};

export type UnsubscribeMarketingCommunicationErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
};

export type UnsubscribeMarketingCommunicationError = UnsubscribeMarketingCommunicationErrors[keyof UnsubscribeMarketingCommunicationErrors];

export type UnsubscribeMarketingCommunicationResponses = {
    /**
     * Response returned after unsubscribing from marketing communication
     */
    200: MarketingCommunicationUnsubscribeResponse;
};

export type UnsubscribeMarketingCommunicationResponse = UnsubscribeMarketingCommunicationResponses[keyof UnsubscribeMarketingCommunicationResponses];

export type CreateOrUpdateMarketingCommunicationData = {
    /**
     * Marketing communication data
     */
    body?: MarketingCommunicationInputFields;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/marketing-communications';
};

export type CreateOrUpdateMarketingCommunicationErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreateOrUpdateMarketingCommunicationError = CreateOrUpdateMarketingCommunicationErrors[keyof CreateOrUpdateMarketingCommunicationErrors];

export type CreateOrUpdateMarketingCommunicationResponses = {
    /**
     * Single marketing communication response
     */
    201: MarketingCommunication;
};

export type CreateOrUpdateMarketingCommunicationResponse = CreateOrUpdateMarketingCommunicationResponses[keyof CreateOrUpdateMarketingCommunicationResponses];

export type DeleteMarketingCommunicationData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Marketing Communication identifier (UUID, subscriber UUID, or email)
         */
        identifier: string;
    };
    query?: {
        /**
         * Marketing Communication topic
         */
        'categories[]'?: Array<string>;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/marketing-communications/{identifier}';
};

export type DeleteMarketingCommunicationErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
};

export type DeleteMarketingCommunicationError = DeleteMarketingCommunicationErrors[keyof DeleteMarketingCommunicationErrors];

export type DeleteMarketingCommunicationResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeleteMarketingCommunicationResponse = DeleteMarketingCommunicationResponses[keyof DeleteMarketingCommunicationResponses];

export type GetMarketingCommunicationsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Marketing Communication identifier (UUID, subscriber UUID, or email)
         */
        identifier: string;
    };
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            category?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
        };
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * DEPRECATED: Filter by marketing communication category (exact match). Use filter[category][eq] instead.
         *
         * @deprecated
         */
        'filter[category]'?: string | null;
        /**
         * DEPRECATED: This parameter was documented but never implemented. It has no effect.
         *
         * @deprecated
         */
        'categories[]'?: Array<string>;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/marketing-communications/{identifier}';
};

export type GetMarketingCommunicationsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetMarketingCommunicationsError = GetMarketingCommunicationsErrors[keyof GetMarketingCommunicationsErrors];

export type GetMarketingCommunicationsResponses = {
    /**
     * Return a list of marketing communications
     */
    200: MarketingCommunicationPaginateResponse;
};

export type GetMarketingCommunicationsResponse = GetMarketingCommunicationsResponses[keyof GetMarketingCommunicationsResponses];

export type UpdateEmailOfMarketingCommunicationsData = {
    /**
     * Update email of marketing communication data
     */
    body?: EmailFields;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Marketing Communication email
         */
        oldEmail: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/marketing-communications/{oldEmail}/email';
};

export type UpdateEmailOfMarketingCommunicationsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateEmailOfMarketingCommunicationsError = UpdateEmailOfMarketingCommunicationsErrors[keyof UpdateEmailOfMarketingCommunicationsErrors];

export type UpdateEmailOfMarketingCommunicationsResponses = {
    /**
     * Return a list of marketing communications
     */
    200: MarketingCommunicationCollectionResponse;
};

export type UpdateEmailOfMarketingCommunicationsResponse = UpdateEmailOfMarketingCommunicationsResponses[keyof UpdateEmailOfMarketingCommunicationsResponses];

export type UpdatePreferredLanguageOfMarketingCommunicationsData = {
    /**
     * Update preferred language of marketing communication data
     */
    body?: PreferredLanguageFields;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Marketing Communication identifier (UUID or email)
         */
        identifier: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/marketing-communications/{identifier}/language';
};

export type UpdatePreferredLanguageOfMarketingCommunicationsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdatePreferredLanguageOfMarketingCommunicationsError = UpdatePreferredLanguageOfMarketingCommunicationsErrors[keyof UpdatePreferredLanguageOfMarketingCommunicationsErrors];

export type UpdatePreferredLanguageOfMarketingCommunicationsResponses = {
    /**
     * Return a list of marketing communications
     */
    200: MarketingCommunicationCollectionResponse;
};

export type UpdatePreferredLanguageOfMarketingCommunicationsResponse = UpdatePreferredLanguageOfMarketingCommunicationsResponses[keyof UpdatePreferredLanguageOfMarketingCommunicationsResponses];

export type ConsumerUnsubscribeAllPushNotificationsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/push';
};

export type ConsumerUnsubscribeAllPushNotificationsErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ConsumerUnsubscribeAllPushNotificationsError = ConsumerUnsubscribeAllPushNotificationsErrors[keyof ConsumerUnsubscribeAllPushNotificationsErrors];

export type ConsumerUnsubscribeAllPushNotificationsResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type ConsumerUnsubscribeAllPushNotificationsResponse = ConsumerUnsubscribeAllPushNotificationsResponses[keyof ConsumerUnsubscribeAllPushNotificationsResponses];

export type ConsumerSubscribePushNotificationData = {
    /**
     * Subscribe push notifications request body
     */
    body?: SubscribePushNotificationFields;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/push';
};

export type ConsumerSubscribePushNotificationErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ConsumerSubscribePushNotificationError = ConsumerSubscribePushNotificationErrors[keyof ConsumerSubscribePushNotificationErrors];

export type ConsumerSubscribePushNotificationResponses = {
    /**
     * Detailed information about the subscribed push notification
     */
    201: PushNotificationSubscribedResponse;
};

export type ConsumerSubscribePushNotificationResponse = ConsumerSubscribePushNotificationResponses[keyof ConsumerSubscribePushNotificationResponses];

export type ConsumerUnsubscribePushNotificationData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path: {
        /**
         * Push subscription uuid
         */
        subscriptionUuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/push/{subscriptionUuid}';
};

export type ConsumerUnsubscribePushNotificationErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ConsumerUnsubscribePushNotificationError = ConsumerUnsubscribePushNotificationErrors[keyof ConsumerUnsubscribePushNotificationErrors];

export type ConsumerUnsubscribePushNotificationResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type ConsumerUnsubscribePushNotificationResponse = ConsumerUnsubscribePushNotificationResponses[keyof ConsumerUnsubscribePushNotificationResponses];

export type GetPushSubscriptionStatusData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/push/status/{uuid}';
};

export type GetPushSubscriptionStatusErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetPushSubscriptionStatusError = GetPushSubscriptionStatusErrors[keyof GetPushSubscriptionStatusErrors];

export type GetPushSubscriptionStatusResponses = {
    /**
     * Detailed information about the status of push notifications
     */
    200: PushNotificationsStatusResponse;
};

export type GetPushSubscriptionStatusResponse = GetPushSubscriptionStatusResponses[keyof GetPushSubscriptionStatusResponses];

export type UnsubscribePushNotificationData = {
    /**
     * Request body for unsubscribing from push notifications
     */
    body?: UnsubscribeRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Push subscription uuid
         */
        subscriptionUuid: string;
        /**
         * Consumer uuid
         */
        consumerUuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/push/{consumerUuid}/{subscriptionUuid}/delete';
};

export type UnsubscribePushNotificationErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UnsubscribePushNotificationError = UnsubscribePushNotificationErrors[keyof UnsubscribePushNotificationErrors];

export type UnsubscribePushNotificationResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type UnsubscribePushNotificationResponse = UnsubscribePushNotificationResponses[keyof UnsubscribePushNotificationResponses];

export type UnsubscribeAllPushNotificationsData = {
    /**
     * Request body for unsubscribing from push notifications
     */
    body?: UnsubscribeRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        consumerUuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/push/{consumerUuid}/delete';
};

export type UnsubscribeAllPushNotificationsErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UnsubscribeAllPushNotificationsError = UnsubscribeAllPushNotificationsErrors[keyof UnsubscribeAllPushNotificationsErrors];

export type UnsubscribeAllPushNotificationsResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type UnsubscribeAllPushNotificationsResponse = UnsubscribeAllPushNotificationsResponses[keyof UnsubscribeAllPushNotificationsResponses];

export type SendSinglePushNotificationData = {
    /**
     * Request body for sending a push notification
     */
    body?: SendPushNotificationRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        consumerUuid: string;
        /**
         * Push subscription uuid
         */
        subscriptionUuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/push/{consumerUuid}/send/{subscriptionUuid}';
};

export type SendSinglePushNotificationErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type SendSinglePushNotificationError = SendSinglePushNotificationErrors[keyof SendSinglePushNotificationErrors];

export type SendSinglePushNotificationResponses = {
    /**
     * Empty response
     */
    202: unknown;
};

export type SendPushNotificationData = {
    /**
     * Request body for sending a push notification
     */
    body?: SendPushNotificationRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        consumerUuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/push/{consumerUuid}/send';
};

export type SendPushNotificationErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type SendPushNotificationError = SendPushNotificationErrors[keyof SendPushNotificationErrors];

export type SendPushNotificationResponses = {
    /**
     * Empty response
     */
    202: unknown;
};

export type GetCampaignEventReportData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * The ID of the campaign to retrieve event statuses for. Must be a alphanumeric with underscores and dashes.
         */
        campaignId: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/campaigns/{campaignId}/report';
};

export type GetCampaignEventReportErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
};

export type GetCampaignEventReportError = GetCampaignEventReportErrors[keyof GetCampaignEventReportErrors];

export type GetCampaignEventReportResponses = {
    /**
     * List of campaign event statuses grouped by channel
     */
    200: CampaignEventReportResponse;
};

export type GetCampaignEventReportResponse = GetCampaignEventReportResponses[keyof GetCampaignEventReportResponses];

export type ShowCampaignDeliveryLogsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * The external campaign ID to retrieve delivery logs for.
         */
        campaignId: string;
    };
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            channel?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * In filter
                 */
                in?: string;
            };
            provider_status?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * In filter
                 */
                in?: string;
            };
            driver?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
        };
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/campaigns/{campaignId}/delivery-logs';
};

export type ShowCampaignDeliveryLogsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
};

export type ShowCampaignDeliveryLogsError = ShowCampaignDeliveryLogsErrors[keyof ShowCampaignDeliveryLogsErrors];

export type ShowCampaignDeliveryLogsResponses = {
    /**
     * Paginated list of campaign delivery logs
     */
    200: CampaignDeliveryLogsResponse;
};

export type ShowCampaignDeliveryLogsResponse = ShowCampaignDeliveryLogsResponses[keyof ShowCampaignDeliveryLogsResponses];

export type ListDeliveryLogsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            campaign_id?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            driver?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            provider_status?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            event_type?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            consumer_uuid?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            reference?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            created_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
        };
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/reporting';
};

export type ListDeliveryLogsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListDeliveryLogsError = ListDeliveryLogsErrors[keyof ListDeliveryLogsErrors];

export type ListDeliveryLogsResponses = {
    /**
     * Paginated list of delivery logs across all drivers
     */
    200: ListDeliveryLogsResponse;
};

export type ListDeliveryLogsResponse2 = ListDeliveryLogsResponses[keyof ListDeliveryLogsResponses];

export type CreateDeliveryEventData = {
    body?: CreateDeliveryEventRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/reporting';
};

export type CreateDeliveryEventErrors = {
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreateDeliveryEventError = CreateDeliveryEventErrors[keyof CreateDeliveryEventErrors];

export type CreateDeliveryEventResponses = {
    /**
     * Delivery event stored successfully
     */
    201: unknown;
};

export type MessagingEventCreateMessageData = {
    body?: EventMessageRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/events';
};

export type MessagingEventCreateMessageErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type MessagingEventCreateMessageError = MessagingEventCreateMessageErrors[keyof MessagingEventCreateMessageErrors];

export type MessagingEventCreateMessageResponses = {
    /**
     * Message event request added in queue for further processing
     */
    200: EventResponse;
};

export type MessagingEventCreateMessageResponse = MessagingEventCreateMessageResponses[keyof MessagingEventCreateMessageResponses];

export type MessagingFormCreateMessageData = {
    body?: FormMessageRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/forms';
};

export type MessagingFormCreateMessageErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type MessagingFormCreateMessageError = MessagingFormCreateMessageErrors[keyof MessagingFormCreateMessageErrors];

export type MessagingFormCreateMessageResponses = {
    /**
     * Empty response
     */
    200: unknown;
};

export type MessagingLocalTemplatesListData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/local-templates';
};

export type MessagingLocalTemplatesListErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type MessagingLocalTemplatesListError = MessagingLocalTemplatesListErrors[keyof MessagingLocalTemplatesListErrors];

export type MessagingLocalTemplatesListResponses = {
    /**
     * Return a list of local templates
     */
    200: LocalTemplateListResponse;
};

export type MessagingLocalTemplatesListResponse = MessagingLocalTemplatesListResponses[keyof MessagingLocalTemplatesListResponses];

export type MessagingLocalTemplateCreateData = {
    /**
     * Local Template data
     */
    body?: LocalTemplateRequest;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/local-templates';
};

export type MessagingLocalTemplateCreateErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type MessagingLocalTemplateCreateError = MessagingLocalTemplateCreateErrors[keyof MessagingLocalTemplateCreateErrors];

export type MessagingLocalTemplateCreateResponses = {
    /**
     * Single template response
     */
    201: LocalTemplate;
};

export type MessagingLocalTemplateCreateResponse = MessagingLocalTemplateCreateResponses[keyof MessagingLocalTemplateCreateResponses];

export type MessagingLocalTemplateDeleteData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Template UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/local-templates/{uuid}';
};

export type MessagingLocalTemplateDeleteErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Local template is used in the configuration.
     */
    409: LocalTemplateInUseResponse;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type MessagingLocalTemplateDeleteError = MessagingLocalTemplateDeleteErrors[keyof MessagingLocalTemplateDeleteErrors];

export type MessagingLocalTemplateDeleteResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type MessagingLocalTemplateDeleteResponse = MessagingLocalTemplateDeleteResponses[keyof MessagingLocalTemplateDeleteResponses];

export type MessagingLocalTemplateDetailData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Template UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/local-templates/{uuid}';
};

export type MessagingLocalTemplateDetailErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type MessagingLocalTemplateDetailError = MessagingLocalTemplateDetailErrors[keyof MessagingLocalTemplateDetailErrors];

export type MessagingLocalTemplateDetailResponses = {
    /**
     * Single local template response
     */
    200: LocalTemplate;
};

export type MessagingLocalTemplateDetailResponse = MessagingLocalTemplateDetailResponses[keyof MessagingLocalTemplateDetailResponses];

export type MessagingLocalTemplatesUpdateData = {
    /**
     * Local Template data
     */
    body?: LocalTemplateRequest;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Template UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/messaging/local-templates/{uuid}';
};

export type MessagingLocalTemplatesUpdateErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type MessagingLocalTemplatesUpdateError = MessagingLocalTemplatesUpdateErrors[keyof MessagingLocalTemplatesUpdateErrors];

export type MessagingLocalTemplatesUpdateResponses = {
    /**
     * Single local template response
     */
    200: LocalTemplate;
};

export type MessagingLocalTemplatesUpdateResponse = MessagingLocalTemplatesUpdateResponses[keyof MessagingLocalTemplatesUpdateResponses];

export type UpdateCmStatusWebhookData = {
    body?: UpdateCmStatusWebhookRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: CmWebhookSecurityScheme
         */
        'X-DES-CM-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/webhooks/messaging/campaigns/cm/update-status';
};

export type UpdateCmStatusWebhookErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type UpdateCmStatusWebhookError = UpdateCmStatusWebhookErrors[keyof UpdateCmStatusWebhookErrors];

export type UpdateCmStatusWebhookResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type UpdateCmStatusWebhookResponse = UpdateCmStatusWebhookResponses[keyof UpdateCmStatusWebhookResponses];

export type UpdateConsentsData = {
    /**
     * Update consents
     */
    body?: UpdateConsents;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/consents/users/{uuid}';
};

export type UpdateConsentsErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type UpdateConsentsError = UpdateConsentsErrors[keyof UpdateConsentsErrors];

export type UpdateConsentsResponses = {
    /**
     * Empty response
     */
    200: unknown;
};

export type UpdateOneTrustPreferenceWebhookData = {
    body?: UpdateOneTrustPreferenceWebhookRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: OneTrustWebhookSecurityScheme
         */
        'X-ONE-TRUST-WEBHOOK-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/webhooks/one-trust/update-consent';
};

export type UpdateOneTrustPreferenceWebhookErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Error response for updating OneTrust preference webhook
     */
    422: UpdateOneTrustPreferenceWebhookErrorResponse;
};

export type UpdateOneTrustPreferenceWebhookError = UpdateOneTrustPreferenceWebhookErrors[keyof UpdateOneTrustPreferenceWebhookErrors];

export type UpdateOneTrustPreferenceWebhookResponses = {
    /**
     * The update was successfully registered.
     */
    201: unknown;
};

export type UpdateOneTrustPurposesData = {
    /**
     * Trigger synchronization of OneTrust purposes with local data
     */
    body?: PerformOneTrustPurposesSyncRequest;
    headers?: {
        /**
         * Security scheme: WebhookSecurityScheme
         */
        'X-DES-SIGNATURE'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/webhooks/one-trust/sync-purposes';
};

export type UpdateOneTrustPurposesErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    424: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateOneTrustPurposesError = UpdateOneTrustPurposesErrors[keyof UpdateOneTrustPurposesErrors];

export type UpdateOneTrustPurposesResponses = {
    /**
     * Success message response
     */
    200: SuccessMessage;
};

export type UpdateOneTrustPurposesResponse = UpdateOneTrustPurposesResponses[keyof UpdateOneTrustPurposesResponses];

export type GetFeedbackVoteData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path?: never;
    query: {
        /**
         * Website content URL used to identify vote
         */
        url: string;
        /**
         * Website content reference type
         */
        reference_type: string;
        /**
         * Website content reference name
         */
        reference_name: string;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/content/feedback-votes';
};

export type GetFeedbackVoteErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    404: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type GetFeedbackVoteError = GetFeedbackVoteErrors[keyof GetFeedbackVoteErrors];

export type GetFeedbackVoteResponses = {
    /**
     * Feedback vote for the current user and URL
     */
    200: GetFeedbackVoteResponse;
};

export type GetFeedbackVoteResponse2 = GetFeedbackVoteResponses[keyof GetFeedbackVoteResponses];

export type CreateFeedbackVoteData = {
    /**
     * Create feedback vote payload
     */
    body?: CreateFeedbackVoteRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/content/feedback-votes';
};

export type CreateFeedbackVoteErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    404: CommonError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
};

export type CreateFeedbackVoteError = CreateFeedbackVoteErrors[keyof CreateFeedbackVoteErrors];

export type CreateFeedbackVoteResponses = {
    /**
     * Created feedback vote for the current user
     */
    201: CreateFeedbackVoteResponse;
};

export type CreateFeedbackVoteResponse2 = CreateFeedbackVoteResponses[keyof CreateFeedbackVoteResponses];

export type GetFeedbackVoteSummaryData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path?: never;
    query: {
        /**
         * Website content URL
         */
        url: string;
        /**
         * Website content reference type
         */
        reference_type: string;
        /**
         * Website content reference name
         */
        reference_name: string;
        /**
         * Filter parameters
         */
        filter?: {
            created_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
        };
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/content/feedback-votes/summary';
};

export type GetFeedbackVoteSummaryErrors = {
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type GetFeedbackVoteSummaryError = GetFeedbackVoteSummaryErrors[keyof GetFeedbackVoteSummaryErrors];

export type GetFeedbackVoteSummaryResponses = {
    /**
     * Feedback vote summary for URL
     */
    200: GetFeedbackVoteSummaryResponse;
};

export type GetFeedbackVoteSummaryResponse2 = GetFeedbackVoteSummaryResponses[keyof GetFeedbackVoteSummaryResponses];

export type ListWebhookTransformersData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/webhooks/transformers';
};

export type ListWebhookTransformersErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListWebhookTransformersError = ListWebhookTransformersErrors[keyof ListWebhookTransformersErrors];

export type ListWebhookTransformersResponses = {
    /**
     * Webhook transformers response
     */
    200: WebhookTransformersResponse;
};

export type ListWebhookTransformersResponse = ListWebhookTransformersResponses[keyof ListWebhookTransformersResponses];

export type ListWebhookEventValuesData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/webhooks/event-values';
};

export type ListWebhookEventValuesResponses = {
    /**
     * List of webhook event values.
     */
    200: WebhookEventValueList;
};

export type ListWebhookEventValuesResponse = ListWebhookEventValuesResponses[keyof ListWebhookEventValuesResponses];

export type ListWebhooksData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            event?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
        };
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/webhooks';
};

export type ListWebhooksErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListWebhooksError = ListWebhooksErrors[keyof ListWebhooksErrors];

export type ListWebhooksResponses = {
    /**
     * Return a list of available webhooks
     */
    200: ListWebhookResponse;
};

export type ListWebhooksResponse = ListWebhooksResponses[keyof ListWebhooksResponses];

export type CreateWebhookData = {
    /**
     * Webhook data
     */
    body?: WebhookFields;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/webhooks';
};

export type CreateWebhookErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreateWebhookError = CreateWebhookErrors[keyof CreateWebhookErrors];

export type CreateWebhookResponses = {
    /**
     * Webhook response
     */
    201: Webhook;
};

export type CreateWebhookResponse = CreateWebhookResponses[keyof CreateWebhookResponses];

export type DeleteWebhookData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Webhook internal id
         */
        webhook_id: number;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/webhooks/{webhook_id}';
};

export type DeleteWebhookErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DeleteWebhookError = DeleteWebhookErrors[keyof DeleteWebhookErrors];

export type DeleteWebhookResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeleteWebhookResponse = DeleteWebhookResponses[keyof DeleteWebhookResponses];

export type GetWebhookData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Webhook internal id
         */
        webhook_id: number;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/webhooks/{webhook_id}';
};

export type GetWebhookErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetWebhookError = GetWebhookErrors[keyof GetWebhookErrors];

export type GetWebhookResponses = {
    /**
     * Webhook response
     */
    200: Webhook;
};

export type GetWebhookResponse = GetWebhookResponses[keyof GetWebhookResponses];

export type UpdateWebhookData = {
    /**
     * Webhook data
     */
    body?: WebhookFields;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Webhook internal id
         */
        webhook_id: number;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/webhooks/{webhook_id}';
};

export type UpdateWebhookErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateWebhookError = UpdateWebhookErrors[keyof UpdateWebhookErrors];

export type UpdateWebhookResponses = {
    /**
     * Webhook response
     */
    200: Webhook;
};

export type UpdateWebhookResponse = UpdateWebhookResponses[keyof UpdateWebhookResponses];

export type ListSearchSearchableItemData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Search term
         */
        q?: string;
        /**
         * Filter search results by entity type
         */
        type?: 'product' | 'page' | 'faq';
        /**
         * Specifies search language with two characters language code
         */
        lang?: string;
        /**
         * Should pattern matches be highlighted in the search results?
         */
        highlight?: boolean;
        /**
         * Field which should influence search results scoring
         */
        sort?: 'created_at' | 'updated_at';
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/search';
};

export type ListSearchSearchableItemErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListSearchSearchableItemError = ListSearchSearchableItemErrors[keyof ListSearchSearchableItemErrors];

export type ListSearchSearchableItemResponses = {
    /**
     * Found items with pagination metadata
     */
    200: SearchItemsResponse;
};

export type ListSearchSearchableItemResponse = ListSearchSearchableItemResponses[keyof ListSearchSearchableItemResponses];

export type ListSearchablesData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            item_id?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * In filter
                 */
                in?: string;
            };
            type?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * In filter
                 */
                in?: string;
            };
            language?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * In filter
                 */
                in?: string;
            };
            title?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            url?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
        };
        /**
         * Comma-separated list of fields to sort by. Prefix with "-" for descending order (e.g., "code,-created_at"). Multiple fields are supported.
         */
        sort?: string;
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/search/index';
};

export type ListSearchablesErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListSearchablesError = ListSearchablesErrors[keyof ListSearchablesErrors];

export type ListSearchablesResponses = {
    /**
     * Return a list of searchable items
     */
    200: ListSearchablesResponse;
};

export type ListSearchablesResponse2 = ListSearchablesResponses[keyof ListSearchablesResponses];

export type CreateSearchableItemData = {
    /**
     * Searchable data
     */
    body?: Searchable;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/search/index';
};

export type CreateSearchableItemErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreateSearchableItemError = CreateSearchableItemErrors[keyof CreateSearchableItemErrors];

export type CreateSearchableItemResponses = {
    /**
     * Item that can be searched
     */
    200: Searchable;
};

export type CreateSearchableItemResponse = CreateSearchableItemResponses[keyof CreateSearchableItemResponses];

export type GetSearchableData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Searchable item original object identifier
         */
        item_id: string;
        /**
         * Searchable item type
         */
        type: 'product' | 'page' | 'faq';
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/search/index/{item_id}/{type}';
};

export type GetSearchableErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetSearchableError = GetSearchableErrors[keyof GetSearchableErrors];

export type GetSearchableResponses = {
    /**
     * Item that can be searched
     */
    200: Searchable;
};

export type GetSearchableResponse = GetSearchableResponses[keyof GetSearchableResponses];

export type DeleteAllSearchableData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/search/index/purge';
};

export type DeleteAllSearchableErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DeleteAllSearchableError = DeleteAllSearchableErrors[keyof DeleteAllSearchableErrors];

export type DeleteAllSearchableResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeleteAllSearchableResponse = DeleteAllSearchableResponses[keyof DeleteAllSearchableResponses];

export type DeleteSearchableData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Searchable item original object identifier
         */
        item_id: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/search/index/{item_id}';
};

export type DeleteSearchableErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DeleteSearchableError = DeleteSearchableErrors[keyof DeleteSearchableErrors];

export type DeleteSearchableResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeleteSearchableResponse = DeleteSearchableResponses[keyof DeleteSearchableResponses];

export type InitializeIndexesData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * Security scheme: StaticTokenSecurityScheme
         */
        'X-DES-STATIC-TOKEN'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/search/index/sync';
};

export type InitializeIndexesErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type InitializeIndexesError = InitializeIndexesErrors[keyof InitializeIndexesErrors];

export type InitializeIndexesResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type InitializeIndexesResponse = InitializeIndexesResponses[keyof InitializeIndexesResponses];

export type ValidateInventoryItemData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Inventory Item Code - unique inventory item identifier
         */
        inventory_item_code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/inventory/items/{inventory_item_code}/validate';
};

export type ValidateInventoryItemErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * The requested Device Id is not registrable.
     */
    409: DeviceNotRegistrableResponse;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ValidateInventoryItemError = ValidateInventoryItemErrors[keyof ValidateInventoryItemErrors];

export type ValidateInventoryItemResponses = {
    /**
     * Single Inventory Item Validation response
     */
    200: InventoryItemValidationResponse;
};

export type ValidateInventoryItemResponse = ValidateInventoryItemResponses[keyof ValidateInventoryItemResponses];

export type ListInventoryItemData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Registered CAS customer UUID - required without external_user_id and personal_identifier
         */
        des_user_id?: string | null;
        /**
         * Registered external customer ID/UUID (Ambassador / Lead) - required without des_user_id and personal_identifier
         */
        external_user_id?: string | null;
        /**
         * Alternative to provide email for registered users - required without des_user_id and external_user_id
         */
        personal_identifier?: string | null;
        /**
         * Filter by product type
         */
        'filters[product_type]'?: string | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/inventory/items';
};

export type ListInventoryItemErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListInventoryItemError = ListInventoryItemErrors[keyof ListInventoryItemErrors];

export type ListInventoryItemResponses = {
    /**
     * Inventory Item list response
     */
    200: InventoryItemListResponse;
};

export type ListInventoryItemResponse = ListInventoryItemResponses[keyof ListInventoryItemResponses];

export type RestoreInventoryItemData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Inventory Item Code - unique inventory item identifier
         */
        inventory_item_code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/inventory/items/{inventory_item_code}';
};

export type RestoreInventoryItemErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type RestoreInventoryItemError = RestoreInventoryItemErrors[keyof RestoreInventoryItemErrors];

export type RestoreInventoryItemResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type RestoreInventoryItemResponse = RestoreInventoryItemResponses[keyof RestoreInventoryItemResponses];

export type GetInventoryItemData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Inventory Item Code - unique inventory item identifier
         */
        inventory_item_code: string;
    };
    query?: {
        /**
         * Registered CAS customer UUID - required without external_user_id and personal_identifier
         */
        des_user_id?: string | null;
        /**
         * Registered external customer ID/UUID (Ambassador / Lead) - required without des_user_id and personal_identifier
         */
        external_user_id?: string | null;
        /**
         * Alternative to provide email for registered users - required without des_user_id and external_user_id
         */
        personal_identifier?: string | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/inventory/items/{inventory_item_code}';
};

export type GetInventoryItemErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetInventoryItemError = GetInventoryItemErrors[keyof GetInventoryItemErrors];

export type GetInventoryItemResponses = {
    /**
     * Detailed information about a specific inventory item
     */
    200: InventoryItemResponse;
};

export type GetInventoryItemResponse = GetInventoryItemResponses[keyof GetInventoryItemResponses];

export type UpdateRegistrabilityInventoryItemData = {
    body?: SetInventoryItemRegistrabilityRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Inventory Item Code - unique inventory item identifier
         */
        inventory_item_code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/inventory/items/{inventory_item_code}/set-registrability';
};

export type UpdateRegistrabilityInventoryItemErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateRegistrabilityInventoryItemError = UpdateRegistrabilityInventoryItemErrors[keyof UpdateRegistrabilityInventoryItemErrors];

export type UpdateRegistrabilityInventoryItemResponses = {
    /**
     * Detailed information about a specific inventory item
     */
    200: InventoryItemResponse;
};

export type UpdateRegistrabilityInventoryItemResponse = UpdateRegistrabilityInventoryItemResponses[keyof UpdateRegistrabilityInventoryItemResponses];

export type RegisterInventoryItemData = {
    body?: RegisterInventoryItemRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Inventory Item Code - unique inventory item identifier
         */
        inventory_item_code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/inventory/items/{inventory_item_code}/register';
};

export type RegisterInventoryItemErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type RegisterInventoryItemError = RegisterInventoryItemErrors[keyof RegisterInventoryItemErrors];

export type RegisterInventoryItemResponses = {
    /**
     * Detailed information about a specific inventory item
     */
    200: InventoryItemResponse;
};

export type RegisterInventoryItemResponse = RegisterInventoryItemResponses[keyof RegisterInventoryItemResponses];

export type UnregisterInventoryItemData = {
    body?: UnregisterInventoryItemRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Inventory Item Code - unique inventory item identifier
         */
        inventory_item_code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/inventory/items/{inventory_item_code}/unregister';
};

export type UnregisterInventoryItemErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UnregisterInventoryItemError = UnregisterInventoryItemErrors[keyof UnregisterInventoryItemErrors];

export type UnregisterInventoryItemResponses = {
    /**
     * Detailed information about a specific inventory item
     */
    200: InventoryItemResponse;
};

export type UnregisterInventoryItemResponse = UnregisterInventoryItemResponses[keyof UnregisterInventoryItemResponses];

export type AttachConsumerToInventoryItemData = {
    body?: AttachInventoryItemRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Inventory Item Code - unique inventory item identifier
         */
        inventory_item_code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/inventory/items/{inventory_item_code}/attach';
};

export type AttachConsumerToInventoryItemErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type AttachConsumerToInventoryItemError = AttachConsumerToInventoryItemErrors[keyof AttachConsumerToInventoryItemErrors];

export type AttachConsumerToInventoryItemResponses = {
    /**
     * Detailed information about a specific inventory item
     */
    200: InventoryItemResponse;
};

export type AttachConsumerToInventoryItemResponse = AttachConsumerToInventoryItemResponses[keyof AttachConsumerToInventoryItemResponses];

export type IsAttachableToConsumerData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Inventory Item Code - unique inventory item identifier
         */
        inventory_item_code: string;
    };
    query: {
        /**
         * Registered CAS customer UUID
         */
        des_user_id: string;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/inventory/items/{inventory_item_code}/is-attachable';
};

export type IsAttachableToConsumerErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type IsAttachableToConsumerError = IsAttachableToConsumerErrors[keyof IsAttachableToConsumerErrors];

export type IsAttachableToConsumerResponses = {
    /**
     * Information about whether an inventory item is attachable to a user or not.
     */
    200: IsAttachableResponse;
};

export type IsAttachableToConsumerResponse = IsAttachableToConsumerResponses[keyof IsAttachableToConsumerResponses];

export type GetWarrantyData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Inventory Item Code - unique Inventory Item identifier
         */
        inventory_item_code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/inventory/items/{inventory_item_code}/warranty';
};

export type GetWarrantyErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetWarrantyError = GetWarrantyErrors[keyof GetWarrantyErrors];

export type GetWarrantyResponses = {
    /**
     * Single warranty item response
     */
    200: WarrantyResponse;
};

export type GetWarrantyResponse = GetWarrantyResponses[keyof GetWarrantyResponses];

export type UpdateWarrantyData = {
    body?: UpdateWarrantyRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Inventory Item Code - unique Inventory Item identifier
         */
        inventory_item_code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/inventory/items/{inventory_item_code}/warranty';
};

export type UpdateWarrantyErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateWarrantyError = UpdateWarrantyErrors[keyof UpdateWarrantyErrors];

export type UpdateWarrantyResponses = {
    /**
     * Single warranty item response
     */
    200: WarrantyResponse;
};

export type UpdateWarrantyResponse = UpdateWarrantyResponses[keyof UpdateWarrantyResponses];

export type CanceledWarrantyData = {
    body?: CancelWarrantyRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Inventory Item Code - unique Inventory Item identifier
         */
        inventory_item_code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/inventory/items/{inventory_item_code}/warranty/cancel';
};

export type CanceledWarrantyErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CanceledWarrantyError = CanceledWarrantyErrors[keyof CanceledWarrantyErrors];

export type CanceledWarrantyResponses = {
    /**
     * Single warranty item response
     */
    200: WarrantyResponse;
};

export type CanceledWarrantyResponse = CanceledWarrantyResponses[keyof CanceledWarrantyResponses];

export type ListUserInventoryItemData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * The microservice way of authenticating users is now deprecated and will be removed in the future. Use the 'UserSecurityScheme' instead.
         */
        'X-DES-CONSUMER-IAM-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter by product type
         */
        'filters[product_type]'?: string | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/inventory/items';
};

export type ListUserInventoryItemErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListUserInventoryItemError = ListUserInventoryItemErrors[keyof ListUserInventoryItemErrors];

export type ListUserInventoryItemResponses = {
    /**
     * Inventory Item list response
     */
    200: InventoryItemListResponse;
};

export type ListUserInventoryItemResponse = ListUserInventoryItemResponses[keyof ListUserInventoryItemResponses];

export type UserPairInventoryItemData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * The microservice way of authenticating users is now deprecated and will be removed in the future. Use the 'UserSecurityScheme' instead.
         */
        'X-DES-CONSUMER-IAM-TOKEN'?: string | null;
    };
    path: {
        /**
         * Device Identifier. Either LeafletId (RC) which is 16 character long string or Device Serial Number (TC) which is at least 12 characters long. For TC, only first 12 characters will be used
         */
        inventory_item_code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/inventory/items/{inventory_item_code}/pair';
};

export type UserPairInventoryItemErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UserPairInventoryItemError = UserPairInventoryItemErrors[keyof UserPairInventoryItemErrors];

export type UserPairInventoryItemResponses = {
    /**
     * Detailed information about a specific inventory item
     */
    200: InventoryItemResponse;
};

export type UserPairInventoryItemResponse = UserPairInventoryItemResponses[keyof UserPairInventoryItemResponses];

export type UserUnpairInventoryItemData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * The microservice way of authenticating users is now deprecated and will be removed in the future. Use the 'UserSecurityScheme' instead.
         */
        'X-DES-CONSUMER-IAM-TOKEN'?: string | null;
    };
    path: {
        /**
         * Device Identifier. Either LeafletId (RC) which is 16 character long string or Device Serial Number (TC) which is at least 12 characters long. For TC, only first 12 characters will be used
         */
        inventory_item_code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/inventory/items/{inventory_item_code}/unpair';
};

export type UserUnpairInventoryItemErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UserUnpairInventoryItemError = UserUnpairInventoryItemErrors[keyof UserUnpairInventoryItemErrors];

export type UserUnpairInventoryItemResponses = {
    /**
     * Detailed information about a specific inventory item
     */
    200: InventoryItemResponse;
};

export type UserUnpairInventoryItemResponse = UserUnpairInventoryItemResponses[keyof UserUnpairInventoryItemResponses];

export type RegisterUserInventoryItemData = {
    body?: UserRegisterInventoryItemRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * The microservice way of authenticating users is now deprecated and will be removed in the future. Use the 'UserSecurityScheme' instead.
         */
        'X-DES-CONSUMER-IAM-TOKEN'?: string | null;
    };
    path: {
        /**
         * Device Identifier. Either LeafletId (RC) which is 16 character long string or Device Serial Number (TC) which is at least 12 characters long. For TC, only first 12 characters will be used
         */
        inventory_item_code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/inventory/items/{inventory_item_code}/register';
};

export type RegisterUserInventoryItemErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type RegisterUserInventoryItemError = RegisterUserInventoryItemErrors[keyof RegisterUserInventoryItemErrors];

export type RegisterUserInventoryItemResponses = {
    /**
     * Detailed information about a specific inventory item
     */
    200: InventoryItemResponse;
};

export type RegisterUserInventoryItemResponse = RegisterUserInventoryItemResponses[keyof RegisterUserInventoryItemResponses];

export type UserUnregisterInventoryItemData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * The microservice way of authenticating users is now deprecated and will be removed in the future. Use the 'UserSecurityScheme' instead.
         */
        'X-DES-CONSUMER-IAM-TOKEN'?: string | null;
    };
    path: {
        /**
         * Device Identifier. Either LeafletId (RC) which is 16 character long string or Device Serial Number (TC) which is at least 12 characters long. For TC, only first 12 characters will be used
         */
        inventory_item_code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/inventory/items/{inventory_item_code}/unregister';
};

export type UserUnregisterInventoryItemErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UserUnregisterInventoryItemError = UserUnregisterInventoryItemErrors[keyof UserUnregisterInventoryItemErrors];

export type UserUnregisterInventoryItemResponses = {
    /**
     * Detailed information about a specific inventory item
     */
    200: InventoryItemResponse;
};

export type UserUnregisterInventoryItemResponse = UserUnregisterInventoryItemResponses[keyof UserUnregisterInventoryItemResponses];

export type UserIsAttachableInventoryItemData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
        /**
         * The microservice way of authenticating users is now deprecated and will be removed in the future. Use the 'UserSecurityScheme' instead.
         */
        'X-DES-CONSUMER-IAM-TOKEN'?: string | null;
    };
    path: {
        /**
         * Device Identifier. Either LeafletId (RC) which is 16 character long string or Device Serial Number (TC) which is at least 12 characters long. For TC, only first 12 characters will be used
         */
        inventory_item_code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/inventory/items/{inventory_item_code}/is-attachable';
};

export type UserIsAttachableInventoryItemErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UserIsAttachableInventoryItemError = UserIsAttachableInventoryItemErrors[keyof UserIsAttachableInventoryItemErrors];

export type UserIsAttachableInventoryItemResponses = {
    /**
     * Information about whether an inventory item is attachable to a user or not.
     */
    200: IsAttachableResponse;
};

export type UserIsAttachableInventoryItemResponse = UserIsAttachableInventoryItemResponses[keyof UserIsAttachableInventoryItemResponses];

export type InventoryItemsReportData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Include additional data.
         */
        'include[]'?: Array<string> | null;
        /**
         * Sorting by field. Adding '-' before field changes the direction to descending
         */
        sort?: string | null;
        /**
         * Filter by tenant code
         */
        'filters[tenant_code]'?: string | null;
        /**
         * Filter by prefix code for the device. It is embedded in the leaflet number
         */
        'filters[prefix]'?: string | null;
        /**
         * Filter by country code
         */
        'filters[country_code]'?: string | null;
        /**
         * Filter by inventory items created after this date
         */
        'filters[from][created_at]'?: string | null;
        /**
         * Filter by inventory items created before this date
         */
        'filters[to][created_at]'?: string | null;
        /**
         * Filter by inventory items updated after this date
         */
        'filters[from][updated_at]'?: string | null;
        /**
         * Filter by inventory items updated before this date
         */
        'filters[to][updated_at]'?: string | null;
        /**
         * Filter the list by any type of code. Use % as a wildcard character.
         */
        'filters[codes][]'?: Array<string> | null;
        /**
         * Filter by list of serial numbers. Use % as a wildcard character. Deprecated in favor of codes[]
         *
         * @deprecated
         */
        'filters[serials][]'?: Array<string> | null;
        /**
         * Filter by list of serial numbers. Use % as a wildcard character. Deprecated in favor of codes[]
         *
         * @deprecated
         */
        'filters[leaflets][]'?: Array<string> | null;
        /**
         * Filter by registration status. If true, only registered items will be returned. If false, only unregistered items will be returned. If not provided, all items will be returned.
         */
        'filters[registered]'?: '0' | '1' | null;
        /**
         * Filter by is_virtual flag. If true, only virtual items will be returned. If false, only real items will be returned. If not provided, all items will be returned.
         */
        'filters[is_virtual]'?: '0' | '1' | null;
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
    };
    url: '/api/inventory/reporting/items';
};

export type InventoryItemsReportErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type InventoryItemsReportError = InventoryItemsReportErrors[keyof InventoryItemsReportErrors];

export type InventoryItemsReportResponses = {
    /**
     * List of inventory items for report with pagination meta fields.
     */
    200: InventoryItemReportResponse;
};

export type InventoryItemsReportResponse = InventoryItemsReportResponses[keyof InventoryItemsReportResponses];

export type ExportInventoryItemsReportData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Sorting by field. Adding '-' before field changes the direction to descending
         */
        sort?: string | null;
        /**
         * Filter by tenant code
         */
        'filters[tenant_code]'?: string | null;
        /**
         * Filter by prefix code for the device. It is embedded in the leaflet number
         */
        'filters[prefix]'?: string | null;
        /**
         * Filter by country code
         */
        'filters[country_code]'?: string | null;
        /**
         * Filter by inventory items created after this date
         */
        'filters[from][created_at]'?: string | null;
        /**
         * Filter by inventory items created before this date
         */
        'filters[to][created_at]'?: string | null;
        /**
         * Filter by inventory items updated after this date
         */
        'filters[from][updated_at]'?: string | null;
        /**
         * Filter by inventory items updated before this date
         */
        'filters[to][updated_at]'?: string | null;
        /**
         * Filter the list by any type of code. Use % as a wildcard character.
         */
        'filters[codes][]'?: Array<string> | null;
        /**
         * Filter by list of serial numbers. Use % as a wildcard character. Deprecated in favor of codes[]
         *
         * @deprecated
         */
        'filters[serials][]'?: Array<string> | null;
        /**
         * Filter by list of serial numbers. Use % as a wildcard character. Deprecated in favor of codes[]
         *
         * @deprecated
         */
        'filters[leaflets][]'?: Array<string> | null;
        /**
         * Filter by registration status. If true, only registered items will be returned. If false, only unregistered items will be returned. If not provided, all items will be returned.
         */
        'filters[registered]'?: '0' | '1' | null;
        /**
         * Filter by is_virtual flag. If true, only virtual items will be returned. If false, only real items will be returned. If not provided, all items will be returned.
         */
        'filters[is_virtual]'?: '0' | '1' | null;
    };
    url: '/api/inventory/reporting/items/export';
};

export type ExportInventoryItemsReportErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ExportInventoryItemsReportError = ExportInventoryItemsReportErrors[keyof ExportInventoryItemsReportErrors];

export type ExportInventoryItemsReportResponses = {
    /**
     * CSV file with exported inventory items
     */
    200: InventoryItemReportExportResponse;
};

export type ExportInventoryItemsReportResponse = ExportInventoryItemsReportResponses[keyof ExportInventoryItemsReportResponses];

export type InventoryImportReportData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Filter by started_at after this date
         */
        'filters[from]'?: string | null;
        /**
         * Filter by started_at before this date
         */
        'filters[to]'?: string | null;
        /**
         * Sorting by field. Adding '-' before field changes the direction to descending
         */
        sort?: string | null;
    };
    url: '/api/inventory/reporting/imports';
};

export type InventoryImportReportErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type InventoryImportReportError = InventoryImportReportErrors[keyof InventoryImportReportErrors];

export type InventoryImportReportResponses = {
    /**
     * List of inventory import reports with pagination meta fields.
     */
    200: InventoryImportReportResponse;
};

export type InventoryImportReportResponse2 = InventoryImportReportResponses[keyof InventoryImportReportResponses];

export type ImportInventoryErrorsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Inventory Import Report ID
         */
        id: string;
    };
    query?: {
        /**
         * Filter by message. Use % as a wildcard character.
         */
        'filters[message]'?: string | null;
        /**
         * Filter by data. Use % as a wildcard character.
         */
        'filters[data]'?: string | null;
        /**
         * Filter by error type.
         */
        'filters[type]'?: string | null;
        /**
         * Sorting by field. Adding '-' before field changes the direction to descending
         */
        sort?: string | null;
        /**
         * The page number of items
         */
        page?: number | null;
        /**
         * The number of items per page
         */
        per_page?: number | null;
    };
    url: '/api/inventory/reporting/imports/{id}/errors';
};

export type ImportInventoryErrorsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ImportInventoryErrorsError = ImportInventoryErrorsErrors[keyof ImportInventoryErrorsErrors];

export type ImportInventoryErrorsResponses = {
    /**
     * Inventory import report error list with meta pagination fields.
     */
    200: InventoryImportErrorReportResponse;
};

export type ImportInventoryErrorsResponse = ImportInventoryErrorsResponses[keyof ImportInventoryErrorsResponses];

export type PrefixesReportData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Filter by prefix code for the device. It is embedded in the leaflet number
         */
        'filters[prefix]'?: string | null;
        /**
         * Filter by tenant code
         */
        'filters[tenant_code]'?: string | null;
        /**
         * Filter by country code
         */
        'filters[country_code]'?: string | null;
        /**
         * Filter by spex cluster name
         */
        'filters[spex_cluster]'?: string | null;
        /**
         * Filter by is_virtual flag. If true, only virtual items will be returned. If false, only real items will be returned. If not provided, all items will be returned.
         */
        'filters[is_virtual]'?: '0' | '1' | null;
        /**
         * Filter by product relation to prefix. If true, only prefixes with product relation will be returned.
         */
        'filters[has_product]'?: '0' | '1' | null;
        /**
         * Sorting by field. Adding '-' before field changes the direction to descending
         */
        sort?: string | null;
    };
    url: '/api/inventory/reporting/prefixes';
};

export type PrefixesReportErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type PrefixesReportError = PrefixesReportErrors[keyof PrefixesReportErrors];

export type PrefixesReportResponses = {
    /**
     * List of prefixes for report with pagination meta fields.
     */
    200: PrefixesReportResponse;
};

export type PrefixesReportResponse2 = PrefixesReportResponses[keyof PrefixesReportResponses];

export type ListInventoryExportsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            file_name?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            export_id?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            batch_id?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            status?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            created_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            updated_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            expires_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
        };
        /**
         * Comma-separated list of fields to sort by. Prefix with "-" for descending order (e.g., "code,-created_at"). Multiple fields are supported.
         */
        sort?: string;
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
    };
    url: '/api/inventory/export';
};

export type ListInventoryExportsErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListInventoryExportsError = ListInventoryExportsErrors[keyof ListInventoryExportsErrors];

export type ListInventoryExportsResponses = {
    /**
     * List of Inventory Exports
     */
    200: ListInventoryExportsResponse;
};

export type ListInventoryExportsResponse2 = ListInventoryExportsResponses[keyof ListInventoryExportsResponses];

export type GetInventoryExportData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Inventory Export ID
         */
        export_id: string;
    };
    query?: never;
    url: '/api/inventory/export/{export_id}';
};

export type GetInventoryExportErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Resource not found
     */
    406: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetInventoryExportError = GetInventoryExportErrors[keyof GetInventoryExportErrors];

export type GetInventoryExportResponses = {
    /**
     * Single Inventory Export
     */
    200: InventoryExportResponse;
};

export type GetInventoryExportResponse = GetInventoryExportResponses[keyof GetInventoryExportResponses];

export type ExportStartInventoryData = {
    body?: StartInventoryExportRequestBody;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/inventory/export/start';
};

export type ExportStartInventoryErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Resource not found
     */
    406: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ExportStartInventoryError = ExportStartInventoryErrors[keyof ExportStartInventoryErrors];

export type ExportStartInventoryResponses = {
    /**
     * Single Inventory Export
     */
    200: InventoryExportResponse;
};

export type ExportStartInventoryResponse = ExportStartInventoryResponses[keyof ExportStartInventoryResponses];

export type ImportInventoryItemsData = {
    body?: InventoryItemImportRequestBody;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/inventory/import/items';
};

export type ImportInventoryItemsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ImportInventoryItemsError = ImportInventoryItemsErrors[keyof ImportInventoryItemsErrors];

export type ImportInventoryItemsResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type ImportInventoryItemsResponse = ImportInventoryItemsResponses[keyof ImportInventoryItemsResponses];

export type ImportDiSv1StorageData = {
    body?: DeviceInventoryImportRequestBody;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/inventory/import/device-inventory/storage';
};

export type ImportDiSv1StorageErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ImportDiSv1StorageError = ImportDiSv1StorageErrors[keyof ImportDiSv1StorageErrors];

export type ImportDiSv1StorageResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type ImportDiSv1StorageResponse = ImportDiSv1StorageResponses[keyof ImportDiSv1StorageResponses];

export type DiSv1PayloadImportData = {
    body?: DeviceInventoryPayloadImportRequestBody;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/inventory/import/device-inventory/payload';
};

export type DiSv1PayloadImportErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors for the import request.
     */
    422: DiSv1ImportValidationErrorResponse;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DiSv1PayloadImportError = DiSv1PayloadImportErrors[keyof DiSv1PayloadImportErrors];

export type DiSv1PayloadImportResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DiSv1PayloadImportResponse = DiSv1PayloadImportResponses[keyof DiSv1PayloadImportResponses];

export type ImportPackCodesData = {
    body?: PackCodesImportRequestBody;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/inventory/import/pack-codes';
};

export type ImportPackCodesErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ImportPackCodesError = ImportPackCodesErrors[keyof ImportPackCodesErrors];

export type ImportPackCodesResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type ImportPackCodesResponse = ImportPackCodesResponses[keyof ImportPackCodesResponses];

export type GetSpexClustersData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * The page number of items
         */
        page?: number | null;
        /**
         * The number of items per page
         */
        per_page?: number | null;
    };
    url: '/api/inventory/spex-clusters';
};

export type GetSpexClustersErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetSpexClustersError = GetSpexClustersErrors[keyof GetSpexClustersErrors];

export type GetSpexClustersResponses = {
    /**
     * Spex cluster response
     */
    200: SpexClusterListResponse;
};

export type GetSpexClustersResponse = GetSpexClustersResponses[keyof GetSpexClustersResponses];

export type SpexClusterData = {
    /**
     * SpexCluster data
     */
    body?: CreateSpexClusterRequestBody;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/inventory/spex-clusters';
};

export type SpexClusterErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type SpexClusterError = SpexClusterErrors[keyof SpexClusterErrors];

export type SpexClusterResponses = {
    /**
     * Spex cluster response
     */
    201: SpexCluster;
};

export type SpexClusterResponse2 = SpexClusterResponses[keyof SpexClusterResponses];

export type DeleteSpexClusterData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * The name of the Spex Cluster
         */
        name: string;
    };
    query?: never;
    url: '/api/inventory/spex-clusters/{name}';
};

export type DeleteSpexClusterErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DeleteSpexClusterError = DeleteSpexClusterErrors[keyof DeleteSpexClusterErrors];

export type DeleteSpexClusterResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeleteSpexClusterResponse = DeleteSpexClusterResponses[keyof DeleteSpexClusterResponses];

export type GetSpexClusterData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * The name of the Spex Cluster
         */
        name: string;
    };
    query?: never;
    url: '/api/inventory/spex-clusters/{name}';
};

export type GetSpexClusterErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetSpexClusterError = GetSpexClusterErrors[keyof GetSpexClusterErrors];

export type GetSpexClusterResponses = {
    /**
     * Spex cluster response
     */
    200: SpexCluster;
};

export type GetSpexClusterResponse = GetSpexClusterResponses[keyof GetSpexClusterResponses];

export type UpdateSpexClusterData = {
    /**
     * SpexCluster data
     */
    body?: UpdateSpexClusterRequestBody;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * The name of the Spex Cluster
         */
        name: string;
    };
    query?: never;
    url: '/api/inventory/spex-clusters/{name}';
};

export type UpdateSpexClusterErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateSpexClusterError = UpdateSpexClusterErrors[keyof UpdateSpexClusterErrors];

export type UpdateSpexClusterResponses = {
    /**
     * Spex cluster response
     */
    200: SpexCluster;
};

export type UpdateSpexClusterResponse = UpdateSpexClusterResponses[keyof UpdateSpexClusterResponses];

export type CreateReviewEventData = {
    body?: EventRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/products/reviews/event';
};

export type CreateReviewEventErrors = {
    /**
     * Forbidden Error
     */
    403: ForbiddenErrorResponse;
    /**
     * Validation errors
     */
    422: ValidationErrorResponse;
    /**
     * Failed due to processing error
     */
    423: CommonErrorResponse;
    /**
     * Failed due to processing error
     */
    500: CommonErrorResponse;
};

export type CreateReviewEventError = CreateReviewEventErrors[keyof CreateReviewEventErrors];

export type CreateReviewEventResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type ListReviewsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            type?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * In filter
                 */
                in?: string;
            };
            profile_uuid?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * In filter
                 */
                in?: string;
            };
            sku?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
        };
        /**
         * Comma-separated list of fields to sort by. Prefix with "-" for descending order (e.g., "code,-created_at"). Multiple fields are supported.
         */
        sort?: string;
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/products/reviews';
};

export type ListReviewsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListReviewsError = ListReviewsErrors[keyof ListReviewsErrors];

export type ListReviewsResponses = {
    /**
     * Product reviews list response
     */
    200: ListReviewsResponse;
};

export type ListReviewsResponse2 = ListReviewsResponses[keyof ListReviewsResponses];

export type ImportReviewsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/products/reviews/sync';
};

export type ImportReviewsErrors = {
    /**
     * Forbidden Error
     */
    403: ForbiddenErrorResponse;
    /**
     * Validation errors
     */
    422: ValidationErrorResponse;
    /**
     * Failed due to processing error
     */
    423: CommonErrorResponse;
    /**
     * Failed due to processing error
     */
    500: CommonErrorResponse;
};

export type ImportReviewsError = ImportReviewsErrors[keyof ImportReviewsErrors];

export type ImportReviewsResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type ListProductData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/products';
};

export type ListProductErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListProductError = ListProductErrors[keyof ListProductErrors];

export type ListProductResponses = {
    /**
     * Product list response
     */
    200: ListProductResponse;
};

export type ListProductResponse2 = ListProductResponses[keyof ListProductResponses];

export type GetProductData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Sku - unique product identifier
         */
        sku: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/products/{sku}';
};

export type GetProductErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetProductError = GetProductErrors[keyof GetProductErrors];

export type GetProductResponses = {
    /**
     * Single product item response
     */
    200: ProductResponse;
};

export type GetProductResponse = GetProductResponses[keyof GetProductResponses];

export type ImportProductData = {
    body?: ImportProductSchema;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Process import in sync mode, using sync mode will return body and status code 201, which is different than default 204
         */
        sync?: string;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/products/import';
};

export type ImportProductErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ImportProductError = ImportProductErrors[keyof ImportProductErrors];

export type ImportProductResponses = {
    /**
     * Single product item response
     */
    201: ProductResponse;
    /**
     * Empty response
     */
    204: void;
};

export type ImportProductResponse = ImportProductResponses[keyof ImportProductResponses];

export type ImportDeleteProductData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * SKU - unique product identifier
         */
        sku: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/products/import/{sku}';
};

export type ImportDeleteProductErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ImportDeleteProductError = ImportDeleteProductErrors[keyof ImportDeleteProductErrors];

export type ImportDeleteProductResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type ImportDeleteProductResponse = ImportDeleteProductResponses[keyof ImportDeleteProductResponses];

export type InitializeAuthorisationData = {
    /**
     * Initialize authorisation request
     */
    body?: InitializeAuthorisationRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/authorisations/init';
};

export type InitializeAuthorisationErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type InitializeAuthorisationError = InitializeAuthorisationErrors[keyof InitializeAuthorisationErrors];

export type InitializeAuthorisationResponses = {
    /**
     * Payment session
     */
    200: SessionResponse;
};

export type InitializeAuthorisationResponse = InitializeAuthorisationResponses[keyof InitializeAuthorisationResponses];

export type GetCreditCardsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/cards';
};

export type GetCreditCardsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetCreditCardsError = GetCreditCardsErrors[keyof GetCreditCardsErrors];

export type GetCreditCardsResponses = {
    /**
     * Available credit cards
     */
    200: ListCreditCardsResponse;
};

export type GetCreditCardsResponse = GetCreditCardsResponses[keyof GetCreditCardsResponses];

export type GetCreditCardData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path: {
        /**
         * Credit card identifier
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/cards/{uuid}';
};

export type GetCreditCardErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetCreditCardError = GetCreditCardErrors[keyof GetCreditCardErrors];

export type GetCreditCardResponses = {
    /**
     * Credit card
     */
    200: CreditCardResponse;
};

export type GetCreditCardResponse = GetCreditCardResponses[keyof GetCreditCardResponses];

export type CreatePaymentData = {
    /**
     * Create a payment and acquire payment token
     */
    body?: CreatePaymentRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/generate-token';
};

export type CreatePaymentErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreatePaymentError = CreatePaymentErrors[keyof CreatePaymentErrors];

export type CreatePaymentResponses = {
    /**
     * Payment token
     */
    200: PaymentTokenResponse;
};

export type CreatePaymentResponse = CreatePaymentResponses[keyof CreatePaymentResponses];

export type GetPaymentMethodsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Payment type
         */
        'filter[type]'?: string;
        'filter[tokenizable]'?: '0' | '1';
        'filter[skus]'?: string;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/methods';
};

export type GetPaymentMethodsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetPaymentMethodsError = GetPaymentMethodsErrors[keyof GetPaymentMethodsErrors];

export type GetPaymentMethodsResponses = {
    /**
     * Available payment methods
     */
    200: ListPaymentMethodsResponse;
};

export type GetPaymentMethodsResponse = GetPaymentMethodsResponses[keyof GetPaymentMethodsResponses];

export type CreatePaymentMethodData = {
    body?: PaymentMethod;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/methods';
};

export type CreatePaymentMethodErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreatePaymentMethodError = CreatePaymentMethodErrors[keyof CreatePaymentMethodErrors];

export type CreatePaymentMethodResponses = {
    /**
     * Payment Method
     */
    200: PaymentMethodResponse;
};

export type CreatePaymentMethodResponse = CreatePaymentMethodResponses[keyof CreatePaymentMethodResponses];

export type GetPaymentMethodClientData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path: {
        /**
         * Payment Method for which client.js is required
         */
        code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/methods/{code}/client';
};

export type GetPaymentMethodClientErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetPaymentMethodClientError = GetPaymentMethodClientErrors[keyof GetPaymentMethodClientErrors];

export type GetPaymentMethodClientResponses = {
    /**
     * JS Script that can handle payment request based on payment method provided in request
     */
    200: PaymentMethodClientResponse;
};

export type GetPaymentMethodClientResponse = GetPaymentMethodClientResponses[keyof GetPaymentMethodClientResponses];

export type GetPaymentData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path: {
        /**
         * Payment identifier
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/{uuid}';
};

export type GetPaymentErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetPaymentError = GetPaymentErrors[keyof GetPaymentErrors];

export type GetPaymentResponses = {
    /**
     * Payment details
     */
    200: PaymentResponse;
};

export type GetPaymentResponse = GetPaymentResponses[keyof GetPaymentResponses];

export type UpdatePaymentData = {
    /**
     * Update payment session
     */
    body?: UpdatePaymentRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating adapters is now deprecated and will be removed in the future. Use the 'AdapterSecurityScheme' instead.
         */
        'X-DES-ADAPTER-AK'?: string | null;
        /**
         * Security scheme: AdapterSecurityScheme
         */
        'X-DES-ADAPTER'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Payment identifier
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/{uuid}';
};

export type UpdatePaymentErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdatePaymentError = UpdatePaymentErrors[keyof UpdatePaymentErrors];

export type UpdatePaymentResponses = {
    /**
     * OK
     */
    200: UpdatePaymentResponse;
};

export type UpdatePaymentResponse2 = UpdatePaymentResponses[keyof UpdatePaymentResponses];

export type GetTokenData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path: {
        /**
         * ID of related order
         */
        order_id: number;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/tokens/{order_id}';
};

export type GetTokenErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetTokenError = GetTokenErrors[keyof GetTokenErrors];

export type GetTokenResponses = {
    /**
     * Requested token
     */
    200: GetTokenResponse;
};

export type GetTokenResponse2 = GetTokenResponses[keyof GetTokenResponses];

export type CreatePaymentSessionData = {
    /**
     * Create payment session for secured fields flow
     */
    body?: CreateSessionRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/sessions';
};

export type CreatePaymentSessionErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreatePaymentSessionError = CreatePaymentSessionErrors[keyof CreatePaymentSessionErrors];

export type CreatePaymentSessionResponses = {
    /**
     * Payment session
     */
    200: SessionResponse;
};

export type CreatePaymentSessionResponse = CreatePaymentSessionResponses[keyof CreatePaymentSessionResponses];

export type InitializePaymentSessionData = {
    /**
     * Init payment session
     */
    body?: InitializeSessionRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/sessions/init';
};

export type InitializePaymentSessionErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type InitializePaymentSessionError = InitializePaymentSessionErrors[keyof InitializePaymentSessionErrors];

export type InitializePaymentSessionResponses = {
    /**
     * Payment session
     */
    200: SessionResponse;
};

export type InitializePaymentSessionResponse = InitializePaymentSessionResponses[keyof InitializePaymentSessionResponses];

export type PaySessionData = {
    /**
     * Pay for an order using a secured fields payment session
     */
    body?: PaySessionRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/sessions/pay';
};

export type PaySessionErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type PaySessionError = PaySessionErrors[keyof PaySessionErrors];

export type PaySessionResponses = {
    /**
     * Payment details
     */
    200: PaymentResponse;
};

export type PaySessionResponse = PaySessionResponses[keyof PaySessionResponses];

export type GetRefundData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating adapters is now deprecated and will be removed in the future. Use the 'AdapterSecurityScheme' instead.
         */
        'X-DES-ADAPTER-AK'?: string | null;
        /**
         * Security scheme: AdapterSecurityScheme
         */
        'X-DES-ADAPTER'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Refund identifier
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/refunds/{uuid}';
};

export type GetRefundErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetRefundError = GetRefundErrors[keyof GetRefundErrors];

export type GetRefundResponses = {
    /**
     * Refund
     */
    200: RefundResponse;
};

export type GetRefundResponse = GetRefundResponses[keyof GetRefundResponses];

export type UpdateRefundData = {
    /**
     * Update refund status
     */
    body?: UpdateRefundRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating adapters is now deprecated and will be removed in the future. Use the 'AdapterSecurityScheme' instead.
         */
        'X-DES-ADAPTER-AK'?: string | null;
        /**
         * Security scheme: AdapterSecurityScheme
         */
        'X-DES-ADAPTER'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Refund identifier
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/refunds/{uuid}';
};

export type UpdateRefundErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateRefundError = UpdateRefundErrors[keyof UpdateRefundErrors];

export type UpdateRefundResponses = {
    /**
     * Refund
     */
    200: RefundResponse;
};

export type UpdateRefundResponse = UpdateRefundResponses[keyof UpdateRefundResponses];

export type GetTransactionData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating adapters is now deprecated and will be removed in the future. Use the 'AdapterSecurityScheme' instead.
         */
        'X-DES-ADAPTER-AK'?: string | null;
        /**
         * Security scheme: AdapterSecurityScheme
         */
        'X-DES-ADAPTER'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Transaction identifier
         */
        external_id: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/transactions/{external_id}';
};

export type GetTransactionErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetTransactionError = GetTransactionErrors[keyof GetTransactionErrors];

export type GetTransactionResponses = {
    /**
     * Payment external data
     */
    200: PaymentExternalDataResponse;
};

export type GetTransactionResponse = GetTransactionResponses[keyof GetTransactionResponses];

export type GetPaymentExternalDataData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating adapters is now deprecated and will be removed in the future. Use the 'AdapterSecurityScheme' instead.
         */
        'X-DES-ADAPTER-AK'?: string | null;
        /**
         * Security scheme: AdapterSecurityScheme
         */
        'X-DES-ADAPTER'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Payment identifier
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/data/{uuid}';
};

export type GetPaymentExternalDataErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetPaymentExternalDataError = GetPaymentExternalDataErrors[keyof GetPaymentExternalDataErrors];

export type GetPaymentExternalDataResponses = {
    /**
     * Payment external data
     */
    200: PaymentExternalDataResponse;
};

export type GetPaymentExternalDataResponse = GetPaymentExternalDataResponses[keyof GetPaymentExternalDataResponses];

export type UpdatePaymentExternalDataData = {
    /**
     * Update payment external data
     */
    body?: UpdatePaymentExternalDataRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating adapters is now deprecated and will be removed in the future. Use the 'AdapterSecurityScheme' instead.
         */
        'X-DES-ADAPTER-AK'?: string | null;
        /**
         * Security scheme: AdapterSecurityScheme
         */
        'X-DES-ADAPTER'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Payment identifier
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/data/{uuid}';
};

export type UpdatePaymentExternalDataErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdatePaymentExternalDataError = UpdatePaymentExternalDataErrors[keyof UpdatePaymentExternalDataErrors];

export type UpdatePaymentExternalDataResponses = {
    /**
     * Payment external data
     */
    200: PaymentExternalDataResponse;
};

export type UpdatePaymentExternalDataResponse = UpdatePaymentExternalDataResponses[keyof UpdatePaymentExternalDataResponses];

export type CreateAuthorisationData = {
    /**
     * Create authorisation request
     */
    body?: CreateAuthorisationRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating adapters is now deprecated and will be removed in the future. Use the 'AdapterSecurityScheme' instead.
         */
        'X-DES-ADAPTER-AK'?: string | null;
        /**
         * Security scheme: AdapterSecurityScheme
         */
        'X-DES-ADAPTER'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/authorisations';
};

export type CreateAuthorisationErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreateAuthorisationError = CreateAuthorisationErrors[keyof CreateAuthorisationErrors];

export type CreateAuthorisationResponses = {
    /**
     * Success message response
     */
    default: SuccessMessage;
};

export type CreateAuthorisationResponse = CreateAuthorisationResponses[keyof CreateAuthorisationResponses];

export type CreateRefundData = {
    /**
     * Create a payment and acquire payment token
     */
    body?: CreateRefundRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/refunds';
};

export type CreateRefundErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreateRefundError = CreateRefundErrors[keyof CreateRefundErrors];

export type CreateRefundResponses = {
    /**
     * Refund
     */
    200: RefundResponse;
};

export type CreateRefundResponse = CreateRefundResponses[keyof CreateRefundResponses];

export type DeletePaymentMethodData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Payment method code
         */
        code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/methods/{code}';
};

export type DeletePaymentMethodErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DeletePaymentMethodError = DeletePaymentMethodErrors[keyof DeletePaymentMethodErrors];

export type DeletePaymentMethodResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeletePaymentMethodResponse = DeletePaymentMethodResponses[keyof DeletePaymentMethodResponses];

export type GetPaymentMethodData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Payment method code
         */
        code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/methods/{code}';
};

export type GetPaymentMethodErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetPaymentMethodError = GetPaymentMethodErrors[keyof GetPaymentMethodErrors];

export type GetPaymentMethodResponses = {
    /**
     * Payment Method
     */
    200: PaymentMethodResponse;
};

export type GetPaymentMethodResponse = GetPaymentMethodResponses[keyof GetPaymentMethodResponses];

export type UpdatePaymentMethodData = {
    body?: PaymentMethod;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Payment method code
         */
        code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/methods/{code}';
};

export type UpdatePaymentMethodErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdatePaymentMethodError = UpdatePaymentMethodErrors[keyof UpdatePaymentMethodErrors];

export type UpdatePaymentMethodResponses = {
    /**
     * Payment Method
     */
    200: PaymentMethodResponse;
};

export type UpdatePaymentMethodResponse = UpdatePaymentMethodResponses[keyof UpdatePaymentMethodResponses];

export type SendPaymentLinkData = {
    /**
     * Send a payment link for an order
     */
    body?: SendPaymentLinkRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/payments/link';
};

export type SendPaymentLinkErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type SendPaymentLinkError = SendPaymentLinkErrors[keyof SendPaymentLinkErrors];

export type SendPaymentLinkResponses = {
    /**
     * Success message response
     */
    200: SuccessMessage;
};

export type SendPaymentLinkResponse = SendPaymentLinkResponses[keyof SendPaymentLinkResponses];

export type ListAdaptersData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            name?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            url?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            code?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
        };
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
    };
    url: '/api/adapters';
};

export type ListAdaptersErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListAdaptersError = ListAdaptersErrors[keyof ListAdaptersErrors];

export type ListAdaptersResponses = {
    /**
     * Return a list of adapters
     */
    200: ListAdapterResponse;
};

export type ListAdaptersResponse = ListAdaptersResponses[keyof ListAdaptersResponses];

export type CreateAdapterData = {
    /**
     * Adapter data
     */
    body?: AdapterFields;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/adapters';
};

export type CreateAdapterErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreateAdapterError = CreateAdapterErrors[keyof CreateAdapterErrors];

export type CreateAdapterResponses = {
    /**
     * Adapter response
     */
    201: Adapter;
};

export type CreateAdapterResponse = CreateAdapterResponses[keyof CreateAdapterResponses];

export type DeleteAdapterData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Adapter unique code
         */
        adapter_code: string;
    };
    query?: never;
    url: '/api/adapters/{adapter_code}';
};

export type DeleteAdapterErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DeleteAdapterError = DeleteAdapterErrors[keyof DeleteAdapterErrors];

export type DeleteAdapterResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeleteAdapterResponse = DeleteAdapterResponses[keyof DeleteAdapterResponses];

export type GetAdapterData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Adapter unique code
         */
        adapter_code: string;
    };
    query?: never;
    url: '/api/adapters/{adapter_code}';
};

export type GetAdapterErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetAdapterError = GetAdapterErrors[keyof GetAdapterErrors];

export type GetAdapterResponses = {
    /**
     * Adapter response
     */
    200: Adapter;
};

export type GetAdapterResponse = GetAdapterResponses[keyof GetAdapterResponses];

export type UpdateAdapterData = {
    /**
     * Adapter data
     */
    body?: AdapterFields;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Adapter unique code
         */
        adapter_code: string;
    };
    query?: never;
    url: '/api/adapters/{adapter_code}';
};

export type UpdateAdapterErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateAdapterError = UpdateAdapterErrors[keyof UpdateAdapterErrors];

export type UpdateAdapterResponses = {
    /**
     * Adapter response
     */
    200: Adapter;
};

export type UpdateAdapterResponse = UpdateAdapterResponses[keyof UpdateAdapterResponses];

export type ConnectAdapterData = {
    /**
     * Connection data
     */
    body?: AdapterConnectionFields;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/adapters/connect';
};

export type ConnectAdapterErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
    /**
     * Failed due to processing error
     */
    501: CommonError;
};

export type ConnectAdapterError = ConnectAdapterErrors[keyof ConnectAdapterErrors];

export type ConnectAdapterResponses = {
    /**
     * Connection data
     */
    200: AdapterConnectionFields;
};

export type ConnectAdapterResponse = ConnectAdapterResponses[keyof ConnectAdapterResponses];

export type DisconnectAdapterData = {
    /**
     * Disconnect data
     */
    body?: DisconnectAdapterRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/adapters/disconnect';
};

export type DisconnectAdapterErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DisconnectAdapterError = DisconnectAdapterErrors[keyof DisconnectAdapterErrors];

export type DisconnectAdapterResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DisconnectAdapterResponse = DisconnectAdapterResponses[keyof DisconnectAdapterResponses];

export type GetAvailableVerificationMethodsControllerData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/age-verification/methods';
};

export type GetAvailableVerificationMethodsControllerErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetAvailableVerificationMethodsControllerError = GetAvailableVerificationMethodsControllerErrors[keyof GetAvailableVerificationMethodsControllerErrors];

export type GetAvailableVerificationMethodsControllerResponses = {
    /**
     * Return a list of verification methods
     */
    200: AvailableMethodsResponse;
};

export type GetAvailableVerificationMethodsControllerResponse = GetAvailableVerificationMethodsControllerResponses[keyof GetAvailableVerificationMethodsControllerResponses];

export type CheckIfHasHiddenVerificationControllerData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/age-verification/methods/has-hidden-verification';
};

export type CheckIfHasHiddenVerificationControllerErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CheckIfHasHiddenVerificationControllerError = CheckIfHasHiddenVerificationControllerErrors[keyof CheckIfHasHiddenVerificationControllerErrors];

export type CheckIfHasHiddenVerificationControllerResponses = {
    /**
     * Return has or not hidden-verification
     */
    200: HasHiddenVerificationResponse;
};

export type CheckIfHasHiddenVerificationControllerResponse = CheckIfHasHiddenVerificationControllerResponses[keyof CheckIfHasHiddenVerificationControllerResponses];

export type PerformAgeVerificationControllerData = {
    /**
     * Performs age verification for synchronous method and verify already initialized verification for asynchronous method
     */
    body?: PerformAgeVerificationRequest;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/age-verification/verify/init';
};

export type PerformAgeVerificationControllerErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type PerformAgeVerificationControllerError = PerformAgeVerificationControllerErrors[keyof PerformAgeVerificationControllerErrors];

export type PerformAgeVerificationControllerResponses = {
    /**
     * Single age verification response
     */
    200: AgeVerificationItemSchema;
};

export type PerformAgeVerificationControllerResponse = PerformAgeVerificationControllerResponses[keyof PerformAgeVerificationControllerResponses];

export type InitializeAsynchronousAgeVerificationControllerData = {
    /**
     * Initializes asynchronous age verification
     */
    body?: InitializeAsynchronousAgeVerificationRequest;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/age-verification/verify/init-async';
};

export type InitializeAsynchronousAgeVerificationControllerErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type InitializeAsynchronousAgeVerificationControllerError = InitializeAsynchronousAgeVerificationControllerErrors[keyof InitializeAsynchronousAgeVerificationControllerErrors];

export type InitializeAsynchronousAgeVerificationControllerResponses = {
    /**
     * Initialize asynchronous age verification response
     */
    200: InitializeAsynchronousAgeVerificationResponse;
};

export type InitializeAsynchronousAgeVerificationControllerResponse = InitializeAsynchronousAgeVerificationControllerResponses[keyof InitializeAsynchronousAgeVerificationControllerResponses];

export type GetAgeVerificationResultControllerData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path: {
        /**
         * Uuid of AgeVerificationItem
         */
        uuid: string;
        /**
         * Token value of AgeVerificationItem. Hash created from user email (SHA256).
         */
        token: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/age-verification/verify/verification-result/{uuid}/{token}';
};

export type GetAgeVerificationResultControllerErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetAgeVerificationResultControllerError = GetAgeVerificationResultControllerErrors[keyof GetAgeVerificationResultControllerErrors];

export type GetAgeVerificationResultControllerResponses = {
    /**
     * Single age verification response
     */
    200: AgeVerificationItemSchema;
};

export type GetAgeVerificationResultControllerResponse = GetAgeVerificationResultControllerResponses[keyof GetAgeVerificationResultControllerResponses];

export type GetAgeVerificationDateControllerData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path: {
        /**
         * Token value of AgeVerificationItem. Hash created from user email (SHA256).
         */
        token: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/age-verification/verify/{token}/date';
};

export type GetAgeVerificationDateControllerErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetAgeVerificationDateControllerError = GetAgeVerificationDateControllerErrors[keyof GetAgeVerificationDateControllerErrors];

export type GetAgeVerificationDateControllerResponses = {
    /**
     * Single age verification date response
     */
    200: AgeVerificationDateResponse;
};

export type GetAgeVerificationDateControllerResponse = GetAgeVerificationDateControllerResponses[keyof GetAgeVerificationDateControllerResponses];

export type UpdateConsumerUuidControllerData = {
    /**
     * Update consumer uuid data
     */
    body?: UpdateConsumerUuidRequest;
    headers?: {
        /**
         * Security scheme: WebhookSecurityScheme
         */
        'X-DES-SIGNATURE'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/age-verification/webhooks/update-consumer-uuid';
};

export type UpdateConsumerUuidControllerErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateConsumerUuidControllerError = UpdateConsumerUuidControllerErrors[keyof UpdateConsumerUuidControllerErrors];

export type UpdateConsumerUuidControllerResponses = {
    /**
     * Single age verification item hash response
     */
    200: AgeVerificationItemHashSchema;
};

export type UpdateConsumerUuidControllerResponse = UpdateConsumerUuidControllerResponses[keyof UpdateConsumerUuidControllerResponses];

export type GetUsersPublicDomainConfigurationData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/configuration';
};

export type GetUsersPublicDomainConfigurationErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type GetUsersPublicDomainConfigurationError = GetUsersPublicDomainConfigurationErrors[keyof GetUsersPublicDomainConfigurationErrors];

export type GetUsersPublicDomainConfigurationResponses = {
    /**
     * Users domain configuration response
     */
    200: UsersDomainConfiguration;
};

export type GetUsersPublicDomainConfigurationResponse = GetUsersPublicDomainConfigurationResponses[keyof GetUsersPublicDomainConfigurationResponses];

export type InitAuthenticationData = {
    /**
     * Authentication initialization request
     */
    body?: InitializeAuthentication;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: StaticTokenSecurityScheme
         */
        'X-DES-STATIC-TOKEN'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/authentication/initialize';
};

export type InitAuthenticationErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    429: CommonError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type InitAuthenticationError = InitAuthenticationErrors[keyof InitAuthenticationErrors];

export type InitAuthenticationResponses = {
    /**
     * Authentication initialization response
     */
    200: InitializeAuthenticationResponse;
};

export type InitAuthenticationResponse = InitAuthenticationResponses[keyof InitAuthenticationResponses];

export type LogoutData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/authentication/sessions';
};

export type LogoutErrors = {
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type LogoutError = LogoutErrors[keyof LogoutErrors];

export type LogoutResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type LogoutResponse = LogoutResponses[keyof LogoutResponses];

export type AuthenticateData = {
    /**
     * Authentication
     */
    body?: Authentication;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: StaticTokenSecurityScheme
         */
        'X-DES-STATIC-TOKEN'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/authentication/sessions';
};

export type AuthenticateErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type AuthenticateError = AuthenticateErrors[keyof AuthenticateErrors];

export type AuthenticateResponses = {
    /**
     * Authentication response
     */
    200: AuthenticationResponse;
};

export type AuthenticateResponse = AuthenticateResponses[keyof AuthenticateResponses];

export type ValidateSessionData = {
    /**
     * ValidateSession
     */
    body?: ValidateSession;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/authentication/sessions/validate';
};

export type ValidateSessionErrors = {
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type ValidateSessionError = ValidateSessionErrors[keyof ValidateSessionErrors];

export type ValidateSessionResponses = {
    /**
     * Authentication response
     */
    200: AuthenticationResponse;
    /**
     * Empty response
     */
    204: void;
};

export type ValidateSessionResponse = ValidateSessionResponses[keyof ValidateSessionResponses];

export type ForgotPasswordData = {
    /**
     * Forgot password
     */
    body?: ForgotPassword;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: StaticTokenSecurityScheme
         */
        'X-DES-STATIC-TOKEN'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/authentication/password/forget';
};

export type ForgotPasswordErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    424: CommonError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type ForgotPasswordError = ForgotPasswordErrors[keyof ForgotPasswordErrors];

export type ForgotPasswordResponses = {
    /**
     * Success message response
     */
    200: SuccessMessage;
};

export type ForgotPasswordResponse = ForgotPasswordResponses[keyof ForgotPasswordResponses];

export type ChangePasswordData = {
    /**
     * Change password
     */
    body?: ChangePassword;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/authentication/password/change';
};

export type ChangePasswordErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type ChangePasswordError = ChangePasswordErrors[keyof ChangePasswordErrors];

export type ChangePasswordResponses = {
    /**
     * Success message response
     */
    200: SuccessMessage;
};

export type ChangePasswordResponse = ChangePasswordResponses[keyof ChangePasswordResponses];

export type SetPasswordData = {
    /**
     * Set password
     */
    body?: SetPassword;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Forgot password token
         */
        token: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/authentication/password/change/{token}';
};

export type SetPasswordErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type SetPasswordError = SetPasswordErrors[keyof SetPasswordErrors];

export type SetPasswordResponses = {
    /**
     * Success message response
     */
    200: SuccessMessage;
};

export type SetPasswordResponse = SetPasswordResponses[keyof SetPasswordResponses];

export type CreateBulkOneTimeLimitedTokenRequestData = {
    /**
     * Create bulk one time limited tokens
     */
    body?: CreateBulkOneTimeLimitedToken;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/authentication/one-time-limited-token/bulk';
};

export type CreateBulkOneTimeLimitedTokenRequestErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type CreateBulkOneTimeLimitedTokenRequestError = CreateBulkOneTimeLimitedTokenRequestErrors[keyof CreateBulkOneTimeLimitedTokenRequestErrors];

export type CreateBulkOneTimeLimitedTokenRequestResponses = {
    /**
     * Bulk one time limited token response
     */
    200: BulkOneTimeLimitedTokenResponse;
};

export type CreateBulkOneTimeLimitedTokenRequestResponse = CreateBulkOneTimeLimitedTokenRequestResponses[keyof CreateBulkOneTimeLimitedTokenRequestResponses];

export type CreateOneTimeLimitedTokenRequestData = {
    /**
     * Create one time limited token
     */
    body?: CreateOneTimeLimitedToken;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/authentication/one-time-limited-token/{uuid}/user';
};

export type CreateOneTimeLimitedTokenRequestErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type CreateOneTimeLimitedTokenRequestError = CreateOneTimeLimitedTokenRequestErrors[keyof CreateOneTimeLimitedTokenRequestErrors];

export type CreateOneTimeLimitedTokenRequestResponses = {
    /**
     * One time limited token response
     */
    200: OneTimeLimitedTokenResponse;
};

export type CreateOneTimeLimitedTokenRequestResponse = CreateOneTimeLimitedTokenRequestResponses[keyof CreateOneTimeLimitedTokenRequestResponses];

export type DeleteOneTimeLimitedTokenRequestData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * One time limited token
         */
        token: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/authentication/one-time-limited-token/{token}/token';
};

export type DeleteOneTimeLimitedTokenRequestErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type DeleteOneTimeLimitedTokenRequestError = DeleteOneTimeLimitedTokenRequestErrors[keyof DeleteOneTimeLimitedTokenRequestErrors];

export type DeleteOneTimeLimitedTokenRequestResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeleteOneTimeLimitedTokenRequestResponse = DeleteOneTimeLimitedTokenRequestResponses[keyof DeleteOneTimeLimitedTokenRequestResponses];

export type CreateConsumerOneTimeLimitedTokenData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/authentication/one-time-limited-token';
};

export type CreateConsumerOneTimeLimitedTokenErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
};

export type CreateConsumerOneTimeLimitedTokenError = CreateConsumerOneTimeLimitedTokenErrors[keyof CreateConsumerOneTimeLimitedTokenErrors];

export type CreateConsumerOneTimeLimitedTokenResponses = {
    /**
     * One time limited token response
     */
    200: ConsumerOneTimeLimitedTokenResponse;
};

export type CreateConsumerOneTimeLimitedTokenResponse = CreateConsumerOneTimeLimitedTokenResponses[keyof CreateConsumerOneTimeLimitedTokenResponses];

export type VerifyReferralCodeData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Referral code to verify. When the tenant has the phone-alias feature enabled, the referrer's phone number (E.164 with a URL-encoded '+', '00'-prefixed, or local format) is also accepted and resolved to their referral code.
         */
        code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/referrals/{code}/verify';
};

export type VerifyReferralCodeErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type VerifyReferralCodeError = VerifyReferralCodeErrors[keyof VerifyReferralCodeErrors];

export type VerifyReferralCodeResponses = {
    /**
     * Empty response
     */
    200: unknown;
};

export type InitRegistrationData = {
    /**
     * Registration initialization request
     */
    body?: InitializeRegistration;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/initialize-registration';
};

export type InitRegistrationErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type InitRegistrationError = InitRegistrationErrors[keyof InitRegistrationErrors];

export type InitRegistrationResponses = {
    /**
     * Registration initialization response
     */
    201: InitializeRegistrationResponse;
};

export type InitRegistrationResponse = InitRegistrationResponses[keyof InitRegistrationResponses];

export type RegisterData = {
    /**
     * Registration
     */
    body?: Registration;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/register';
};

export type RegisterErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    424: CommonError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type RegisterError = RegisterErrors[keyof RegisterErrors];

export type RegisterResponses = {
    /**
     * Registration response
     */
    201: RegistrationSchema;
};

export type RegisterResponse = RegisterResponses[keyof RegisterResponses];

export type SynchronizeAddressesData = {
    /**
     * Consumer address
     */
    body?: Address;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Consumer identifier (uuid or email)
         */
        identifier: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{identifier}/addresses/sync';
};

export type SynchronizeAddressesErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type SynchronizeAddressesError = SynchronizeAddressesErrors[keyof SynchronizeAddressesErrors];

export type SynchronizeAddressesResponses = {
    /**
     * Consumer response
     */
    200: Consumer;
};

export type SynchronizeAddressesResponse = SynchronizeAddressesResponses[keyof SynchronizeAddressesResponses];

export type StoreAddressData = {
    /**
     * Consumer address
     */
    body?: AddressBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/addresses';
};

export type StoreAddressErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    424: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type StoreAddressError = StoreAddressErrors[keyof StoreAddressErrors];

export type StoreAddressResponses = {
    /**
     * Consumer response
     */
    200: Consumer;
};

export type StoreAddressResponse = StoreAddressResponses[keyof StoreAddressResponses];

export type DeleteAddressData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
        /**
         * Address id
         */
        addressId: number;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/addresses/{addressId}';
};

export type DeleteAddressErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type DeleteAddressError = DeleteAddressErrors[keyof DeleteAddressErrors];

export type DeleteAddressResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeleteAddressResponse = DeleteAddressResponses[keyof DeleteAddressResponses];

export type UpdateAddressData = {
    /**
     * Consumer address
     */
    body?: AddressBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
        /**
         * Address id
         */
        addressId: number;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/addresses/{addressId}';
};

export type UpdateAddressErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type UpdateAddressError = UpdateAddressErrors[keyof UpdateAddressErrors];

export type UpdateAddressResponses = {
    /**
     * Consumer response
     */
    200: Consumer;
};

export type UpdateAddressResponse = UpdateAddressResponses[keyof UpdateAddressResponses];

export type SetDefaultAddressData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
        /**
         * Address id
         */
        addressId: number;
        /**
         * Address type
         */
        addressType: 'billing' | 'shipping';
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/addresses/{addressType}/{addressId}';
};

export type SetDefaultAddressErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type SetDefaultAddressError = SetDefaultAddressErrors[keyof SetDefaultAddressErrors];

export type SetDefaultAddressResponses = {
    /**
     * Consumer response
     */
    200: Consumer;
};

export type SetDefaultAddressResponse = SetDefaultAddressResponses[keyof SetDefaultAddressResponses];

export type UpdateEmailRequestData = {
    /**
     * Update email request
     */
    body?: UpdateEmailRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/profile/email/request-update';
};

export type UpdateEmailRequestErrors = {
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type UpdateEmailRequestError = UpdateEmailRequestErrors[keyof UpdateEmailRequestErrors];

export type UpdateEmailRequestResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type UpdateEmailRequestResponse = UpdateEmailRequestResponses[keyof UpdateEmailRequestResponses];

export type ChangePhoneData = {
    /**
     * Change consumer phone
     */
    body?: ChangePhoneRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/profile/phone';
};

export type ChangePhoneErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type ChangePhoneError = ChangePhoneErrors[keyof ChangePhoneErrors];

export type ChangePhoneResponses = {
    /**
     * Consumer response
     */
    200: Consumer;
};

export type ChangePhoneResponse = ChangePhoneResponses[keyof ChangePhoneResponses];

export type ValidateAddressData = {
    /**
     * Consumer address
     */
    body?: AddressBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/addresses/validate';
};

export type ValidateAddressErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type ValidateAddressError = ValidateAddressErrors[keyof ValidateAddressErrors];

export type ValidateAddressResponses = {
    /**
     * Response for address validation
     */
    200: ValidateAddressResponse;
};

export type ValidateAddressResponse2 = ValidateAddressResponses[keyof ValidateAddressResponses];

export type VerifyAgeData = {
    body?: VerifyAgeBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/av';
};

export type VerifyAgeErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type VerifyAgeError = VerifyAgeErrors[keyof VerifyAgeErrors];

export type VerifyAgeResponses = {
    /**
     * Verify consumer age response
     */
    200: VerifyAgeResponse;
};

export type VerifyAgeResponse2 = VerifyAgeResponses[keyof VerifyAgeResponses];

export type RequestPromoCodeData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/coupons';
};

export type RequestPromoCodeErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Too many attempts
     */
    429: TooManyAttemptsError;
};

export type RequestPromoCodeError = RequestPromoCodeErrors[keyof RequestPromoCodeErrors];

export type RequestPromoCodeResponses = {
    /**
     * Empty response
     */
    200: unknown;
};

export type GetComplaintsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/complaints';
};

export type GetComplaintsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type GetComplaintsError = GetComplaintsErrors[keyof GetComplaintsErrors];

export type GetComplaintsResponses = {
    /**
     * Whether the user has any special complaints
     */
    200: GetComplaints;
};

export type GetComplaintsResponse = GetComplaintsResponses[keyof GetComplaintsResponses];

export type GetSessionsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/sessions';
};

export type GetSessionsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
};

export type GetSessionsError = GetSessionsErrors[keyof GetSessionsErrors];

export type GetSessionsResponses = {
    /**
     * List all active personal access tokens for the user
     */
    200: UserSessionsResponse;
};

export type GetSessionsResponse = GetSessionsResponses[keyof GetSessionsResponses];

export type GetProfileData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/profile';
};

export type GetProfileErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type GetProfileError = GetProfileErrors[keyof GetProfileErrors];

export type GetProfileResponses = {
    /**
     * Consumer profile response
     */
    200: ConsumerProfileSchema;
};

export type GetProfileResponse = GetProfileResponses[keyof GetProfileResponses];

export type UpdateProfileData = {
    /**
     * Update profile request
     */
    body?: UpdateProfileRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/profile';
};

export type UpdateProfileErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type UpdateProfileError = UpdateProfileErrors[keyof UpdateProfileErrors];

export type UpdateProfileResponses = {
    /**
     * Consumer profile response
     */
    200: ConsumerProfileSchema;
};

export type UpdateProfileResponse = UpdateProfileResponses[keyof UpdateProfileResponses];

export type GenerateWalletPassData = {
    /**
     * Generate Wallet Pass
     */
    body?: GenerateWalletPass;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/profile/wallet';
};

export type GenerateWalletPassErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type GenerateWalletPassError = GenerateWalletPassErrors[keyof GenerateWalletPassErrors];

export type GenerateWalletPassResponses = {
    /**
     * Generated wallet pass data
     */
    201: GeneratedWalletPass;
};

export type GenerateWalletPassResponse = GenerateWalletPassResponses[keyof GenerateWalletPassResponses];

export type AnonymizeConsumerData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/cancel';
};

export type AnonymizeConsumerErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type AnonymizeConsumerError = AnonymizeConsumerErrors[keyof AnonymizeConsumerErrors];

export type AnonymizeConsumerResponses = {
    /**
     * Consumer response
     */
    200: Consumer;
};

export type AnonymizeConsumerResponse = AnonymizeConsumerResponses[keyof AnonymizeConsumerResponses];

export type DeleteProfileData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users';
};

export type DeleteProfileErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type DeleteProfileError = DeleteProfileErrors[keyof DeleteProfileErrors];

export type DeleteProfileResponses = {
    /**
     * Anonymized profile response
     */
    200: AnonymizedProfileSchema;
};

export type DeleteProfileResponse = DeleteProfileResponses[keyof DeleteProfileResponses];

export type ConsumersReportData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters using the standardized query processing system
         */
        filter?: {
            /**
             * Filter by consumer identifier fields using OR logic
             */
            anyIdentifier?: {
                /**
                 * UUID filter operators
                 */
                uuid?: {
                    /**
                     * Exact match
                     */
                    eq?: string;
                    /**
                     * Pattern match
                     */
                    like?: string;
                    /**
                     * Not equal
                     */
                    neq?: string;
                };
                /**
                 * Email filter operators
                 */
                email?: {
                    /**
                     * Exact match
                     */
                    eq?: string;
                    /**
                     * Pattern match
                     */
                    like?: string;
                    /**
                     * Not equal
                     */
                    neq?: string;
                };
                /**
                 * Phone filter operators
                 */
                phone?: {
                    /**
                     * Exact match
                     */
                    eq?: string;
                    /**
                     * Pattern match
                     */
                    like?: string;
                    /**
                     * Not equal
                     */
                    neq?: string;
                };
                /**
                 * First name filter operators
                 */
                first_name?: {
                    /**
                     * Exact match
                     */
                    eq?: string;
                    /**
                     * Pattern match
                     */
                    like?: string;
                    /**
                     * Not equal
                     */
                    neq?: string;
                };
                /**
                 * Last name filter operators
                 */
                last_name?: {
                    /**
                     * Exact match
                     */
                    eq?: string;
                    /**
                     * Pattern match
                     */
                    like?: string;
                    /**
                     * Not equal
                     */
                    neq?: string;
                };
                /**
                 * Referral code filter operators (supports 7-char uppercase and legacy 10-char codes)
                 */
                referral_code?: {
                    /**
                     * Exact match
                     */
                    eq?: string;
                    /**
                     * Pattern match
                     */
                    like?: string;
                    /**
                     * Not equal
                     */
                    neq?: string;
                };
            };
            created_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            updated_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            deactivated_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            anonymized_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
        };
        /**
         * Comma-separated list of fields to sort by. Prefix with "-" for descending order (e.g., "code,-created_at"). Multiple fields are supported.
         */
        sort?: string;
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * DEPRECATED: Filter by consumers matching provided uuid. Use filter[anyIdentifier][uuid][eq] instead.
         *
         * @deprecated
         */
        'filters[anyIdentifier][uuid]'?: string | null;
        /**
         * DEPRECATED: Filter by consumers matching provided email. Use filter[anyIdentifier][email][eq] instead.
         *
         * @deprecated
         */
        'filters[anyIdentifier][email]'?: string | null;
        /**
         * DEPRECATED: Filter by consumers matching provided phone. Use filter[anyIdentifier][phone][eq] instead.
         *
         * @deprecated
         */
        'filters[anyIdentifier][phone]'?: string | null;
        /**
         * DEPRECATED: Filter by consumers matching provided referral code. Use filter[anyIdentifier][referral_code][eq] instead.
         *
         * @deprecated
         */
        'filters[anyIdentifier][referral_code]'?: string | null;
        /**
         * DEPRECATED: Filter by consumers matching provided first name. Use filter[anyIdentifier][first_name][eq] instead.
         *
         * @deprecated
         */
        'filters[anyIdentifier][first_name]'?: string | null;
        /**
         * DEPRECATED: Filter by consumers matching provided last name. Use filter[anyIdentifier][last_name][eq] instead.
         *
         * @deprecated
         */
        'filters[anyIdentifier][last_name]'?: string | null;
        /**
         * DEPRECATED: Filter by consumers created after this date. Use filter[created_at][gte] instead.
         *
         * @deprecated
         */
        'filters[from]'?: string | null;
        /**
         * DEPRECATED: Filter by consumers created before this date. Use filter[created_at][lte] instead.
         *
         * @deprecated
         */
        'filters[to]'?: string | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users';
};

export type ConsumersReportErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ConsumersReportError = ConsumersReportErrors[keyof ConsumersReportErrors];

export type ConsumersReportResponses = {
    /**
     * List of consumers for report with pagination meta fields.
     */
    200: ConsumersReportResponse;
};

export type ConsumersReportResponse2 = ConsumersReportResponses[keyof ConsumersReportResponses];

export type VerifyPhoneOrEmailData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * The phone or email to verify.
         */
        phone_or_email: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/verify/{phone_or_email}';
};

export type VerifyPhoneOrEmailErrors = {
    /**
     * Empty response
     */
    404: unknown;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type VerifyPhoneOrEmailError = VerifyPhoneOrEmailErrors[keyof VerifyPhoneOrEmailErrors];

export type VerifyPhoneOrEmailResponses = {
    /**
     * Empty response
     */
    200: unknown;
};

export type ChangeConsumerEmailData = {
    /**
     * Verify update email
     */
    body?: ChangeEmailRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/profile/email';
};

export type ChangeConsumerEmailErrors = {
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type ChangeConsumerEmailError = ChangeConsumerEmailErrors[keyof ChangeConsumerEmailErrors];

export type ChangeConsumerEmailResponses = {
    /**
     * Consumer response
     */
    200: Consumer;
};

export type ChangeConsumerEmailResponse = ChangeConsumerEmailResponses[keyof ChangeConsumerEmailResponses];

export type DataSubjectAccessRequestData = {
    body?: ProcessDataSubjectAccessRequestRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/privacy';
};

export type DataSubjectAccessRequestErrors = {
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type DataSubjectAccessRequestError = DataSubjectAccessRequestErrors[keyof DataSubjectAccessRequestErrors];

export type DataSubjectAccessRequestResponses = {
    /**
     * Consumer response
     */
    201: ProcessDataSubjectAccessRequestResponse;
};

export type DataSubjectAccessRequestResponse = DataSubjectAccessRequestResponses[keyof DataSubjectAccessRequestResponses];

export type UpdateCustomAttributesData = {
    /**
     * Update consumer custom attributes
     */
    body?: UpdateCustomAttributes;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/custom-attributes';
};

export type UpdateCustomAttributesErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type UpdateCustomAttributesError = UpdateCustomAttributesErrors[keyof UpdateCustomAttributesErrors];

export type UpdateCustomAttributesResponses = {
    /**
     * Consumer response
     */
    200: Consumer;
};

export type UpdateCustomAttributesResponse = UpdateCustomAttributesResponses[keyof UpdateCustomAttributesResponses];

export type DeleteCustomAttributeData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
        /**
         * Custom attribute slug
         */
        customAttribute: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/custom-attributes/{customAttribute}';
};

export type DeleteCustomAttributeErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type DeleteCustomAttributeError = DeleteCustomAttributeErrors[keyof DeleteCustomAttributeErrors];

export type DeleteCustomAttributeResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeleteCustomAttributeResponse = DeleteCustomAttributeResponses[keyof DeleteCustomAttributeResponses];

export type UpdateCustomAttributeData = {
    /**
     * Update consumer custom attribute
     */
    body?: UpdateCustomAttribute;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
        /**
         * Custom attribute slug
         */
        customAttribute: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/custom-attributes/{customAttribute}';
};

export type UpdateCustomAttributeErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type UpdateCustomAttributeError = UpdateCustomAttributeErrors[keyof UpdateCustomAttributeErrors];

export type UpdateCustomAttributeResponses = {
    /**
     * Consumer response
     */
    200: Consumer;
};

export type UpdateCustomAttributeResponse = UpdateCustomAttributeResponses[keyof UpdateCustomAttributeResponses];

export type GetUsersConsentsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query: {
        /**
         * The context for which to return the purposes (formerly step/category).
         */
        context: string;
        /**
         * The language in which the purpose should be returned. (If available.)
         */
        language?: string;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/consents';
};

export type GetUsersConsentsErrors = {
    /**
     * Failed due to processing error
     */
    401: CommonError;
    /**
     * Failed due to processing error
     */
    403: CommonError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type GetUsersConsentsError = GetUsersConsentsErrors[keyof GetUsersConsentsErrors];

export type GetUsersConsentsResponses = {
    /**
     * Users' consents
     */
    200: GetUsersConsentsResponse;
};

export type GetUsersConsentsResponse2 = GetUsersConsentsResponses[keyof GetUsersConsentsResponses];

export type DeprecatedUpdateConsentsData = {
    /**
     * Update consents
     */
    body?: DeprecatedUpdateConsents;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/consents';
};

export type DeprecatedUpdateConsentsErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type DeprecatedUpdateConsentsError = DeprecatedUpdateConsentsErrors[keyof DeprecatedUpdateConsentsErrors];

export type DeprecatedUpdateConsentsResponses = {
    /**
     * Consumer response
     */
    200: Consumer;
};

export type DeprecatedUpdateConsentsResponse = DeprecatedUpdateConsentsResponses[keyof DeprecatedUpdateConsentsResponses];

export type AssignReferrerData = {
    /**
     * Assign referrer code
     */
    body?: AssignReferrerRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/profile/referrer-code';
};

export type AssignReferrerErrors = {
    /**
     * Failed due to processing error
     */
    403: CommonError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type AssignReferrerError = AssignReferrerErrors[keyof AssignReferrerErrors];

export type AssignReferrerResponses = {
    /**
     * Consumer response
     */
    200: Consumer;
};

export type AssignReferrerResponse = AssignReferrerResponses[keyof AssignReferrerResponses];

export type StreamedWalletPassData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
        /**
         * Wallet provider
         */
        walletProvider: 'apple' | 'google';
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/wallets/{walletProvider}/stream';
};

export type StreamedWalletPassErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Wallet provider is not streamable
     */
    422: WalletProviderIsNotStreamable;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed to generate pass
     */
    500: FailedToGeneratePass;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type StreamedWalletPassError = StreamedWalletPassErrors[keyof StreamedWalletPassErrors];

export type StreamedWalletPassResponses = {
    /**
     * Streamed wallet pass data
     */
    200: StreamedWalletPass;
};

export type StreamedWalletPassResponse = StreamedWalletPassResponses[keyof StreamedWalletPassResponses];

export type ProcessAnonymizedCdpProfilesData = {
    body?: ProcessAnonymizedCdpProfilesRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/cancel';
};

export type ProcessAnonymizedCdpProfilesErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
};

export type ProcessAnonymizedCdpProfilesError = ProcessAnonymizedCdpProfilesErrors[keyof ProcessAnonymizedCdpProfilesErrors];

export type ProcessAnonymizedCdpProfilesResponses = {
    /**
     * Process anonymized CDP profiles response
     */
    200: ProcessAnonymizedCdpProfilesResponse;
};

export type ProcessAnonymizedCdpProfilesResponse2 = ProcessAnonymizedCdpProfilesResponses[keyof ProcessAnonymizedCdpProfilesResponses];

export type ReferralsRegisterOfflineActionData = {
    /**
     * Process offline action for has_first_referrer_purchase customer flag
     */
    body?: RegisterOfflineActionRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/referrals/register-offline-action';
};

export type ReferralsRegisterOfflineActionErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type ReferralsRegisterOfflineActionError = ReferralsRegisterOfflineActionErrors[keyof ReferralsRegisterOfflineActionErrors];

export type ReferralsRegisterOfflineActionResponses = {
    /**
     * Empty response
     */
    200: unknown;
};

export type GetAvailableConsentsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path?: never;
    query: {
        /**
         * The context for which to return the purposes (formerly step/category).
         */
        context: string;
        /**
         * The language in which the purpose should be returned. (If available.)
         */
        language?: string;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/consents';
};

export type GetAvailableConsentsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetAvailableConsentsError = GetAvailableConsentsErrors[keyof GetAvailableConsentsErrors];

export type GetAvailableConsentsResponses = {
    /**
     * Available Consents
     */
    200: GetAvailableConsentsResponse;
};

export type GetAvailableConsentsResponse2 = GetAvailableConsentsResponses[keyof GetAvailableConsentsResponses];

export type DeactivateConsumerData = {
    body?: DeactivateConsumerRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/deactivate';
};

export type DeactivateConsumerErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type DeactivateConsumerError = DeactivateConsumerErrors[keyof DeactivateConsumerErrors];

export type DeactivateConsumerResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeactivateConsumerResponse = DeactivateConsumerResponses[keyof DeactivateConsumerResponses];

export type UpdateFullProfileData = {
    /**
     * Update full profile request
     */
    body?: UpdateFullProfileRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/full-profile';
};

export type UpdateFullProfileErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type UpdateFullProfileError = UpdateFullProfileErrors[keyof UpdateFullProfileErrors];

export type UpdateFullProfileResponses = {
    /**
     * Consumer profile response
     */
    200: ConsumerProfileSchema;
};

export type UpdateFullProfileResponse = UpdateFullProfileResponses[keyof UpdateFullProfileResponses];

export type DeprecatedUpdateFullProfileData = {
    /**
     * Update full profile request
     */
    body?: UpdateFullProfileRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/full-profile';
};

export type DeprecatedUpdateFullProfileErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type DeprecatedUpdateFullProfileError = DeprecatedUpdateFullProfileErrors[keyof DeprecatedUpdateFullProfileErrors];

export type DeprecatedUpdateFullProfileResponses = {
    /**
     * Consumer profile response
     */
    200: ConsumerProfileSchema;
};

export type DeprecatedUpdateFullProfileResponse = DeprecatedUpdateFullProfileResponses[keyof DeprecatedUpdateFullProfileResponses];

export type AnonymizeConsumersData = {
    /**
     * Request body for anonymizing consumers
     */
    body?: AnonymizeConsumersRequest;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/consumers/anonymize';
};

export type AnonymizeConsumersErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type AnonymizeConsumersError = AnonymizeConsumersErrors[keyof AnonymizeConsumersErrors];

export type AnonymizeConsumersResponses = {
    /**
     * Consumers anonymized successfully
     */
    202: AnonymizeConsumersResponse;
};

export type AnonymizeConsumersResponse2 = AnonymizeConsumersResponses[keyof AnonymizeConsumersResponses];

export type AnonymizeConsumerManuallyData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/anonymize';
};

export type AnonymizeConsumerManuallyErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type AnonymizeConsumerManuallyError = AnonymizeConsumerManuallyErrors[keyof AnonymizeConsumerManuallyErrors];

export type AnonymizeConsumerManuallyResponses = {
    /**
     * Consumer response
     */
    200: Consumer;
};

export type AnonymizeConsumerManuallyResponse = AnonymizeConsumerManuallyResponses[keyof AnonymizeConsumerManuallyResponses];

export type UnlockConsumerLoginData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/unlock';
};

export type UnlockConsumerLoginErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
};

export type UnlockConsumerLoginError = UnlockConsumerLoginErrors[keyof UnlockConsumerLoginErrors];

export type UnlockConsumerLoginResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type UnlockConsumerLoginResponse = UnlockConsumerLoginResponses[keyof UnlockConsumerLoginResponses];

export type ListConsumerDeactivationsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters using the standardized query processing system
         */
        filter?: {
            consumer_uuid?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * In filter
                 */
                in?: string;
            };
            deactivated_until?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            created_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            reason?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            type?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            status?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
        };
        /**
         * Comma-separated list of fields to sort by. Prefix with "-" for descending order (e.g., "code,-created_at"). Multiple fields are supported.
         */
        sort?: string;
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/s2s/users/deactivations';
};

export type ListConsumerDeactivationsErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type ListConsumerDeactivationsError = ListConsumerDeactivationsErrors[keyof ListConsumerDeactivationsErrors];

export type ListConsumerDeactivationsResponses = {
    /**
     * Paginated list of consumer deactivations (permanent and temporary, active and expired).
     */
    200: ListConsumerDeactivationsResponse;
};

export type ListConsumerDeactivationsResponse2 = ListConsumerDeactivationsResponses[keyof ListConsumerDeactivationsResponses];

export type GetProfileForServiceData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/s2s/users/{uuid}';
};

export type GetProfileForServiceErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type GetProfileForServiceError = GetProfileForServiceErrors[keyof GetProfileForServiceErrors];

export type GetProfileForServiceResponses = {
    /**
     * Consumer profile response
     */
    200: ConsumerProfileSchema;
};

export type GetProfileForServiceResponse = GetProfileForServiceResponses[keyof GetProfileForServiceResponses];

export type ActivateConsumerData = {
    body?: ActivateConsumerRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/activate';
};

export type ActivateConsumerErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type ActivateConsumerError = ActivateConsumerErrors[keyof ActivateConsumerErrors];

export type ActivateConsumerResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type ActivateConsumerResponse = ActivateConsumerResponses[keyof ActivateConsumerResponses];

export type MarkConsumersAsExternalAgeVerifiedData = {
    /**
     * Request body for marking consumers as external age-verified
     */
    body?: MarkConsumersAsExternalAgeVerifiedRequest;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/mark-external-age-verified';
};

export type MarkConsumersAsExternalAgeVerifiedErrors = {
    /**
     * Forbidden
     */
    403: ErrorForbidden;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type MarkConsumersAsExternalAgeVerifiedError = MarkConsumersAsExternalAgeVerifiedErrors[keyof MarkConsumersAsExternalAgeVerifiedErrors];

export type MarkConsumersAsExternalAgeVerifiedResponses = {
    /**
     * Result of marking consumers as external age-verified
     */
    200: MarkConsumersAsExternalAgeVerifiedResponse;
};

export type MarkConsumersAsExternalAgeVerifiedResponse2 = MarkConsumersAsExternalAgeVerifiedResponses[keyof MarkConsumersAsExternalAgeVerifiedResponses];

export type ProcessKakaoUnlinkRequestData = {
    /**
     * Unlink Kakao account
     */
    body?: KakaoUnlinkCallback;
    headers?: {
        /**
         * This security scheme is used to verify the IP addresses of Kakao servers.
         * https://developers.kakao.com/docs/latest/en/reference/utility#get-ip (IP address based)
         */
        Authorization?: string | null;
    };
    path?: never;
    query?: never;
    url: '/webhooks/users/authentication/kakao/callback';
};

export type ProcessKakaoUnlinkRequestErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type ProcessKakaoUnlinkRequestError = ProcessKakaoUnlinkRequestErrors[keyof ProcessKakaoUnlinkRequestErrors];

export type ProcessKakaoUnlinkRequestResponses = {
    /**
     * Empty response
     */
    200: unknown;
};

export type GenerateBulkCouponsData = {
    body?: BulkGenerateCouponRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/coupons/bulk/generate';
};

export type GenerateBulkCouponsErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GenerateBulkCouponsError = GenerateBulkCouponsErrors[keyof GenerateBulkCouponsErrors];

export type GenerateBulkCouponsResponses = {
    /**
     * Coupon batch response
     */
    201: CouponBatchResponse;
};

export type GenerateBulkCouponsResponse = GenerateBulkCouponsResponses[keyof GenerateBulkCouponsResponses];

export type GetBulkCouponBatchData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path: {
        /**
         * Coupon batch ID obtained in response of bulk generate endpoint
         */
        batch_id: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/coupons/bulk/generate/{batch_id}';
};

export type GetBulkCouponBatchErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetBulkCouponBatchError = GetBulkCouponBatchErrors[keyof GetBulkCouponBatchErrors];

export type GetBulkCouponBatchResponses = {
    /**
     * Collection of generated coupons
     */
    200: CouponsResponse;
};

export type GetBulkCouponBatchResponse = GetBulkCouponBatchResponses[keyof GetBulkCouponBatchResponses];

export type GetBulkCouponBatchStatusData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path: {
        /**
         * Coupon batch ID obtained in response of bulk generate endpoint
         */
        batch_id: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/coupons/bulk/generate/{batch_id}/status';
};

export type GetBulkCouponBatchStatusErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetBulkCouponBatchStatusError = GetBulkCouponBatchStatusErrors[keyof GetBulkCouponBatchStatusErrors];

export type GetBulkCouponBatchStatusResponses = {
    /**
     * Coupon batch status info
     */
    200: CouponBatchStatusResponse;
};

export type GetBulkCouponBatchStatusResponse = GetBulkCouponBatchStatusResponses[keyof GetBulkCouponBatchStatusResponses];

export type GetExternalProvidersData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path: {
        country: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/coupons/external/providers/{country}';
};

export type GetExternalProvidersErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetExternalProvidersError = GetExternalProvidersErrors[keyof GetExternalProvidersErrors];

export type GetExternalProvidersResponses = {
    /**
     * Return a list of external coupon providers
     */
    200: ExternalProvidersResponse;
};

export type GetExternalProvidersResponse = GetExternalProvidersResponses[keyof GetExternalProvidersResponses];

export type GenerateSingleCouponData = {
    body?: GenerateSingleCouponRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/coupons/generate';
};

export type GenerateSingleCouponErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GenerateSingleCouponError = GenerateSingleCouponErrors[keyof GenerateSingleCouponErrors];

export type GenerateSingleCouponResponses = {
    /**
     * Collection of generated coupons
     */
    201: CouponsResponse;
};

export type GenerateSingleCouponResponse = GenerateSingleCouponResponses[keyof GenerateSingleCouponResponses];

export type ListCouponUsersData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Coupon code
         */
        code: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/coupons/{code}/users';
};

export type ListCouponUsersErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListCouponUsersError = ListCouponUsersErrors[keyof ListCouponUsersErrors];

export type ListCouponUsersResponses = {
    /**
     * List of users assigned for the coupon
     */
    200: CouponUsersResponse;
};

export type ListCouponUsersResponse = ListCouponUsersResponses[keyof ListCouponUsersResponses];

export type CreateCouponGenerationWebhookData = {
    body?: CouponGenerationWebhookRequest;
    headers?: {
        /**
         * Security scheme: WebhookSecurityScheme
         */
        'X-DES-SIGNATURE'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/api/coupons/global-webhooks/generate';
};

export type CreateCouponGenerationWebhookErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreateCouponGenerationWebhookError = CreateCouponGenerationWebhookErrors[keyof CreateCouponGenerationWebhookErrors];

export type CreateCouponGenerationWebhookResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type CreateCouponGenerationWebhookResponse = CreateCouponGenerationWebhookResponses[keyof CreateCouponGenerationWebhookResponses];

export type RequestExternalCouponData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * The code of one of the configured external coupon providers.
         */
        provider: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/coupons/external/providers/{provider}/request';
};

export type RequestExternalCouponErrors = {
    /**
     * Empty response
     */
    404: unknown;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    424: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type RequestExternalCouponError = RequestExternalCouponErrors[keyof RequestExternalCouponErrors];

export type RequestExternalCouponResponses = {
    /**
     * Empty response
     */
    201: unknown;
};

export type ServiceRequestExternalCouponData = {
    body?: ServiceRequestExternalCouponRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * The code of one of the configured external coupon providers.
         */
        provider: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/services/coupons/external/providers/{provider}/request';
};

export type ServiceRequestExternalCouponErrors = {
    /**
     * Empty response
     */
    400: unknown;
    /**
     * Empty response
     */
    404: unknown;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    424: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ServiceRequestExternalCouponError = ServiceRequestExternalCouponErrors[keyof ServiceRequestExternalCouponErrors];

export type ServiceRequestExternalCouponResponses = {
    /**
     * Return requested coupons
     */
    200: ServiceExternalProvidersResponse;
};

export type ServiceRequestExternalCouponResponse = ServiceRequestExternalCouponResponses[keyof ServiceRequestExternalCouponResponses];

export type CreateYggWebhookData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/services/coupons/external/providers/ygg/webhook';
};

export type CreateYggWebhookErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    404: CommonError;
    /**
     * Failed due to processing error
     */
    424: CommonError;
};

export type CreateYggWebhookError = CreateYggWebhookErrors[keyof CreateYggWebhookErrors];

export type CreateYggWebhookResponses = {
    /**
     * YGG webhook registered and activated.
     */
    201: CreateYggWebhookResponse;
};

export type CreateYggWebhookResponse2 = CreateYggWebhookResponses[keyof CreateYggWebhookResponses];

export type SyncExternalRewardsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/services/coupons/external/providers/ygg/sync-rewards';
};

export type SyncExternalRewardsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Too many attempts
     */
    429: TooManyAttemptsError;
};

export type SyncExternalRewardsError = SyncExternalRewardsErrors[keyof SyncExternalRewardsErrors];

export type SyncExternalRewardsResponses = {
    /**
     * Empty response
     */
    202: unknown;
};

export type ExternalProviderRewardUpdatedData = {
    body?: ExternalProviderRewardUpdatedRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * HMAC-SHA256 signature of the request body, prefixed with "sha256=". Key configured in "coupons.external_providers.*.options.webhook_private_key".
         */
        'YGAG-Webhook-Signature'?: string | null;
    };
    path: {
        /**
         * The external loyalty provider sending the reward-updated webhook.
         */
        provider: 'physical_prize' | 'delayed_lottery_physical_prize' | 'instant_lottery_physical_prize' | 'amilon' | 'ygg';
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/webhooks/external-providers/{provider}/reward-updated';
};

export type ExternalProviderRewardUpdatedErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    424: CommonError;
};

export type ExternalProviderRewardUpdatedError = ExternalProviderRewardUpdatedErrors[keyof ExternalProviderRewardUpdatedErrors];

export type ExternalProviderRewardUpdatedResponses = {
    /**
     * Empty response
     */
    200: unknown;
};

export type ListActivityLogsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            log_name?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * In filter
                 */
                in?: string;
            };
            subject_type?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * In filter
                 */
                in?: string;
            };
            subject_id?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * In filter
                 */
                in?: string;
            };
            causer_email?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            tenant_code?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * In filter
                 */
                in?: string;
            };
            created_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
        };
        /**
         * Include relations
         */
        include?: string;
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * DEPRECATED: Filter by log name. Use filter[log_name][eq] instead.
         *
         * @deprecated
         */
        'filter[log_name]'?: string | null;
        /**
         * DEPRECATED: Filter by subject model class. Use filter[subject_type][eq] instead.
         *
         * @deprecated
         */
        'filter[subject_type]'?: string | null;
        /**
         * DEPRECATED: Filter by subject primary key. Use filter[subject_id][eq] instead.
         *
         * @deprecated
         */
        'filter[subject_id]'?: number | null;
        /**
         * DEPRECATED: Filter by causer email address. Use filter[causer_email][eq] instead.
         *
         * @deprecated
         */
        'filter[causer_email]'?: string | null;
        /**
         * DEPRECATED: Filter by related tenant code. Use filter[tenant_code][eq] instead.
         *
         * @deprecated
         */
        'filter[tenant_code]'?: string | null;
        /**
         * DEPRECATED: Filter by activity logs created before date. Use filter[created_at][lte] instead.
         *
         * @deprecated
         */
        'filter[created_before]'?: string | null;
        /**
         * DEPRECATED: Filter by activity logs created after date. Use filter[created_at][gte] instead.
         *
         * @deprecated
         */
        'filter[created_after]'?: string | null;
        /**
         * DEPRECATED: Page number. Use page instead.
         *
         * @deprecated
         */
        'page[number]'?: number | null;
        /**
         * DEPRECATED: Page size. Use per_page instead.
         *
         * @deprecated
         */
        'page[size]'?: number | null;
        /**
         * DEPRECATED: Cursor pagination was never implemented. This parameter has no effect.
         *
         * @deprecated
         */
        'page[cursor]'?: number | null;
    };
    url: '/api/monitoring/activity-log';
};

export type ListActivityLogsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListActivityLogsError = ListActivityLogsErrors[keyof ListActivityLogsErrors];

export type ListActivityLogsResponses = {
    /**
     * Returns a list of activity logs
     */
    200: ListActivityLogResponse;
};

export type ListActivityLogsResponse = ListActivityLogsResponses[keyof ListActivityLogsResponses];

export type GetHealthCheckData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: StaticTokenSecurityScheme
         */
        'X-DES-STATIC-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Whether to force a refresh in the checks that support caching it.
         */
        fresh?: boolean;
        /**
         * Possibility to filter checks by class name.
         */
        filters?: Array<string> | null;
    };
    url: '/api/healthcheck';
};

export type GetHealthCheckErrors = {
    /**
     * The response with health checks details.
     */
    400: HealthCheckFailedResponse;
};

export type GetHealthCheckError = GetHealthCheckErrors[keyof GetHealthCheckErrors];

export type GetHealthCheckResponses = {
    /**
     * The response representing all health checks.
     */
    200: HealthCheckResponse;
};

export type GetHealthCheckResponse = GetHealthCheckResponses[keyof GetHealthCheckResponses];

export type GetTenantHealthCheckData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Whether to force a refresh in the checks that support caching it.
         */
        fresh?: boolean;
        /**
         * Possibility to filter checks by class name.
         */
        filters?: Array<string> | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/tenant-healthcheck';
};

export type GetTenantHealthCheckErrors = {
    /**
     * The response with health checks details.
     */
    400: HealthCheckFailedResponse;
};

export type GetTenantHealthCheckError = GetTenantHealthCheckErrors[keyof GetTenantHealthCheckErrors];

export type GetTenantHealthCheckResponses = {
    /**
     * The response representing all health checks.
     */
    200: HealthCheckResponse;
};

export type GetTenantHealthCheckResponse = GetTenantHealthCheckResponses[keyof GetTenantHealthCheckResponses];

export type ListOrdersData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating adapters is now deprecated and will be removed in the future. Use the 'AdapterSecurityScheme' instead.
         */
        'X-DES-ADAPTER-AK'?: string | null;
        /**
         * Security scheme: AdapterSecurityScheme
         */
        'X-DES-ADAPTER'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            /**
             * Export orders for specific customer
             */
            customer_uuid?: string;
            /**
             * Export from date
             */
            start_date?: string;
            /**
             * Export to date
             */
            end_date?: string;
            /**
             * Export orders with specific status
             */
            status?: string;
        };
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/orders';
};

export type ListOrdersErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListOrdersError = ListOrdersErrors[keyof ListOrdersErrors];

export type ListOrdersResponses = {
    /**
     * Return a list of orders
     */
    200: ListOrderResponse;
};

export type ListOrdersResponse = ListOrdersResponses[keyof ListOrdersResponses];

export type CreateOrderData = {
    /**
     * Magento store order event data
     */
    body?: CreateOrderRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/orders';
};

export type CreateOrderErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreateOrderError = CreateOrderErrors[keyof CreateOrderErrors];

export type CreateOrderResponses = {
    /**
     * Success response
     */
    200: OrderSuccessResponse;
};

export type CreateOrderResponse = CreateOrderResponses[keyof CreateOrderResponses];

export type GetInvoiceData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer uuid
         */
        uuid: string;
        /**
         * Order id
         */
        orderId: number;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/users/{uuid}/orders/{orderId}/invoice';
};

export type GetInvoiceErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
};

export type GetInvoiceError = GetInvoiceErrors[keyof GetInvoiceErrors];

export type GetInvoiceResponses = {
    /**
     * Link to the invoice
     */
    200: FetchInvoiceResponse;
};

export type GetInvoiceResponse = GetInvoiceResponses[keyof GetInvoiceResponses];

export type CreateOrderInMagentoData = {
    body?: CreateOrderInMagentoRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/orders/create';
};

export type CreateOrderInMagentoErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreateOrderInMagentoError = CreateOrderInMagentoErrors[keyof CreateOrderInMagentoErrors];

export type CreateOrderInMagentoResponses = {
    /**
     * OK
     */
    200: CreateOrderInMagentoResponse;
};

export type CreateOrderInMagentoResponse2 = CreateOrderInMagentoResponses[keyof CreateOrderInMagentoResponses];

export type CreateCancellationRequestData = {
    /**
     * Order cancellation request body
     */
    body?: CancellationRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/orders/request-cancellation';
};

export type CreateCancellationRequestErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreateCancellationRequestError = CreateCancellationRequestErrors[keyof CreateCancellationRequestErrors];

export type CreateCancellationRequestResponses = {
    /**
     * Order cancellation request details
     */
    200: CancellationRequestResponse;
};

export type CreateCancellationRequestResponse = CreateCancellationRequestResponses[keyof CreateCancellationRequestResponses];

export type ListWithdrawsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            order_id?: {
                /**
                 * In filter
                 */
                in?: string;
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            status?: {
                /**
                 * In filter
                 */
                in?: string;
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            created_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            closed_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
        };
        /**
         * Comma-separated list of fields to sort by. Prefix with "-" for descending order (e.g., "code,-created_at"). Multiple fields are supported.
         */
        sort?: string;
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/orders/withdraws';
};

export type ListWithdrawsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type ListWithdrawsError = ListWithdrawsErrors[keyof ListWithdrawsErrors];

export type ListWithdrawsResponses = {
    /**
     * Return a list of order withdraws
     */
    200: ListWithdrawsResponse;
};

export type ListWithdrawsResponse2 = ListWithdrawsResponses[keyof ListWithdrawsResponses];

export type CreateWithdrawData = {
    /**
     * Order withdraw request body
     */
    body?: WithdrawRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/orders/withdraws';
};

export type CreateWithdrawErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type CreateWithdrawError = CreateWithdrawErrors[keyof CreateWithdrawErrors];

export type CreateWithdrawResponses = {
    /**
     * Order withdraw details
     */
    201: WithdrawResponse;
};

export type CreateWithdrawResponse = CreateWithdrawResponses[keyof CreateWithdrawResponses];

export type DeleteWithdrawData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * The unique identifier of the order withdraw
         */
        order_id: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/orders/withdraws/{order_id}';
};

export type DeleteWithdrawErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
};

export type DeleteWithdrawError = DeleteWithdrawErrors[keyof DeleteWithdrawErrors];

export type DeleteWithdrawResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeleteWithdrawResponse = DeleteWithdrawResponses[keyof DeleteWithdrawResponses];

export type GetWithdrawData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * The unique identifier of the order withdraw
         */
        order_id: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/orders/withdraws/{order_id}';
};

export type GetWithdrawErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
};

export type GetWithdrawError = GetWithdrawErrors[keyof GetWithdrawErrors];

export type GetWithdrawResponses = {
    /**
     * Order withdraw details
     */
    200: WithdrawResponse;
};

export type GetWithdrawResponse = GetWithdrawResponses[keyof GetWithdrawResponses];

export type GetWithdrawCandidatesData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/orders/withdraws/candidates';
};

export type GetWithdrawCandidatesErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetWithdrawCandidatesError = GetWithdrawCandidatesErrors[keyof GetWithdrawCandidatesErrors];

export type GetWithdrawCandidatesResponses = {
    /**
     * Returns the consumer orders that are currently eligible for withdrawal
     */
    200: GetWithdrawCandidatesResponse;
};

export type GetWithdrawCandidatesResponse2 = GetWithdrawCandidatesResponses[keyof GetWithdrawCandidatesResponses];

export type IsWithdrawEligibleData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * The unique identifier of the order withdraw
         */
        order_id: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/orders/withdraws/{order_id}/is-eligible';
};

export type IsWithdrawEligibleErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type IsWithdrawEligibleError = IsWithdrawEligibleErrors[keyof IsWithdrawEligibleErrors];

export type IsWithdrawEligibleResponses = {
    /**
     * Returns whether order withdrawal is currently available for the order
     */
    200: IsWithdrawEligibleResponse;
};

export type IsWithdrawEligibleResponse2 = IsWithdrawEligibleResponses[keyof IsWithdrawEligibleResponses];

export type GetOrderData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating adapters is now deprecated and will be removed in the future. Use the 'AdapterSecurityScheme' instead.
         */
        'X-DES-ADAPTER-AK'?: string | null;
        /**
         * Security scheme: AdapterSecurityScheme
         */
        'X-DES-ADAPTER'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Order unique identifier
         */
        order_id: number;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/orders/{order_id}';
};

export type GetOrderErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetOrderError = GetOrderErrors[keyof GetOrderErrors];

export type GetOrderResponses = {
    /**
     * Return a single orders
     */
    200: OrderFields;
};

export type GetOrderResponse = GetOrderResponses[keyof GetOrderResponses];

export type UpdateShippingData = {
    /**
     * Update order shipping data
     */
    body?: UpdateShippingRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating adapters is now deprecated and will be removed in the future. Use the 'AdapterSecurityScheme' instead.
         */
        'X-DES-ADAPTER-AK'?: string | null;
        /**
         * Security scheme: AdapterSecurityScheme
         */
        'X-DES-ADAPTER'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Order unique identifier
         */
        order_id: number;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/orders/{order_id}/shipping-info';
};

export type UpdateShippingErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateShippingError = UpdateShippingErrors[keyof UpdateShippingErrors];

export type UpdateShippingResponses = {
    /**
     * Success response
     */
    200: OrderSuccessResponse;
};

export type UpdateShippingResponse = UpdateShippingResponses[keyof UpdateShippingResponses];

export type UpdateOrderStatusData = {
    /**
     * Update order status
     */
    body?: UpdateStatusRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating adapters is now deprecated and will be removed in the future. Use the 'AdapterSecurityScheme' instead.
         */
        'X-DES-ADAPTER-AK'?: string | null;
        /**
         * Security scheme: AdapterSecurityScheme
         */
        'X-DES-ADAPTER'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Order unique identifier
         */
        order_id: number;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/orders/{order_id}/status';
};

export type UpdateOrderStatusErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateOrderStatusError = UpdateOrderStatusErrors[keyof UpdateOrderStatusErrors];

export type UpdateOrderStatusResponses = {
    /**
     * Status updated
     */
    200: UpdateStatusResponse;
};

export type UpdateOrderStatusResponse = UpdateOrderStatusResponses[keyof UpdateOrderStatusResponses];

export type CreateOrderInvoiceData = {
    /**
     * Create order invoice
     */
    body?: CreateInvoiceRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating adapters is now deprecated and will be removed in the future. Use the 'AdapterSecurityScheme' instead.
         */
        'X-DES-ADAPTER-AK'?: string | null;
        /**
         * Security scheme: AdapterSecurityScheme
         */
        'X-DES-ADAPTER'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Order unique identifier
         */
        order_id: number;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/orders/{order_id}/invoice';
};

export type CreateOrderInvoiceErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreateOrderInvoiceError = CreateOrderInvoiceErrors[keyof CreateOrderInvoiceErrors];

export type CreateOrderInvoiceResponses = {
    /**
     * Success response
     */
    200: OrderSuccessResponse;
};

export type CreateOrderInvoiceResponse = CreateOrderInvoiceResponses[keyof CreateOrderInvoiceResponses];

export type UpdateOrderStatusToRejectData = {
    /**
     * Reason for order action
     */
    body?: ReasonRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating adapters is now deprecated and will be removed in the future. Use the 'AdapterSecurityScheme' instead.
         */
        'X-DES-ADAPTER-AK'?: string | null;
        /**
         * Security scheme: AdapterSecurityScheme
         */
        'X-DES-ADAPTER'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Order unique identifier
         */
        order_id: number;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/orders/{order_id}/reject';
};

export type UpdateOrderStatusToRejectErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateOrderStatusToRejectError = UpdateOrderStatusToRejectErrors[keyof UpdateOrderStatusToRejectErrors];

export type UpdateOrderStatusToRejectResponses = {
    /**
     * Success response
     */
    200: OrderSuccessResponse;
};

export type UpdateOrderStatusToRejectResponse = UpdateOrderStatusToRejectResponses[keyof UpdateOrderStatusToRejectResponses];

export type UpdateOrderStatusToHoldOrderData = {
    /**
     * Reason for order action
     */
    body?: ReasonRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating adapters is now deprecated and will be removed in the future. Use the 'AdapterSecurityScheme' instead.
         */
        'X-DES-ADAPTER-AK'?: string | null;
        /**
         * Security scheme: AdapterSecurityScheme
         */
        'X-DES-ADAPTER'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Order unique identifier
         */
        order_id: number;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/orders/{order_id}/hold';
};

export type UpdateOrderStatusToHoldOrderErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateOrderStatusToHoldOrderError = UpdateOrderStatusToHoldOrderErrors[keyof UpdateOrderStatusToHoldOrderErrors];

export type UpdateOrderStatusToHoldOrderResponses = {
    /**
     * Success response
     */
    200: OrderSuccessResponse;
};

export type UpdateOrderStatusToHoldOrderResponse = UpdateOrderStatusToHoldOrderResponses[keyof UpdateOrderStatusToHoldOrderResponses];

export type UpdateOrderStatusToUnholdData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating adapters is now deprecated and will be removed in the future. Use the 'AdapterSecurityScheme' instead.
         */
        'X-DES-ADAPTER-AK'?: string | null;
        /**
         * Security scheme: AdapterSecurityScheme
         */
        'X-DES-ADAPTER'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Order unique identifier
         */
        order_id: number;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/orders/{order_id}/unhold';
};

export type UpdateOrderStatusToUnholdErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateOrderStatusToUnholdError = UpdateOrderStatusToUnholdErrors[keyof UpdateOrderStatusToUnholdErrors];

export type UpdateOrderStatusToUnholdResponses = {
    /**
     * Success response
     */
    200: OrderSuccessResponse;
};

export type UpdateOrderStatusToUnholdResponse = UpdateOrderStatusToUnholdResponses[keyof UpdateOrderStatusToUnholdResponses];

export type CancelOrderData = {
    /**
     * Cancel order items
     */
    body?: CancelOrderRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * The microservice way of authenticating adapters is now deprecated and will be removed in the future. Use the 'AdapterSecurityScheme' instead.
         */
        'X-DES-ADAPTER-AK'?: string | null;
        /**
         * Security scheme: AdapterSecurityScheme
         */
        'X-DES-ADAPTER'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Order unique identifier
         */
        order_id: number;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/orders/{order_id}/cancel';
};

export type CancelOrderErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CancelOrderError = CancelOrderErrors[keyof CancelOrderErrors];

export type CancelOrderResponses = {
    /**
     * Success response
     */
    200: OrderSuccessResponse;
};

export type CancelOrderResponse = CancelOrderResponses[keyof CancelOrderResponses];

export type GetUserSubscriptionData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/subscriptions/user';
};

export type GetUserSubscriptionErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetUserSubscriptionError = GetUserSubscriptionErrors[keyof GetUserSubscriptionErrors];

export type GetUserSubscriptionResponses = {
    /**
     * Return user subscription
     */
    200: UserSubscriptionResponse;
};

export type GetUserSubscriptionResponse = GetUserSubscriptionResponses[keyof GetUserSubscriptionResponses];

export type GetSubscriptionConfigurationData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/subscriptions/configurations';
};

export type GetSubscriptionConfigurationErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetSubscriptionConfigurationError = GetSubscriptionConfigurationErrors[keyof GetSubscriptionConfigurationErrors];

export type GetSubscriptionConfigurationResponses = {
    /**
     * Return information about subscription configurations
     */
    200: SubscriptionConfigurationResponse;
};

export type GetSubscriptionConfigurationResponse = GetSubscriptionConfigurationResponses[keyof GetSubscriptionConfigurationResponses];

export type CreateSubscriptionData = {
    /**
     * Create subscription data
     */
    body?: CreateSubscriptionRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/subscriptions';
};

export type CreateSubscriptionErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreateSubscriptionError = CreateSubscriptionErrors[keyof CreateSubscriptionErrors];

export type CreateSubscriptionResponses = {
    /**
     * Return a single subscription
     */
    200: SubscriptionFields;
};

export type CreateSubscriptionResponse = CreateSubscriptionResponses[keyof CreateSubscriptionResponses];

export type IsConsumerEligibleForSubscriptionsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer identifier
         */
        consumer_id: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/subscriptions/is-eligible/consumer/{consumer_id}';
};

export type IsConsumerEligibleForSubscriptionsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type IsConsumerEligibleForSubscriptionsError = IsConsumerEligibleForSubscriptionsErrors[keyof IsConsumerEligibleForSubscriptionsErrors];

export type IsConsumerEligibleForSubscriptionsResponses = {
    /**
     * Return information about user eligibility for subscription
     */
    200: SubscriptionEligibilityResponse;
};

export type IsConsumerEligibleForSubscriptionsResponse = IsConsumerEligibleForSubscriptionsResponses[keyof IsConsumerEligibleForSubscriptionsResponses];

export type IsShippingAddressEligibleForRemovalData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Shipping address identifier
         */
        address_id: number;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/subscriptions/is-eligible/shipping-address/{address_id}';
};

export type IsShippingAddressEligibleForRemovalErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type IsShippingAddressEligibleForRemovalError = IsShippingAddressEligibleForRemovalErrors[keyof IsShippingAddressEligibleForRemovalErrors];

export type IsShippingAddressEligibleForRemovalResponses = {
    /**
     * Return information about shipping address eligibility for removal
     */
    200: IsShippingAddressEligibleForRemovalResponse;
};

export type IsShippingAddressEligibleForRemovalResponse2 = IsShippingAddressEligibleForRemovalResponses[keyof IsShippingAddressEligibleForRemovalResponses];

export type UpdateSubscriptionChargeData = {
    /**
     * Subscription charge data
     */
    body?: UpdateChargeRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Subscription unique identifier
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/subscriptions/{uuid}/charge';
};

export type UpdateSubscriptionChargeErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateSubscriptionChargeError = UpdateSubscriptionChargeErrors[keyof UpdateSubscriptionChargeErrors];

export type UpdateSubscriptionChargeResponses = {
    /**
     * Return a single subscription
     */
    200: SubscriptionFields;
};

export type UpdateSubscriptionChargeResponse = UpdateSubscriptionChargeResponses[keyof UpdateSubscriptionChargeResponses];

export type GetSubscriptionEventsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Subscription unique identifier
         */
        uuid: string;
    };
    query?: {
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/subscriptions/{uuid}/events';
};

export type GetSubscriptionEventsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetSubscriptionEventsError = GetSubscriptionEventsErrors[keyof GetSubscriptionEventsErrors];

export type GetSubscriptionEventsResponses = {
    /**
     * Return subscription events
     */
    200: SubscriptionEventsResponse;
};

export type GetSubscriptionEventsResponse = GetSubscriptionEventsResponses[keyof GetSubscriptionEventsResponses];

export type UpdateSubscriptionStatusData = {
    /**
     * Update subscription status
     */
    body?: UpdateSubscriptionStatusRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Subscription unique identifier
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/subscriptions/{uuid}/status';
};

export type UpdateSubscriptionStatusErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateSubscriptionStatusError = UpdateSubscriptionStatusErrors[keyof UpdateSubscriptionStatusErrors];

export type UpdateSubscriptionStatusResponses = {
    /**
     * Return a single subscription
     */
    200: SubscriptionFields;
};

export type UpdateSubscriptionStatusResponse = UpdateSubscriptionStatusResponses[keyof UpdateSubscriptionStatusResponses];

export type ListConsumerSubscriptionsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        consumer_id: string;
    };
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            status?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            amount?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            billed_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            next_charge_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            created_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            updated_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
        };
        /**
         * Comma-separated list of fields to sort by. Prefix with "-" for descending order (e.g., "code,-created_at"). Multiple fields are supported.
         */
        sort?: string;
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/subscriptions/consumer/{consumer_id}';
};

export type ListConsumerSubscriptionsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListConsumerSubscriptionsError = ListConsumerSubscriptionsErrors[keyof ListConsumerSubscriptionsErrors];

export type ListConsumerSubscriptionsResponses = {
    /**
     * Return subscription events
     */
    200: ConsumerSubscriptionsResponse;
};

export type ListConsumerSubscriptionsResponse = ListConsumerSubscriptionsResponses[keyof ListConsumerSubscriptionsResponses];

export type GetConsumerSubscriptionData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Subscription UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/subscriptions/{uuid}';
};

export type GetConsumerSubscriptionErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetConsumerSubscriptionError = GetConsumerSubscriptionErrors[keyof GetConsumerSubscriptionErrors];

export type GetConsumerSubscriptionResponses = {
    /**
     * Return a single subscription
     */
    200: SubscriptionFields;
};

export type GetConsumerSubscriptionResponse = GetConsumerSubscriptionResponses[keyof GetConsumerSubscriptionResponses];

export type UpdateSubscriptionData = {
    /**
     * Update subscription data
     */
    body?: UpdateSubscriptionRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Subscription unique identifier
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/subscriptions/{uuid}';
};

export type UpdateSubscriptionErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateSubscriptionError = UpdateSubscriptionErrors[keyof UpdateSubscriptionErrors];

export type UpdateSubscriptionResponses = {
    /**
     * Return a single subscription
     */
    200: SubscriptionFields;
};

export type UpdateSubscriptionResponse = UpdateSubscriptionResponses[keyof UpdateSubscriptionResponses];

export type CancelSubscriptionData = {
    /**
     * Cancel subscription with optional cancellation reason
     */
    body?: CancelSubscriptionRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Subscription unique identifier
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/subscriptions/{uuid}/cancel';
};

export type CancelSubscriptionErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CancelSubscriptionError = CancelSubscriptionErrors[keyof CancelSubscriptionErrors];

export type CancelSubscriptionResponses = {
    /**
     * Return a single subscription
     */
    200: SubscriptionFields;
};

export type CancelSubscriptionResponse = CancelSubscriptionResponses[keyof CancelSubscriptionResponses];

export type UpdateSubscriptionToPauseData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Subscription unique identifier
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/subscriptions/{uuid}/pause';
};

export type UpdateSubscriptionToPauseErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateSubscriptionToPauseError = UpdateSubscriptionToPauseErrors[keyof UpdateSubscriptionToPauseErrors];

export type UpdateSubscriptionToPauseResponses = {
    /**
     * Return a single subscription
     */
    200: SubscriptionFields;
};

export type UpdateSubscriptionToPauseResponse = UpdateSubscriptionToPauseResponses[keyof UpdateSubscriptionToPauseResponses];

export type UpdateSubscriptionToResumeData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Subscription unique identifier
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/subscriptions/{uuid}/resume';
};

export type UpdateSubscriptionToResumeErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateSubscriptionToResumeError = UpdateSubscriptionToResumeErrors[keyof UpdateSubscriptionToResumeErrors];

export type UpdateSubscriptionToResumeResponses = {
    /**
     * Return a single subscription
     */
    200: SubscriptionFields;
};

export type UpdateSubscriptionToResumeResponse = UpdateSubscriptionToResumeResponses[keyof UpdateSubscriptionToResumeResponses];

export type IsEligibleForTrialData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Trial program identifier
         */
        program: string;
        /**
         * Consumer identifier
         */
        consumer: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/trials/is-eligible/{program}/{consumer}';
};

export type IsEligibleForTrialErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type IsEligibleForTrialError = IsEligibleForTrialErrors[keyof IsEligibleForTrialErrors];

export type IsEligibleForTrialResponses = {
    /**
     * Return information about user eligibility for the trial program
     */
    200: IsEligibleResponse;
};

export type IsEligibleForTrialResponse = IsEligibleForTrialResponses[keyof IsEligibleForTrialResponses];

export type ListTrialsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            consumer_id?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            status?: {
                /**
                 * In filter
                 */
                in?: string;
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            channel?: {
                /**
                 * In filter
                 */
                in?: string;
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            channel_type?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            sku?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            final_sku?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            manufacturer?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            order_id?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            final_order_id?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            program_id?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            start_date?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            end_date?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            billing_date?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            created_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            updated_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
        };
        /**
         * Comma-separated list of fields to sort by. Prefix with "-" for descending order (e.g., "code,-created_at"). Multiple fields are supported.
         */
        sort?: string;
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/trials';
};

export type ListTrialsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListTrialsError = ListTrialsErrors[keyof ListTrialsErrors];

export type ListTrialsResponses = {
    /**
     * Return trials list
     */
    200: ListTrialResponse;
};

export type ListTrialsResponse = ListTrialsResponses[keyof ListTrialsResponses];

export type UpdateTrialData = {
    /**
     * Update trial data
     */
    body?: UpdateTrialRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Trial UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/trials/{uuid}';
};

export type UpdateTrialErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type UpdateTrialError = UpdateTrialErrors[keyof UpdateTrialErrors];

export type UpdateTrialResponses = {
    /**
     * Return trial details
     */
    200: TrialFields;
};

export type UpdateTrialResponse = UpdateTrialResponses[keyof UpdateTrialResponses];

export type ListActionsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters using the standardized query processing system
         */
        filter?: {
            uuid?: {
                /**
                 * In filter
                 */
                in?: string;
            } | Array<string>;
            lead_uuid?: {
                /**
                 * In filter
                 */
                in?: string;
            } | Array<string>;
            lead_email?: {
                /**
                 * In filter
                 */
                in?: string;
            } | Array<string>;
        };
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/leads/actions';
};

export type ListActionsErrors = {
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type ListActionsError = ListActionsErrors[keyof ListActionsErrors];

export type ListActionsResponses = {
    /**
     * List of actions
     */
    200: ListActionsResponse;
};

export type ListActionsResponse2 = ListActionsResponses[keyof ListActionsResponses];

export type CreateActionData = {
    /**
     * Create action
     */
    body?: CreateActionRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/leads/actions';
};

export type CreateActionErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type CreateActionError = CreateActionErrors[keyof CreateActionErrors];

export type CreateActionResponses = {
    /**
     * Single action item response
     */
    201: ActionResponse;
};

export type CreateActionResponse = CreateActionResponses[keyof CreateActionResponses];

export type CreateDeviceRegistrationActionData = {
    /**
     * Create device registration action
     */
    body?: CreateDeviceRegistrationActionRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/leads/actions/devices/register';
};

export type CreateDeviceRegistrationActionErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type CreateDeviceRegistrationActionError = CreateDeviceRegistrationActionErrors[keyof CreateDeviceRegistrationActionErrors];

export type CreateDeviceRegistrationActionResponses = {
    /**
     * Single action item response
     */
    201: ActionResponse;
};

export type CreateDeviceRegistrationActionResponse = CreateDeviceRegistrationActionResponses[keyof CreateDeviceRegistrationActionResponses];

export type CreateOrderActionData = {
    /**
     * Create order action
     */
    body?: CreateOrderActionRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/leads/actions/orders';
};

export type CreateOrderActionErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type CreateOrderActionError = CreateOrderActionErrors[keyof CreateOrderActionErrors];

export type CreateOrderActionResponses = {
    /**
     * Single action item response
     */
    201: ActionResponse;
};

export type CreateOrderActionResponse = CreateOrderActionResponses[keyof CreateOrderActionResponses];

export type GetActionData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Action uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/leads/actions/{uuid}';
};

export type GetActionErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
};

export type GetActionError = GetActionErrors[keyof GetActionErrors];

export type GetActionResponses = {
    /**
     * Single action item response
     */
    200: ActionResponse;
};

export type GetActionResponse = GetActionResponses[keyof GetActionResponses];

export type UpdateActionData = {
    /**
     * Update action
     */
    body?: UpdateActionRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Action uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/leads/actions/{uuid}';
};

export type UpdateActionErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
};

export type UpdateActionError = UpdateActionErrors[keyof UpdateActionErrors];

export type UpdateActionResponses = {
    /**
     * Single action item response
     */
    200: ActionResponse;
};

export type UpdateActionResponse = UpdateActionResponses[keyof UpdateActionResponses];

export type ListLeadsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters using the standardized query processing system
         */
        filter?: {
            email?: {
                /**
                 * In filter
                 */
                in?: string;
                /**
                 * SQL LIKE pattern filter
                 */
                like?: string;
            } | Array<string>;
            uuid?: {
                /**
                 * In filter
                 */
                in?: string;
            } | Array<string>;
            phone?: {
                /**
                 * In filter
                 */
                in?: string;
            } | Array<string>;
            created_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            updated_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
        };
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Filter by leads created after this date. Use filter[created_at][gte] instead.
         *
         * @deprecated
         */
        'filter[from][created_at]'?: string | null;
        /**
         * Filter by leads created before this date. Use filter[created_at][lte] instead.
         *
         * @deprecated
         */
        'filter[to][created_at]'?: string | null;
        /**
         * Filter by leads updated after this date. Use filter[updated_at][gte] instead.
         *
         * @deprecated
         */
        'filter[from][updated_at]'?: string | null;
        /**
         * Filter by leads updated before this date. Use filter[updated_at][lte] instead.
         *
         * @deprecated
         */
        'filter[to][updated_at]'?: string | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/leads';
};

export type ListLeadsErrors = {
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type ListLeadsError = ListLeadsErrors[keyof ListLeadsErrors];

export type ListLeadsResponses = {
    /**
     * List of leads
     */
    200: ListLeadsResponse;
};

export type ListLeadsResponse2 = ListLeadsResponses[keyof ListLeadsResponses];

export type CreateLeadData = {
    /**
     * Create lead
     */
    body?: CreateLeadRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/leads';
};

export type CreateLeadErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Single lead item response
     */
    409: LeadResponse;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type CreateLeadError = CreateLeadErrors[keyof CreateLeadErrors];

export type CreateLeadResponses = {
    /**
     * Single lead item response
     */
    201: LeadResponse;
};

export type CreateLeadResponse = CreateLeadResponses[keyof CreateLeadResponses];

export type TriggerDoiData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Lead identifier - uuid, email address or phone number
         */
        identifier: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/leads/{identifier}/retrigger-doi';
};

export type TriggerDoiErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type TriggerDoiError = TriggerDoiErrors[keyof TriggerDoiErrors];

export type TriggerDoiResponses = {
    /**
     * Single lead item response
     */
    200: LeadResponse;
};

export type TriggerDoiResponse = TriggerDoiResponses[keyof TriggerDoiResponses];

export type CancelLeadData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Lead identifier - uuid, email address or phone number
         */
        identifier: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/leads/{identifier}';
};

export type CancelLeadErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type CancelLeadError = CancelLeadErrors[keyof CancelLeadErrors];

export type CancelLeadResponses = {
    /**
     * Single lead item response
     */
    200: LeadResponse;
};

export type CancelLeadResponse = CancelLeadResponses[keyof CancelLeadResponses];

export type GetLeadData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Lead identifier - uuid, email address or phone number
         */
        identifier: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/leads/{identifier}';
};

export type GetLeadErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type GetLeadError = GetLeadErrors[keyof GetLeadErrors];

export type GetLeadResponses = {
    /**
     * Single lead item response
     */
    200: LeadResponse;
};

export type GetLeadResponse = GetLeadResponses[keyof GetLeadResponses];

export type UpdateLeadData = {
    /**
     * Update lead
     */
    body?: UpdateLeadRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Lead identifier - uuid, email address or phone number
         */
        identifier: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/leads/{identifier}';
};

export type UpdateLeadErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type UpdateLeadError = UpdateLeadErrors[keyof UpdateLeadErrors];

export type UpdateLeadResponses = {
    /**
     * Single lead item response
     */
    200: LeadResponse;
};

export type UpdateLeadResponse = UpdateLeadResponses[keyof UpdateLeadResponses];

export type VerifyConsentData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Hash of the consent to be validated
         */
        hash: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/leads/consents/validate/{hash}';
};

export type VerifyConsentErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type VerifyConsentError = VerifyConsentErrors[keyof VerifyConsentErrors];

export type VerifyConsentResponses = {
    /**
     * The set password token
     */
    200: VerifyConsentResponse;
};

export type VerifyConsentResponse2 = VerifyConsentResponses[keyof VerifyConsentResponses];

export type ListPurchasesData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Lead / consumer - uuid
         */
        uuid: string;
    };
    query?: {
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/leads/{uuid}/actions/purchase';
};

export type ListPurchasesErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type ListPurchasesError = ListPurchasesErrors[keyof ListPurchasesErrors];

export type ListPurchasesResponses = {
    /**
     * List of purchases
     */
    200: ListPurchasesResponse;
};

export type ListPurchasesResponse2 = ListPurchasesResponses[keyof ListPurchasesResponses];

export type GetPurchaseData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Consumer - uuid
         */
        uuid: string;
        /**
         * Action - uuid
         */
        actionUuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/leads/{uuid}/actions/purchase/{actionUuid}';
};

export type GetPurchaseErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to invalid or absent auth header
     */
    default: PermissionError;
};

export type GetPurchaseError = GetPurchaseErrors[keyof GetPurchaseErrors];

export type GetPurchaseResponses = {
    /**
     * Single purchase response
     */
    200: PurchaseResponse;
};

export type GetPurchaseResponse = GetPurchaseResponses[keyof GetPurchaseResponses];

export type DeactivateConsumerInLoyaltyData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/services/consumers/{uuid}';
};

export type DeactivateConsumerInLoyaltyErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    424: CommonError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type DeactivateConsumerInLoyaltyError = DeactivateConsumerInLoyaltyErrors[keyof DeactivateConsumerInLoyaltyErrors];

export type DeactivateConsumerInLoyaltyResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeactivateConsumerInLoyaltyResponse = DeactivateConsumerInLoyaltyResponses[keyof DeactivateConsumerInLoyaltyResponses];

export type GetConsumerLoyaltyProfileS2sData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/services/consumers/{uuid}';
};

export type GetConsumerLoyaltyProfileS2sErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetConsumerLoyaltyProfileS2sError = GetConsumerLoyaltyProfileS2sErrors[keyof GetConsumerLoyaltyProfileS2sErrors];

export type GetConsumerLoyaltyProfileS2sResponses = {
    /**
     * Consumer loyalty profile
     */
    200: ConsumerLoyaltyProfileResponse;
};

export type GetConsumerLoyaltyProfileS2sResponse = GetConsumerLoyaltyProfileS2sResponses[keyof GetConsumerLoyaltyProfileS2sResponses];

export type ActivateConsumerInLoyaltyData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/services/consumers/{uuid}';
};

export type ActivateConsumerInLoyaltyErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type ActivateConsumerInLoyaltyError = ActivateConsumerInLoyaltyErrors[keyof ActivateConsumerInLoyaltyErrors];

export type ActivateConsumerInLoyaltyResponses = {
    /**
     * Loyalty domain configuration response
     */
    200: ConsumerActivatedInLoyaltyResponse;
};

export type ActivateConsumerInLoyaltyResponse = ActivateConsumerInLoyaltyResponses[keyof ActivateConsumerInLoyaltyResponses];

export type GetConsumerNetworkPointsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/services/consumers/{uuid}/points';
};

export type GetConsumerNetworkPointsErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetConsumerNetworkPointsError = GetConsumerNetworkPointsErrors[keyof GetConsumerNetworkPointsErrors];

export type GetConsumerNetworkPointsResponses = {
    /**
     * Consumer network points
     */
    200: ConsumerNetworkPointsResponse;
};

export type GetConsumerNetworkPointsResponse = GetConsumerNetworkPointsResponses[keyof GetConsumerNetworkPointsResponses];

export type InitializeAddingConsumerPointsByTypeData = {
    /**
     * Trigger adding consumer points payload
     */
    body?: TriggerAddingConsumerPointsRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/services/consumers/{uuid}/points';
};

export type InitializeAddingConsumerPointsByTypeErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type InitializeAddingConsumerPointsByTypeError = InitializeAddingConsumerPointsByTypeErrors[keyof InitializeAddingConsumerPointsByTypeErrors];

export type InitializeAddingConsumerPointsByTypeResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type InitializeAddingConsumerPointsByTypeResponse = InitializeAddingConsumerPointsByTypeResponses[keyof InitializeAddingConsumerPointsByTypeResponses];

export type IncreaseConsumerPointsData = {
    /**
     * Increase or decrease consumer points
     */
    body?: TransferRequestBodySchema;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/services/consumers/{uuid}/points/increase';
};

export type IncreaseConsumerPointsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type IncreaseConsumerPointsError = IncreaseConsumerPointsErrors[keyof IncreaseConsumerPointsErrors];

export type IncreaseConsumerPointsResponses = {
    /**
     * Transfer points response
     */
    200: TransferConsumerPointsResponse;
};

export type IncreaseConsumerPointsResponse = IncreaseConsumerPointsResponses[keyof IncreaseConsumerPointsResponses];

export type DecreaseConsumerPointsData = {
    /**
     * Increase or decrease consumer points
     */
    body?: TransferRequestBodySchema;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/services/consumers/{uuid}/points/decrease';
};

export type DecreaseConsumerPointsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type DecreaseConsumerPointsError = DecreaseConsumerPointsErrors[keyof DecreaseConsumerPointsErrors];

export type DecreaseConsumerPointsResponses = {
    /**
     * Transfer points response
     */
    200: TransferConsumerPointsResponse;
};

export type DecreaseConsumerPointsResponse = DecreaseConsumerPointsResponses[keyof DecreaseConsumerPointsResponses];

export type InitializeBulkEventsData = {
    body?: InitializeBulkEventsRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/services/consumers/points';
};

export type InitializeBulkEventsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type InitializeBulkEventsError = InitializeBulkEventsErrors[keyof InitializeBulkEventsErrors];

export type InitializeBulkEventsResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type InitializeBulkEventsResponse = InitializeBulkEventsResponses[keyof InitializeBulkEventsResponses];

export type GetConsumerRewardsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/services/consumers/{uuid}/rewards';
};

export type GetConsumerRewardsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetConsumerRewardsError = GetConsumerRewardsErrors[keyof GetConsumerRewardsErrors];

export type GetConsumerRewardsResponses = {
    /**
     * List of consumer rewards
     */
    200: ConsumerRewardsResponse;
};

export type GetConsumerRewardsResponse = GetConsumerRewardsResponses[keyof GetConsumerRewardsResponses];

export type GetConsumerEligibleRewardsForServiceData = {
    body?: EligibleRewardRequestBodySchema;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/services/consumers/{uuid}/rewards';
};

export type GetConsumerEligibleRewardsForServiceErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetConsumerEligibleRewardsForServiceError = GetConsumerEligibleRewardsForServiceErrors[keyof GetConsumerEligibleRewardsForServiceErrors];

export type GetConsumerEligibleRewardsForServiceResponses = {
    /**
     * List of consumer eligible rewards
     */
    200: ConsumerEligibleRewardsResponse;
};

export type GetConsumerEligibleRewardsForServiceResponse = GetConsumerEligibleRewardsForServiceResponses[keyof GetConsumerEligibleRewardsForServiceResponses];

export type CheckRewardEligibilityControllerData = {
    body?: EligibleRewardRequestBodySchema;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
        /**
         * Reward UUID
         */
        reward_uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/services/consumers/{uuid}/reward/{reward_uuid}';
};

export type CheckRewardEligibilityControllerErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type CheckRewardEligibilityControllerError = CheckRewardEligibilityControllerErrors[keyof CheckRewardEligibilityControllerErrors];

export type CheckRewardEligibilityControllerResponses = {
    /**
     * Eligible reward
     */
    200: CheckRewardEligibilityResponse;
};

export type CheckRewardEligibilityControllerResponse = CheckRewardEligibilityControllerResponses[keyof CheckRewardEligibilityControllerResponses];

export type GetRedeemRewardData = {
    body?: GetRedeemRewardRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/services/consumers/{uuid}/reward';
};

export type GetRedeemRewardErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetRedeemRewardError = GetRedeemRewardErrors[keyof GetRedeemRewardErrors];

export type GetRedeemRewardResponses = {
    /**
     * List of coupons
     */
    200: RedeemRewardResponse;
};

export type GetRedeemRewardResponse = GetRedeemRewardResponses[keyof GetRedeemRewardResponses];

export type GetConsumerTierS2sData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/services/consumers/{uuid}/tier';
};

export type GetConsumerTierS2sErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetConsumerTierS2sError = GetConsumerTierS2sErrors[keyof GetConsumerTierS2sErrors];

export type GetConsumerTierS2sResponses = {
    /**
     * Consumer tier details
     */
    200: ConsumerTierResponse;
};

export type GetConsumerTierS2sResponse = GetConsumerTierS2sResponses[keyof GetConsumerTierS2sResponses];

export type GetTiersServiceData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/services/tiers';
};

export type GetTiersServiceErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetTiersServiceError = GetTiersServiceErrors[keyof GetTiersServiceErrors];

export type GetTiersServiceResponses = {
    /**
     * List of tiers
     */
    200: TiersResponse;
};

export type GetTiersServiceResponse = GetTiersServiceResponses[keyof GetTiersServiceResponses];

export type IncreaseCouponsToRewardData = {
    body?: IncreaseRewardCouponsRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Reward UUID
         */
        reward_uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/services/reward/{reward_uuid}/coupons';
};

export type IncreaseCouponsToRewardErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type IncreaseCouponsToRewardError = IncreaseCouponsToRewardErrors[keyof IncreaseCouponsToRewardErrors];

export type IncreaseCouponsToRewardResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type IncreaseCouponsToRewardResponse = IncreaseCouponsToRewardResponses[keyof IncreaseCouponsToRewardResponses];

export type ListRewardConsumersData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Reward UUID
         */
        reward_uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/services/reward/{reward_uuid}/consumers';
};

export type ListRewardConsumersErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type ListRewardConsumersError = ListRewardConsumersErrors[keyof ListRewardConsumersErrors];

export type ListRewardConsumersResponses = {
    /**
     * Reward Consumers list response
     */
    200: RewardConsumersListResponse;
};

export type ListRewardConsumersResponse = ListRewardConsumersResponses[keyof ListRewardConsumersResponses];

export type UpdateRewardRedemptionsStatusData = {
    body?: UpdateRewardRedemptionsStatusRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/services/redemptions/status';
};

export type UpdateRewardRedemptionsStatusErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    424: CommonError;
};

export type UpdateRewardRedemptionsStatusError = UpdateRewardRedemptionsStatusErrors[keyof UpdateRewardRedemptionsStatusErrors];

export type UpdateRewardRedemptionsStatusResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type UpdateRewardRedemptionsStatusResponse = UpdateRewardRedemptionsStatusResponses[keyof UpdateRewardRedemptionsStatusResponses];

export type SyncOpenLoyaltyRewardsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/services/rewards/sync';
};

export type SyncOpenLoyaltyRewardsErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
};

export type SyncOpenLoyaltyRewardsError = SyncOpenLoyaltyRewardsErrors[keyof SyncOpenLoyaltyRewardsErrors];

export type SyncOpenLoyaltyRewardsResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type SyncOpenLoyaltyRewardsResponse = SyncOpenLoyaltyRewardsResponses[keyof SyncOpenLoyaltyRewardsResponses];

export type InvalidateTranslationsCacheData = {
    body?: InvalidateTranslationCacheRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/services/cache/translations';
};

export type InvalidateTranslationsCacheErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type InvalidateTranslationsCacheError = InvalidateTranslationsCacheErrors[keyof InvalidateTranslationsCacheErrors];

export type InvalidateTranslationsCacheResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type InvalidateTranslationsCacheResponse = InvalidateTranslationsCacheResponses[keyof InvalidateTranslationsCacheResponses];

export type GetLoyaltyPublicDomainConfigurationData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/configuration';
};

export type GetLoyaltyPublicDomainConfigurationErrors = {
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Unauthorized
     */
    default: unknown;
};

export type GetLoyaltyPublicDomainConfigurationError = GetLoyaltyPublicDomainConfigurationErrors[keyof GetLoyaltyPublicDomainConfigurationErrors];

export type GetLoyaltyPublicDomainConfigurationResponses = {
    /**
     * Loyalty domain configuration response
     */
    200: LoyaltyDomainConfiguration;
};

export type GetLoyaltyPublicDomainConfigurationResponse = GetLoyaltyPublicDomainConfigurationResponses[keyof GetLoyaltyPublicDomainConfigurationResponses];

export type GetTiersData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/tiers';
};

export type GetTiersErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetTiersError = GetTiersErrors[keyof GetTiersErrors];

export type GetTiersResponses = {
    /**
     * List of tiers
     */
    200: TiersResponse;
};

export type GetTiersResponse = GetTiersResponses[keyof GetTiersResponses];

export type GetConsumerPointsHistoryData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Type of history items
         */
        type?: 'referral' | 'history' | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/points';
};

export type GetConsumerPointsHistoryErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetConsumerPointsHistoryError = GetConsumerPointsHistoryErrors[keyof GetConsumerPointsHistoryErrors];

export type GetConsumerPointsHistoryResponses = {
    /**
     * Consumer historical points
     */
    200: ConsumerPointsHistoryResponse;
};

export type GetConsumerPointsHistoryResponse = GetConsumerPointsHistoryResponses[keyof GetConsumerPointsHistoryResponses];

export type GetConsumerRewardData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
        /**
         * Reward UUID
         */
        reward_uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/reward/{reward_uuid}';
};

export type GetConsumerRewardErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetConsumerRewardError = GetConsumerRewardErrors[keyof GetConsumerRewardErrors];

export type GetConsumerRewardResponses = {
    /**
     * Reward response
     */
    200: ConsumerRedeemRewardResponse;
};

export type GetConsumerRewardResponse = GetConsumerRewardResponses[keyof GetConsumerRewardResponses];

export type GetConsumerLoyaltyProfileData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}';
};

export type GetConsumerLoyaltyProfileErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetConsumerLoyaltyProfileError = GetConsumerLoyaltyProfileErrors[keyof GetConsumerLoyaltyProfileErrors];

export type GetConsumerLoyaltyProfileResponses = {
    /**
     * Consumer loyalty profile
     */
    200: ConsumerLoyaltyProfileResponse;
};

export type GetConsumerLoyaltyProfileResponse = GetConsumerLoyaltyProfileResponses[keyof GetConsumerLoyaltyProfileResponses];

export type GetEarningsForConsumerData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Field used to order by
         */
        order_by?: 'created_at' | 'points' | null;
        /**
         * Sort direction
         */
        sort?: 'asc' | 'desc' | null;
        /**
         * Location ids - comma separated list
         */
        location_ids?: string | null;
        /**
         * Array of identifiers filter - required when type=product for other optional
         *
         * @deprecated
         */
        'identifier[]'?: Array<string> | null;
        /**
         * Earning type
         */
        type?: 'article' | 'product' | 'video' | 'quiz' | null;
        /**
         * Array of identifiers for a specific earning type. Replace <type> with a valid earning type (e.g., product, article). Example: typed_identifiers[product][]=SKU1234
         */
        'typed_identifiers[<type>][]'?: Array<string> | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/earnings';
};

export type GetEarningsForConsumerErrors = {
    /**
     * Resource not found
     */
    400: NotFoundError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetEarningsForConsumerError = GetEarningsForConsumerErrors[keyof GetEarningsForConsumerErrors];

export type GetEarningsForConsumerResponses = {
    /**
     * List of earnings (articles, products, videos and quizzes)
     */
    200: ListEarningsResponse;
};

export type GetEarningsForConsumerResponse = GetEarningsForConsumerResponses[keyof GetEarningsForConsumerResponses];

export type GetQrCodeDetailsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
        /**
         * QR Code ID
         */
        id: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/earnings/qr-code/{id}';
};

export type GetQrCodeDetailsErrors = {
    /**
     * Resource not found
     */
    400: NotFoundError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetQrCodeDetailsError = GetQrCodeDetailsErrors[keyof GetQrCodeDetailsErrors];

export type GetQrCodeDetailsResponses = {
    /**
     * QR Code lottery details
     */
    200: QrCodeGetResponse;
};

export type GetQrCodeDetailsResponse = GetQrCodeDetailsResponses[keyof GetQrCodeDetailsResponses];

export type GetConsumerOrderData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
        /**
         * Order Id
         */
        order_id: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/orders/{order_id}';
};

export type GetConsumerOrderErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetConsumerOrderError = GetConsumerOrderErrors[keyof GetConsumerOrderErrors];

export type GetConsumerOrderResponses = {
    /**
     * Order response
     */
    200: ConsumerOrderResponse;
};

export type GetConsumerOrderResponse = GetConsumerOrderResponses[keyof GetConsumerOrderResponses];

export type GetAvailableSurveysForConsumerData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/surveys';
};

export type GetAvailableSurveysForConsumerErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetAvailableSurveysForConsumerError = GetAvailableSurveysForConsumerErrors[keyof GetAvailableSurveysForConsumerErrors];

export type GetAvailableSurveysForConsumerResponses = {
    /**
     * Available surveys for a consumer
     */
    200: AvailableSurveysResponse;
};

export type GetAvailableSurveysForConsumerResponse = GetAvailableSurveysForConsumerResponses[keyof GetAvailableSurveysForConsumerResponses];

export type GetConsumerSurveyStatusData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
        /**
         * Survey ID
         */
        survey_id: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/survey/{survey_id}/status';
};

export type GetConsumerSurveyStatusErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetConsumerSurveyStatusError = GetConsumerSurveyStatusErrors[keyof GetConsumerSurveyStatusErrors];

export type GetConsumerSurveyStatusResponses = {
    /**
     * Consumer survey status
     */
    200: GetConsumerSurveyStatusResponse;
};

export type GetConsumerSurveyStatusResponse2 = GetConsumerSurveyStatusResponses[keyof GetConsumerSurveyStatusResponses];

export type GetConsumerTierData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/tier';
};

export type GetConsumerTierErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetConsumerTierError = GetConsumerTierErrors[keyof GetConsumerTierErrors];

export type GetConsumerTierResponses = {
    /**
     * Consumer tier details
     */
    200: ConsumerTierResponse;
};

export type GetConsumerTierResponse = GetConsumerTierResponses[keyof GetConsumerTierResponses];

export type GetRewardData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path: {
        /**
         * Reward UUID
         */
        reward_uuid: string;
    };
    query?: {
        /**
         * Pass consumer UUID to obtain info how many times the consumer redeemed such reward via redeemed_times in response.
         */
        consumer_uuid?: string | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/reward/{reward_uuid}';
};

export type GetRewardErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetRewardError = GetRewardErrors[keyof GetRewardErrors];

export type GetRewardResponses = {
    /**
     * Reward response
     */
    200: RewardDetailResponse;
};

export type GetRewardResponse = GetRewardResponses[keyof GetRewardResponses];

export type ListRewardsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Field used to order by. Defaults to points when omitted or unrecognized.
         */
        order_by?: 'created_at' | 'points' | 'name' | 'expiration' | null;
        /**
         * Sort direction
         */
        sort?: 'asc' | 'desc' | null;
        /**
         * Location ids - comma separated list
         */
        location_ids?: string | null;
        /**
         * Is reward virtual
         */
        is_virtual?: '0' | '1' | null;
        /**
         * Is reward lottery
         */
        is_lottery?: '0' | '1' | null;
        /**
         * Pass consumer UUID to obtain info how many times the consumer redeemed such reward via redeemed_times in response.
         */
        consumer_uuid?: string | null;
        /**
         * Reward type
         */
        type?: 'campaign' | 'prize' | 'external' | null;
        /**
         * Prize type: physical, simplified, delayed_lottery_physical, instant_lottery_physical - one or comma separated list
         */
        prize_type?: string | null;
        /**
         * Reward subcategories - one or comma separated list
         */
        subcategories?: string | null;
        /**
         * Reward levels - one or comma separated list
         */
        levels?: string | null;
        /**
         * Minimum reward cost in points, inclusive
         */
        min_points?: number | null;
        /**
         * Maximum reward cost in points, inclusive
         */
        max_points?: number | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/rewards';
};

export type ListRewardsErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type ListRewardsError = ListRewardsErrors[keyof ListRewardsErrors];

export type ListRewardsResponses = {
    /**
     * List of rewards (prizes and campaigns)
     */
    200: IndexRewardsResponse;
};

export type ListRewardsResponse = ListRewardsResponses[keyof ListRewardsResponses];

export type ListRewardFiltersData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/rewards/filters';
};

export type ListRewardFiltersErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type ListRewardFiltersError = ListRewardFiltersErrors[keyof ListRewardFiltersErrors];

export type ListRewardFiltersResponses = {
    /**
     * Filter metadata for the rewards list
     */
    200: RewardFiltersResponseSchema;
};

export type ListRewardFiltersResponse2 = ListRewardFiltersResponses[keyof ListRewardFiltersResponses];

export type ListEarningsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Field used to order by
         */
        order_by?: 'created_at' | 'points' | null;
        /**
         * Sort direction
         */
        sort?: 'asc' | 'desc' | null;
        /**
         * Location ids - comma separated list
         */
        location_ids?: string | null;
        /**
         * Array of identifiers filter - required when type=product for other optional
         *
         * @deprecated
         */
        'identifier[]'?: Array<string> | null;
        /**
         * Earning type
         */
        type?: 'article' | 'product' | 'video' | 'quiz' | null;
        /**
         * Array of identifiers for a specific earning type. Replace <type> with a valid earning type (e.g., product, article). Example: typed_identifiers[product][]=SKU1234
         */
        'typed_identifiers[<type>][]'?: Array<string> | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/earnings';
};

export type ListEarningsErrors = {
    /**
     * Resource not found
     */
    400: NotFoundError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type ListEarningsError = ListEarningsErrors[keyof ListEarningsErrors];

export type ListEarningsResponses = {
    /**
     * List of earnings (articles, products, videos and quizzes)
     */
    200: ListEarningsResponse;
};

export type ListEarningsResponse2 = ListEarningsResponses[keyof ListEarningsResponses];

export type UpdateArticleReadData = {
    body?: UpdateReadRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/earnings/article';
};

export type UpdateArticleReadErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type UpdateArticleReadError = UpdateArticleReadErrors[keyof UpdateArticleReadErrors];

export type UpdateArticleReadResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type UpdateArticleReadResponse = UpdateArticleReadResponses[keyof UpdateArticleReadResponses];

export type UpdateVideoWatchedData = {
    body?: VideoWatchedRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/earnings/video';
};

export type UpdateVideoWatchedErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
};

export type UpdateVideoWatchedError = UpdateVideoWatchedErrors[keyof UpdateVideoWatchedErrors];

export type UpdateVideoWatchedResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type UpdateVideoWatchedResponse = UpdateVideoWatchedResponses[keyof UpdateVideoWatchedResponses];

export type UpdateQuizCompletedData = {
    body?: QuizCompletedRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/earnings/quiz';
};

export type UpdateQuizCompletedErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
};

export type UpdateQuizCompletedError = UpdateQuizCompletedErrors[keyof UpdateQuizCompletedErrors];

export type UpdateQuizCompletedResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type UpdateQuizCompletedResponse = UpdateQuizCompletedResponses[keyof UpdateQuizCompletedResponses];

export type GetQrCodeReadData = {
    body?: GetQrCodeReadRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/earnings/qr-code';
};

export type GetQrCodeReadErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * QR code read cannot be completed due to a conflicting state
     */
    409: QrCodeReadConflictResponse;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * QR code read cannot be completed until the next available date
     */
    423: ErrorWithNextAvailableDateResponse;
};

export type GetQrCodeReadError = GetQrCodeReadErrors[keyof GetQrCodeReadErrors];

export type GetQrCodeReadResponses = {
    /**
     * Qr Code Read Response
     */
    200: QrCodeReadResponse;
};

export type GetQrCodeReadResponse = GetQrCodeReadResponses[keyof GetQrCodeReadResponses];

export type GetBuyPrizeData = {
    body?: GetBuyPrizeRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/reward';
};

export type GetBuyPrizeErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    424: CommonError;
};

export type GetBuyPrizeError = GetBuyPrizeErrors[keyof GetBuyPrizeErrors];

export type GetBuyPrizeResponses = {
    /**
     * Prize bought response
     */
    200: PrizeBoughtResponse;
};

export type GetBuyPrizeResponse = GetBuyPrizeResponses[keyof GetBuyPrizeResponses];

export type GetConsumerRewardsCampaignsOrPrizesData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Field used to order by. Defaults to points when omitted or unrecognized.
         */
        order_by?: 'created_at' | 'points' | 'name' | 'expiration' | null;
        /**
         * Sort direction
         */
        sort?: 'asc' | 'desc' | null;
        /**
         * Location ids - comma separated list
         */
        location_ids?: string | null;
        /**
         * Is reward virtual
         */
        is_virtual?: '0' | '1' | null;
        /**
         * Is reward lottery
         */
        is_lottery?: '0' | '1' | null;
        /**
         * Pass consumer UUID to obtain info how many times the consumer redeemed such reward via redeemed_times in response.
         */
        consumer_uuid?: string | null;
        /**
         * Reward type
         */
        type?: 'campaign' | 'prize' | 'external' | null;
        /**
         * Prize type: physical, simplified, delayed_lottery_physical, instant_lottery_physical - one or comma separated list
         */
        prize_type?: string | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/rewards';
};

export type GetConsumerRewardsCampaignsOrPrizesErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetConsumerRewardsCampaignsOrPrizesError = GetConsumerRewardsCampaignsOrPrizesErrors[keyof GetConsumerRewardsCampaignsOrPrizesErrors];

export type GetConsumerRewardsCampaignsOrPrizesResponses = {
    /**
     * List of rewards (prizes and campaigns)
     */
    200: IndexRewardsResponse;
};

export type GetConsumerRewardsCampaignsOrPrizesResponse = GetConsumerRewardsCampaignsOrPrizesResponses[keyof GetConsumerRewardsCampaignsOrPrizesResponses];

export type GetConsumerEligibleRewardsData = {
    body?: EligibleRewardRequestBodySchema;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/rewards';
};

export type GetConsumerEligibleRewardsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetConsumerEligibleRewardsError = GetConsumerEligibleRewardsErrors[keyof GetConsumerEligibleRewardsErrors];

export type GetConsumerEligibleRewardsResponses = {
    /**
     * List of consumer eligible rewards
     */
    200: ConsumerEligibleRewardsResponse;
};

export type GetConsumerEligibleRewardsResponse = GetConsumerEligibleRewardsResponses[keyof GetConsumerEligibleRewardsResponses];

export type GetAchievementsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/achievements';
};

export type GetAchievementsErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetAchievementsError = GetAchievementsErrors[keyof GetAchievementsErrors];

export type GetAchievementsResponses = {
    /**
     * Consumer achievements
     */
    200: ConsumerAchievementsResponse;
};

export type GetAchievementsResponse = GetAchievementsResponses[keyof GetAchievementsResponses];

export type InitializeConsumerSurveyStartedControllerData = {
    body?: ConsumerSurveyStartedRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
        /**
         * Survey ID
         */
        survey_id: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/survey/{survey_id}/start';
};

export type InitializeConsumerSurveyStartedControllerErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type InitializeConsumerSurveyStartedControllerError = InitializeConsumerSurveyStartedControllerErrors[keyof InitializeConsumerSurveyStartedControllerErrors];

export type InitializeConsumerSurveyStartedControllerResponses = {
    /**
     * Consumer survey status
     */
    200: GetConsumerSurveyStatusResponse;
};

export type InitializeConsumerSurveyStartedControllerResponse = InitializeConsumerSurveyStartedControllerResponses[keyof InitializeConsumerSurveyStartedControllerResponses];

export type ValidateConsumerCanStartSurveyControllerData = {
    body?: ConsumerSurveyStartedRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
        /**
         * Survey ID
         */
        survey_id: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/survey/{survey_id}/validate';
};

export type ValidateConsumerCanStartSurveyControllerErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type ValidateConsumerCanStartSurveyControllerError = ValidateConsumerCanStartSurveyControllerErrors[keyof ValidateConsumerCanStartSurveyControllerErrors];

export type ValidateConsumerCanStartSurveyControllerResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type ValidateConsumerCanStartSurveyControllerResponse = ValidateConsumerCanStartSurveyControllerResponses[keyof ValidateConsumerCanStartSurveyControllerResponses];

export type CreateContestData = {
    /**
     * Request body for submitting contest identifier, questions, answers and files.
     */
    body?: CreateContestRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/contests';
};

export type CreateContestErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type CreateContestError = CreateContestErrors[keyof CreateContestErrors];

export type CreateContestResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type CreateContestResponse = CreateContestResponses[keyof CreateContestResponses];

export type GetContestStatusData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/contests/status';
};

export type GetContestStatusErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetContestStatusError = GetContestStatusErrors[keyof GetContestStatusErrors];

export type GetContestStatusResponses = {
    /**
     * Contest status for consumer
     */
    200: ContestStatusResponse;
};

export type GetContestStatusResponse = GetContestStatusResponses[keyof GetContestStatusResponses];

export type ListRewardsExtendedData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
    };
    query?: {
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Field used to order by. Defaults to points when omitted or unrecognized.
         */
        order_by?: 'created_at' | 'points' | 'name' | 'expiration' | null;
        /**
         * Sort direction
         */
        sort?: 'asc' | 'desc' | null;
        /**
         * Location ids - comma separated list
         */
        location_ids?: string | null;
        /**
         * Is reward virtual
         */
        is_virtual?: '0' | '1' | null;
        /**
         * Is reward lottery
         */
        is_lottery?: '0' | '1' | null;
        /**
         * Pass consumer UUID to obtain info how many times the consumer redeemed such reward via redeemed_times in response.
         */
        consumer_uuid?: string | null;
        /**
         * Reward type
         */
        type?: 'campaign' | 'prize' | 'external' | null;
        /**
         * Prize type: physical, simplified, delayed_lottery_physical, instant_lottery_physical - one or comma separated list
         */
        prize_type?: string | null;
        /**
         * Reward subcategories - one or comma separated list
         */
        subcategories?: string | null;
        /**
         * Reward levels - one or comma separated list
         */
        levels?: string | null;
        /**
         * Minimum reward cost in points, inclusive
         */
        min_points?: number | null;
        /**
         * Maximum reward cost in points, inclusive
         */
        max_points?: number | null;
        /**
         * When 1, returns only rewards available for the route consumer: cost within the active points balance and level matching the current tier or unrestricted. Overrides min_points, max_points and levels.
         */
        available_for_me?: '0' | '1' | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/rewards-extended';
};

export type ListRewardsExtendedErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type ListRewardsExtendedError = ListRewardsExtendedErrors[keyof ListRewardsExtendedErrors];

export type ListRewardsExtendedResponses = {
    /**
     * List of rewards (prizes and campaigns)
     */
    200: IndexRewardsResponse;
};

export type ListRewardsExtendedResponse = ListRewardsExtendedResponses[keyof ListRewardsExtendedResponses];

export type GetRewardExtendedData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
        /**
         * Reward UUID
         */
        reward_uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/rewards-extended/{reward_uuid}';
};

export type GetRewardExtendedErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetRewardExtendedError = GetRewardExtendedErrors[keyof GetRewardExtendedErrors];

export type GetRewardExtendedResponses = {
    /**
     * Reward response
     */
    200: RewardDetailResponse;
};

export type GetRewardExtendedResponse = GetRewardExtendedResponses[keyof GetRewardExtendedResponses];

export type GetEarningRuleByNameData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
        /**
         * Security scheme: GoogleRecaptchaSecurityScheme
         */
        'X-DES-RECAPTCHA-TOKEN'?: string | null;
        /**
         * On the lower environments, when coming from the Azure VPN or WARP, this header can be used to deactivate the Google reCAPTCHA check. Simply set the value to 1.
         */
        'X-SKIP-RECAPTCHA'?: string | null;
    };
    path: {
        /**
         * Consumer UUID
         */
        uuid: string;
        /**
         * Name of event
         */
        event_name: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/loyalty/consumers/{uuid}/earning-rule/{event_name}';
};

export type GetEarningRuleByNameErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
};

export type GetEarningRuleByNameError = GetEarningRuleByNameErrors[keyof GetEarningRuleByNameErrors];

export type GetEarningRuleByNameResponses = {
    /**
     * Earning rule for consumer
     */
    200: EarningRuleResponse;
};

export type GetEarningRuleByNameResponse = GetEarningRuleByNameResponses[keyof GetEarningRuleByNameResponses];

export type UpdateLevelChangedWebhookData = {
    body?: UpdateLevelChangedWebhookRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Token to authenticate the webhook request with. It can be configured in "loyalty.open_loyalty.admin_token".
         */
        'X-DES-OPEN-LOYALTY-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/webhooks/level-changed';
};

export type UpdateLevelChangedWebhookErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type UpdateLevelChangedWebhookError = UpdateLevelChangedWebhookErrors[keyof UpdateLevelChangedWebhookErrors];

export type UpdateLevelChangedWebhookResponses = {
    /**
     * Empty response
     */
    200: unknown;
};

export type UpdatePointsChangedWebhookData = {
    body?: PointsChangedWebhookRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Token to authenticate the webhook request with. It can be configured in "loyalty.open_loyalty.admin_token".
         */
        'X-DES-OPEN-LOYALTY-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/webhooks/points-changed';
};

export type UpdatePointsChangedWebhookErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type UpdatePointsChangedWebhookError = UpdatePointsChangedWebhookErrors[keyof UpdatePointsChangedWebhookErrors];

export type UpdatePointsChangedWebhookResponses = {
    /**
     * Empty response
     */
    200: unknown;
};

export type CreateTransferWebhookData = {
    body?: TransferCreatedWebhookRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Token to authenticate the webhook request with. It can be configured in "loyalty.open_loyalty.admin_token".
         */
        'X-DES-OPEN-LOYALTY-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/webhooks/transfer-created';
};

export type CreateTransferWebhookErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type CreateTransferWebhookError = CreateTransferWebhookErrors[keyof CreateTransferWebhookErrors];

export type CreateTransferWebhookResponses = {
    /**
     * Empty response
     */
    200: unknown;
};

export type CreateRewardRedeemedWebhookData = {
    body?: CreateRewardRedeemedWebhookRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Token to authenticate the webhook request with. It can be configured in "loyalty.open_loyalty.admin_token".
         */
        'X-DES-OPEN-LOYALTY-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/webhooks/reward-redeemed';
};

export type CreateRewardRedeemedWebhookErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type CreateRewardRedeemedWebhookError = CreateRewardRedeemedWebhookErrors[keyof CreateRewardRedeemedWebhookErrors];

export type CreateRewardRedeemedWebhookResponses = {
    /**
     * Empty response
     */
    200: unknown;
};

export type UpdateRewardRedemptionStatusChangedWebhookData = {
    body?: UpdateRewardRedemptionStatusChangedWebhookRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Token to authenticate the webhook request with. It can be configured in "loyalty.open_loyalty.admin_token".
         */
        'X-DES-OPEN-LOYALTY-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/webhooks/reward-redemption-status-changed';
};

export type UpdateRewardRedemptionStatusChangedWebhookErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type UpdateRewardRedemptionStatusChangedWebhookError = UpdateRewardRedemptionStatusChangedWebhookErrors[keyof UpdateRewardRedemptionStatusChangedWebhookErrors];

export type UpdateRewardRedemptionStatusChangedWebhookResponses = {
    /**
     * Empty response
     */
    200: unknown;
};

export type CreateRewardWebhookData = {
    body?: CreateUpdateRewardWebhookRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Token to authenticate the webhook request with. It can be configured in "loyalty.open_loyalty.admin_token".
         */
        'X-DES-OPEN-LOYALTY-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/webhooks/reward-created';
};

export type CreateRewardWebhookErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type CreateRewardWebhookError = CreateRewardWebhookErrors[keyof CreateRewardWebhookErrors];

export type CreateRewardWebhookResponses = {
    /**
     * Empty response
     */
    200: unknown;
};

export type UpdateRewardWebhookData = {
    body?: CreateUpdateRewardWebhookRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Token to authenticate the webhook request with. It can be configured in "loyalty.open_loyalty.admin_token".
         */
        'X-DES-OPEN-LOYALTY-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/webhooks/reward-updated';
};

export type UpdateRewardWebhookErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type UpdateRewardWebhookError = UpdateRewardWebhookErrors[keyof UpdateRewardWebhookErrors];

export type UpdateRewardWebhookResponses = {
    /**
     * Empty response
     */
    200: unknown;
};

export type DeleteRewardWebhookData = {
    body?: DeleteRewardWebhookRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Token to authenticate the webhook request with. It can be configured in "loyalty.open_loyalty.admin_token".
         */
        'X-DES-OPEN-LOYALTY-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/webhooks/reward-deleted';
};

export type DeleteRewardWebhookErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    409: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type DeleteRewardWebhookError = DeleteRewardWebhookErrors[keyof DeleteRewardWebhookErrors];

export type DeleteRewardWebhookResponses = {
    /**
     * Empty response
     */
    200: unknown;
};

export type ListOfflineCampaignsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            starts_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            ends_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            name?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            slug?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            event?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            source_id?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
        };
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * DEPRECATED: Filter campaigns that end after this date. Use filter[starts_at][eq] instead.
         *
         * @deprecated
         */
        'filter[starts_at]'?: string | null;
        /**
         * DEPRECATED: Filter campaigns that start before this date. Use filter[ends_at][eq] instead.
         *
         * @deprecated
         */
        'filter[ends_at]'?: string | null;
        /**
         * DEPRECATED: Filter by campaign name (partial match, uses LIKE). Use filter[name][like] instead.
         *
         * @deprecated
         */
        'filter[name]'?: string | null;
        /**
         * DEPRECATED: Filter by campaign slug. Use filter[slug][eq] instead.
         *
         * @deprecated
         */
        'filter[slug]'?: string | null;
        /**
         * DEPRECATED: Filter by event name. Use filter[event][eq] instead.
         *
         * @deprecated
         */
        'filter[event]'?: string | null;
        /**
         * DEPRECATED: Filter by source ID. Use filter[source_id][eq] instead.
         *
         * @deprecated
         */
        'filter[source_id]'?: string | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/offline-campaigns/campaigns';
};

export type ListOfflineCampaignsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListOfflineCampaignsError = ListOfflineCampaignsErrors[keyof ListOfflineCampaignsErrors];

export type ListOfflineCampaignsResponses = {
    /**
     * The offline campaign data.
     */
    200: ListOfflineCampaignsResponse;
};

export type ListOfflineCampaignsResponse2 = ListOfflineCampaignsResponses[keyof ListOfflineCampaignsResponses];

export type CreateOfflineCampaignData = {
    /**
     * OfflineCampaign create or update request body
     */
    body?: OfflineCampaign;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/offline-campaigns/campaigns';
};

export type CreateOfflineCampaignErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type CreateOfflineCampaignError = CreateOfflineCampaignErrors[keyof CreateOfflineCampaignErrors];

export type CreateOfflineCampaignResponses = {
    /**
     * Create Offline Campaign Response
     */
    201: CreateOfflineCampaignResponse;
};

export type CreateOfflineCampaignResponse2 = CreateOfflineCampaignResponses[keyof CreateOfflineCampaignResponses];

export type DeleteOfflineCampaignData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/offline-campaigns/campaigns/{uuid}';
};

export type DeleteOfflineCampaignErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
};

export type DeleteOfflineCampaignError = DeleteOfflineCampaignErrors[keyof DeleteOfflineCampaignErrors];

export type DeleteOfflineCampaignResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeleteOfflineCampaignResponse = DeleteOfflineCampaignResponses[keyof DeleteOfflineCampaignResponses];

export type GetOfflineCampaignData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/offline-campaigns/campaigns/{uuid}';
};

export type GetOfflineCampaignErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
};

export type GetOfflineCampaignError = GetOfflineCampaignErrors[keyof GetOfflineCampaignErrors];

export type GetOfflineCampaignResponses = {
    /**
     * The offline campaign data.
     */
    200: GetOfflineCampaignResponse;
};

export type GetOfflineCampaignResponse2 = GetOfflineCampaignResponses[keyof GetOfflineCampaignResponses];

export type UpdateOfflineCampaignData = {
    /**
     * OfflineCampaign create or update request body
     */
    body?: OfflineCampaign;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/offline-campaigns/campaigns/{uuid}';
};

export type UpdateOfflineCampaignErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type UpdateOfflineCampaignError = UpdateOfflineCampaignErrors[keyof UpdateOfflineCampaignErrors];

export type UpdateOfflineCampaignResponses = {
    /**
     * Update Offline Campaign Response
     */
    200: UpdateOfflineCampaignResponse;
};

export type UpdateOfflineCampaignResponse2 = UpdateOfflineCampaignResponses[keyof UpdateOfflineCampaignResponses];

export type ListOfflineCampaignCuponsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            offline_campaign_uuid?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            format?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            code?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            is_burned?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            user_uuid?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            burned_after?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            burned_before?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
        };
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * DEPRECATED: Filter by offline campaign UUID. Use filter[offline_campaign_uuid][eq] instead.
         *
         * @deprecated
         */
        'filter[offline_campaign_uuid]'?: string | null;
        /**
         * DEPRECATED: Filter by coupon format. Use filter[format][eq] instead.
         *
         * @deprecated
         */
        'filter[format]'?: string | null;
        /**
         * DEPRECATED: Filter by coupon code (partial match, uses LIKE). Use filter[code][like] instead.
         *
         * @deprecated
         */
        'filter[code]'?: string | null;
        /**
         * DEPRECATED: Filter by burned status. Use filter[is_burned][eq] instead.
         *
         * @deprecated
         */
        'filter[is_burned]'?: boolean | null;
        /**
         * DEPRECATED: Filter by user UUID who burned the coupon. Use filter[user_uuid][eq] instead.
         *
         * @deprecated
         */
        'filter[user_uuid]'?: string | null;
        /**
         * DEPRECATED: Filter by coupons burned after date. Use filter[burned_at][gte] instead.
         *
         * @deprecated
         */
        'filter[burned_after]'?: string | null;
        /**
         * DEPRECATED: Filter by coupons burned before date. Use filter[burned_at][lte] instead.
         *
         * @deprecated
         */
        'filter[burned_before]'?: string | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/offline-campaigns/coupons';
};

export type ListOfflineCampaignCuponsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListOfflineCampaignCuponsError = ListOfflineCampaignCuponsErrors[keyof ListOfflineCampaignCuponsErrors];

export type ListOfflineCampaignCuponsResponses = {
    /**
     * The offline campaign coupon list.
     */
    200: ListOfflineCampaignCouponsResponse;
};

export type ListOfflineCampaignCuponsResponse = ListOfflineCampaignCuponsResponses[keyof ListOfflineCampaignCuponsResponses];

export type CreateOfflineCampaignCouponData = {
    /**
     * Offline campaign coupon create/update request body
     */
    body?: OfflineCampaignCouponRequest;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/offline-campaigns/coupons';
};

export type CreateOfflineCampaignCouponErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type CreateOfflineCampaignCouponError = CreateOfflineCampaignCouponErrors[keyof CreateOfflineCampaignCouponErrors];

export type CreateOfflineCampaignCouponResponses = {
    /**
     * The offline campaign coupon data.
     */
    201: OfflineCampaignCouponResponse;
};

export type CreateOfflineCampaignCouponResponse = CreateOfflineCampaignCouponResponses[keyof CreateOfflineCampaignCouponResponses];

export type DeleteOfflineCampaignCouponData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/offline-campaigns/coupons/{uuid}';
};

export type DeleteOfflineCampaignCouponErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Empty response
     */
    404: unknown;
};

export type DeleteOfflineCampaignCouponError = DeleteOfflineCampaignCouponErrors[keyof DeleteOfflineCampaignCouponErrors];

export type DeleteOfflineCampaignCouponResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type DeleteOfflineCampaignCouponResponse = DeleteOfflineCampaignCouponResponses[keyof DeleteOfflineCampaignCouponResponses];

export type GetOfflineCampaignCouponData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/offline-campaigns/coupons/{uuid}';
};

export type GetOfflineCampaignCouponErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
};

export type GetOfflineCampaignCouponError = GetOfflineCampaignCouponErrors[keyof GetOfflineCampaignCouponErrors];

export type GetOfflineCampaignCouponResponses = {
    /**
     * The offline campaign coupon data.
     */
    200: OfflineCampaignCouponResponse;
};

export type GetOfflineCampaignCouponResponse = GetOfflineCampaignCouponResponses[keyof GetOfflineCampaignCouponResponses];

export type UpdateOfflineCampaignCouponData = {
    /**
     * Offline campaign coupon create/update request body
     */
    body?: OfflineCampaignCouponRequest;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/offline-campaigns/coupons/{uuid}';
};

export type UpdateOfflineCampaignCouponErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Empty response
     */
    404: unknown;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type UpdateOfflineCampaignCouponError = UpdateOfflineCampaignCouponErrors[keyof UpdateOfflineCampaignCouponErrors];

export type UpdateOfflineCampaignCouponResponses = {
    /**
     * The offline campaign coupon data.
     */
    200: OfflineCampaignCouponResponse;
};

export type UpdateOfflineCampaignCouponResponse = UpdateOfflineCampaignCouponResponses[keyof UpdateOfflineCampaignCouponResponses];

export type ImportOfflineCampaignCouponsData = {
    /**
     * Import offline campaign coupons request body
     */
    body?: ImportOfflineCampaignCouponsRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/offline-campaigns/campaigns/{uuid}/import';
};

export type ImportOfflineCampaignCouponsErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Empty response
     */
    404: unknown;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type ImportOfflineCampaignCouponsError = ImportOfflineCampaignCouponsErrors[keyof ImportOfflineCampaignCouponsErrors];

export type ImportOfflineCampaignCouponsResponses = {
    /**
     * The number of imports.
     */
    200: ImportOfflineCampaignCouponResponse;
};

export type ImportOfflineCampaignCouponsResponse = ImportOfflineCampaignCouponsResponses[keyof ImportOfflineCampaignCouponsResponses];

export type UpdateBurnOfflineCampaignCouponWebhookData = {
    /**
     * Request body for webhooks to burn a coupon.
     */
    body?: UpdateBurnOfflineCampaignCouponWebhookRequestBody;
    headers?: {
        /**
         * Security scheme: WebhookSecurityScheme
         */
        'X-DES-SIGNATURE'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/webhooks/burn-offline-campaign-coupon';
};

export type UpdateBurnOfflineCampaignCouponWebhookErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    410: CommonError;
};

export type UpdateBurnOfflineCampaignCouponWebhookError = UpdateBurnOfflineCampaignCouponWebhookErrors[keyof UpdateBurnOfflineCampaignCouponWebhookErrors];

export type UpdateBurnOfflineCampaignCouponWebhookResponses = {
    /**
     * Success message response
     */
    200: SuccessMessage;
};

export type UpdateBurnOfflineCampaignCouponWebhookResponse = UpdateBurnOfflineCampaignCouponWebhookResponses[keyof UpdateBurnOfflineCampaignCouponWebhookResponses];

export type RegisterCasConsumerWebhookData = {
    /**
     * Request body for webhooks from CAS to burn a coupon.
     */
    body?: RegisterCasConsumerWebhookRequestBody;
    headers?: {
        /**
         * Security scheme: WebhookSecurityScheme
         */
        'X-DES-SIGNATURE'?: string | null;
    };
    path?: never;
    query?: never;
    url: '/webhooks/cas-register-consumer';
};

export type RegisterCasConsumerWebhookErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    410: CommonError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type RegisterCasConsumerWebhookError = RegisterCasConsumerWebhookErrors[keyof RegisterCasConsumerWebhookErrors];

export type RegisterCasConsumerWebhookResponses = {
    /**
     * Success message response
     */
    200: SuccessMessage;
};

export type RegisterCasConsumerWebhookResponse = RegisterCasConsumerWebhookResponses[keyof RegisterCasConsumerWebhookResponses];

export type GetQuizzesUserSubmissionsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path: {
        /**
         * User identifier
         */
        userUuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/quizzes/by-user/{userUuid}';
};

export type GetQuizzesUserSubmissionsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    422: CommonError;
};

export type GetQuizzesUserSubmissionsError = GetQuizzesUserSubmissionsErrors[keyof GetQuizzesUserSubmissionsErrors];

export type GetQuizzesUserSubmissionsResponses = {
    /**
     * Display user submissions
     */
    200: UserSubmissionsResponse;
};

export type GetQuizzesUserSubmissionsResponse = GetQuizzesUserSubmissionsResponses[keyof GetQuizzesUserSubmissionsResponses];

export type CreateQuizzesUserSubmissionData = {
    /**
     * Create user submission
     */
    body?: CreateUserSubmissionRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path: {
        /**
         * User identifier
         */
        userUuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/quizzes/by-user/{userUuid}';
};

export type CreateQuizzesUserSubmissionErrors = {
    /**
     * Bad Request
     */
    400: ErrorBadRequest;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
};

export type CreateQuizzesUserSubmissionError = CreateQuizzesUserSubmissionErrors[keyof CreateQuizzesUserSubmissionErrors];

export type CreateQuizzesUserSubmissionResponses = {
    /**
     * Create unvalidated user submission
     */
    201: CreateUserSubmissionResponse;
};

export type CreateQuizzesUserSubmissionResponse = CreateQuizzesUserSubmissionResponses[keyof CreateQuizzesUserSubmissionResponses];

export type SurveyMonkeyGetTenantWorkgroupsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/survey-monkey/tenant-workgroups';
};

export type SurveyMonkeyGetTenantWorkgroupsErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type SurveyMonkeyGetTenantWorkgroupsError = SurveyMonkeyGetTenantWorkgroupsErrors[keyof SurveyMonkeyGetTenantWorkgroupsErrors];

export type SurveyMonkeyGetTenantWorkgroupsResponses = {
    /**
     * Returns a list of tenant-workgroup mappings
     */
    200: TenantWorkgroupsResponse;
};

export type SurveyMonkeyGetTenantWorkgroupsResponse = SurveyMonkeyGetTenantWorkgroupsResponses[keyof SurveyMonkeyGetTenantWorkgroupsResponses];

export type SurveyMonkeyAssignWorkgroupToTenantData = {
    body?: AssignWorkgroupRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/survey-monkey/tenant-workgroups';
};

export type SurveyMonkeyAssignWorkgroupToTenantErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type SurveyMonkeyAssignWorkgroupToTenantError = SurveyMonkeyAssignWorkgroupToTenantErrors[keyof SurveyMonkeyAssignWorkgroupToTenantErrors];

export type SurveyMonkeyAssignWorkgroupToTenantResponses = {
    /**
     * Tenant-workgroup mapping created successfully
     */
    201: TenantWorkgroupCreatedResponse;
};

export type SurveyMonkeyAssignWorkgroupToTenantResponse = SurveyMonkeyAssignWorkgroupToTenantResponses[keyof SurveyMonkeyAssignWorkgroupToTenantResponses];

export type SurveyMonkeyRemoveWorkgroupFromTenantData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Tenant-workgroup mapping ID
         */
        id: number;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/survey-monkey/tenant-workgroups/{id}';
};

export type SurveyMonkeyRemoveWorkgroupFromTenantErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type SurveyMonkeyRemoveWorkgroupFromTenantError = SurveyMonkeyRemoveWorkgroupFromTenantErrors[keyof SurveyMonkeyRemoveWorkgroupFromTenantErrors];

export type SurveyMonkeyRemoveWorkgroupFromTenantResponses = {
    /**
     * Empty response
     */
    204: void;
};

export type SurveyMonkeyRemoveWorkgroupFromTenantResponse = SurveyMonkeyRemoveWorkgroupFromTenantResponses[keyof SurveyMonkeyRemoveWorkgroupFromTenantResponses];

export type SurveyMonkeyBackfillSurveyResponsesData = {
    body?: BackfillSurveyResponsesRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/survey-monkey/responses/backfill';
};

export type SurveyMonkeyBackfillSurveyResponsesErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type SurveyMonkeyBackfillSurveyResponsesError = SurveyMonkeyBackfillSurveyResponsesErrors[keyof SurveyMonkeyBackfillSurveyResponsesErrors];

export type SurveyMonkeyBackfillSurveyResponsesResponses = {
    /**
     * Response backfill job queued for async processing
     */
    202: BackfillSurveyResponsesAcceptedResponse;
};

export type SurveyMonkeyBackfillSurveyResponsesResponse = SurveyMonkeyBackfillSurveyResponsesResponses[keyof SurveyMonkeyBackfillSurveyResponsesResponses];

export type SurveyMonkeyFetchSurveyResponsesData = {
    body?: FetchSurveyResponsesRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/survey-monkey/responses/fetch';
};

export type SurveyMonkeyFetchSurveyResponsesErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type SurveyMonkeyFetchSurveyResponsesError = SurveyMonkeyFetchSurveyResponsesErrors[keyof SurveyMonkeyFetchSurveyResponsesErrors];

export type SurveyMonkeyFetchSurveyResponsesResponses = {
    /**
     * Survey responses fetched synchronously
     */
    200: FetchSurveyResponsesResponse;
};

export type SurveyMonkeyFetchSurveyResponsesResponse = SurveyMonkeyFetchSurveyResponsesResponses[keyof SurveyMonkeyFetchSurveyResponsesResponses];

export type SurveyMonkeyResponseCompletedWebhookData = {
    body?: SurveyMonkeyWebhookRequestBody;
    path: {
        /**
         * Tenant code that owns the survey, embedded in the subscription URL at registration
         */
        tenantCode: string;
        /**
         * External SurveyMonkey survey identifier
         */
        surveyId: string;
    };
    query?: never;
    url: '/webhooks/survey-monkey/{tenantCode}/response-completed/{surveyId}';
};

export type SurveyMonkeyResponseCompletedWebhookErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type SurveyMonkeyResponseCompletedWebhookError = SurveyMonkeyResponseCompletedWebhookErrors[keyof SurveyMonkeyResponseCompletedWebhookErrors];

export type SurveyMonkeyResponseCompletedWebhookResponses = {
    /**
     * Webhook received and processed successfully
     */
    200: SurveyMonkeyWebhookResponse;
};

export type SurveyMonkeyResponseCompletedWebhookResponse = SurveyMonkeyResponseCompletedWebhookResponses[keyof SurveyMonkeyResponseCompletedWebhookResponses];

export type SurveyMonkeyCollectorCreatedWebhookData = {
    body?: SurveyMonkeyWebhookRequestBody;
    path: {
        /**
         * Tenant code that owns the survey, embedded in the subscription URL at registration
         */
        tenantCode: string;
        /**
         * External SurveyMonkey survey identifier
         */
        surveyId: string;
    };
    query?: never;
    url: '/webhooks/survey-monkey/{tenantCode}/collector-created/{surveyId}';
};

export type SurveyMonkeyCollectorCreatedWebhookErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type SurveyMonkeyCollectorCreatedWebhookError = SurveyMonkeyCollectorCreatedWebhookErrors[keyof SurveyMonkeyCollectorCreatedWebhookErrors];

export type SurveyMonkeyCollectorCreatedWebhookResponses = {
    /**
     * Webhook received and processed successfully
     */
    200: SurveyMonkeyWebhookResponse;
};

export type SurveyMonkeyCollectorCreatedWebhookResponse = SurveyMonkeyCollectorCreatedWebhookResponses[keyof SurveyMonkeyCollectorCreatedWebhookResponses];

export type SurveyMonkeyCollectorUpdatedWebhookData = {
    body?: SurveyMonkeyWebhookRequestBody;
    path: {
        /**
         * Tenant code that owns the survey, embedded in the subscription URL at registration
         */
        tenantCode: string;
        /**
         * External SurveyMonkey survey identifier
         */
        surveyId: string;
    };
    query?: never;
    url: '/webhooks/survey-monkey/{tenantCode}/collector-updated/{surveyId}';
};

export type SurveyMonkeyCollectorUpdatedWebhookErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type SurveyMonkeyCollectorUpdatedWebhookError = SurveyMonkeyCollectorUpdatedWebhookErrors[keyof SurveyMonkeyCollectorUpdatedWebhookErrors];

export type SurveyMonkeyCollectorUpdatedWebhookResponses = {
    /**
     * Webhook received and processed successfully
     */
    200: SurveyMonkeyWebhookResponse;
};

export type SurveyMonkeyCollectorUpdatedWebhookResponse = SurveyMonkeyCollectorUpdatedWebhookResponses[keyof SurveyMonkeyCollectorUpdatedWebhookResponses];

export type SurveyMonkeySurveyUpdatedWebhookData = {
    body?: SurveyMonkeyWebhookRequestBody;
    path: {
        /**
         * Tenant code that owns the survey, embedded in the subscription URL at registration
         */
        tenantCode: string;
        /**
         * External SurveyMonkey survey identifier
         */
        surveyId: string;
    };
    query?: never;
    url: '/webhooks/survey-monkey/{tenantCode}/survey-updated/{surveyId}';
};

export type SurveyMonkeySurveyUpdatedWebhookErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type SurveyMonkeySurveyUpdatedWebhookError = SurveyMonkeySurveyUpdatedWebhookErrors[keyof SurveyMonkeySurveyUpdatedWebhookErrors];

export type SurveyMonkeySurveyUpdatedWebhookResponses = {
    /**
     * Webhook received and processed successfully
     */
    200: SurveyMonkeyWebhookResponse;
};

export type SurveyMonkeySurveyUpdatedWebhookResponse = SurveyMonkeySurveyUpdatedWebhookResponses[keyof SurveyMonkeySurveyUpdatedWebhookResponses];

export type SurveyMonkeySurveyDeletedWebhookData = {
    body?: SurveyMonkeyWebhookRequestBody;
    path: {
        /**
         * Tenant code that owns the survey, embedded in the subscription URL at registration
         */
        tenantCode: string;
        /**
         * External SurveyMonkey survey identifier
         */
        surveyId: string;
    };
    query?: never;
    url: '/webhooks/survey-monkey/{tenantCode}/survey-deleted/{surveyId}';
};

export type SurveyMonkeySurveyDeletedWebhookErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type SurveyMonkeySurveyDeletedWebhookError = SurveyMonkeySurveyDeletedWebhookErrors[keyof SurveyMonkeySurveyDeletedWebhookErrors];

export type SurveyMonkeySurveyDeletedWebhookResponses = {
    /**
     * Webhook received and processed successfully
     */
    200: SurveyMonkeyWebhookResponse;
};

export type SurveyMonkeySurveyDeletedWebhookResponse = SurveyMonkeySurveyDeletedWebhookResponses[keyof SurveyMonkeySurveyDeletedWebhookResponses];

export type SurveyMonkeyCollectorDeletedWebhookData = {
    body?: SurveyMonkeyWebhookRequestBody;
    path: {
        /**
         * Tenant code that owns the survey, embedded in the subscription URL at registration
         */
        tenantCode: string;
        /**
         * External SurveyMonkey survey identifier
         */
        surveyId: string;
    };
    query?: never;
    url: '/webhooks/survey-monkey/{tenantCode}/collector-deleted/{surveyId}';
};

export type SurveyMonkeyCollectorDeletedWebhookErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Validation errors
     */
    422: ValidationError;
};

export type SurveyMonkeyCollectorDeletedWebhookError = SurveyMonkeyCollectorDeletedWebhookErrors[keyof SurveyMonkeyCollectorDeletedWebhookErrors];

export type SurveyMonkeyCollectorDeletedWebhookResponses = {
    /**
     * Webhook received and processed successfully
     */
    200: SurveyMonkeyWebhookResponse;
};

export type SurveyMonkeyCollectorDeletedWebhookResponse = SurveyMonkeyCollectorDeletedWebhookResponses[keyof SurveyMonkeyCollectorDeletedWebhookResponses];

export type GetTradeInPublicDomainConfigurationData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/trade-in/configuration';
};

export type GetTradeInPublicDomainConfigurationErrors = {
    /**
     * Resource not found
     */
    404: NotFoundError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetTradeInPublicDomainConfigurationError = GetTradeInPublicDomainConfigurationErrors[keyof GetTradeInPublicDomainConfigurationErrors];

export type GetTradeInPublicDomainConfigurationResponses = {
    /**
     * TradeIn domain public configuration response
     */
    200: TradeInPublicConfigurationResponse;
};

export type GetTradeInPublicDomainConfigurationResponse = GetTradeInPublicDomainConfigurationResponses[keyof GetTradeInPublicDomainConfigurationResponses];

export type CreateTradeInData = {
    body?: CreateTradeInRequestBody;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/trade-in';
};

export type CreateTradeInErrors = {
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type CreateTradeInError = CreateTradeInErrors[keyof CreateTradeInErrors];

export type CreateTradeInResponses = {
    /**
     * OK
     */
    200: CreateTradeInResponse;
};

export type CreateTradeInResponse2 = CreateTradeInResponses[keyof CreateTradeInResponses];

export type IsConsumerEligibleForTradeInData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path: {
        /**
         * Consumer identifier
         */
        uuid: string;
    };
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/trade-in/is-eligible/{uuid}';
};

export type IsConsumerEligibleForTradeInErrors = {
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type IsConsumerEligibleForTradeInError = IsConsumerEligibleForTradeInErrors[keyof IsConsumerEligibleForTradeInErrors];

export type IsConsumerEligibleForTradeInResponses = {
    /**
     * Return information about user eligibility for subscription
     */
    200: IsConsumerEligibleResponse;
};

export type IsConsumerEligibleForTradeInResponse = IsConsumerEligibleForTradeInResponses[keyof IsConsumerEligibleForTradeInResponses];

export type ListAllTradeInsData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
        /**
         * Security scheme: ServiceSecurityScheme (Bearer JWT)
         */
        Authorization?: string | null;
        /**
         * The microservice way of authenticating services and service users is now deprecated and will be removed in the future. Use the 'ServiceSecurityScheme' instead.
         */
        'X-DES-SERVICE-AUTHENTICATION'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Filter parameters
         */
        filter?: {
            model?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            model_type?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            status?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Like filter
                 */
                like?: string;
            };
            consumer_id?: {
                /**
                 * Equal filter
                 */
                eq?: string;
            };
            created_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
            updated_at?: {
                /**
                 * Equal filter
                 */
                eq?: string;
                /**
                 * Not Equal filter
                 */
                neq?: string;
                /**
                 * Greater Than filter
                 */
                gt?: string;
                /**
                 * Greater Than Or Equal filter
                 */
                gte?: string;
                /**
                 * Lower Than filter
                 */
                lt?: string;
                /**
                 * Lower Than Or Equal filter
                 */
                lte?: string;
            };
        };
        /**
         * Requested page number
         */
        page?: number | null;
        /**
         * Amount of results per page
         */
        per_page?: number | null;
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/trade-in/list';
};

export type ListAllTradeInsErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Validation errors
     */
    422: ValidationError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type ListAllTradeInsError = ListAllTradeInsErrors[keyof ListAllTradeInsErrors];

export type ListAllTradeInsResponses = {
    /**
     * List trade ins
     */
    200: ListAllTradeInsResponse;
};

export type ListAllTradeInsResponse2 = ListAllTradeInsResponses[keyof ListAllTradeInsResponses];

export type GetEligibleDevicesData = {
    body?: never;
    headers?: {
        /**
         * Security scheme: TenantSecurityScheme
         */
        'X-DES-TENANT'?: string | null;
        /**
         * Security scheme: UserSecurityScheme
         */
        'X-DES-USER-TOKEN'?: string | null;
    };
    path?: never;
    query?: {
        /**
         * Security scheme: TenantSecurityQueryStringScheme
         */
        tenant_code?: string | null;
    };
    url: '/api/trade-in/devices';
};

export type GetEligibleDevicesErrors = {
    /**
     * Failed due to processing error
     */
    400: CommonError;
    /**
     * Failed due to invalid or absent auth header
     */
    403: PermissionError;
    /**
     * Failed due to processing error
     */
    423: CommonError;
    /**
     * Failed due to processing error
     */
    500: CommonError;
};

export type GetEligibleDevicesError = GetEligibleDevicesErrors[keyof GetEligibleDevicesErrors];

export type GetEligibleDevicesResponses = {
    /**
     * Get eligible devices for trade-in
     */
    200: GetEligibleDevicesResponse;
};

export type GetEligibleDevicesResponse2 = GetEligibleDevicesResponses[keyof GetEligibleDevicesResponses];
